
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8689"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8689"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kQfpd", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f2c49d36ff853345$export$ffb0004e005737fa, (v) => $f2c49d36ff853345$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $f2c49d36ff853345$export$34b9dba7ce09269b, (v) => $f2c49d36ff853345$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $f2c49d36ff853345$export$25062201e9e25d76, (v) => $f2c49d36ff853345$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f2c49d36ff853345$export$ffb0004e005737fa;
var $f2c49d36ff853345$export$34b9dba7ce09269b;
var $f2c49d36ff853345$export$25062201e9e25d76;
"use strict";
var $f2c49d36ff853345$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f2c49d36ff853345$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $f2c49d36ff853345$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $f2c49d36ff853345$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$f2c49d36ff853345$export$ffb0004e005737fa = $f2c49d36ff853345$var$REACT_FRAGMENT_TYPE;
$f2c49d36ff853345$export$34b9dba7ce09269b = $f2c49d36ff853345$var$jsxProd;
$f2c49d36ff853345$export$25062201e9e25d76 = $f2c49d36ff853345$var$jsxProd;

});

parcelRegister("3WPYT", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $2dff1c3b98c2ac71$export$9c16c1426311996d, (v) => $2dff1c3b98c2ac71$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $2dff1c3b98c2ac71$export$dca3b0875bd9a954, (v) => $2dff1c3b98c2ac71$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $2dff1c3b98c2ac71$export$16fa2f45be04daa8, (v) => $2dff1c3b98c2ac71$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $2dff1c3b98c2ac71$export$ffb0004e005737fa, (v) => $2dff1c3b98c2ac71$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $2dff1c3b98c2ac71$export$e2c29f18771995cb, (v) => $2dff1c3b98c2ac71$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $2dff1c3b98c2ac71$export$221d75b3f55bb0bd, (v) => $2dff1c3b98c2ac71$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $2dff1c3b98c2ac71$export$5f8d39834fd61797, (v) => $2dff1c3b98c2ac71$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2dff1c3b98c2ac71$export$74bf444e3cd11ea5, (v) => $2dff1c3b98c2ac71$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $2dff1c3b98c2ac71$export$1ced07cd6b1985ce, (v) => $2dff1c3b98c2ac71$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $2dff1c3b98c2ac71$export$abd8e32b826d7ea7, (v) => $2dff1c3b98c2ac71$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $2dff1c3b98c2ac71$export$69a3209f1a06c04d, (v) => $2dff1c3b98c2ac71$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $2dff1c3b98c2ac71$export$8c538325882c7eec, (v) => $2dff1c3b98c2ac71$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $2dff1c3b98c2ac71$export$e530037191fcd5d7, (v) => $2dff1c3b98c2ac71$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $2dff1c3b98c2ac71$export$fd42f52fd3ae1109, (v) => $2dff1c3b98c2ac71$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $2dff1c3b98c2ac71$export$c8a8987d4410bf2d, (v) => $2dff1c3b98c2ac71$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $2dff1c3b98c2ac71$export$7d1e3a5e95ceca43, (v) => $2dff1c3b98c2ac71$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $2dff1c3b98c2ac71$export$257a8862b851cb5b, (v) => $2dff1c3b98c2ac71$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $2dff1c3b98c2ac71$export$a8257692ac88316c, (v) => $2dff1c3b98c2ac71$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $2dff1c3b98c2ac71$export$488013bae63b21da, (v) => $2dff1c3b98c2ac71$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $2dff1c3b98c2ac71$export$7c73462e0d25e514, (v) => $2dff1c3b98c2ac71$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $2dff1c3b98c2ac71$export$7568632d0d33d16d, (v) => $2dff1c3b98c2ac71$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8, (v) => $2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $2dff1c3b98c2ac71$export$1f96ae73734a86cc, (v) => $2dff1c3b98c2ac71$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $2dff1c3b98c2ac71$export$9a47ced3238df325, (v) => $2dff1c3b98c2ac71$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $2dff1c3b98c2ac71$export$35808ee640e87ca7, (v) => $2dff1c3b98c2ac71$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $2dff1c3b98c2ac71$export$fae74005e78b1a27, (v) => $2dff1c3b98c2ac71$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e, (v) => $2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $2dff1c3b98c2ac71$export$6a7bc4e911dc01cf, (v) => $2dff1c3b98c2ac71$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $2dff1c3b98c2ac71$export$6d9c69b0de29b591, (v) => $2dff1c3b98c2ac71$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $2dff1c3b98c2ac71$export$7f54fc3180508a52, (v) => $2dff1c3b98c2ac71$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $2dff1c3b98c2ac71$export$f680877a34711e37, (v) => $2dff1c3b98c2ac71$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $2dff1c3b98c2ac71$export$d5a552a76deda3c2, (v) => $2dff1c3b98c2ac71$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $2dff1c3b98c2ac71$export$aaabe4eda9ed9969, (v) => $2dff1c3b98c2ac71$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $2dff1c3b98c2ac71$export$e5c5a5f917a5871c, (v) => $2dff1c3b98c2ac71$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $2dff1c3b98c2ac71$export$1538c33de8887b59, (v) => $2dff1c3b98c2ac71$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $2dff1c3b98c2ac71$export$fca7f784ae7a249a, (v) => $2dff1c3b98c2ac71$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $2dff1c3b98c2ac71$export$13e3392192263954, (v) => $2dff1c3b98c2ac71$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $2dff1c3b98c2ac71$export$b8f5890fc79d6aca, (v) => $2dff1c3b98c2ac71$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $2dff1c3b98c2ac71$export$60241385465d0a34, (v) => $2dff1c3b98c2ac71$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $2dff1c3b98c2ac71$export$306c0aa65ff9ec16, (v) => $2dff1c3b98c2ac71$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $2dff1c3b98c2ac71$export$7b286972b8d8ccbf, (v) => $2dff1c3b98c2ac71$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $2dff1c3b98c2ac71$export$83d89fbfd8236492, (v) => $2dff1c3b98c2ac71$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2dff1c3b98c2ac71$export$9c16c1426311996d;
var $2dff1c3b98c2ac71$export$dca3b0875bd9a954;
var $2dff1c3b98c2ac71$export$16fa2f45be04daa8;
var $2dff1c3b98c2ac71$export$ffb0004e005737fa;
var $2dff1c3b98c2ac71$export$e2c29f18771995cb;
var $2dff1c3b98c2ac71$export$221d75b3f55bb0bd;
var $2dff1c3b98c2ac71$export$5f8d39834fd61797;
var $2dff1c3b98c2ac71$export$74bf444e3cd11ea5;
var $2dff1c3b98c2ac71$export$1ced07cd6b1985ce;
var $2dff1c3b98c2ac71$export$abd8e32b826d7ea7;
var $2dff1c3b98c2ac71$export$69a3209f1a06c04d;
var $2dff1c3b98c2ac71$export$8c538325882c7eec;
var $2dff1c3b98c2ac71$export$e530037191fcd5d7;
var $2dff1c3b98c2ac71$export$fd42f52fd3ae1109;
var $2dff1c3b98c2ac71$export$c8a8987d4410bf2d;
var $2dff1c3b98c2ac71$export$7d1e3a5e95ceca43;
var $2dff1c3b98c2ac71$export$257a8862b851cb5b;
var $2dff1c3b98c2ac71$export$a8257692ac88316c;
var $2dff1c3b98c2ac71$export$488013bae63b21da;
var $2dff1c3b98c2ac71$export$7c73462e0d25e514;
var $2dff1c3b98c2ac71$export$7568632d0d33d16d;
var $2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8;
var $2dff1c3b98c2ac71$export$1f96ae73734a86cc;
var $2dff1c3b98c2ac71$export$9a47ced3238df325;
var $2dff1c3b98c2ac71$export$35808ee640e87ca7;
var $2dff1c3b98c2ac71$export$fae74005e78b1a27;
var $2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e;
var $2dff1c3b98c2ac71$export$6a7bc4e911dc01cf;
var $2dff1c3b98c2ac71$export$6d9c69b0de29b591;
var $2dff1c3b98c2ac71$export$7f54fc3180508a52;
var $2dff1c3b98c2ac71$export$f680877a34711e37;
var $2dff1c3b98c2ac71$export$d5a552a76deda3c2;
var $2dff1c3b98c2ac71$export$aaabe4eda9ed9969;
var $2dff1c3b98c2ac71$export$e5c5a5f917a5871c;
var $2dff1c3b98c2ac71$export$1538c33de8887b59;
var $2dff1c3b98c2ac71$export$fca7f784ae7a249a;
var $2dff1c3b98c2ac71$export$13e3392192263954;
var $2dff1c3b98c2ac71$export$b8f5890fc79d6aca;
var $2dff1c3b98c2ac71$export$60241385465d0a34;
var $2dff1c3b98c2ac71$export$306c0aa65ff9ec16;
var $2dff1c3b98c2ac71$export$7b286972b8d8ccbf;
var $2dff1c3b98c2ac71$export$83d89fbfd8236492;
"use strict";
var $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2dff1c3b98c2ac71$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2dff1c3b98c2ac71$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2dff1c3b98c2ac71$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2dff1c3b98c2ac71$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2dff1c3b98c2ac71$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2dff1c3b98c2ac71$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2dff1c3b98c2ac71$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2dff1c3b98c2ac71$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2dff1c3b98c2ac71$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2dff1c3b98c2ac71$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $2dff1c3b98c2ac71$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $2dff1c3b98c2ac71$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2dff1c3b98c2ac71$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2dff1c3b98c2ac71$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2dff1c3b98c2ac71$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2dff1c3b98c2ac71$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $2dff1c3b98c2ac71$var$assign = Object.assign, $2dff1c3b98c2ac71$var$emptyObject = {};
function $2dff1c3b98c2ac71$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2dff1c3b98c2ac71$var$emptyObject;
    this.updater = updater || $2dff1c3b98c2ac71$var$ReactNoopUpdateQueue;
}
$2dff1c3b98c2ac71$var$Component.prototype.isReactComponent = {};
$2dff1c3b98c2ac71$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$2dff1c3b98c2ac71$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $2dff1c3b98c2ac71$var$ComponentDummy() {}
$2dff1c3b98c2ac71$var$ComponentDummy.prototype = $2dff1c3b98c2ac71$var$Component.prototype;
function $2dff1c3b98c2ac71$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $2dff1c3b98c2ac71$var$emptyObject;
    this.updater = updater || $2dff1c3b98c2ac71$var$ReactNoopUpdateQueue;
}
var $2dff1c3b98c2ac71$var$pureComponentPrototype = $2dff1c3b98c2ac71$var$PureComponent.prototype = new $2dff1c3b98c2ac71$var$ComponentDummy();
$2dff1c3b98c2ac71$var$pureComponentPrototype.constructor = $2dff1c3b98c2ac71$var$PureComponent;
$2dff1c3b98c2ac71$var$assign($2dff1c3b98c2ac71$var$pureComponentPrototype, $2dff1c3b98c2ac71$var$Component.prototype);
$2dff1c3b98c2ac71$var$pureComponentPrototype.isPureReactComponent = !0;
var $2dff1c3b98c2ac71$var$isArrayImpl = Array.isArray;
function $2dff1c3b98c2ac71$var$noop() {}
var $2dff1c3b98c2ac71$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $2dff1c3b98c2ac71$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2dff1c3b98c2ac71$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $2dff1c3b98c2ac71$var$cloneAndReplaceKey(oldElement, newKey) {
    return $2dff1c3b98c2ac71$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $2dff1c3b98c2ac71$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE;
}
function $2dff1c3b98c2ac71$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $2dff1c3b98c2ac71$var$userProvidedKeyEscapeRegex = /\/+/g;
function $2dff1c3b98c2ac71$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $2dff1c3b98c2ac71$var$escape("" + element.key) : index.toString(36);
}
function $2dff1c3b98c2ac71$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($2dff1c3b98c2ac71$var$noop, $2dff1c3b98c2ac71$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $2dff1c3b98c2ac71$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $2dff1c3b98c2ac71$var$REACT_ELEMENT_TYPE:
                case $2dff1c3b98c2ac71$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $2dff1c3b98c2ac71$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $2dff1c3b98c2ac71$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $2dff1c3b98c2ac71$var$getElementKey(children, 0) : nameSoFar, $2dff1c3b98c2ac71$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($2dff1c3b98c2ac71$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $2dff1c3b98c2ac71$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($2dff1c3b98c2ac71$var$isValidElement(callback) && (callback = $2dff1c3b98c2ac71$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($2dff1c3b98c2ac71$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($2dff1c3b98c2ac71$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $2dff1c3b98c2ac71$var$getElementKey(nameSoFar, i), invokeCallback += $2dff1c3b98c2ac71$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $2dff1c3b98c2ac71$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $2dff1c3b98c2ac71$var$getElementKey(nameSoFar, i++), invokeCallback += $2dff1c3b98c2ac71$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $2dff1c3b98c2ac71$var$mapIntoArray($2dff1c3b98c2ac71$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $2dff1c3b98c2ac71$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $2dff1c3b98c2ac71$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $2dff1c3b98c2ac71$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $2dff1c3b98c2ac71$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $2dff1c3b98c2ac71$var$Children = {
    map: $2dff1c3b98c2ac71$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $2dff1c3b98c2ac71$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $2dff1c3b98c2ac71$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $2dff1c3b98c2ac71$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$2dff1c3b98c2ac71$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$2dff1c3b98c2ac71$export$9c16c1426311996d = $2dff1c3b98c2ac71$var$REACT_ACTIVITY_TYPE;
$2dff1c3b98c2ac71$export$dca3b0875bd9a954 = $2dff1c3b98c2ac71$var$Children;
$2dff1c3b98c2ac71$export$16fa2f45be04daa8 = $2dff1c3b98c2ac71$var$Component;
$2dff1c3b98c2ac71$export$ffb0004e005737fa = $2dff1c3b98c2ac71$var$REACT_FRAGMENT_TYPE;
$2dff1c3b98c2ac71$export$e2c29f18771995cb = $2dff1c3b98c2ac71$var$REACT_PROFILER_TYPE;
$2dff1c3b98c2ac71$export$221d75b3f55bb0bd = $2dff1c3b98c2ac71$var$PureComponent;
$2dff1c3b98c2ac71$export$5f8d39834fd61797 = $2dff1c3b98c2ac71$var$REACT_STRICT_MODE_TYPE;
$2dff1c3b98c2ac71$export$74bf444e3cd11ea5 = $2dff1c3b98c2ac71$var$REACT_SUSPENSE_TYPE;
$2dff1c3b98c2ac71$export$1ced07cd6b1985ce = $2dff1c3b98c2ac71$var$ReactSharedInternals;
$2dff1c3b98c2ac71$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$2dff1c3b98c2ac71$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$2dff1c3b98c2ac71$export$8c538325882c7eec = function() {
    return null;
};
$2dff1c3b98c2ac71$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $2dff1c3b98c2ac71$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$2dff1c3b98c2ac71$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $2dff1c3b98c2ac71$var$ReactElement(element.type, key, props);
};
$2dff1c3b98c2ac71$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$2dff1c3b98c2ac71$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$2dff1c3b98c2ac71$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $2dff1c3b98c2ac71$var$ReactElement(type, key, props);
};
$2dff1c3b98c2ac71$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$2dff1c3b98c2ac71$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$2dff1c3b98c2ac71$export$a8257692ac88316c = $2dff1c3b98c2ac71$var$isValidElement;
$2dff1c3b98c2ac71$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $2dff1c3b98c2ac71$var$lazyInitializer
    };
};
$2dff1c3b98c2ac71$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $2dff1c3b98c2ac71$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$2dff1c3b98c2ac71$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $2dff1c3b98c2ac71$var$ReactSharedInternals.T, currentTransition = {};
    $2dff1c3b98c2ac71$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $2dff1c3b98c2ac71$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($2dff1c3b98c2ac71$var$noop, $2dff1c3b98c2ac71$var$reportGlobalError);
    } catch (error) {
        $2dff1c3b98c2ac71$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2dff1c3b98c2ac71$var$ReactSharedInternals.T = prevTransition;
    }
};
$2dff1c3b98c2ac71$export$f93f40ac0ca7e3a8 = function() {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useCacheRefresh();
};
$2dff1c3b98c2ac71$export$1f96ae73734a86cc = function(usable) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.use(usable);
};
$2dff1c3b98c2ac71$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$2dff1c3b98c2ac71$export$35808ee640e87ca7 = function(callback, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$2dff1c3b98c2ac71$export$fae74005e78b1a27 = function(Context) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useContext(Context);
};
$2dff1c3b98c2ac71$export$dc8fbce3eb94dc1e = function() {};
$2dff1c3b98c2ac71$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$2dff1c3b98c2ac71$export$6d9c69b0de29b591 = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useEffect(create, deps);
};
$2dff1c3b98c2ac71$export$7f54fc3180508a52 = function(callback) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$2dff1c3b98c2ac71$export$f680877a34711e37 = function() {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useId();
};
$2dff1c3b98c2ac71$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$2dff1c3b98c2ac71$export$aaabe4eda9ed9969 = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$2dff1c3b98c2ac71$export$e5c5a5f917a5871c = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$2dff1c3b98c2ac71$export$1538c33de8887b59 = function(create, deps) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useMemo(create, deps);
};
$2dff1c3b98c2ac71$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$2dff1c3b98c2ac71$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$2dff1c3b98c2ac71$export$b8f5890fc79d6aca = function(initialValue) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useRef(initialValue);
};
$2dff1c3b98c2ac71$export$60241385465d0a34 = function(initialState) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useState(initialState);
};
$2dff1c3b98c2ac71$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$2dff1c3b98c2ac71$export$7b286972b8d8ccbf = function() {
    return $2dff1c3b98c2ac71$var$ReactSharedInternals.H.useTransition();
};
$2dff1c3b98c2ac71$export$83d89fbfd8236492 = "19.2.0";

});

parcelRegister("hoNSH", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $caab5ef096c4d11c$export$2b8d127b894957b9, (v) => $caab5ef096c4d11c$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $caab5ef096c4d11c$export$cea3a54a6425200c, (v) => $caab5ef096c4d11c$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $caab5ef096c4d11c$export$a7c73072b1a182ae, (v) => $caab5ef096c4d11c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $caab5ef096c4d11c$export$9f27bc3417b4524d, (v) => $caab5ef096c4d11c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $caab5ef096c4d11c$export$db77ccec0bb4ccac, (v) => $caab5ef096c4d11c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $caab5ef096c4d11c$export$8392c0c9d3dcbd35, (v) => $caab5ef096c4d11c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $caab5ef096c4d11c$export$ffb0004e005737fa, (v) => $caab5ef096c4d11c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $caab5ef096c4d11c$export$b624eff549462981, (v) => $caab5ef096c4d11c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $caab5ef096c4d11c$export$7897aa7841a5380c, (v) => $caab5ef096c4d11c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $caab5ef096c4d11c$export$602eac185826482c, (v) => $caab5ef096c4d11c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $caab5ef096c4d11c$export$e2c29f18771995cb, (v) => $caab5ef096c4d11c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $caab5ef096c4d11c$export$5f8d39834fd61797, (v) => $caab5ef096c4d11c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $caab5ef096c4d11c$export$74bf444e3cd11ea5, (v) => $caab5ef096c4d11c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $caab5ef096c4d11c$export$92387174baf9b227, (v) => $caab5ef096c4d11c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $caab5ef096c4d11c$export$ec112efeb987d9c6, (v) => $caab5ef096c4d11c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $caab5ef096c4d11c$export$b706b080d889d2c9, (v) => $caab5ef096c4d11c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $caab5ef096c4d11c$export$5be5a87408f70ddc, (v) => $caab5ef096c4d11c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $caab5ef096c4d11c$export$45a5e7f76e0caa8d, (v) => $caab5ef096c4d11c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $caab5ef096c4d11c$export$455c2e768291efa6, (v) => $caab5ef096c4d11c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $caab5ef096c4d11c$export$9522e17588c12572, (v) => $caab5ef096c4d11c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $caab5ef096c4d11c$export$2110ac352bb060b9, (v) => $caab5ef096c4d11c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $caab5ef096c4d11c$export$56885ab8b9c456ab, (v) => $caab5ef096c4d11c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $caab5ef096c4d11c$export$d927fcb6adf8f9de, (v) => $caab5ef096c4d11c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $caab5ef096c4d11c$export$b82d16f27459e05a, (v) => $caab5ef096c4d11c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $caab5ef096c4d11c$export$522c17b4f5e123e8, (v) => $caab5ef096c4d11c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $caab5ef096c4d11c$export$1aabd8a0274ecfd6, (v) => $caab5ef096c4d11c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $caab5ef096c4d11c$export$9b621391a187a31a, (v) => $caab5ef096c4d11c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $caab5ef096c4d11c$export$f5bbd400c2f4426f, (v) => $caab5ef096c4d11c$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $caab5ef096c4d11c$export$2b8d127b894957b9;
var $caab5ef096c4d11c$export$cea3a54a6425200c;
var $caab5ef096c4d11c$export$a7c73072b1a182ae;
var $caab5ef096c4d11c$export$9f27bc3417b4524d;
var $caab5ef096c4d11c$export$db77ccec0bb4ccac;
var $caab5ef096c4d11c$export$8392c0c9d3dcbd35;
var $caab5ef096c4d11c$export$ffb0004e005737fa;
var $caab5ef096c4d11c$export$b624eff549462981;
var $caab5ef096c4d11c$export$7897aa7841a5380c;
var $caab5ef096c4d11c$export$602eac185826482c;
var $caab5ef096c4d11c$export$e2c29f18771995cb;
var $caab5ef096c4d11c$export$5f8d39834fd61797;
var $caab5ef096c4d11c$export$74bf444e3cd11ea5;
var $caab5ef096c4d11c$export$92387174baf9b227;
var $caab5ef096c4d11c$export$ec112efeb987d9c6;
var $caab5ef096c4d11c$export$b706b080d889d2c9;
var $caab5ef096c4d11c$export$5be5a87408f70ddc;
var $caab5ef096c4d11c$export$45a5e7f76e0caa8d;
var $caab5ef096c4d11c$export$455c2e768291efa6;
var $caab5ef096c4d11c$export$9522e17588c12572;
var $caab5ef096c4d11c$export$2110ac352bb060b9;
var $caab5ef096c4d11c$export$56885ab8b9c456ab;
var $caab5ef096c4d11c$export$d927fcb6adf8f9de;
var $caab5ef096c4d11c$export$b82d16f27459e05a;
var $caab5ef096c4d11c$export$522c17b4f5e123e8;
var $caab5ef096c4d11c$export$1aabd8a0274ecfd6;
var $caab5ef096c4d11c$export$9b621391a187a31a;
var $caab5ef096c4d11c$export$f5bbd400c2f4426f;
'use strict';
var $caab5ef096c4d11c$var$b = "function" === typeof Symbol && Symbol.for, $caab5ef096c4d11c$var$c = $caab5ef096c4d11c$var$b ? Symbol.for("react.element") : 60103, $caab5ef096c4d11c$var$d = $caab5ef096c4d11c$var$b ? Symbol.for("react.portal") : 60106, $caab5ef096c4d11c$var$e = $caab5ef096c4d11c$var$b ? Symbol.for("react.fragment") : 60107, $caab5ef096c4d11c$var$f = $caab5ef096c4d11c$var$b ? Symbol.for("react.strict_mode") : 60108, $caab5ef096c4d11c$var$g = $caab5ef096c4d11c$var$b ? Symbol.for("react.profiler") : 60114, $caab5ef096c4d11c$var$h = $caab5ef096c4d11c$var$b ? Symbol.for("react.provider") : 60109, $caab5ef096c4d11c$var$k = $caab5ef096c4d11c$var$b ? Symbol.for("react.context") : 60110, $caab5ef096c4d11c$var$l = $caab5ef096c4d11c$var$b ? Symbol.for("react.async_mode") : 60111, $caab5ef096c4d11c$var$m = $caab5ef096c4d11c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $caab5ef096c4d11c$var$n = $caab5ef096c4d11c$var$b ? Symbol.for("react.forward_ref") : 60112, $caab5ef096c4d11c$var$p = $caab5ef096c4d11c$var$b ? Symbol.for("react.suspense") : 60113, $caab5ef096c4d11c$var$q = $caab5ef096c4d11c$var$b ? Symbol.for("react.suspense_list") : 60120, $caab5ef096c4d11c$var$r = $caab5ef096c4d11c$var$b ? Symbol.for("react.memo") : 60115, $caab5ef096c4d11c$var$t = $caab5ef096c4d11c$var$b ? Symbol.for("react.lazy") : 60116, $caab5ef096c4d11c$var$v = $caab5ef096c4d11c$var$b ? Symbol.for("react.block") : 60121, $caab5ef096c4d11c$var$w = $caab5ef096c4d11c$var$b ? Symbol.for("react.fundamental") : 60117, $caab5ef096c4d11c$var$x = $caab5ef096c4d11c$var$b ? Symbol.for("react.responder") : 60118, $caab5ef096c4d11c$var$y = $caab5ef096c4d11c$var$b ? Symbol.for("react.scope") : 60119;
function $caab5ef096c4d11c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $caab5ef096c4d11c$var$c:
                switch(a = a.type, a){
                    case $caab5ef096c4d11c$var$l:
                    case $caab5ef096c4d11c$var$m:
                    case $caab5ef096c4d11c$var$e:
                    case $caab5ef096c4d11c$var$g:
                    case $caab5ef096c4d11c$var$f:
                    case $caab5ef096c4d11c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $caab5ef096c4d11c$var$k:
                            case $caab5ef096c4d11c$var$n:
                            case $caab5ef096c4d11c$var$t:
                            case $caab5ef096c4d11c$var$r:
                            case $caab5ef096c4d11c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $caab5ef096c4d11c$var$d:
                return u;
        }
    }
}
function $caab5ef096c4d11c$var$A(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$m;
}
$caab5ef096c4d11c$export$2b8d127b894957b9 = $caab5ef096c4d11c$var$l;
$caab5ef096c4d11c$export$cea3a54a6425200c = $caab5ef096c4d11c$var$m;
$caab5ef096c4d11c$export$a7c73072b1a182ae = $caab5ef096c4d11c$var$k;
$caab5ef096c4d11c$export$9f27bc3417b4524d = $caab5ef096c4d11c$var$h;
$caab5ef096c4d11c$export$db77ccec0bb4ccac = $caab5ef096c4d11c$var$c;
$caab5ef096c4d11c$export$8392c0c9d3dcbd35 = $caab5ef096c4d11c$var$n;
$caab5ef096c4d11c$export$ffb0004e005737fa = $caab5ef096c4d11c$var$e;
$caab5ef096c4d11c$export$b624eff549462981 = $caab5ef096c4d11c$var$t;
$caab5ef096c4d11c$export$7897aa7841a5380c = $caab5ef096c4d11c$var$r;
$caab5ef096c4d11c$export$602eac185826482c = $caab5ef096c4d11c$var$d;
$caab5ef096c4d11c$export$e2c29f18771995cb = $caab5ef096c4d11c$var$g;
$caab5ef096c4d11c$export$5f8d39834fd61797 = $caab5ef096c4d11c$var$f;
$caab5ef096c4d11c$export$74bf444e3cd11ea5 = $caab5ef096c4d11c$var$p;
$caab5ef096c4d11c$export$92387174baf9b227 = function(a) {
    return $caab5ef096c4d11c$var$A(a) || $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$l;
};
$caab5ef096c4d11c$export$ec112efeb987d9c6 = $caab5ef096c4d11c$var$A;
$caab5ef096c4d11c$export$b706b080d889d2c9 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$k;
};
$caab5ef096c4d11c$export$5be5a87408f70ddc = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$h;
};
$caab5ef096c4d11c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $caab5ef096c4d11c$var$c;
};
$caab5ef096c4d11c$export$455c2e768291efa6 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$n;
};
$caab5ef096c4d11c$export$9522e17588c12572 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$e;
};
$caab5ef096c4d11c$export$2110ac352bb060b9 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$t;
};
$caab5ef096c4d11c$export$56885ab8b9c456ab = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$r;
};
$caab5ef096c4d11c$export$d927fcb6adf8f9de = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$d;
};
$caab5ef096c4d11c$export$b82d16f27459e05a = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$g;
};
$caab5ef096c4d11c$export$522c17b4f5e123e8 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$f;
};
$caab5ef096c4d11c$export$1aabd8a0274ecfd6 = function(a) {
    return $caab5ef096c4d11c$var$z(a) === $caab5ef096c4d11c$var$p;
};
$caab5ef096c4d11c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $caab5ef096c4d11c$var$e || a === $caab5ef096c4d11c$var$m || a === $caab5ef096c4d11c$var$g || a === $caab5ef096c4d11c$var$f || a === $caab5ef096c4d11c$var$p || a === $caab5ef096c4d11c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $caab5ef096c4d11c$var$t || a.$$typeof === $caab5ef096c4d11c$var$r || a.$$typeof === $caab5ef096c4d11c$var$h || a.$$typeof === $caab5ef096c4d11c$var$k || a.$$typeof === $caab5ef096c4d11c$var$n || a.$$typeof === $caab5ef096c4d11c$var$w || a.$$typeof === $caab5ef096c4d11c$var$x || a.$$typeof === $caab5ef096c4d11c$var$y || a.$$typeof === $caab5ef096c4d11c$var$v);
};
$caab5ef096c4d11c$export$f5bbd400c2f4426f = $caab5ef096c4d11c$var$z;

});

parcelRegister("kUzXm", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f394edd4427d52c3$export$882461b6382ed46c, (v) => $f394edd4427d52c3$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f394edd4427d52c3$export$757ceba2d55c277e, (v) => $f394edd4427d52c3$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $f394edd4427d52c3$export$83d89fbfd8236492, (v) => $f394edd4427d52c3$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f394edd4427d52c3$export$882461b6382ed46c;
var $f394edd4427d52c3$export$757ceba2d55c277e;
var $f394edd4427d52c3$export$83d89fbfd8236492;
"use strict";

var $kkkYV = parcelRequire("kkkYV");

var $7pfQ9 = parcelRequire("7pfQ9");

var $3G714 = parcelRequire("3G714");
function $f394edd4427d52c3$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f394edd4427d52c3$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $f394edd4427d52c3$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $f394edd4427d52c3$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $f394edd4427d52c3$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $f394edd4427d52c3$var$assertIsMounted(fiber) {
    if ($f394edd4427d52c3$var$getNearestMountedFiber(fiber) !== fiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
}
function $f394edd4427d52c3$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $f394edd4427d52c3$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $f394edd4427d52c3$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $f394edd4427d52c3$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $f394edd4427d52c3$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $f394edd4427d52c3$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $f394edd4427d52c3$var$assign = Object.assign, $f394edd4427d52c3$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $f394edd4427d52c3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f394edd4427d52c3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f394edd4427d52c3$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f394edd4427d52c3$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f394edd4427d52c3$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f394edd4427d52c3$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f394edd4427d52c3$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f394edd4427d52c3$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $f394edd4427d52c3$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $f394edd4427d52c3$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f394edd4427d52c3$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f394edd4427d52c3$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f394edd4427d52c3$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f394edd4427d52c3$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f394edd4427d52c3$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $f394edd4427d52c3$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $f394edd4427d52c3$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $f394edd4427d52c3$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $f394edd4427d52c3$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $f394edd4427d52c3$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $f394edd4427d52c3$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $f394edd4427d52c3$var$getComponentNameFromType(type.type) || "Memo";
        case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $f394edd4427d52c3$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $f394edd4427d52c3$var$isArrayImpl = Array.isArray, $f394edd4427d52c3$var$ReactSharedInternals = $7pfQ9.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f394edd4427d52c3$var$ReactDOMSharedInternals = $3G714.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f394edd4427d52c3$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $f394edd4427d52c3$var$valueStack = [], $f394edd4427d52c3$var$index = -1;
function $f394edd4427d52c3$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $f394edd4427d52c3$var$pop(cursor) {
    0 > $f394edd4427d52c3$var$index || (cursor.current = $f394edd4427d52c3$var$valueStack[$f394edd4427d52c3$var$index], $f394edd4427d52c3$var$valueStack[$f394edd4427d52c3$var$index] = null, $f394edd4427d52c3$var$index--);
}
function $f394edd4427d52c3$var$push(cursor, value) {
    $f394edd4427d52c3$var$index++;
    $f394edd4427d52c3$var$valueStack[$f394edd4427d52c3$var$index] = cursor.current;
    cursor.current = value;
}
var $f394edd4427d52c3$var$contextStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$contextFiberStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$rootInstanceStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$hostTransitionProviderCursor = $f394edd4427d52c3$var$createCursor(null);
function $f394edd4427d52c3$var$pushHostContainer(fiber, nextRootInstance) {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$rootInstanceStackCursor, nextRootInstance);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextFiberStackCursor, fiber);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $f394edd4427d52c3$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $f394edd4427d52c3$var$getOwnHostContext(nextRootInstance), fiber = $f394edd4427d52c3$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextStackCursor);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextStackCursor, fiber);
}
function $f394edd4427d52c3$var$popHostContainer() {
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextStackCursor);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextFiberStackCursor);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$rootInstanceStackCursor);
}
function $f394edd4427d52c3$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $f394edd4427d52c3$var$push($f394edd4427d52c3$var$hostTransitionProviderCursor, fiber);
    var context = $f394edd4427d52c3$var$contextStackCursor.current;
    var JSCompiler_inline_result = $f394edd4427d52c3$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextFiberStackCursor, fiber), $f394edd4427d52c3$var$push($f394edd4427d52c3$var$contextStackCursor, JSCompiler_inline_result));
}
function $f394edd4427d52c3$var$popHostContext(fiber) {
    $f394edd4427d52c3$var$contextFiberStackCursor.current === fiber && ($f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextStackCursor), $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$contextFiberStackCursor));
    $f394edd4427d52c3$var$hostTransitionProviderCursor.current === fiber && ($f394edd4427d52c3$var$pop($f394edd4427d52c3$var$hostTransitionProviderCursor), $f394edd4427d52c3$var$HostTransitionContext._currentValue = $f394edd4427d52c3$var$sharedNotPendingObject);
}
var $f394edd4427d52c3$var$prefix, $f394edd4427d52c3$var$suffix;
function $f394edd4427d52c3$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $f394edd4427d52c3$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $f394edd4427d52c3$var$prefix = match && match[1] || "";
        $f394edd4427d52c3$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $f394edd4427d52c3$var$prefix + name + $f394edd4427d52c3$var$suffix;
}
var $f394edd4427d52c3$var$reentry = !1;
function $f394edd4427d52c3$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $f394edd4427d52c3$var$reentry) return "";
    $f394edd4427d52c3$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $f394edd4427d52c3$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $f394edd4427d52c3$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $f394edd4427d52c3$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $f394edd4427d52c3$var$describeBuiltInComponentFrame("Suspense Fallback") : $f394edd4427d52c3$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $f394edd4427d52c3$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $f394edd4427d52c3$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $f394edd4427d52c3$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $f394edd4427d52c3$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $f394edd4427d52c3$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $f394edd4427d52c3$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $f394edd4427d52c3$var$hasOwnProperty = Object.prototype.hasOwnProperty, $f394edd4427d52c3$var$scheduleCallback$3 = $kkkYV.unstable_scheduleCallback, $f394edd4427d52c3$var$cancelCallback$1 = $kkkYV.unstable_cancelCallback, $f394edd4427d52c3$var$shouldYield = $kkkYV.unstable_shouldYield, $f394edd4427d52c3$var$requestPaint = $kkkYV.unstable_requestPaint, $f394edd4427d52c3$var$now = $kkkYV.unstable_now, $f394edd4427d52c3$var$getCurrentPriorityLevel = $kkkYV.unstable_getCurrentPriorityLevel, $f394edd4427d52c3$var$ImmediatePriority = $kkkYV.unstable_ImmediatePriority, $f394edd4427d52c3$var$UserBlockingPriority = $kkkYV.unstable_UserBlockingPriority, $f394edd4427d52c3$var$NormalPriority$1 = $kkkYV.unstable_NormalPriority, $f394edd4427d52c3$var$LowPriority = $kkkYV.unstable_LowPriority, $f394edd4427d52c3$var$IdlePriority = $kkkYV.unstable_IdlePriority, $f394edd4427d52c3$var$log$1 = $kkkYV.log, $f394edd4427d52c3$var$unstable_setDisableYieldValue = $kkkYV.unstable_setDisableYieldValue, $f394edd4427d52c3$var$rendererID = null, $f394edd4427d52c3$var$injectedHook = null;
function $f394edd4427d52c3$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $f394edd4427d52c3$var$log$1 && $f394edd4427d52c3$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.setStrictMode) try {
        $f394edd4427d52c3$var$injectedHook.setStrictMode($f394edd4427d52c3$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $f394edd4427d52c3$var$clz32 = Math.clz32 ? Math.clz32 : $f394edd4427d52c3$var$clz32Fallback, $f394edd4427d52c3$var$log = Math.log, $f394edd4427d52c3$var$LN2 = Math.LN2;
function $f394edd4427d52c3$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($f394edd4427d52c3$var$log(x) / $f394edd4427d52c3$var$LN2 | 0) | 0;
}
var $f394edd4427d52c3$var$nextTransitionUpdateLane = 256, $f394edd4427d52c3$var$nextTransitionDeferredLane = 262144, $f394edd4427d52c3$var$nextRetryLane = 4194304;
function $f394edd4427d52c3$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $f394edd4427d52c3$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f394edd4427d52c3$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $f394edd4427d52c3$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f394edd4427d52c3$var$claimNextRetryLane() {
    var lane = $f394edd4427d52c3$var$nextRetryLane;
    $f394edd4427d52c3$var$nextRetryLane <<= 1;
    0 === ($f394edd4427d52c3$var$nextRetryLane & 62914560) && ($f394edd4427d52c3$var$nextRetryLane = 4194304);
    return lane;
}
function $f394edd4427d52c3$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $f394edd4427d52c3$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $f394edd4427d52c3$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $f394edd4427d52c3$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $f394edd4427d52c3$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $f394edd4427d52c3$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $f394edd4427d52c3$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $f394edd4427d52c3$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $f394edd4427d52c3$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $f394edd4427d52c3$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $f394edd4427d52c3$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $f394edd4427d52c3$var$resolveUpdatePriority() {
    var updatePriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $f394edd4427d52c3$var$getEventPriority(updatePriority.type);
}
function $f394edd4427d52c3$var$runWithPriority(priority, fn) {
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        return $f394edd4427d52c3$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $f394edd4427d52c3$var$randomKey = Math.random().toString(36).slice(2), $f394edd4427d52c3$var$internalInstanceKey = "__reactFiber$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalPropsKey = "__reactProps$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalContainerInstanceKey = "__reactContainer$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalEventHandlersKey = "__reactEvents$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalEventHandlerListenersKey = "__reactListeners$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalEventHandlesSetKey = "__reactHandles$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalRootNodeResourcesKey = "__reactResources$" + $f394edd4427d52c3$var$randomKey, $f394edd4427d52c3$var$internalHoistableMarker = "__reactMarker$" + $f394edd4427d52c3$var$randomKey;
function $f394edd4427d52c3$var$detachDeletedInstance(node) {
    delete node[$f394edd4427d52c3$var$internalInstanceKey];
    delete node[$f394edd4427d52c3$var$internalPropsKey];
    delete node[$f394edd4427d52c3$var$internalEventHandlersKey];
    delete node[$f394edd4427d52c3$var$internalEventHandlerListenersKey];
    delete node[$f394edd4427d52c3$var$internalEventHandlesSetKey];
}
function $f394edd4427d52c3$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$f394edd4427d52c3$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$f394edd4427d52c3$var$internalContainerInstanceKey] || parentNode[$f394edd4427d52c3$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $f394edd4427d52c3$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$f394edd4427d52c3$var$internalInstanceKey]) return parentNode;
                targetNode = $f394edd4427d52c3$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $f394edd4427d52c3$var$getInstanceFromNode(node) {
    if (node = node[$f394edd4427d52c3$var$internalInstanceKey] || node[$f394edd4427d52c3$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $f394edd4427d52c3$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(33));
}
function $f394edd4427d52c3$var$getResourcesFromRoot(root) {
    var resources = root[$f394edd4427d52c3$var$internalRootNodeResourcesKey];
    resources || (resources = root[$f394edd4427d52c3$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $f394edd4427d52c3$var$markNodeAsHoistable(node) {
    node[$f394edd4427d52c3$var$internalHoistableMarker] = !0;
}
var $f394edd4427d52c3$var$allNativeEvents = new Set(), $f394edd4427d52c3$var$registrationNameDependencies = {};
function $f394edd4427d52c3$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $f394edd4427d52c3$var$registerDirectEvent(registrationName, dependencies);
    $f394edd4427d52c3$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $f394edd4427d52c3$var$registerDirectEvent(registrationName, dependencies) {
    $f394edd4427d52c3$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$f394edd4427d52c3$var$allNativeEvents.add(dependencies[registrationName]);
}
var $f394edd4427d52c3$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $f394edd4427d52c3$var$illegalAttributeNameCache = {}, $f394edd4427d52c3$var$validatedAttributeNameCache = {};
function $f394edd4427d52c3$var$isAttributeNameSafe(attributeName) {
    if ($f394edd4427d52c3$var$hasOwnProperty.call($f394edd4427d52c3$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($f394edd4427d52c3$var$hasOwnProperty.call($f394edd4427d52c3$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($f394edd4427d52c3$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $f394edd4427d52c3$var$validatedAttributeNameCache[attributeName] = !0;
    $f394edd4427d52c3$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $f394edd4427d52c3$var$setValueForAttribute(node, name, value) {
    if ($f394edd4427d52c3$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $f394edd4427d52c3$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $f394edd4427d52c3$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $f394edd4427d52c3$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $f394edd4427d52c3$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $f394edd4427d52c3$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $f394edd4427d52c3$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $f394edd4427d52c3$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $f394edd4427d52c3$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $f394edd4427d52c3$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $f394edd4427d52c3$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $f394edd4427d52c3$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $f394edd4427d52c3$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $f394edd4427d52c3$var$getToStringValue(value);
        } else element.value !== "" + $f394edd4427d52c3$var$getToStringValue(value) && (element.value = "" + $f394edd4427d52c3$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $f394edd4427d52c3$var$setDefaultValue(element, type, $f394edd4427d52c3$var$getToStringValue(value)) : null != defaultValue ? $f394edd4427d52c3$var$setDefaultValue(element, type, $f394edd4427d52c3$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $f394edd4427d52c3$var$getToStringValue(name) : element.removeAttribute("name");
}
function $f394edd4427d52c3$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $f394edd4427d52c3$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $f394edd4427d52c3$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $f394edd4427d52c3$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $f394edd4427d52c3$var$track(element);
}
function $f394edd4427d52c3$var$setDefaultValue(node, type, value) {
    "number" === type && $f394edd4427d52c3$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $f394edd4427d52c3$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $f394edd4427d52c3$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $f394edd4427d52c3$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $f394edd4427d52c3$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $f394edd4427d52c3$var$getToStringValue(defaultValue) : "";
}
function $f394edd4427d52c3$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(92));
            if ($f394edd4427d52c3$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $f394edd4427d52c3$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $f394edd4427d52c3$var$track(element);
}
function $f394edd4427d52c3$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $f394edd4427d52c3$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $f394edd4427d52c3$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $f394edd4427d52c3$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $f394edd4427d52c3$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $f394edd4427d52c3$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $f394edd4427d52c3$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $f394edd4427d52c3$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f394edd4427d52c3$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $f394edd4427d52c3$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $f394edd4427d52c3$var$sanitizeURL(url) {
    return $f394edd4427d52c3$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $f394edd4427d52c3$var$noop$1() {}
var $f394edd4427d52c3$var$currentReplayingEvent = null;
function $f394edd4427d52c3$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $f394edd4427d52c3$var$restoreTarget = null, $f394edd4427d52c3$var$restoreQueue = null;
function $f394edd4427d52c3$var$restoreStateOfTarget(target) {
    var internalInstance = $f394edd4427d52c3$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$f394edd4427d52c3$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $f394edd4427d52c3$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$f394edd4427d52c3$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(90));
                            $f394edd4427d52c3$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $f394edd4427d52c3$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $f394edd4427d52c3$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $f394edd4427d52c3$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $f394edd4427d52c3$var$isInsideEventHandler = !1;
function $f394edd4427d52c3$var$batchedUpdates$1(fn, a, b) {
    if ($f394edd4427d52c3$var$isInsideEventHandler) return fn(a, b);
    $f394edd4427d52c3$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($f394edd4427d52c3$var$isInsideEventHandler = !1, null !== $f394edd4427d52c3$var$restoreTarget || null !== $f394edd4427d52c3$var$restoreQueue) {
            if ($f394edd4427d52c3$var$flushSyncWork$1(), $f394edd4427d52c3$var$restoreTarget && (a = $f394edd4427d52c3$var$restoreTarget, fn = $f394edd4427d52c3$var$restoreQueue, $f394edd4427d52c3$var$restoreQueue = $f394edd4427d52c3$var$restoreTarget = null, $f394edd4427d52c3$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$f394edd4427d52c3$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $f394edd4427d52c3$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$f394edd4427d52c3$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $f394edd4427d52c3$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f394edd4427d52c3$var$passiveBrowserEventsSupported = !1;
if ($f394edd4427d52c3$var$canUseDOM) try {
    var $f394edd4427d52c3$var$options = {};
    Object.defineProperty($f394edd4427d52c3$var$options, "passive", {
        get: function() {
            $f394edd4427d52c3$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $f394edd4427d52c3$var$options, $f394edd4427d52c3$var$options);
    window.removeEventListener("test", $f394edd4427d52c3$var$options, $f394edd4427d52c3$var$options);
} catch (e) {
    $f394edd4427d52c3$var$passiveBrowserEventsSupported = !1;
}
var $f394edd4427d52c3$var$root = null, $f394edd4427d52c3$var$startText = null, $f394edd4427d52c3$var$fallbackText = null;
function $f394edd4427d52c3$var$getData() {
    if ($f394edd4427d52c3$var$fallbackText) return $f394edd4427d52c3$var$fallbackText;
    var start, startValue = $f394edd4427d52c3$var$startText, startLength = startValue.length, end, endValue = "value" in $f394edd4427d52c3$var$root ? $f394edd4427d52c3$var$root.value : $f394edd4427d52c3$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $f394edd4427d52c3$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $f394edd4427d52c3$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $f394edd4427d52c3$var$functionThatReturnsTrue() {
    return !0;
}
function $f394edd4427d52c3$var$functionThatReturnsFalse() {
    return !1;
}
function $f394edd4427d52c3$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $f394edd4427d52c3$var$functionThatReturnsTrue : $f394edd4427d52c3$var$functionThatReturnsFalse;
        this.isPropagationStopped = $f394edd4427d52c3$var$functionThatReturnsFalse;
        return this;
    }
    $f394edd4427d52c3$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $f394edd4427d52c3$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $f394edd4427d52c3$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $f394edd4427d52c3$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $f394edd4427d52c3$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f394edd4427d52c3$var$SyntheticEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$EventInterface), $f394edd4427d52c3$var$UIEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    view: 0,
    detail: 0
}), $f394edd4427d52c3$var$SyntheticUIEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$UIEventInterface), $f394edd4427d52c3$var$lastMovementX, $f394edd4427d52c3$var$lastMovementY, $f394edd4427d52c3$var$lastMouseEvent, $f394edd4427d52c3$var$MouseEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f394edd4427d52c3$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $f394edd4427d52c3$var$lastMouseEvent && ($f394edd4427d52c3$var$lastMouseEvent && "mousemove" === event.type ? ($f394edd4427d52c3$var$lastMovementX = event.screenX - $f394edd4427d52c3$var$lastMouseEvent.screenX, $f394edd4427d52c3$var$lastMovementY = event.screenY - $f394edd4427d52c3$var$lastMouseEvent.screenY) : $f394edd4427d52c3$var$lastMovementY = $f394edd4427d52c3$var$lastMovementX = 0, $f394edd4427d52c3$var$lastMouseEvent = event);
        return $f394edd4427d52c3$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $f394edd4427d52c3$var$lastMovementY;
    }
}), $f394edd4427d52c3$var$SyntheticMouseEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$MouseEventInterface), $f394edd4427d52c3$var$DragEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$MouseEventInterface, {
    dataTransfer: 0
}), $f394edd4427d52c3$var$SyntheticDragEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$DragEventInterface), $f394edd4427d52c3$var$FocusEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    relatedTarget: 0
}), $f394edd4427d52c3$var$SyntheticFocusEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$FocusEventInterface), $f394edd4427d52c3$var$AnimationEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f394edd4427d52c3$var$SyntheticAnimationEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$AnimationEventInterface), $f394edd4427d52c3$var$ClipboardEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $f394edd4427d52c3$var$SyntheticClipboardEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$ClipboardEventInterface), $f394edd4427d52c3$var$CompositionEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    data: 0
}), $f394edd4427d52c3$var$SyntheticCompositionEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$CompositionEventInterface), $f394edd4427d52c3$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f394edd4427d52c3$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f394edd4427d52c3$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f394edd4427d52c3$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $f394edd4427d52c3$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $f394edd4427d52c3$var$getEventModifierState() {
    return $f394edd4427d52c3$var$modifierStateGetter;
}
var $f394edd4427d52c3$var$KeyboardEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $f394edd4427d52c3$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $f394edd4427d52c3$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $f394edd4427d52c3$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f394edd4427d52c3$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $f394edd4427d52c3$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $f394edd4427d52c3$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $f394edd4427d52c3$var$SyntheticKeyboardEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$KeyboardEventInterface), $f394edd4427d52c3$var$PointerEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f394edd4427d52c3$var$SyntheticPointerEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$PointerEventInterface), $f394edd4427d52c3$var$TouchEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f394edd4427d52c3$var$getEventModifierState
}), $f394edd4427d52c3$var$SyntheticTouchEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$TouchEventInterface), $f394edd4427d52c3$var$TransitionEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f394edd4427d52c3$var$SyntheticTransitionEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$TransitionEventInterface), $f394edd4427d52c3$var$WheelEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f394edd4427d52c3$var$SyntheticWheelEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$WheelEventInterface), $f394edd4427d52c3$var$ToggleEventInterface = $f394edd4427d52c3$var$assign({}, $f394edd4427d52c3$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $f394edd4427d52c3$var$SyntheticToggleEvent = $f394edd4427d52c3$var$createSyntheticEvent($f394edd4427d52c3$var$ToggleEventInterface), $f394edd4427d52c3$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $f394edd4427d52c3$var$canUseCompositionEvent = $f394edd4427d52c3$var$canUseDOM && "CompositionEvent" in window, $f394edd4427d52c3$var$documentMode = null;
$f394edd4427d52c3$var$canUseDOM && "documentMode" in document && ($f394edd4427d52c3$var$documentMode = document.documentMode);
var $f394edd4427d52c3$var$canUseTextInputEvent = $f394edd4427d52c3$var$canUseDOM && "TextEvent" in window && !$f394edd4427d52c3$var$documentMode, $f394edd4427d52c3$var$useFallbackCompositionData = $f394edd4427d52c3$var$canUseDOM && (!$f394edd4427d52c3$var$canUseCompositionEvent || $f394edd4427d52c3$var$documentMode && 8 < $f394edd4427d52c3$var$documentMode && 11 >= $f394edd4427d52c3$var$documentMode), $f394edd4427d52c3$var$SPACEBAR_CHAR = String.fromCharCode(32), $f394edd4427d52c3$var$hasSpaceKeypress = !1;
function $f394edd4427d52c3$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $f394edd4427d52c3$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f394edd4427d52c3$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $f394edd4427d52c3$var$isComposing = !1;
function $f394edd4427d52c3$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $f394edd4427d52c3$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $f394edd4427d52c3$var$hasSpaceKeypress = !0;
            return $f394edd4427d52c3$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $f394edd4427d52c3$var$SPACEBAR_CHAR && $f394edd4427d52c3$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $f394edd4427d52c3$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($f394edd4427d52c3$var$isComposing) return "compositionend" === domEventName || !$f394edd4427d52c3$var$canUseCompositionEvent && $f394edd4427d52c3$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $f394edd4427d52c3$var$getData(), $f394edd4427d52c3$var$fallbackText = $f394edd4427d52c3$var$startText = $f394edd4427d52c3$var$root = null, $f394edd4427d52c3$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $f394edd4427d52c3$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $f394edd4427d52c3$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f394edd4427d52c3$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$f394edd4427d52c3$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $f394edd4427d52c3$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $f394edd4427d52c3$var$restoreTarget ? $f394edd4427d52c3$var$restoreQueue ? $f394edd4427d52c3$var$restoreQueue.push(target) : $f394edd4427d52c3$var$restoreQueue = [
        target
    ] : $f394edd4427d52c3$var$restoreTarget = target;
    inst = $f394edd4427d52c3$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $f394edd4427d52c3$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $f394edd4427d52c3$var$activeElement$1 = null, $f394edd4427d52c3$var$activeElementInst$1 = null;
function $f394edd4427d52c3$var$runEventInBatch(dispatchQueue) {
    $f394edd4427d52c3$var$processDispatchQueue(dispatchQueue, 0);
}
function $f394edd4427d52c3$var$getInstIfValueChanged(targetInst) {
    var targetNode = $f394edd4427d52c3$var$getNodeFromInstance(targetInst);
    if ($f394edd4427d52c3$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $f394edd4427d52c3$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $f394edd4427d52c3$var$isInputEventSupported = !1;
if ($f394edd4427d52c3$var$canUseDOM) {
    var $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286;
    if ($f394edd4427d52c3$var$canUseDOM) {
        var $f394edd4427d52c3$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$f394edd4427d52c3$var$isSupported$jscomp$inline_427) {
            var $f394edd4427d52c3$var$element$jscomp$inline_428 = document.createElement("div");
            $f394edd4427d52c3$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $f394edd4427d52c3$var$isSupported$jscomp$inline_427 = "function" === typeof $f394edd4427d52c3$var$element$jscomp$inline_428.oninput;
        }
        $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286 = $f394edd4427d52c3$var$isSupported$jscomp$inline_427;
    } else $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286 = !1;
    $f394edd4427d52c3$var$isInputEventSupported = $f394edd4427d52c3$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $f394edd4427d52c3$var$stopWatchingForValueChange() {
    $f394edd4427d52c3$var$activeElement$1 && ($f394edd4427d52c3$var$activeElement$1.detachEvent("onpropertychange", $f394edd4427d52c3$var$handlePropertyChange), $f394edd4427d52c3$var$activeElementInst$1 = $f394edd4427d52c3$var$activeElement$1 = null);
}
function $f394edd4427d52c3$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $f394edd4427d52c3$var$getInstIfValueChanged($f394edd4427d52c3$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $f394edd4427d52c3$var$createAndAccumulateChangeEvent(dispatchQueue, $f394edd4427d52c3$var$activeElementInst$1, nativeEvent, $f394edd4427d52c3$var$getEventTarget(nativeEvent));
        $f394edd4427d52c3$var$batchedUpdates$1($f394edd4427d52c3$var$runEventInBatch, dispatchQueue);
    }
}
function $f394edd4427d52c3$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($f394edd4427d52c3$var$stopWatchingForValueChange(), $f394edd4427d52c3$var$activeElement$1 = target, $f394edd4427d52c3$var$activeElementInst$1 = targetInst, $f394edd4427d52c3$var$activeElement$1.attachEvent("onpropertychange", $f394edd4427d52c3$var$handlePropertyChange)) : "focusout" === domEventName && $f394edd4427d52c3$var$stopWatchingForValueChange();
}
function $f394edd4427d52c3$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $f394edd4427d52c3$var$getInstIfValueChanged($f394edd4427d52c3$var$activeElementInst$1);
}
function $f394edd4427d52c3$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $f394edd4427d52c3$var$getInstIfValueChanged(targetInst);
}
function $f394edd4427d52c3$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $f394edd4427d52c3$var$getInstIfValueChanged(targetInst);
}
function $f394edd4427d52c3$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f394edd4427d52c3$var$objectIs = "function" === typeof Object.is ? Object.is : $f394edd4427d52c3$var$is;
function $f394edd4427d52c3$var$shallowEqual(objA, objB) {
    if ($f394edd4427d52c3$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$f394edd4427d52c3$var$hasOwnProperty.call(objB, currentKey) || !$f394edd4427d52c3$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $f394edd4427d52c3$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $f394edd4427d52c3$var$getNodeForCharacterOffset(root, offset) {
    var node = $f394edd4427d52c3$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $f394edd4427d52c3$var$getLeafNode(node);
    }
}
function $f394edd4427d52c3$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $f394edd4427d52c3$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $f394edd4427d52c3$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $f394edd4427d52c3$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $f394edd4427d52c3$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $f394edd4427d52c3$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $f394edd4427d52c3$var$skipSelectionChangeEvent = $f394edd4427d52c3$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $f394edd4427d52c3$var$activeElement = null, $f394edd4427d52c3$var$activeElementInst = null, $f394edd4427d52c3$var$lastSelection = null, $f394edd4427d52c3$var$mouseDown = !1;
function $f394edd4427d52c3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $f394edd4427d52c3$var$mouseDown || null == $f394edd4427d52c3$var$activeElement || $f394edd4427d52c3$var$activeElement !== $f394edd4427d52c3$var$getActiveElement(doc) || (doc = $f394edd4427d52c3$var$activeElement, "selectionStart" in doc && $f394edd4427d52c3$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $f394edd4427d52c3$var$lastSelection && $f394edd4427d52c3$var$shallowEqual($f394edd4427d52c3$var$lastSelection, doc) || ($f394edd4427d52c3$var$lastSelection = doc, doc = $f394edd4427d52c3$var$accumulateTwoPhaseListeners($f394edd4427d52c3$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $f394edd4427d52c3$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $f394edd4427d52c3$var$activeElement)));
}
function $f394edd4427d52c3$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $f394edd4427d52c3$var$vendorPrefixes = {
    animationend: $f394edd4427d52c3$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $f394edd4427d52c3$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $f394edd4427d52c3$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $f394edd4427d52c3$var$makePrefixMap("Transition", "TransitionEnd")
}, $f394edd4427d52c3$var$prefixedEventNames = {}, $f394edd4427d52c3$var$style = {};
$f394edd4427d52c3$var$canUseDOM && ($f394edd4427d52c3$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $f394edd4427d52c3$var$vendorPrefixes.animationend.animation, delete $f394edd4427d52c3$var$vendorPrefixes.animationiteration.animation, delete $f394edd4427d52c3$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $f394edd4427d52c3$var$vendorPrefixes.transitionend.transition);
function $f394edd4427d52c3$var$getVendorPrefixedEventName(eventName) {
    if ($f394edd4427d52c3$var$prefixedEventNames[eventName]) return $f394edd4427d52c3$var$prefixedEventNames[eventName];
    if (!$f394edd4427d52c3$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $f394edd4427d52c3$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $f394edd4427d52c3$var$style) return $f394edd4427d52c3$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $f394edd4427d52c3$var$ANIMATION_END = $f394edd4427d52c3$var$getVendorPrefixedEventName("animationend"), $f394edd4427d52c3$var$ANIMATION_ITERATION = $f394edd4427d52c3$var$getVendorPrefixedEventName("animationiteration"), $f394edd4427d52c3$var$ANIMATION_START = $f394edd4427d52c3$var$getVendorPrefixedEventName("animationstart"), $f394edd4427d52c3$var$TRANSITION_RUN = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitionrun"), $f394edd4427d52c3$var$TRANSITION_START = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitionstart"), $f394edd4427d52c3$var$TRANSITION_CANCEL = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitioncancel"), $f394edd4427d52c3$var$TRANSITION_END = $f394edd4427d52c3$var$getVendorPrefixedEventName("transitionend"), $f394edd4427d52c3$var$topLevelEventsToReactNames = new Map(), $f394edd4427d52c3$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$f394edd4427d52c3$var$simpleEventPluginEvents.push("scrollEnd");
function $f394edd4427d52c3$var$registerSimpleEvent(domEventName, reactName) {
    $f394edd4427d52c3$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $f394edd4427d52c3$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $f394edd4427d52c3$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $f394edd4427d52c3$var$concurrentQueues = [], $f394edd4427d52c3$var$concurrentQueuesIndex = 0, $f394edd4427d52c3$var$concurrentlyUpdatedLanes = 0;
function $f394edd4427d52c3$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $f394edd4427d52c3$var$concurrentQueuesIndex, i = $f394edd4427d52c3$var$concurrentlyUpdatedLanes = $f394edd4427d52c3$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        var queue = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        var update = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        var lane = $f394edd4427d52c3$var$concurrentQueues[i];
        $f394edd4427d52c3$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $f394edd4427d52c3$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $f394edd4427d52c3$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = fiber;
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = queue;
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = update;
    $f394edd4427d52c3$var$concurrentQueues[$f394edd4427d52c3$var$concurrentQueuesIndex++] = lane;
    $f394edd4427d52c3$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $f394edd4427d52c3$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
}
function $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $f394edd4427d52c3$var$enqueueUpdate$1(fiber, null, null, lane);
    return $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
}
function $f394edd4427d52c3$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $f394edd4427d52c3$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $f394edd4427d52c3$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $f394edd4427d52c3$var$nestedUpdateCount) throw $f394edd4427d52c3$var$nestedUpdateCount = 0, $f394edd4427d52c3$var$rootWithNestedUpdates = null, Error($f394edd4427d52c3$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $f394edd4427d52c3$var$emptyContextObject = {};
function $f394edd4427d52c3$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f394edd4427d52c3$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $f394edd4427d52c3$var$FiberNode(tag, pendingProps, key, mode);
}
function $f394edd4427d52c3$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $f394edd4427d52c3$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $f394edd4427d52c3$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $f394edd4427d52c3$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $f394edd4427d52c3$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $f394edd4427d52c3$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $f394edd4427d52c3$var$isHostHoistableType(type, pendingProps, $f394edd4427d52c3$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $f394edd4427d52c3$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE:
            return $f394edd4427d52c3$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $f394edd4427d52c3$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $f394edd4427d52c3$var$REACT_PROFILER_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $f394edd4427d52c3$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $f394edd4427d52c3$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $f394edd4427d52c3$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $f394edd4427d52c3$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $f394edd4427d52c3$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $f394edd4427d52c3$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $f394edd4427d52c3$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($f394edd4427d52c3$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $f394edd4427d52c3$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $f394edd4427d52c3$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $f394edd4427d52c3$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $f394edd4427d52c3$var$createFiberFromText(content, mode, lanes) {
    content = $f394edd4427d52c3$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $f394edd4427d52c3$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $f394edd4427d52c3$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $f394edd4427d52c3$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $f394edd4427d52c3$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $f394edd4427d52c3$var$CapturedStacks = new WeakMap();
function $f394edd4427d52c3$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $f394edd4427d52c3$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $f394edd4427d52c3$var$getStackByFiberInDevAndProd(source)
        };
        $f394edd4427d52c3$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $f394edd4427d52c3$var$getStackByFiberInDevAndProd(source)
    };
}
var $f394edd4427d52c3$var$forkStack = [], $f394edd4427d52c3$var$forkStackIndex = 0, $f394edd4427d52c3$var$treeForkProvider = null, $f394edd4427d52c3$var$treeForkCount = 0, $f394edd4427d52c3$var$idStack = [], $f394edd4427d52c3$var$idStackIndex = 0, $f394edd4427d52c3$var$treeContextProvider = null, $f394edd4427d52c3$var$treeContextId = 1, $f394edd4427d52c3$var$treeContextOverflow = "";
function $f394edd4427d52c3$var$pushTreeFork(workInProgress, totalChildren) {
    $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex++] = $f394edd4427d52c3$var$treeForkCount;
    $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex++] = $f394edd4427d52c3$var$treeForkProvider;
    $f394edd4427d52c3$var$treeForkProvider = workInProgress;
    $f394edd4427d52c3$var$treeForkCount = totalChildren;
}
function $f394edd4427d52c3$var$pushTreeId(workInProgress, totalChildren, index) {
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextId;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextOverflow;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextProvider;
    $f394edd4427d52c3$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $f394edd4427d52c3$var$treeContextId;
    workInProgress = $f394edd4427d52c3$var$treeContextOverflow;
    var baseLength = 32 - $f394edd4427d52c3$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $f394edd4427d52c3$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $f394edd4427d52c3$var$treeContextId = 1 << 32 - $f394edd4427d52c3$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $f394edd4427d52c3$var$treeContextOverflow = length + workInProgress;
    } else $f394edd4427d52c3$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $f394edd4427d52c3$var$treeContextOverflow = workInProgress;
}
function $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($f394edd4427d52c3$var$pushTreeFork(workInProgress, 1), $f394edd4427d52c3$var$pushTreeId(workInProgress, 1, 0));
}
function $f394edd4427d52c3$var$popTreeContext(workInProgress) {
    for(; workInProgress === $f394edd4427d52c3$var$treeForkProvider;)$f394edd4427d52c3$var$treeForkProvider = $f394edd4427d52c3$var$forkStack[--$f394edd4427d52c3$var$forkStackIndex], $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex] = null, $f394edd4427d52c3$var$treeForkCount = $f394edd4427d52c3$var$forkStack[--$f394edd4427d52c3$var$forkStackIndex], $f394edd4427d52c3$var$forkStack[$f394edd4427d52c3$var$forkStackIndex] = null;
    for(; workInProgress === $f394edd4427d52c3$var$treeContextProvider;)$f394edd4427d52c3$var$treeContextProvider = $f394edd4427d52c3$var$idStack[--$f394edd4427d52c3$var$idStackIndex], $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex] = null, $f394edd4427d52c3$var$treeContextOverflow = $f394edd4427d52c3$var$idStack[--$f394edd4427d52c3$var$idStackIndex], $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex] = null, $f394edd4427d52c3$var$treeContextId = $f394edd4427d52c3$var$idStack[--$f394edd4427d52c3$var$idStackIndex], $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex] = null;
}
function $f394edd4427d52c3$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextId;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextOverflow;
    $f394edd4427d52c3$var$idStack[$f394edd4427d52c3$var$idStackIndex++] = $f394edd4427d52c3$var$treeContextProvider;
    $f394edd4427d52c3$var$treeContextId = suspendedContext.id;
    $f394edd4427d52c3$var$treeContextOverflow = suspendedContext.overflow;
    $f394edd4427d52c3$var$treeContextProvider = workInProgress;
}
var $f394edd4427d52c3$var$hydrationParentFiber = null, $f394edd4427d52c3$var$nextHydratableInstance = null, $f394edd4427d52c3$var$isHydrating = !1, $f394edd4427d52c3$var$hydrationErrors = null, $f394edd4427d52c3$var$rootOrSingletonContext = !1, $f394edd4427d52c3$var$HydrationMismatchException = Error($f394edd4427d52c3$var$formatProdErrorMessage(519));
function $f394edd4427d52c3$var$throwOnHydrationMismatch(fiber) {
    var error = Error($f394edd4427d52c3$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $f394edd4427d52c3$var$queueHydrationError($f394edd4427d52c3$var$createCapturedValueAtFiber(error, fiber));
    throw $f394edd4427d52c3$var$HydrationMismatchException;
}
function $f394edd4427d52c3$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$f394edd4427d52c3$var$internalInstanceKey] = fiber;
    instance[$f394edd4427d52c3$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("cancel", instance);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $f394edd4427d52c3$var$mediaEventTypes.length; type++)$f394edd4427d52c3$var$listenToNonDelegatedEvent($f394edd4427d52c3$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", instance);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", instance);
            $f394edd4427d52c3$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", instance), $f394edd4427d52c3$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $f394edd4427d52c3$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($f394edd4427d52c3$var$listenToNonDelegatedEvent("beforetoggle", instance), $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $f394edd4427d52c3$var$noop$1), instance = !0) : instance = !1;
    instance || $f394edd4427d52c3$var$throwOnHydrationMismatch(fiber, !0);
}
function $f394edd4427d52c3$var$popToNextHostParent(fiber) {
    for($f394edd4427d52c3$var$hydrationParentFiber = fiber.return; $f394edd4427d52c3$var$hydrationParentFiber;)switch($f394edd4427d52c3$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $f394edd4427d52c3$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $f394edd4427d52c3$var$rootOrSingletonContext = !0;
            return;
        default:
            $f394edd4427d52c3$var$hydrationParentFiber = $f394edd4427d52c3$var$hydrationParentFiber.return;
    }
}
function $f394edd4427d52c3$var$popHydrationState(fiber) {
    if (fiber !== $f394edd4427d52c3$var$hydrationParentFiber) return !1;
    if (!$f394edd4427d52c3$var$isHydrating) return $f394edd4427d52c3$var$popToNextHostParent(fiber), $f394edd4427d52c3$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $f394edd4427d52c3$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $f394edd4427d52c3$var$nextHydratableInstance && $f394edd4427d52c3$var$throwOnHydrationMismatch(fiber);
    $f394edd4427d52c3$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(317));
        $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(317));
        $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $f394edd4427d52c3$var$nextHydratableInstance, $f394edd4427d52c3$var$isSingletonScope(fiber.type) ? (fiber = $f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton, $f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton = null, $f394edd4427d52c3$var$nextHydratableInstance = fiber) : $f394edd4427d52c3$var$nextHydratableInstance = tag) : $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$hydrationParentFiber ? $f394edd4427d52c3$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $f394edd4427d52c3$var$resetHydrationState() {
    $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$hydrationParentFiber = null;
    $f394edd4427d52c3$var$isHydrating = !1;
}
function $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $f394edd4427d52c3$var$hydrationErrors;
    null !== queuedErrors && (null === $f394edd4427d52c3$var$workInProgressRootRecoverableErrors ? $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = queuedErrors : $f394edd4427d52c3$var$workInProgressRootRecoverableErrors.push.apply($f394edd4427d52c3$var$workInProgressRootRecoverableErrors, queuedErrors), $f394edd4427d52c3$var$hydrationErrors = null);
    return queuedErrors;
}
function $f394edd4427d52c3$var$queueHydrationError(error) {
    null === $f394edd4427d52c3$var$hydrationErrors ? $f394edd4427d52c3$var$hydrationErrors = [
        error
    ] : $f394edd4427d52c3$var$hydrationErrors.push(error);
}
var $f394edd4427d52c3$var$valueCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null, $f394edd4427d52c3$var$lastContextDependency = null;
function $f394edd4427d52c3$var$pushProvider(providerFiber, context, nextValue) {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $f394edd4427d52c3$var$popProvider(context) {
    context._currentValue = $f394edd4427d52c3$var$valueCursor.current;
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$valueCursor);
}
function $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $f394edd4427d52c3$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $f394edd4427d52c3$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $f394edd4427d52c3$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($f394edd4427d52c3$var$HostTransitionContext) : current = [
                $f394edd4427d52c3$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $f394edd4427d52c3$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $f394edd4427d52c3$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$f394edd4427d52c3$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $f394edd4427d52c3$var$prepareToReadContext(workInProgress) {
    $f394edd4427d52c3$var$currentlyRenderingFiber$1 = workInProgress;
    $f394edd4427d52c3$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $f394edd4427d52c3$var$readContext(context) {
    return $f394edd4427d52c3$var$readContextForConsumer($f394edd4427d52c3$var$currentlyRenderingFiber$1, context);
}
function $f394edd4427d52c3$var$readContextDuringReconciliation(consumer, context) {
    null === $f394edd4427d52c3$var$currentlyRenderingFiber$1 && $f394edd4427d52c3$var$prepareToReadContext(consumer);
    return $f394edd4427d52c3$var$readContextForConsumer(consumer, context);
}
function $f394edd4427d52c3$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $f394edd4427d52c3$var$lastContextDependency) {
        if (null === consumer) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(308));
        $f394edd4427d52c3$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$lastContextDependency.next = context;
    return value;
}
var $f394edd4427d52c3$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $f394edd4427d52c3$var$scheduleCallback$2 = $kkkYV.unstable_scheduleCallback, $f394edd4427d52c3$var$NormalPriority = $kkkYV.unstable_NormalPriority, $f394edd4427d52c3$var$CacheContext = {
    $$typeof: $f394edd4427d52c3$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $f394edd4427d52c3$var$createCache() {
    return {
        controller: new $f394edd4427d52c3$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $f394edd4427d52c3$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $f394edd4427d52c3$var$scheduleCallback$2($f394edd4427d52c3$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $f394edd4427d52c3$var$currentEntangledListeners = null, $f394edd4427d52c3$var$currentEntangledPendingCount = 0, $f394edd4427d52c3$var$currentEntangledLane = 0, $f394edd4427d52c3$var$currentEntangledActionThenable = null;
function $f394edd4427d52c3$var$entangleAsyncAction(transition, thenable) {
    if (null === $f394edd4427d52c3$var$currentEntangledListeners) {
        var entangledListeners = $f394edd4427d52c3$var$currentEntangledListeners = [];
        $f394edd4427d52c3$var$currentEntangledPendingCount = 0;
        $f394edd4427d52c3$var$currentEntangledLane = $f394edd4427d52c3$var$requestTransitionLane();
        $f394edd4427d52c3$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $f394edd4427d52c3$var$currentEntangledPendingCount++;
    thenable.then($f394edd4427d52c3$var$pingEngtangledActionScope, $f394edd4427d52c3$var$pingEngtangledActionScope);
    return thenable;
}
function $f394edd4427d52c3$var$pingEngtangledActionScope() {
    if (0 === --$f394edd4427d52c3$var$currentEntangledPendingCount && null !== $f394edd4427d52c3$var$currentEntangledListeners) {
        null !== $f394edd4427d52c3$var$currentEntangledActionThenable && ($f394edd4427d52c3$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $f394edd4427d52c3$var$currentEntangledListeners;
        $f394edd4427d52c3$var$currentEntangledListeners = null;
        $f394edd4427d52c3$var$currentEntangledLane = 0;
        $f394edd4427d52c3$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $f394edd4427d52c3$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $f394edd4427d52c3$var$prevOnStartTransitionFinish = $f394edd4427d52c3$var$ReactSharedInternals.S;
$f394edd4427d52c3$var$ReactSharedInternals.S = function(transition, returnValue) {
    $f394edd4427d52c3$var$globalMostRecentTransitionTime = $f394edd4427d52c3$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $f394edd4427d52c3$var$entangleAsyncAction(transition, returnValue);
    null !== $f394edd4427d52c3$var$prevOnStartTransitionFinish && $f394edd4427d52c3$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $f394edd4427d52c3$var$resumedCache = $f394edd4427d52c3$var$createCursor(null);
function $f394edd4427d52c3$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $f394edd4427d52c3$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $f394edd4427d52c3$var$workInProgressRoot.pooledCache;
}
function $f394edd4427d52c3$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $f394edd4427d52c3$var$push($f394edd4427d52c3$var$resumedCache, $f394edd4427d52c3$var$resumedCache.current) : $f394edd4427d52c3$var$push($f394edd4427d52c3$var$resumedCache, prevCachePool.pool);
}
function $f394edd4427d52c3$var$getSuspendedCache() {
    var cacheFromPool = $f394edd4427d52c3$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $f394edd4427d52c3$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $f394edd4427d52c3$var$SuspenseException = Error($f394edd4427d52c3$var$formatProdErrorMessage(460)), $f394edd4427d52c3$var$SuspenseyCommitException = Error($f394edd4427d52c3$var$formatProdErrorMessage(474)), $f394edd4427d52c3$var$SuspenseActionException = Error($f394edd4427d52c3$var$formatProdErrorMessage(542)), $f394edd4427d52c3$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $f394edd4427d52c3$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $f394edd4427d52c3$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($f394edd4427d52c3$var$noop$1, $f394edd4427d52c3$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $f394edd4427d52c3$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($f394edd4427d52c3$var$noop$1, $f394edd4427d52c3$var$noop$1);
            else {
                thenableState = $f394edd4427d52c3$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $f394edd4427d52c3$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $f394edd4427d52c3$var$suspendedThenable = thenable;
            throw $f394edd4427d52c3$var$SuspenseException;
    }
}
function $f394edd4427d52c3$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $f394edd4427d52c3$var$suspendedThenable = x, $f394edd4427d52c3$var$SuspenseException;
        throw x;
    }
}
var $f394edd4427d52c3$var$suspendedThenable = null;
function $f394edd4427d52c3$var$getSuspendedThenable() {
    if (null === $f394edd4427d52c3$var$suspendedThenable) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(459));
    var thenable = $f394edd4427d52c3$var$suspendedThenable;
    $f394edd4427d52c3$var$suspendedThenable = null;
    return thenable;
}
function $f394edd4427d52c3$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $f394edd4427d52c3$var$SuspenseException || rejectedReason === $f394edd4427d52c3$var$SuspenseActionException) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(483));
}
var $f394edd4427d52c3$var$thenableState$1 = null, $f394edd4427d52c3$var$thenableIndexCounter$1 = 0;
function $f394edd4427d52c3$var$unwrapThenable(thenable) {
    var index = $f394edd4427d52c3$var$thenableIndexCounter$1;
    $f394edd4427d52c3$var$thenableIndexCounter$1 += 1;
    null === $f394edd4427d52c3$var$thenableState$1 && ($f394edd4427d52c3$var$thenableState$1 = []);
    return $f394edd4427d52c3$var$trackUsedThenable($f394edd4427d52c3$var$thenableState$1, thenable, index);
}
function $f394edd4427d52c3$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $f394edd4427d52c3$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $f394edd4427d52c3$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $f394edd4427d52c3$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $f394edd4427d52c3$var$REACT_LAZY_TYPE && $f394edd4427d52c3$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $f394edd4427d52c3$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $f394edd4427d52c3$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $f394edd4427d52c3$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $f394edd4427d52c3$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $f394edd4427d52c3$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $f394edd4427d52c3$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    return lanes = $f394edd4427d52c3$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f394edd4427d52c3$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    return newChild = $f394edd4427d52c3$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild) || $f394edd4427d52c3$var$getIteratorFn(newChild)) return newChild = $f394edd4427d52c3$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild) || $f394edd4427d52c3$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild) || $f394edd4427d52c3$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f394edd4427d52c3$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $f394edd4427d52c3$var$REACT_LAZY_TYPE && $f394edd4427d52c3$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $f394edd4427d52c3$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $f394edd4427d52c3$var$REACT_FRAGMENT_TYPE ? (lanes = $f394edd4427d52c3$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $f394edd4427d52c3$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f394edd4427d52c3$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $f394edd4427d52c3$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $f394edd4427d52c3$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $f394edd4427d52c3$var$REACT_LAZY_TYPE:
                    return newChild = $f394edd4427d52c3$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($f394edd4427d52c3$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($f394edd4427d52c3$var$getIteratorFn(newChild)) {
                key = $f394edd4427d52c3$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f394edd4427d52c3$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f394edd4427d52c3$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f394edd4427d52c3$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $f394edd4427d52c3$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $f394edd4427d52c3$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $f394edd4427d52c3$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $f394edd4427d52c3$var$SuspenseException || x === $f394edd4427d52c3$var$SuspenseActionException) throw x;
            var fiber = $f394edd4427d52c3$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $f394edd4427d52c3$var$reconcileChildFibers = $f394edd4427d52c3$var$createChildReconciler(!0), $f394edd4427d52c3$var$mountChildFibers = $f394edd4427d52c3$var$createChildReconciler(!1), $f394edd4427d52c3$var$hasForceUpdate = !1;
function $f394edd4427d52c3$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $f394edd4427d52c3$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f394edd4427d52c3$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($f394edd4427d52c3$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
        $f394edd4427d52c3$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $f394edd4427d52c3$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $f394edd4427d52c3$var$getRootForUpdatedFiber(fiber);
}
function $f394edd4427d52c3$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $f394edd4427d52c3$var$markRootEntangled(root, lane);
    }
}
function $f394edd4427d52c3$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $f394edd4427d52c3$var$didReadFromEntangledAsyncAction = !1;
function $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($f394edd4427d52c3$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $f394edd4427d52c3$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $f394edd4427d52c3$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $f394edd4427d52c3$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $f394edd4427d52c3$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($f394edd4427d52c3$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $f394edd4427d52c3$var$currentEntangledLane && ($f394edd4427d52c3$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $f394edd4427d52c3$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $f394edd4427d52c3$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $f394edd4427d52c3$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $f394edd4427d52c3$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$f394edd4427d52c3$var$callCallback(callbacks[updateQueue], context);
}
var $f394edd4427d52c3$var$currentTreeHiddenStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$prevEntangledRenderLanesCursor = $f394edd4427d52c3$var$createCursor(0);
function $f394edd4427d52c3$var$pushHiddenContext(fiber, context) {
    fiber = $f394edd4427d52c3$var$entangledRenderLanes;
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$prevEntangledRenderLanesCursor, fiber);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$currentTreeHiddenStackCursor, context);
    $f394edd4427d52c3$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $f394edd4427d52c3$var$reuseHiddenContextOnStack() {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$prevEntangledRenderLanesCursor, $f394edd4427d52c3$var$entangledRenderLanes);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$currentTreeHiddenStackCursor, $f394edd4427d52c3$var$currentTreeHiddenStackCursor.current);
}
function $f394edd4427d52c3$var$popHiddenContext() {
    $f394edd4427d52c3$var$entangledRenderLanes = $f394edd4427d52c3$var$prevEntangledRenderLanesCursor.current;
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$currentTreeHiddenStackCursor);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$prevEntangledRenderLanesCursor);
}
var $f394edd4427d52c3$var$suspenseHandlerStackCursor = $f394edd4427d52c3$var$createCursor(null), $f394edd4427d52c3$var$shellBoundary = null;
function $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current & 1);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, handler);
    null === $f394edd4427d52c3$var$shellBoundary && (null === current || null !== $f394edd4427d52c3$var$currentTreeHiddenStackCursor.current ? $f394edd4427d52c3$var$shellBoundary = handler : null !== current.memoizedState && ($f394edd4427d52c3$var$shellBoundary = handler));
}
function $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, fiber);
    null === $f394edd4427d52c3$var$shellBoundary && ($f394edd4427d52c3$var$shellBoundary = fiber);
}
function $f394edd4427d52c3$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current), $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, fiber), null === $f394edd4427d52c3$var$shellBoundary && ($f394edd4427d52c3$var$shellBoundary = fiber)) : $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(fiber);
}
function $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack() {
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current);
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseHandlerStackCursor, $f394edd4427d52c3$var$suspenseHandlerStackCursor.current);
}
function $f394edd4427d52c3$var$popSuspenseHandler(fiber) {
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseHandlerStackCursor);
    $f394edd4427d52c3$var$shellBoundary === fiber && ($f394edd4427d52c3$var$shellBoundary = null);
    $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor);
}
var $f394edd4427d52c3$var$suspenseStackCursor = $f394edd4427d52c3$var$createCursor(0);
function $f394edd4427d52c3$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $f394edd4427d52c3$var$isSuspenseInstancePending(state) || $f394edd4427d52c3$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $f394edd4427d52c3$var$renderLanes = 0, $f394edd4427d52c3$var$currentlyRenderingFiber = null, $f394edd4427d52c3$var$currentHook = null, $f394edd4427d52c3$var$workInProgressHook = null, $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !1, $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $f394edd4427d52c3$var$localIdCounter = 0, $f394edd4427d52c3$var$thenableIndexCounter = 0, $f394edd4427d52c3$var$thenableState = null, $f394edd4427d52c3$var$globalClientIdCounter = 0;
function $f394edd4427d52c3$var$throwInvalidHookError() {
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(321));
}
function $f394edd4427d52c3$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$f394edd4427d52c3$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $f394edd4427d52c3$var$renderLanes = nextRenderLanes;
    $f394edd4427d52c3$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $f394edd4427d52c3$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $f394edd4427d52c3$var$HooksDispatcherOnMount : $f394edd4427d52c3$var$HooksDispatcherOnUpdate;
    $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $f394edd4427d52c3$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $f394edd4427d52c3$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $f394edd4427d52c3$var$finishRenderingHooks(current) {
    $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $f394edd4427d52c3$var$currentHook && null !== $f394edd4427d52c3$var$currentHook.next;
    $f394edd4427d52c3$var$renderLanes = 0;
    $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$currentHook = $f394edd4427d52c3$var$currentlyRenderingFiber = null;
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !1;
    $f394edd4427d52c3$var$thenableIndexCounter = 0;
    $f394edd4427d52c3$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(300));
    null === current || $f394edd4427d52c3$var$didReceiveUpdate || (current = current.dependencies, null !== current && $f394edd4427d52c3$var$checkIfContextChanged(current) && ($f394edd4427d52c3$var$didReceiveUpdate = !0));
}
function $f394edd4427d52c3$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $f394edd4427d52c3$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass && ($f394edd4427d52c3$var$thenableState = null);
        $f394edd4427d52c3$var$thenableIndexCounter = 0;
        $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $f394edd4427d52c3$var$TransitionAwareHostComponent() {
    var dispatcher = $f394edd4427d52c3$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $f394edd4427d52c3$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $f394edd4427d52c3$var$currentHook ? $f394edd4427d52c3$var$currentHook.memoizedState : null) !== dispatcher && ($f394edd4427d52c3$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $f394edd4427d52c3$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $f394edd4427d52c3$var$localIdCounter;
    $f394edd4427d52c3$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $f394edd4427d52c3$var$resetHooksOnUnwind(workInProgress) {
    if ($f394edd4427d52c3$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !1;
    }
    $f394edd4427d52c3$var$renderLanes = 0;
    $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$currentHook = $f394edd4427d52c3$var$currentlyRenderingFiber = null;
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $f394edd4427d52c3$var$thenableIndexCounter = $f394edd4427d52c3$var$localIdCounter = 0;
    $f394edd4427d52c3$var$thenableState = null;
}
function $f394edd4427d52c3$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f394edd4427d52c3$var$workInProgressHook ? $f394edd4427d52c3$var$currentlyRenderingFiber.memoizedState = $f394edd4427d52c3$var$workInProgressHook = hook : $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$workInProgressHook.next = hook;
    return $f394edd4427d52c3$var$workInProgressHook;
}
function $f394edd4427d52c3$var$updateWorkInProgressHook() {
    if (null === $f394edd4427d52c3$var$currentHook) {
        var nextCurrentHook = $f394edd4427d52c3$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $f394edd4427d52c3$var$currentHook.next;
    var nextWorkInProgressHook = null === $f394edd4427d52c3$var$workInProgressHook ? $f394edd4427d52c3$var$currentlyRenderingFiber.memoizedState : $f394edd4427d52c3$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $f394edd4427d52c3$var$workInProgressHook = nextWorkInProgressHook, $f394edd4427d52c3$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $f394edd4427d52c3$var$currentlyRenderingFiber.alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(467));
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(310));
        }
        $f394edd4427d52c3$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $f394edd4427d52c3$var$currentHook.memoizedState,
            baseState: $f394edd4427d52c3$var$currentHook.baseState,
            baseQueue: $f394edd4427d52c3$var$currentHook.baseQueue,
            queue: $f394edd4427d52c3$var$currentHook.queue,
            next: null
        };
        null === $f394edd4427d52c3$var$workInProgressHook ? $f394edd4427d52c3$var$currentlyRenderingFiber.memoizedState = $f394edd4427d52c3$var$workInProgressHook = nextCurrentHook : $f394edd4427d52c3$var$workInProgressHook = $f394edd4427d52c3$var$workInProgressHook.next = nextCurrentHook;
    }
    return $f394edd4427d52c3$var$workInProgressHook;
}
function $f394edd4427d52c3$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $f394edd4427d52c3$var$useThenable(thenable) {
    var index = $f394edd4427d52c3$var$thenableIndexCounter;
    $f394edd4427d52c3$var$thenableIndexCounter += 1;
    null === $f394edd4427d52c3$var$thenableState && ($f394edd4427d52c3$var$thenableState = []);
    thenable = $f394edd4427d52c3$var$trackUsedThenable($f394edd4427d52c3$var$thenableState, thenable, index);
    index = $f394edd4427d52c3$var$currentlyRenderingFiber;
    null === (null === $f394edd4427d52c3$var$workInProgressHook ? index.memoizedState : $f394edd4427d52c3$var$workInProgressHook.next) && (index = index.alternate, $f394edd4427d52c3$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $f394edd4427d52c3$var$HooksDispatcherOnMount : $f394edd4427d52c3$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $f394edd4427d52c3$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $f394edd4427d52c3$var$useThenable(usable);
        if (usable.$$typeof === $f394edd4427d52c3$var$REACT_CONTEXT_TYPE) return $f394edd4427d52c3$var$readContext(usable);
    }
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(438, String(usable)));
}
function $f394edd4427d52c3$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $f394edd4427d52c3$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $f394edd4427d52c3$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $f394edd4427d52c3$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $f394edd4427d52c3$var$updateReducer(reducer) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    return $f394edd4427d52c3$var$updateReducerImpl(hook, $f394edd4427d52c3$var$currentHook, reducer);
}
function $f394edd4427d52c3$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($f394edd4427d52c3$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($f394edd4427d52c3$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $f394edd4427d52c3$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($f394edd4427d52c3$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $f394edd4427d52c3$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= revertLane, $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= updateLane, $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$f394edd4427d52c3$var$objectIs(pendingQueue, hook.memoizedState) && ($f394edd4427d52c3$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $f394edd4427d52c3$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $f394edd4427d52c3$var$rerenderReducer(reducer) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $f394edd4427d52c3$var$objectIs(newState, hook.memoizedState) || ($f394edd4427d52c3$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $f394edd4427d52c3$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $f394edd4427d52c3$var$currentlyRenderingFiber, hook = $f394edd4427d52c3$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $f394edd4427d52c3$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$f394edd4427d52c3$var$objectIs(($f394edd4427d52c3$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $f394edd4427d52c3$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $f394edd4427d52c3$var$updateEffect($f394edd4427d52c3$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $f394edd4427d52c3$var$workInProgressHook && $f394edd4427d52c3$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $f394edd4427d52c3$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f394edd4427d52c3$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $f394edd4427d52c3$var$workInProgressRoot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($f394edd4427d52c3$var$renderLanes & 127) || $f394edd4427d52c3$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $f394edd4427d52c3$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $f394edd4427d52c3$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $f394edd4427d52c3$var$checkIfSnapshotChanged(inst) && $f394edd4427d52c3$var$forceStoreRerender(fiber);
}
function $f394edd4427d52c3$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $f394edd4427d52c3$var$checkIfSnapshotChanged(inst) && $f394edd4427d52c3$var$forceStoreRerender(fiber);
    });
}
function $f394edd4427d52c3$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f394edd4427d52c3$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f394edd4427d52c3$var$forceStoreRerender(fiber) {
    var root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $f394edd4427d52c3$var$mountStateImpl(initialState) {
    var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f394edd4427d52c3$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $f394edd4427d52c3$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $f394edd4427d52c3$var$updateReducerImpl(hook, $f394edd4427d52c3$var$currentHook, "function" === typeof reducer ? reducer : $f394edd4427d52c3$var$basicStateReducer);
}
function $f394edd4427d52c3$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($f394edd4427d52c3$var$isRenderPhaseUpdate(fiber)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $f394edd4427d52c3$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $f394edd4427d52c3$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $f394edd4427d52c3$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T, currentTransition = {};
        $f394edd4427d52c3$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $f394edd4427d52c3$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $f394edd4427d52c3$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $f394edd4427d52c3$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $f394edd4427d52c3$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $f394edd4427d52c3$var$onActionError(actionQueue, node, error$66);
    }
}
function $f394edd4427d52c3$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $f394edd4427d52c3$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $f394edd4427d52c3$var$onActionError(actionQueue, node, error);
    }) : $f394edd4427d52c3$var$onActionSuccess(actionQueue, node, returnValue);
}
function $f394edd4427d52c3$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $f394edd4427d52c3$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $f394edd4427d52c3$var$runActionStateAction(actionQueue, nextState)));
}
function $f394edd4427d52c3$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $f394edd4427d52c3$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $f394edd4427d52c3$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $f394edd4427d52c3$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $f394edd4427d52c3$var$mountActionState(action, initialStateProp) {
    if ($f394edd4427d52c3$var$isHydrating) {
        var ssrFormState = $f394edd4427d52c3$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $f394edd4427d52c3$var$currentlyRenderingFiber;
                if ($f394edd4427d52c3$var$isHydrating) {
                    if ($f394edd4427d52c3$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $f394edd4427d52c3$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $f394edd4427d52c3$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $f394edd4427d52c3$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $f394edd4427d52c3$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $f394edd4427d52c3$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f394edd4427d52c3$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $f394edd4427d52c3$var$dispatchSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $f394edd4427d52c3$var$mountStateImpl(!1);
    inRootOrSingleton = $f394edd4427d52c3$var$dispatchOptimisticSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $f394edd4427d52c3$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $f394edd4427d52c3$var$dispatchActionState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $f394edd4427d52c3$var$updateActionState(action) {
    var stateHook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    return $f394edd4427d52c3$var$updateActionStateImpl(stateHook, $f394edd4427d52c3$var$currentHook, action);
}
function $f394edd4427d52c3$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $f394edd4427d52c3$var$updateReducerImpl(stateHook, currentStateHook, $f394edd4427d52c3$var$actionStateReducer)[0];
    stateHook = $f394edd4427d52c3$var$updateReducer($f394edd4427d52c3$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $f394edd4427d52c3$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $f394edd4427d52c3$var$SuspenseException) throw $f394edd4427d52c3$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($f394edd4427d52c3$var$currentlyRenderingFiber.flags |= 2048, $f394edd4427d52c3$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $f394edd4427d52c3$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $f394edd4427d52c3$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $f394edd4427d52c3$var$rerenderActionState(action) {
    var stateHook = $f394edd4427d52c3$var$updateWorkInProgressHook(), currentStateHook = $f394edd4427d52c3$var$currentHook;
    if (null !== currentStateHook) return $f394edd4427d52c3$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $f394edd4427d52c3$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $f394edd4427d52c3$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $f394edd4427d52c3$var$updateRef() {
    return $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
}
function $f394edd4427d52c3$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
    $f394edd4427d52c3$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $f394edd4427d52c3$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $f394edd4427d52c3$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $f394edd4427d52c3$var$currentHook && null !== deps && $f394edd4427d52c3$var$areHookInputsEqual(deps, $f394edd4427d52c3$var$currentHook.memoizedState.deps) ? hook.memoizedState = $f394edd4427d52c3$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($f394edd4427d52c3$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $f394edd4427d52c3$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $f394edd4427d52c3$var$mountEffect(create, deps) {
    $f394edd4427d52c3$var$mountEffectImpl(8390656, 8, create, deps);
}
function $f394edd4427d52c3$var$updateEffect(create, deps) {
    $f394edd4427d52c3$var$updateEffectImpl(2048, 8, create, deps);
}
function $f394edd4427d52c3$var$useEffectEventImpl(payload) {
    $f394edd4427d52c3$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $f394edd4427d52c3$var$createFunctionComponentUpdateQueue(), $f394edd4427d52c3$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $f394edd4427d52c3$var$updateEvent(callback) {
    var ref = $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
    $f394edd4427d52c3$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($f394edd4427d52c3$var$executionContext & 2)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $f394edd4427d52c3$var$updateInsertionEffect(create, deps) {
    return $f394edd4427d52c3$var$updateEffectImpl(4, 2, create, deps);
}
function $f394edd4427d52c3$var$updateLayoutEffect(create, deps) {
    return $f394edd4427d52c3$var$updateEffectImpl(4, 4, create, deps);
}
function $f394edd4427d52c3$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $f394edd4427d52c3$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $f394edd4427d52c3$var$updateEffectImpl(4, 4, $f394edd4427d52c3$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $f394edd4427d52c3$var$mountDebugValue() {}
function $f394edd4427d52c3$var$updateCallback(callback, deps) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f394edd4427d52c3$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $f394edd4427d52c3$var$updateMemo(nextCreate, deps) {
    var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f394edd4427d52c3$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($f394edd4427d52c3$var$renderLanes & 1073741824) && 0 === ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $f394edd4427d52c3$var$requestDeferredLane();
    $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= hook;
    $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $f394edd4427d52c3$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($f394edd4427d52c3$var$objectIs(value, prevValue)) return value;
    if (null !== $f394edd4427d52c3$var$currentTreeHiddenStackCursor.current) return hook = $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue), $f394edd4427d52c3$var$objectIs(hook, prevValue) || ($f394edd4427d52c3$var$didReceiveUpdate = !0), hook;
    if (0 === ($f394edd4427d52c3$var$renderLanes & 42) || 0 !== ($f394edd4427d52c3$var$renderLanes & 1073741824) && 0 === ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 261930)) return $f394edd4427d52c3$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $f394edd4427d52c3$var$requestDeferredLane();
    $f394edd4427d52c3$var$currentlyRenderingFiber.lanes |= hook;
    $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $f394edd4427d52c3$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T, currentTransition = {};
    $f394edd4427d52c3$var$ReactSharedInternals.T = currentTransition;
    $f394edd4427d52c3$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $f394edd4427d52c3$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $f394edd4427d52c3$var$chainThenableValue(returnValue, finishedState);
            $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $f394edd4427d52c3$var$requestUpdateLane(fiber));
        } else $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, finishedState, $f394edd4427d52c3$var$requestUpdateLane(fiber));
    } catch (error) {
        $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $f394edd4427d52c3$var$requestUpdateLane());
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f394edd4427d52c3$var$noop() {}
function $f394edd4427d52c3$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(476));
    var queue = $f394edd4427d52c3$var$ensureFormComponentIsStateful(formFiber).queue;
    $f394edd4427d52c3$var$startTransition(formFiber, queue, pendingState, $f394edd4427d52c3$var$sharedNotPendingObject, null === action ? $f394edd4427d52c3$var$noop : function() {
        $f394edd4427d52c3$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $f394edd4427d52c3$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $f394edd4427d52c3$var$sharedNotPendingObject,
        baseState: $f394edd4427d52c3$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f394edd4427d52c3$var$basicStateReducer,
            lastRenderedState: $f394edd4427d52c3$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f394edd4427d52c3$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $f394edd4427d52c3$var$requestFormReset$1(formFiber) {
    var stateHook = $f394edd4427d52c3$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $f394edd4427d52c3$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $f394edd4427d52c3$var$requestUpdateLane());
}
function $f394edd4427d52c3$var$useHostTransitionStatus() {
    return $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$HostTransitionContext);
}
function $f394edd4427d52c3$var$updateId() {
    return $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
}
function $f394edd4427d52c3$var$updateRefresh() {
    return $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
}
function $f394edd4427d52c3$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $f394edd4427d52c3$var$requestUpdateLane();
                fiber = $f394edd4427d52c3$var$createUpdate(lane);
                var root$69 = $f394edd4427d52c3$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(root$69, provider, lane), $f394edd4427d52c3$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $f394edd4427d52c3$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $f394edd4427d52c3$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $f394edd4427d52c3$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $f394edd4427d52c3$var$isRenderPhaseUpdate(fiber) ? $f394edd4427d52c3$var$enqueueRenderPhaseUpdate(queue, action) : (action = $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(action, fiber, lane), $f394edd4427d52c3$var$entangleTransitionUpdate(action, queue, lane)));
}
function $f394edd4427d52c3$var$dispatchSetState(fiber, queue, action) {
    var lane = $f394edd4427d52c3$var$requestUpdateLane();
    $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $f394edd4427d52c3$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f394edd4427d52c3$var$isRenderPhaseUpdate(fiber)) $f394edd4427d52c3$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($f394edd4427d52c3$var$objectIs(eagerState, currentState)) return $f394edd4427d52c3$var$enqueueUpdate$1(fiber, queue, update, 0), null === $f394edd4427d52c3$var$workInProgressRoot && $f394edd4427d52c3$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $f394edd4427d52c3$var$scheduleUpdateOnFiber(action, fiber, lane), $f394edd4427d52c3$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $f394edd4427d52c3$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $f394edd4427d52c3$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f394edd4427d52c3$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $f394edd4427d52c3$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $f394edd4427d52c3$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $f394edd4427d52c3$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $f394edd4427d52c3$var$currentlyRenderingFiber || null !== alternate && alternate === $f394edd4427d52c3$var$currentlyRenderingFiber;
}
function $f394edd4427d52c3$var$enqueueRenderPhaseUpdate(queue, update) {
    $f394edd4427d52c3$var$didScheduleRenderPhaseUpdateDuringThisPass = $f394edd4427d52c3$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $f394edd4427d52c3$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $f394edd4427d52c3$var$markRootEntangled(root, lane);
    }
}
var $f394edd4427d52c3$var$ContextOnlyDispatcher = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: $f394edd4427d52c3$var$throwInvalidHookError,
    useContext: $f394edd4427d52c3$var$throwInvalidHookError,
    useEffect: $f394edd4427d52c3$var$throwInvalidHookError,
    useImperativeHandle: $f394edd4427d52c3$var$throwInvalidHookError,
    useLayoutEffect: $f394edd4427d52c3$var$throwInvalidHookError,
    useInsertionEffect: $f394edd4427d52c3$var$throwInvalidHookError,
    useMemo: $f394edd4427d52c3$var$throwInvalidHookError,
    useReducer: $f394edd4427d52c3$var$throwInvalidHookError,
    useRef: $f394edd4427d52c3$var$throwInvalidHookError,
    useState: $f394edd4427d52c3$var$throwInvalidHookError,
    useDebugValue: $f394edd4427d52c3$var$throwInvalidHookError,
    useDeferredValue: $f394edd4427d52c3$var$throwInvalidHookError,
    useTransition: $f394edd4427d52c3$var$throwInvalidHookError,
    useSyncExternalStore: $f394edd4427d52c3$var$throwInvalidHookError,
    useId: $f394edd4427d52c3$var$throwInvalidHookError,
    useHostTransitionStatus: $f394edd4427d52c3$var$throwInvalidHookError,
    useFormState: $f394edd4427d52c3$var$throwInvalidHookError,
    useActionState: $f394edd4427d52c3$var$throwInvalidHookError,
    useOptimistic: $f394edd4427d52c3$var$throwInvalidHookError,
    useMemoCache: $f394edd4427d52c3$var$throwInvalidHookError,
    useCacheRefresh: $f394edd4427d52c3$var$throwInvalidHookError
};
$f394edd4427d52c3$var$ContextOnlyDispatcher.useEffectEvent = $f394edd4427d52c3$var$throwInvalidHookError;
var $f394edd4427d52c3$var$HooksDispatcherOnMount = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: function(callback, deps) {
        $f394edd4427d52c3$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $f394edd4427d52c3$var$readContext,
    useEffect: $f394edd4427d52c3$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $f394edd4427d52c3$var$mountEffectImpl(4194308, 4, $f394edd4427d52c3$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $f394edd4427d52c3$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $f394edd4427d52c3$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($f394edd4427d52c3$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $f394edd4427d52c3$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $f394edd4427d52c3$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $f394edd4427d52c3$var$dispatchReducerAction.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $f394edd4427d52c3$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $f394edd4427d52c3$var$dispatchSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $f394edd4427d52c3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        return $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $f394edd4427d52c3$var$mountStateImpl(!1);
        stateHook = $f394edd4427d52c3$var$startTransition.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $f394edd4427d52c3$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $f394edd4427d52c3$var$currentlyRenderingFiber, hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        if ($f394edd4427d52c3$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $f394edd4427d52c3$var$workInProgressRoot) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(349));
            0 !== ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 127) || $f394edd4427d52c3$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $f394edd4427d52c3$var$mountEffect($f394edd4427d52c3$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $f394edd4427d52c3$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f394edd4427d52c3$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook(), identifierPrefix = $f394edd4427d52c3$var$workInProgressRoot.identifierPrefix;
        if ($f394edd4427d52c3$var$isHydrating) {
            var JSCompiler_inline_result = $f394edd4427d52c3$var$treeContextOverflow;
            var idWithLeadingBit = $f394edd4427d52c3$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $f394edd4427d52c3$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $f394edd4427d52c3$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $f394edd4427d52c3$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $f394edd4427d52c3$var$useHostTransitionStatus,
    useFormState: $f394edd4427d52c3$var$mountActionState,
    useActionState: $f394edd4427d52c3$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $f394edd4427d52c3$var$dispatchOptimisticSetState.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $f394edd4427d52c3$var$useMemoCache,
    useCacheRefresh: function() {
        return $f394edd4427d52c3$var$mountWorkInProgressHook().memoizedState = $f394edd4427d52c3$var$refreshCache.bind(null, $f394edd4427d52c3$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $f394edd4427d52c3$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($f394edd4427d52c3$var$executionContext & 2)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $f394edd4427d52c3$var$HooksDispatcherOnUpdate = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: $f394edd4427d52c3$var$updateCallback,
    useContext: $f394edd4427d52c3$var$readContext,
    useEffect: $f394edd4427d52c3$var$updateEffect,
    useImperativeHandle: $f394edd4427d52c3$var$updateImperativeHandle,
    useInsertionEffect: $f394edd4427d52c3$var$updateInsertionEffect,
    useLayoutEffect: $f394edd4427d52c3$var$updateLayoutEffect,
    useMemo: $f394edd4427d52c3$var$updateMemo,
    useReducer: $f394edd4427d52c3$var$updateReducer,
    useRef: $f394edd4427d52c3$var$updateRef,
    useState: function() {
        return $f394edd4427d52c3$var$updateReducer($f394edd4427d52c3$var$basicStateReducer);
    },
    useDebugValue: $f394edd4427d52c3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        return $f394edd4427d52c3$var$updateDeferredValueImpl(hook, $f394edd4427d52c3$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f394edd4427d52c3$var$updateReducer($f394edd4427d52c3$var$basicStateReducer)[0], start = $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f394edd4427d52c3$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f394edd4427d52c3$var$updateSyncExternalStore,
    useId: $f394edd4427d52c3$var$updateId,
    useHostTransitionStatus: $f394edd4427d52c3$var$useHostTransitionStatus,
    useFormState: $f394edd4427d52c3$var$updateActionState,
    useActionState: $f394edd4427d52c3$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        return $f394edd4427d52c3$var$updateOptimisticImpl(hook, $f394edd4427d52c3$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $f394edd4427d52c3$var$useMemoCache,
    useCacheRefresh: $f394edd4427d52c3$var$updateRefresh
};
$f394edd4427d52c3$var$HooksDispatcherOnUpdate.useEffectEvent = $f394edd4427d52c3$var$updateEvent;
var $f394edd4427d52c3$var$HooksDispatcherOnRerender = {
    readContext: $f394edd4427d52c3$var$readContext,
    use: $f394edd4427d52c3$var$use,
    useCallback: $f394edd4427d52c3$var$updateCallback,
    useContext: $f394edd4427d52c3$var$readContext,
    useEffect: $f394edd4427d52c3$var$updateEffect,
    useImperativeHandle: $f394edd4427d52c3$var$updateImperativeHandle,
    useInsertionEffect: $f394edd4427d52c3$var$updateInsertionEffect,
    useLayoutEffect: $f394edd4427d52c3$var$updateLayoutEffect,
    useMemo: $f394edd4427d52c3$var$updateMemo,
    useReducer: $f394edd4427d52c3$var$rerenderReducer,
    useRef: $f394edd4427d52c3$var$updateRef,
    useState: function() {
        return $f394edd4427d52c3$var$rerenderReducer($f394edd4427d52c3$var$basicStateReducer);
    },
    useDebugValue: $f394edd4427d52c3$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        return null === $f394edd4427d52c3$var$currentHook ? $f394edd4427d52c3$var$mountDeferredValueImpl(hook, value, initialValue) : $f394edd4427d52c3$var$updateDeferredValueImpl(hook, $f394edd4427d52c3$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f394edd4427d52c3$var$rerenderReducer($f394edd4427d52c3$var$basicStateReducer)[0], start = $f394edd4427d52c3$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f394edd4427d52c3$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f394edd4427d52c3$var$updateSyncExternalStore,
    useId: $f394edd4427d52c3$var$updateId,
    useHostTransitionStatus: $f394edd4427d52c3$var$useHostTransitionStatus,
    useFormState: $f394edd4427d52c3$var$rerenderActionState,
    useActionState: $f394edd4427d52c3$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f394edd4427d52c3$var$updateWorkInProgressHook();
        if (null !== $f394edd4427d52c3$var$currentHook) return $f394edd4427d52c3$var$updateOptimisticImpl(hook, $f394edd4427d52c3$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $f394edd4427d52c3$var$useMemoCache,
    useCacheRefresh: $f394edd4427d52c3$var$updateRefresh
};
$f394edd4427d52c3$var$HooksDispatcherOnRerender.useEffectEvent = $f394edd4427d52c3$var$updateEvent;
function $f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $f394edd4427d52c3$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $f394edd4427d52c3$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f394edd4427d52c3$var$requestUpdateLane(), update = $f394edd4427d52c3$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f394edd4427d52c3$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(payload, inst, lane), $f394edd4427d52c3$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f394edd4427d52c3$var$requestUpdateLane(), update = $f394edd4427d52c3$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f394edd4427d52c3$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(payload, inst, lane), $f394edd4427d52c3$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $f394edd4427d52c3$var$requestUpdateLane(), update = $f394edd4427d52c3$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $f394edd4427d52c3$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(callback, inst, lane), $f394edd4427d52c3$var$entangleTransitions(callback, inst, lane));
    }
};
function $f394edd4427d52c3$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$f394edd4427d52c3$var$shallowEqual(oldProps, newProps) || !$f394edd4427d52c3$var$shallowEqual(oldState, newState) : !0;
}
function $f394edd4427d52c3$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $f394edd4427d52c3$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $f394edd4427d52c3$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $f394edd4427d52c3$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $f394edd4427d52c3$var$defaultOnUncaughtError(error) {
    $f394edd4427d52c3$var$reportGlobalError(error);
}
function $f394edd4427d52c3$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $f394edd4427d52c3$var$defaultOnRecoverableError(error) {
    $f394edd4427d52c3$var$reportGlobalError(error);
}
function $f394edd4427d52c3$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $f394edd4427d52c3$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $f394edd4427d52c3$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $f394edd4427d52c3$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $f394edd4427d52c3$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $f394edd4427d52c3$var$createClassErrorUpdate(lane) {
    lane = $f394edd4427d52c3$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $f394edd4427d52c3$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $f394edd4427d52c3$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $f394edd4427d52c3$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed ? $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $f394edd4427d52c3$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $f394edd4427d52c3$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $f394edd4427d52c3$var$shellBoundary ? $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $f394edd4427d52c3$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $f394edd4427d52c3$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $f394edd4427d52c3$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $f394edd4427d52c3$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $f394edd4427d52c3$var$attachPingListener(root, value, rootRenderLanes);
        $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($f394edd4427d52c3$var$isHydrating) return returnFiber = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $f394edd4427d52c3$var$HydrationMismatchException && (root = Error($f394edd4427d52c3$var$formatProdErrorMessage(422), {
        cause: value
    }), $f394edd4427d52c3$var$queueHydrationError($f394edd4427d52c3$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $f394edd4427d52c3$var$HydrationMismatchException && (returnFiber = Error($f394edd4427d52c3$var$formatProdErrorMessage(423), {
        cause: value
    }), $f394edd4427d52c3$var$queueHydrationError($f394edd4427d52c3$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $f394edd4427d52c3$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $f394edd4427d52c3$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $f394edd4427d52c3$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($f394edd4427d52c3$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $f394edd4427d52c3$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $f394edd4427d52c3$var$workInProgressRootConcurrentErrors ? $f394edd4427d52c3$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $f394edd4427d52c3$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $f394edd4427d52c3$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $f394edd4427d52c3$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $f394edd4427d52c3$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed || !$f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $f394edd4427d52c3$var$createClassErrorUpdate(rootRenderLanes), $f394edd4427d52c3$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $f394edd4427d52c3$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $f394edd4427d52c3$var$SelectiveHydrationException = Error($f394edd4427d52c3$var$formatProdErrorMessage(461)), $f394edd4427d52c3$var$didReceiveUpdate = !1;
function $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $f394edd4427d52c3$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $f394edd4427d52c3$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    nextProps = $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $f394edd4427d52c3$var$checkDidRenderIdHook();
    if (null !== current && !$f394edd4427d52c3$var$didReceiveUpdate) return $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, renderLanes), $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f394edd4427d52c3$var$isHydrating && key && $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$f394edd4427d52c3$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $f394edd4427d52c3$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $f394edd4427d52c3$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $f394edd4427d52c3$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $f394edd4427d52c3$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $f394edd4427d52c3$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($f394edd4427d52c3$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($f394edd4427d52c3$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($f394edd4427d52c3$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $f394edd4427d52c3$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $f394edd4427d52c3$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $f394edd4427d52c3$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $f394edd4427d52c3$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $f394edd4427d52c3$var$pushHiddenContext(workInProgress, prevState) : $f394edd4427d52c3$var$reuseHiddenContextOnStack(), $f394edd4427d52c3$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $f394edd4427d52c3$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($f394edd4427d52c3$var$pushTransition(workInProgress, prevState.cachePool), $f394edd4427d52c3$var$pushHiddenContext(workInProgress, prevState), $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $f394edd4427d52c3$var$pushTransition(workInProgress, null), $f394edd4427d52c3$var$reuseHiddenContextOnStack(), $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress));
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $f394edd4427d52c3$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $f394edd4427d52c3$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $f394edd4427d52c3$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $f394edd4427d52c3$var$pushTransition(workInProgress, null);
    $f394edd4427d52c3$var$reuseHiddenContextOnStack();
    $f394edd4427d52c3$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $f394edd4427d52c3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f394edd4427d52c3$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $f394edd4427d52c3$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($f394edd4427d52c3$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $f394edd4427d52c3$var$bailoutOffscreenComponent(null, current);
            $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $f394edd4427d52c3$var$nextHydratableInstance) ? (current = $f394edd4427d52c3$var$canHydrateHydrationBoundary(current, $f394edd4427d52c3$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f394edd4427d52c3$var$treeContextProvider ? {
                    id: $f394edd4427d52c3$var$treeContextId,
                    overflow: $f394edd4427d52c3$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f394edd4427d52c3$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $f394edd4427d52c3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($f394edd4427d52c3$var$formatProdErrorMessage(558));
        } else if ($f394edd4427d52c3$var$didReceiveUpdate || $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $f394edd4427d52c3$var$didReceiveUpdate || didSuspend) {
            nextProps = $f394edd4427d52c3$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $f394edd4427d52c3$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(current, dehydrated), $f394edd4427d52c3$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $f394edd4427d52c3$var$SelectiveHydrationException;
            $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f394edd4427d52c3$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(dehydrated.nextSibling), $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$isHydrating = !0, $f394edd4427d52c3$var$hydrationErrors = null, $f394edd4427d52c3$var$rootOrSingletonContext = !1, null !== current && $f394edd4427d52c3$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f394edd4427d52c3$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $f394edd4427d52c3$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $f394edd4427d52c3$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $f394edd4427d52c3$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    Component = $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $f394edd4427d52c3$var$checkDidRenderIdHook();
    if (null !== current && !$f394edd4427d52c3$var$didReceiveUpdate) return $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, renderLanes), $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f394edd4427d52c3$var$isHydrating && nextProps && $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $f394edd4427d52c3$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $f394edd4427d52c3$var$finishRenderingHooks(current);
    Component = $f394edd4427d52c3$var$checkDidRenderIdHook();
    if (null !== current && !$f394edd4427d52c3$var$didReceiveUpdate) return $f394edd4427d52c3$var$bailoutHooks(current, workInProgress, renderLanes), $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f394edd4427d52c3$var$isHydrating && Component && $f394edd4427d52c3$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f394edd4427d52c3$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f394edd4427d52c3$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $f394edd4427d52c3$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $f394edd4427d52c3$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $f394edd4427d52c3$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $f394edd4427d52c3$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $f394edd4427d52c3$var$readContext(contextType) : $f394edd4427d52c3$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $f394edd4427d52c3$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $f394edd4427d52c3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $f394edd4427d52c3$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $f394edd4427d52c3$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $f394edd4427d52c3$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $f394edd4427d52c3$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $f394edd4427d52c3$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f394edd4427d52c3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $f394edd4427d52c3$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $f394edd4427d52c3$var$hasForceUpdate || $f394edd4427d52c3$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $f394edd4427d52c3$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $f394edd4427d52c3$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $f394edd4427d52c3$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $f394edd4427d52c3$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $f394edd4427d52c3$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f394edd4427d52c3$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $f394edd4427d52c3$var$hasForceUpdate || null !== current && null !== current.dependencies && $f394edd4427d52c3$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($f394edd4427d52c3$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $f394edd4427d52c3$var$hasForceUpdate || $f394edd4427d52c3$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $f394edd4427d52c3$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $f394edd4427d52c3$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $f394edd4427d52c3$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $f394edd4427d52c3$var$resetHydrationState();
    workInProgress.flags |= 256;
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $f394edd4427d52c3$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $f394edd4427d52c3$var$getSuspendedCache()
    };
}
function $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $f394edd4427d52c3$var$workInProgressDeferredLane);
    return current;
}
function $f394edd4427d52c3$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($f394edd4427d52c3$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($f394edd4427d52c3$var$isHydrating) {
            showFallback ? $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $f394edd4427d52c3$var$nextHydratableInstance) ? (current = $f394edd4427d52c3$var$canHydrateHydrationBoundary(current, $f394edd4427d52c3$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f394edd4427d52c3$var$treeContextProvider ? {
                    id: $f394edd4427d52c3$var$treeContextId,
                    overflow: $f394edd4427d52c3$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f394edd4427d52c3$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            $f394edd4427d52c3$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $f394edd4427d52c3$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f394edd4427d52c3$var$SUSPENDED_MARKER, $f394edd4427d52c3$var$bailoutOffscreenComponent(null, nextProps);
        $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $f394edd4427d52c3$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f394edd4427d52c3$var$SUSPENDED_MARKER, workInProgress = $f394edd4427d52c3$var$bailoutOffscreenComponent(null, nextProps));
        else if ($f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress), $f394edd4427d52c3$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($f394edd4427d52c3$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $f394edd4427d52c3$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($f394edd4427d52c3$var$didReceiveUpdate || $f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $f394edd4427d52c3$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $f394edd4427d52c3$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $f394edd4427d52c3$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(current, nextProps), $f394edd4427d52c3$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $f394edd4427d52c3$var$SelectiveHydrationException;
            $f394edd4427d52c3$var$isSuspenseInstancePending(nextPrimaryChildren) || $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $f394edd4427d52c3$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(nextPrimaryChildren.nextSibling), $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$isHydrating = !0, $f394edd4427d52c3$var$hydrationErrors = null, $f394edd4427d52c3$var$rootOrSingletonContext = !1, null !== current && $f394edd4427d52c3$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $f394edd4427d52c3$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $f394edd4427d52c3$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $f394edd4427d52c3$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $f394edd4427d52c3$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f394edd4427d52c3$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $f394edd4427d52c3$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $f394edd4427d52c3$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $f394edd4427d52c3$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $f394edd4427d52c3$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f394edd4427d52c3$var$SUSPENDED_MARKER, $f394edd4427d52c3$var$bailoutOffscreenComponent(current.child, nextProps);
    $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $f394edd4427d52c3$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $f394edd4427d52c3$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $f394edd4427d52c3$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $f394edd4427d52c3$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f394edd4427d52c3$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $f394edd4427d52c3$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $f394edd4427d52c3$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $f394edd4427d52c3$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $f394edd4427d52c3$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, suspenseContext);
    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $f394edd4427d52c3$var$isHydrating ? $f394edd4427d52c3$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $f394edd4427d52c3$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $f394edd4427d52c3$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $f394edd4427d52c3$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $f394edd4427d52c3$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $f394edd4427d52c3$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $f394edd4427d52c3$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $f394edd4427d52c3$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $f394edd4427d52c3$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $f394edd4427d52c3$var$checkIfContextChanged(current) ? !0 : !1;
}
function $f394edd4427d52c3$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, current.memoizedState.cache);
            $f394edd4427d52c3$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $f394edd4427d52c3$var$pushHostContext(workInProgress);
            break;
        case 4:
            $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $f394edd4427d52c3$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $f394edd4427d52c3$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $f394edd4427d52c3$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $f394edd4427d52c3$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($f394edd4427d52c3$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $f394edd4427d52c3$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $f394edd4427d52c3$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, current.memoizedState.cache);
    }
    return $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $f394edd4427d52c3$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $f394edd4427d52c3$var$didReceiveUpdate = !0;
        else {
            if (!$f394edd4427d52c3$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $f394edd4427d52c3$var$didReceiveUpdate = !1, $f394edd4427d52c3$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $f394edd4427d52c3$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $f394edd4427d52c3$var$didReceiveUpdate = !1, $f394edd4427d52c3$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $f394edd4427d52c3$var$pushTreeId(workInProgress, $f394edd4427d52c3$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $f394edd4427d52c3$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $f394edd4427d52c3$var$shouldConstruct(current) ? (props = $f394edd4427d52c3$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $f394edd4427d52c3$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $f394edd4427d52c3$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $f394edd4427d52c3$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $f394edd4427d52c3$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $f394edd4427d52c3$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $f394edd4427d52c3$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $f394edd4427d52c3$var$getComponentNameFromType(current) || current;
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $f394edd4427d52c3$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $f394edd4427d52c3$var$resolveClassComponentProps(props, workInProgress.pendingProps), $f394edd4427d52c3$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress);
                $f394edd4427d52c3$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, props);
                props !== prevState.cache && $f394edd4427d52c3$var$propagateContextChanges(workInProgress, [
                    $f394edd4427d52c3$var$CacheContext
                ], renderLanes, !0);
                $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $f394edd4427d52c3$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $f394edd4427d52c3$var$createCapturedValueAtFiber(Error($f394edd4427d52c3$var$formatProdErrorMessage(424)), workInProgress);
                        $f394edd4427d52c3$var$queueHydrationError($$typeof);
                        workInProgress = $f394edd4427d52c3$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(current.firstChild);
                        $f394edd4427d52c3$var$hydrationParentFiber = workInProgress;
                        $f394edd4427d52c3$var$isHydrating = !0;
                        $f394edd4427d52c3$var$hydrationErrors = null;
                        $f394edd4427d52c3$var$rootOrSingletonContext = !0;
                        renderLanes = $f394edd4427d52c3$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $f394edd4427d52c3$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $f394edd4427d52c3$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $f394edd4427d52c3$var$markRef(current, workInProgress), null === current ? (renderLanes = $f394edd4427d52c3$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $f394edd4427d52c3$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer($f394edd4427d52c3$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress, props[$f394edd4427d52c3$var$internalPropsKey] = current, $f394edd4427d52c3$var$setInitialProperties(props, renderLanes, current), $f394edd4427d52c3$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $f394edd4427d52c3$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $f394edd4427d52c3$var$pushHostContext(workInProgress), null === current && $f394edd4427d52c3$var$isHydrating && (props = workInProgress.stateNode = $f394edd4427d52c3$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $f394edd4427d52c3$var$rootInstanceStackCursor.current), $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$rootOrSingletonContext = !0, $$typeof = $f394edd4427d52c3$var$nextHydratableInstance, $f394edd4427d52c3$var$isSingletonScope(workInProgress.type) ? ($f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(props.firstChild)) : $f394edd4427d52c3$var$nextHydratableInstance = $$typeof), $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $f394edd4427d52c3$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $f394edd4427d52c3$var$isHydrating) {
                if ($$typeof = props = $f394edd4427d52c3$var$nextHydratableInstance) props = $f394edd4427d52c3$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $f394edd4427d52c3$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = $f394edd4427d52c3$var$getNextHydratable(props.firstChild), $f394edd4427d52c3$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            }
            $f394edd4427d52c3$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $f394edd4427d52c3$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $f394edd4427d52c3$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $f394edd4427d52c3$var$renderWithHooks(current, workInProgress, $f394edd4427d52c3$var$TransitionAwareHostComponent, null, null, renderLanes), $f394edd4427d52c3$var$HostTransitionContext._currentValue = $$typeof);
            $f394edd4427d52c3$var$markRef(current, workInProgress);
            $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $f394edd4427d52c3$var$isHydrating) {
                if (current = renderLanes = $f394edd4427d52c3$var$nextHydratableInstance) renderLanes = $f394edd4427d52c3$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $f394edd4427d52c3$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $f394edd4427d52c3$var$hydrationParentFiber = workInProgress, $f394edd4427d52c3$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $f394edd4427d52c3$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $f394edd4427d52c3$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $f394edd4427d52c3$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $f394edd4427d52c3$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $f394edd4427d52c3$var$pushProvider(workInProgress, workInProgress.type, props.value), $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $f394edd4427d52c3$var$prepareToReadContext(workInProgress), $$typeof = $f394edd4427d52c3$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $f394edd4427d52c3$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $f394edd4427d52c3$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $f394edd4427d52c3$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $f394edd4427d52c3$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $f394edd4427d52c3$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $f394edd4427d52c3$var$prepareToReadContext(workInProgress), props = $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$CacheContext), null === current ? ($$typeof = $f394edd4427d52c3$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $f394edd4427d52c3$var$workInProgressRoot, prevState = $f394edd4427d52c3$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $f394edd4427d52c3$var$initializeUpdateQueue(workInProgress), $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($f394edd4427d52c3$var$cloneUpdateQueue(current, workInProgress), $f394edd4427d52c3$var$processUpdateQueue(workInProgress, null, null, renderLanes), $f394edd4427d52c3$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, props)) : (props = prevState.cache, $f394edd4427d52c3$var$pushProvider(workInProgress, $f394edd4427d52c3$var$CacheContext, props), props !== $$typeof.cache && $f394edd4427d52c3$var$propagateContextChanges(workInProgress, [
                $f394edd4427d52c3$var$CacheContext
            ], renderLanes, !0))), $f394edd4427d52c3$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f394edd4427d52c3$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($f394edd4427d52c3$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $f394edd4427d52c3$var$suspendedThenable = $f394edd4427d52c3$var$noopSuspenseyCommitThenable, $f394edd4427d52c3$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $f394edd4427d52c3$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$f394edd4427d52c3$var$preloadResource(resource)) {
        if ($f394edd4427d52c3$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $f394edd4427d52c3$var$suspendedThenable = $f394edd4427d52c3$var$noopSuspenseyCommitThenable, $f394edd4427d52c3$var$SuspenseyCommitException;
    }
}
function $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $f394edd4427d52c3$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $f394edd4427d52c3$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$f394edd4427d52c3$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $f394edd4427d52c3$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $f394edd4427d52c3$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $f394edd4427d52c3$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 1:
            return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext);
            $f394edd4427d52c3$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $f394edd4427d52c3$var$popHydrationState(workInProgress) ? $f394edd4427d52c3$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable());
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($f394edd4427d52c3$var$markUpdate(workInProgress), null !== nextResource ? ($f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($f394edd4427d52c3$var$markUpdate(workInProgress), $f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f394edd4427d52c3$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress), $f394edd4427d52c3$var$bubbleProperties(workInProgress), $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $f394edd4427d52c3$var$popHostContext(workInProgress);
            renderLanes = $f394edd4427d52c3$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(166));
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f394edd4427d52c3$var$contextStackCursor.current;
                $f394edd4427d52c3$var$popHydrationState(workInProgress) ? $f394edd4427d52c3$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $f394edd4427d52c3$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $f394edd4427d52c3$var$markUpdate(workInProgress));
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $f394edd4427d52c3$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(166));
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $f394edd4427d52c3$var$contextStackCursor.current;
                if ($f394edd4427d52c3$var$popHydrationState(workInProgress)) $f394edd4427d52c3$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer($f394edd4427d52c3$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    nextResource[$f394edd4427d52c3$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($f394edd4427d52c3$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
                }
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            $f394edd4427d52c3$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f394edd4427d52c3$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(166));
                current = $f394edd4427d52c3$var$rootInstanceStackCursor.current;
                if ($f394edd4427d52c3$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $f394edd4427d52c3$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $f394edd4427d52c3$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $f394edd4427d52c3$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $f394edd4427d52c3$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(557));
                        current[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    } else $f394edd4427d52c3$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(558));
            }
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $f394edd4427d52c3$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(317));
                        type[$f394edd4427d52c3$var$internalInstanceKey] = workInProgress;
                    } else $f394edd4427d52c3$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f394edd4427d52c3$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $f394edd4427d52c3$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $f394edd4427d52c3$var$popHostContainer(), null === current && $f394edd4427d52c3$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 10:
            return $f394edd4427d52c3$var$popProvider(workInProgress.type), $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 19:
            $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $f394edd4427d52c3$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $f394edd4427d52c3$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$f394edd4427d52c3$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, $f394edd4427d52c3$var$suspenseStackCursor.current & 1 | 2);
                            $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $f394edd4427d52c3$var$now() > $f394edd4427d52c3$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $f394edd4427d52c3$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, current), $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$f394edd4427d52c3$var$isHydrating) return $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
                    } else 2 * $f394edd4427d52c3$var$now() - newProps.renderingStartTime > $f394edd4427d52c3$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $f394edd4427d52c3$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $f394edd4427d52c3$var$now(), current.sibling = null, renderLanes = $f394edd4427d52c3$var$suspenseStackCursor.current, $f394edd4427d52c3$var$push($f394edd4427d52c3$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $f394edd4427d52c3$var$isHydrating && $f394edd4427d52c3$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $f394edd4427d52c3$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), $f394edd4427d52c3$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($f394edd4427d52c3$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $f394edd4427d52c3$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $f394edd4427d52c3$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext), $f394edd4427d52c3$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f394edd4427d52c3$var$unwindWork(current, workInProgress) {
    $f394edd4427d52c3$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext), $f394edd4427d52c3$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $f394edd4427d52c3$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(340));
                $f394edd4427d52c3$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $f394edd4427d52c3$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(340));
                $f394edd4427d52c3$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor), null;
        case 4:
            return $f394edd4427d52c3$var$popHostContainer(), null;
        case 10:
            return $f394edd4427d52c3$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $f394edd4427d52c3$var$popSuspenseHandler(workInProgress), $f394edd4427d52c3$var$popHiddenContext(), null !== current && $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $f394edd4427d52c3$var$unwindInterruptedWork(current, interruptedWork) {
    $f394edd4427d52c3$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext);
            $f394edd4427d52c3$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $f394edd4427d52c3$var$popHostContext(interruptedWork);
            break;
        case 4:
            $f394edd4427d52c3$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $f394edd4427d52c3$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $f394edd4427d52c3$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$suspenseStackCursor);
            break;
        case 10:
            $f394edd4427d52c3$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $f394edd4427d52c3$var$popSuspenseHandler(interruptedWork);
            $f394edd4427d52c3$var$popHiddenContext();
            null !== current && $f394edd4427d52c3$var$pop($f394edd4427d52c3$var$resumedCache);
            break;
        case 24:
            $f394edd4427d52c3$var$popProvider($f394edd4427d52c3$var$CacheContext);
    }
}
function $f394edd4427d52c3$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $f394edd4427d52c3$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f394edd4427d52c3$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $f394edd4427d52c3$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f394edd4427d52c3$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f394edd4427d52c3$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $f394edd4427d52c3$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $f394edd4427d52c3$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $f394edd4427d52c3$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$f394edd4427d52c3$var$internalPropsKey] = newProps;
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $f394edd4427d52c3$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $f394edd4427d52c3$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $f394edd4427d52c3$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $f394edd4427d52c3$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $f394edd4427d52c3$var$noop$1));
    else if (4 !== tag && (27 === tag && $f394edd4427d52c3$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $f394edd4427d52c3$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $f394edd4427d52c3$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($f394edd4427d52c3$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$f394edd4427d52c3$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $f394edd4427d52c3$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $f394edd4427d52c3$var$setInitialProperties(singleton, type, props);
        singleton[$f394edd4427d52c3$var$internalInstanceKey] = finishedWork;
        singleton[$f394edd4427d52c3$var$internalPropsKey] = props;
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $f394edd4427d52c3$var$offscreenSubtreeIsHidden = !1, $f394edd4427d52c3$var$offscreenSubtreeWasHidden = !1, $f394edd4427d52c3$var$needsFormReset = !1, $f394edd4427d52c3$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $f394edd4427d52c3$var$nextEffect = null;
function $f394edd4427d52c3$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $f394edd4427d52c3$var$eventsEnabled = $f394edd4427d52c3$var$_enabled;
    root = $f394edd4427d52c3$var$getActiveElementDeep(root);
    if ($f394edd4427d52c3$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $f394edd4427d52c3$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $f394edd4427d52c3$var$_enabled = !1;
    for($f394edd4427d52c3$var$nextEffect = firstChild; null !== $f394edd4427d52c3$var$nextEffect;)if (firstChild = $f394edd4427d52c3$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $f394edd4427d52c3$var$nextEffect = root;
    else for(; null !== $f394edd4427d52c3$var$nextEffect;){
        firstChild = $f394edd4427d52c3$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $f394edd4427d52c3$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $f394edd4427d52c3$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $f394edd4427d52c3$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $f394edd4427d52c3$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $f394edd4427d52c3$var$nextEffect = root;
            break;
        }
        $f394edd4427d52c3$var$nextEffect = firstChild.return;
    }
}
function $f394edd4427d52c3$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f394edd4427d52c3$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $f394edd4427d52c3$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $f394edd4427d52c3$var$commitClassCallbacks(finishedWork);
            flags & 512 && $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $f394edd4427d52c3$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $f394edd4427d52c3$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $f394edd4427d52c3$var$commitHostMount(finishedWork);
            flags & 512 && $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f394edd4427d52c3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f394edd4427d52c3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $f394edd4427d52c3$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $f394edd4427d52c3$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $f394edd4427d52c3$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $f394edd4427d52c3$var$offscreenSubtreeWasHidden;
                prevProps = $f394edd4427d52c3$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $f394edd4427d52c3$var$offscreenSubtreeWasHidden;
                $f394edd4427d52c3$var$offscreenSubtreeIsHidden = flags;
                ($f394edd4427d52c3$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $f394edd4427d52c3$var$offscreenSubtreeIsHidden = prevProps;
                $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $f394edd4427d52c3$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $f394edd4427d52c3$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $f394edd4427d52c3$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $f394edd4427d52c3$var$hostParent = null, $f394edd4427d52c3$var$hostParentIsContainer = !1;
function $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$f394edd4427d52c3$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $f394edd4427d52c3$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.onCommitFiberUnmount) try {
        $f394edd4427d52c3$var$injectedHook.onCommitFiberUnmount($f394edd4427d52c3$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $f394edd4427d52c3$var$hostParent, prevHostParentIsContainer = $f394edd4427d52c3$var$hostParentIsContainer;
            $f394edd4427d52c3$var$isSingletonScope(deletedFiber.type) && ($f394edd4427d52c3$var$hostParent = deletedFiber.stateNode, $f394edd4427d52c3$var$hostParentIsContainer = !1);
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$releaseSingletonInstance(deletedFiber.stateNode);
            $f394edd4427d52c3$var$hostParent = prevHostParent;
            $f394edd4427d52c3$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $f394edd4427d52c3$var$hostParent;
            prevHostParentIsContainer = $f394edd4427d52c3$var$hostParentIsContainer;
            $f394edd4427d52c3$var$hostParent = null;
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$hostParent = prevHostParent;
            $f394edd4427d52c3$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $f394edd4427d52c3$var$hostParent) {
                if ($f394edd4427d52c3$var$hostParentIsContainer) try {
                    (9 === $f394edd4427d52c3$var$hostParent.nodeType ? $f394edd4427d52c3$var$hostParent.body : "HTML" === $f394edd4427d52c3$var$hostParent.nodeName ? $f394edd4427d52c3$var$hostParent.ownerDocument.body : $f394edd4427d52c3$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $f394edd4427d52c3$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $f394edd4427d52c3$var$hostParent && ($f394edd4427d52c3$var$hostParentIsContainer ? (finishedRoot = $f394edd4427d52c3$var$hostParent, $f394edd4427d52c3$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $f394edd4427d52c3$var$retryIfBlockedOn(finishedRoot)) : $f394edd4427d52c3$var$clearHydrationBoundary($f394edd4427d52c3$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $f394edd4427d52c3$var$hostParent;
            prevHostParentIsContainer = $f394edd4427d52c3$var$hostParentIsContainer;
            $f394edd4427d52c3$var$hostParent = deletedFiber.stateNode.containerInfo;
            $f394edd4427d52c3$var$hostParentIsContainer = !0;
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$hostParent = prevHostParent;
            $f394edd4427d52c3$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $f394edd4427d52c3$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden || ($f394edd4427d52c3$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $f394edd4427d52c3$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = (prevHostParent = $f394edd4427d52c3$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $f394edd4427d52c3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $f394edd4427d52c3$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f394edd4427d52c3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $f394edd4427d52c3$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f394edd4427d52c3$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $f394edd4427d52c3$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $f394edd4427d52c3$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $f394edd4427d52c3$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $f394edd4427d52c3$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($f394edd4427d52c3$var$isSingletonScope(parent.type)) {
                        $f394edd4427d52c3$var$hostParent = parent.stateNode;
                        $f394edd4427d52c3$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $f394edd4427d52c3$var$hostParent = parent.stateNode;
                    $f394edd4427d52c3$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $f394edd4427d52c3$var$hostParent = parent.stateNode.containerInfo;
                    $f394edd4427d52c3$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $f394edd4427d52c3$var$hostParent) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(160));
        $f394edd4427d52c3$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $f394edd4427d52c3$var$hostParent = null;
        $f394edd4427d52c3$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $f394edd4427d52c3$var$currentHoistableRoot = null;
function $f394edd4427d52c3$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($f394edd4427d52c3$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $f394edd4427d52c3$var$commitHookEffectListMount(3, finishedWork), $f394edd4427d52c3$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            flags & 64 && $f394edd4427d52c3$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$f394edd4427d52c3$var$internalHoistableMarker] || currentResource[$f394edd4427d52c3$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $f394edd4427d52c3$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$f394edd4427d52c3$var$internalInstanceKey] = finishedWork;
                                        $f394edd4427d52c3$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $f394edd4427d52c3$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f394edd4427d52c3$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $f394edd4427d52c3$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f394edd4427d52c3$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$f394edd4427d52c3$var$internalInstanceKey] = finishedWork;
                                $f394edd4427d52c3$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $f394edd4427d52c3$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $f394edd4427d52c3$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $f394edd4427d52c3$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $f394edd4427d52c3$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $f394edd4427d52c3$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $f394edd4427d52c3$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f394edd4427d52c3$var$offscreenSubtreeWasHidden || null === current || $f394edd4427d52c3$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $f394edd4427d52c3$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $f394edd4427d52c3$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($f394edd4427d52c3$var$needsFormReset = !0);
            break;
        case 6:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $f394edd4427d52c3$var$tagCaches = null;
            hoistableRoot = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$currentHoistableRoot = $f394edd4427d52c3$var$getHoistableRoot(root.containerInfo);
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$currentHoistableRoot = hoistableRoot;
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $f394edd4427d52c3$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $f394edd4427d52c3$var$needsFormReset && ($f394edd4427d52c3$var$needsFormReset = !1, $f394edd4427d52c3$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$currentHoistableRoot = $f394edd4427d52c3$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            $f394edd4427d52c3$var$currentHoistableRoot = flags;
            break;
        case 12:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($f394edd4427d52c3$var$globalMostRecentFallbackTime = $f394edd4427d52c3$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $f394edd4427d52c3$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $f394edd4427d52c3$var$offscreenSubtreeWasHidden;
            $f394edd4427d52c3$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $f394edd4427d52c3$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $f394edd4427d52c3$var$offscreenSubtreeIsHidden || $f394edd4427d52c3$var$offscreenSubtreeWasHidden || $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $f394edd4427d52c3$var$hideOrUnhideDehydratedBoundary(instance, !0) : $f394edd4427d52c3$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $f394edd4427d52c3$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f394edd4427d52c3$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraverseMutationEffects(root, finishedWork), $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork);
    }
}
function $f394edd4427d52c3$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($f394edd4427d52c3$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $f394edd4427d52c3$var$getHostSibling(finishedWork);
                    $f394edd4427d52c3$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($f394edd4427d52c3$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $f394edd4427d52c3$var$getHostSibling(finishedWork);
                    $f394edd4427d52c3$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $f394edd4427d52c3$var$getHostSibling(finishedWork);
                    $f394edd4427d52c3$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $f394edd4427d52c3$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $f394edd4427d52c3$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $f394edd4427d52c3$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $f394edd4427d52c3$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $f394edd4427d52c3$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $f394edd4427d52c3$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $f394edd4427d52c3$var$safelyDetachRef(finishedWork, finishedWork.return);
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f394edd4427d52c3$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$f394edd4427d52c3$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $f394edd4427d52c3$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $f394edd4427d52c3$var$commitClassCallbacks(finishedWork);
                $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $f394edd4427d52c3$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $f394edd4427d52c3$var$commitHostMount(finishedWork);
                $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f394edd4427d52c3$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f394edd4427d52c3$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f394edd4427d52c3$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $f394edd4427d52c3$var$releaseCache(previousCache));
}
function $f394edd4427d52c3$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $f394edd4427d52c3$var$releaseCache(current));
}
function $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f394edd4427d52c3$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $f394edd4427d52c3$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $f394edd4427d52c3$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f394edd4427d52c3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $f394edd4427d52c3$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $f394edd4427d52c3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f394edd4427d52c3$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f394edd4427d52c3$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $f394edd4427d52c3$var$suspenseyCommitFlag = 8192;
function $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $f394edd4427d52c3$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $f394edd4427d52c3$var$suspenseyCommitFlag && null !== fiber.memoizedState && $f394edd4427d52c3$var$suspendResource(suspendedState, $f394edd4427d52c3$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $f394edd4427d52c3$var$currentHoistableRoot;
            $f394edd4427d52c3$var$currentHoistableRoot = $f394edd4427d52c3$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $f394edd4427d52c3$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $f394edd4427d52c3$var$suspenseyCommitFlag, $f394edd4427d52c3$var$suspenseyCommitFlag = 16777216, $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $f394edd4427d52c3$var$suspenseyCommitFlag = previousHoistableRoot) : $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $f394edd4427d52c3$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $f394edd4427d52c3$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f394edd4427d52c3$var$nextEffect = childToDelete;
            $f394edd4427d52c3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f394edd4427d52c3$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f394edd4427d52c3$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f394edd4427d52c3$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $f394edd4427d52c3$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $f394edd4427d52c3$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f394edd4427d52c3$var$nextEffect = childToDelete;
            $f394edd4427d52c3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f394edd4427d52c3$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $f394edd4427d52c3$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f394edd4427d52c3$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $f394edd4427d52c3$var$nextEffect;){
        var fiber = $f394edd4427d52c3$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $f394edd4427d52c3$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $f394edd4427d52c3$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $f394edd4427d52c3$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $f394edd4427d52c3$var$nextEffect;){
            cache = $f394edd4427d52c3$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $f394edd4427d52c3$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $f394edd4427d52c3$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $f394edd4427d52c3$var$nextEffect = sibling;
                break a;
            }
            $f394edd4427d52c3$var$nextEffect = returnFiber;
        }
    }
}
var $f394edd4427d52c3$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $f394edd4427d52c3$var$readContext($f394edd4427d52c3$var$CacheContext).controller.signal;
    }
}, $f394edd4427d52c3$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $f394edd4427d52c3$var$executionContext = 0, $f394edd4427d52c3$var$workInProgressRoot = null, $f394edd4427d52c3$var$workInProgress = null, $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0, $f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings = !1, $f394edd4427d52c3$var$workInProgressRootIsPrerendering = !1, $f394edd4427d52c3$var$workInProgressRootDidAttachPingListener = !1, $f394edd4427d52c3$var$entangledRenderLanes = 0, $f394edd4427d52c3$var$workInProgressRootExitStatus = 0, $f394edd4427d52c3$var$workInProgressRootSkippedLanes = 0, $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes = 0, $f394edd4427d52c3$var$workInProgressRootPingedLanes = 0, $f394edd4427d52c3$var$workInProgressDeferredLane = 0, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes = 0, $f394edd4427d52c3$var$workInProgressRootConcurrentErrors = null, $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = null, $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $f394edd4427d52c3$var$globalMostRecentFallbackTime = 0, $f394edd4427d52c3$var$globalMostRecentTransitionTime = 0, $f394edd4427d52c3$var$workInProgressRootRenderTargetTime = Infinity, $f394edd4427d52c3$var$workInProgressTransitions = null, $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed = null, $f394edd4427d52c3$var$pendingEffectsStatus = 0, $f394edd4427d52c3$var$pendingEffectsRoot = null, $f394edd4427d52c3$var$pendingFinishedWork = null, $f394edd4427d52c3$var$pendingEffectsLanes = 0, $f394edd4427d52c3$var$pendingEffectsRemainingLanes = 0, $f394edd4427d52c3$var$pendingPassiveTransitions = null, $f394edd4427d52c3$var$pendingRecoverableErrors = null, $f394edd4427d52c3$var$nestedUpdateCount = 0, $f394edd4427d52c3$var$rootWithNestedUpdates = null;
function $f394edd4427d52c3$var$requestUpdateLane() {
    return 0 !== ($f394edd4427d52c3$var$executionContext & 2) && 0 !== $f394edd4427d52c3$var$workInProgressRootRenderLanes ? $f394edd4427d52c3$var$workInProgressRootRenderLanes & -$f394edd4427d52c3$var$workInProgressRootRenderLanes : null !== $f394edd4427d52c3$var$ReactSharedInternals.T ? $f394edd4427d52c3$var$requestTransitionLane() : $f394edd4427d52c3$var$resolveUpdatePriority();
}
function $f394edd4427d52c3$var$requestDeferredLane() {
    if (0 === $f394edd4427d52c3$var$workInProgressDeferredLane) {
        if (0 === ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 536870912) || $f394edd4427d52c3$var$isHydrating) {
            var lane = $f394edd4427d52c3$var$nextTransitionDeferredLane;
            $f394edd4427d52c3$var$nextTransitionDeferredLane <<= 1;
            0 === ($f394edd4427d52c3$var$nextTransitionDeferredLane & 3932160) && ($f394edd4427d52c3$var$nextTransitionDeferredLane = 262144);
            $f394edd4427d52c3$var$workInProgressDeferredLane = lane;
        } else $f394edd4427d52c3$var$workInProgressDeferredLane = 536870912;
    }
    lane = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $f394edd4427d52c3$var$workInProgressDeferredLane;
}
function $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $f394edd4427d52c3$var$workInProgressRoot && (2 === $f394edd4427d52c3$var$workInProgressSuspendedReason || 9 === $f394edd4427d52c3$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $f394edd4427d52c3$var$prepareFreshStack(root, 0), $f394edd4427d52c3$var$markRootSuspended(root, $f394edd4427d52c3$var$workInProgressRootRenderLanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !1);
    $f394edd4427d52c3$var$markRootUpdated$1(root, lane);
    if (0 === ($f394edd4427d52c3$var$executionContext & 2) || root !== $f394edd4427d52c3$var$workInProgressRoot) root === $f394edd4427d52c3$var$workInProgressRoot && (0 === ($f394edd4427d52c3$var$executionContext & 2) && ($f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $f394edd4427d52c3$var$workInProgressRootExitStatus && $f394edd4427d52c3$var$markRootSuspended(root, $f394edd4427d52c3$var$workInProgressRootRenderLanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !1)), $f394edd4427d52c3$var$ensureRootIsScheduled(root);
}
function $f394edd4427d52c3$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($f394edd4427d52c3$var$executionContext & 6)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $f394edd4427d52c3$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $f394edd4427d52c3$var$renderRootConcurrent(root$jscomp$0, lanes) : $f394edd4427d52c3$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $f394edd4427d52c3$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $f394edd4427d52c3$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$f394edd4427d52c3$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $f394edd4427d52c3$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $f394edd4427d52c3$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($f394edd4427d52c3$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $f394edd4427d52c3$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($f394edd4427d52c3$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $f394edd4427d52c3$var$workInProgressRootRecoverableErrors;
                            $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $f394edd4427d52c3$var$workInProgressRootRecoverableErrors ? $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $f394edd4427d52c3$var$workInProgressRootRecoverableErrors.push.apply($f394edd4427d52c3$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $f394edd4427d52c3$var$prepareFreshStack(root$jscomp$0, 0);
                $f394edd4427d52c3$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $f394edd4427d52c3$var$markRootSuspended(shouldTimeSlice, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !$f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $f394edd4427d52c3$var$globalMostRecentFallbackTime + 300 - $f394edd4427d52c3$var$now(), 10 < exitStatus)) {
                    $f394edd4427d52c3$var$markRootSuspended(shouldTimeSlice, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !$f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $f394edd4427d52c3$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $f394edd4427d52c3$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $f394edd4427d52c3$var$scheduleTimeout($f394edd4427d52c3$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $f394edd4427d52c3$var$workInProgressRootRecoverableErrors, $f394edd4427d52c3$var$workInProgressTransitions, $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $f394edd4427d52c3$var$commitRootWhenReady(shouldTimeSlice, forceSync, $f394edd4427d52c3$var$workInProgressRootRecoverableErrors, $f394edd4427d52c3$var$workInProgressTransitions, $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f394edd4427d52c3$var$workInProgressDeferredLane, $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $f394edd4427d52c3$var$ensureRootIsScheduled(root$jscomp$0);
}
function $f394edd4427d52c3$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $f394edd4427d52c3$var$noop$1
        };
        $f394edd4427d52c3$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $f394edd4427d52c3$var$globalMostRecentFallbackTime - $f394edd4427d52c3$var$now() : (lanes & 4194048) === lanes ? $f394edd4427d52c3$var$globalMostRecentTransitionTime - $f394edd4427d52c3$var$now() : 0;
        timeoutOffset = $f394edd4427d52c3$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $f394edd4427d52c3$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($f394edd4427d52c3$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $f394edd4427d52c3$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $f394edd4427d52c3$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $f394edd4427d52c3$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$f394edd4427d52c3$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $f394edd4427d52c3$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$f394edd4427d52c3$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $f394edd4427d52c3$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $f394edd4427d52c3$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $f394edd4427d52c3$var$flushSyncWork$1() {
    return 0 === ($f394edd4427d52c3$var$executionContext & 6) ? ($f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $f394edd4427d52c3$var$resetWorkInProgressStack() {
    if (null !== $f394edd4427d52c3$var$workInProgress) {
        if (0 === $f394edd4427d52c3$var$workInProgressSuspendedReason) var interruptedWork = $f394edd4427d52c3$var$workInProgress.return;
        else interruptedWork = $f394edd4427d52c3$var$workInProgress, $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null, $f394edd4427d52c3$var$resetHooksOnUnwind(interruptedWork), $f394edd4427d52c3$var$thenableState$1 = null, $f394edd4427d52c3$var$thenableIndexCounter$1 = 0, interruptedWork = $f394edd4427d52c3$var$workInProgress;
        for(; null !== interruptedWork;)$f394edd4427d52c3$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $f394edd4427d52c3$var$workInProgress = null;
    }
}
function $f394edd4427d52c3$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $f394edd4427d52c3$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $f394edd4427d52c3$var$pendingEffectsLanes = 0;
    $f394edd4427d52c3$var$resetWorkInProgressStack();
    $f394edd4427d52c3$var$workInProgressRoot = root;
    $f394edd4427d52c3$var$workInProgress = timeoutHandle = $f394edd4427d52c3$var$createWorkInProgress(root.current, null);
    $f394edd4427d52c3$var$workInProgressRootRenderLanes = lanes;
    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
    $f394edd4427d52c3$var$workInProgressThrownValue = null;
    $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $f394edd4427d52c3$var$workInProgressRootIsPrerendering = $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, lanes);
    $f394edd4427d52c3$var$workInProgressRootDidAttachPingListener = !1;
    $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes = $f394edd4427d52c3$var$workInProgressDeferredLane = $f394edd4427d52c3$var$workInProgressRootPingedLanes = $f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes = $f394edd4427d52c3$var$workInProgressRootSkippedLanes = $f394edd4427d52c3$var$workInProgressRootExitStatus = 0;
    $f394edd4427d52c3$var$workInProgressRootRecoverableErrors = $f394edd4427d52c3$var$workInProgressRootConcurrentErrors = null;
    $f394edd4427d52c3$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $f394edd4427d52c3$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $f394edd4427d52c3$var$entangledRenderLanes = lanes;
    $f394edd4427d52c3$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $f394edd4427d52c3$var$handleThrow(root, thrownValue) {
    $f394edd4427d52c3$var$currentlyRenderingFiber = null;
    $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$ContextOnlyDispatcher;
    thrownValue === $f394edd4427d52c3$var$SuspenseException || thrownValue === $f394edd4427d52c3$var$SuspenseActionException ? (thrownValue = $f394edd4427d52c3$var$getSuspendedThenable(), $f394edd4427d52c3$var$workInProgressSuspendedReason = 3) : thrownValue === $f394edd4427d52c3$var$SuspenseyCommitException ? (thrownValue = $f394edd4427d52c3$var$getSuspendedThenable(), $f394edd4427d52c3$var$workInProgressSuspendedReason = 4) : $f394edd4427d52c3$var$workInProgressSuspendedReason = thrownValue === $f394edd4427d52c3$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $f394edd4427d52c3$var$workInProgressThrownValue = thrownValue;
    null === $f394edd4427d52c3$var$workInProgress && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 1, $f394edd4427d52c3$var$logUncaughtError(root, $f394edd4427d52c3$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $f394edd4427d52c3$var$shouldRemainOnPreviousScreen() {
    var handler = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 4194048) === $f394edd4427d52c3$var$workInProgressRootRenderLanes ? null === $f394edd4427d52c3$var$shellBoundary ? !0 : !1 : ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 62914560) === $f394edd4427d52c3$var$workInProgressRootRenderLanes || 0 !== ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 536870912) ? handler === $f394edd4427d52c3$var$shellBoundary : !1;
}
function $f394edd4427d52c3$var$pushDispatcher() {
    var prevDispatcher = $f394edd4427d52c3$var$ReactSharedInternals.H;
    $f394edd4427d52c3$var$ReactSharedInternals.H = $f394edd4427d52c3$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $f394edd4427d52c3$var$ContextOnlyDispatcher : prevDispatcher;
}
function $f394edd4427d52c3$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $f394edd4427d52c3$var$ReactSharedInternals.A;
    $f394edd4427d52c3$var$ReactSharedInternals.A = $f394edd4427d52c3$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $f394edd4427d52c3$var$renderDidSuspendDelayIfPossible() {
    $f394edd4427d52c3$var$workInProgressRootExitStatus = 4;
    $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings || ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 4194048) !== $f394edd4427d52c3$var$workInProgressRootRenderLanes && null !== $f394edd4427d52c3$var$suspenseHandlerStackCursor.current || ($f394edd4427d52c3$var$workInProgressRootIsPrerendering = !0);
    0 === ($f394edd4427d52c3$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($f394edd4427d52c3$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $f394edd4427d52c3$var$workInProgressRoot || $f394edd4427d52c3$var$markRootSuspended($f394edd4427d52c3$var$workInProgressRoot, $f394edd4427d52c3$var$workInProgressRootRenderLanes, $f394edd4427d52c3$var$workInProgressDeferredLane, !1);
}
function $f394edd4427d52c3$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
    $f394edd4427d52c3$var$executionContext |= 2;
    var prevDispatcher = $f394edd4427d52c3$var$pushDispatcher(), prevAsyncDispatcher = $f394edd4427d52c3$var$pushAsyncDispatcher();
    if ($f394edd4427d52c3$var$workInProgressRoot !== root || $f394edd4427d52c3$var$workInProgressRootRenderLanes !== lanes) $f394edd4427d52c3$var$workInProgressTransitions = null, $f394edd4427d52c3$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $f394edd4427d52c3$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $f394edd4427d52c3$var$workInProgressSuspendedReason && null !== $f394edd4427d52c3$var$workInProgress) {
            var unitOfWork = $f394edd4427d52c3$var$workInProgress, thrownValue = $f394edd4427d52c3$var$workInProgressThrownValue;
            switch($f394edd4427d52c3$var$workInProgressSuspendedReason){
                case 8:
                    $f394edd4427d52c3$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $f394edd4427d52c3$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $f394edd4427d52c3$var$workInProgressSuspendedReason;
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $f394edd4427d52c3$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $f394edd4427d52c3$var$workInProgressSuspendedReason, $f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $f394edd4427d52c3$var$workLoopSync();
        exitStatus = $f394edd4427d52c3$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $f394edd4427d52c3$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null;
    $f394edd4427d52c3$var$executionContext = prevExecutionContext;
    $f394edd4427d52c3$var$ReactSharedInternals.H = prevDispatcher;
    $f394edd4427d52c3$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $f394edd4427d52c3$var$workInProgress && ($f394edd4427d52c3$var$workInProgressRoot = null, $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0, $f394edd4427d52c3$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $f394edd4427d52c3$var$workLoopSync() {
    for(; null !== $f394edd4427d52c3$var$workInProgress;)$f394edd4427d52c3$var$performUnitOfWork($f394edd4427d52c3$var$workInProgress);
}
function $f394edd4427d52c3$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
    $f394edd4427d52c3$var$executionContext |= 2;
    var prevDispatcher = $f394edd4427d52c3$var$pushDispatcher(), prevAsyncDispatcher = $f394edd4427d52c3$var$pushAsyncDispatcher();
    $f394edd4427d52c3$var$workInProgressRoot !== root || $f394edd4427d52c3$var$workInProgressRootRenderLanes !== lanes ? ($f394edd4427d52c3$var$workInProgressTransitions = null, $f394edd4427d52c3$var$workInProgressRootRenderTargetTime = $f394edd4427d52c3$var$now() + 500, $f394edd4427d52c3$var$prepareFreshStack(root, lanes)) : $f394edd4427d52c3$var$workInProgressRootIsPrerendering = $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $f394edd4427d52c3$var$workInProgressSuspendedReason && null !== $f394edd4427d52c3$var$workInProgress) {
            lanes = $f394edd4427d52c3$var$workInProgress;
            var thrownValue = $f394edd4427d52c3$var$workInProgressThrownValue;
            b: switch($f394edd4427d52c3$var$workInProgressSuspendedReason){
                case 1:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($f394edd4427d52c3$var$isThenableResolved(thrownValue)) {
                        $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                        $f394edd4427d52c3$var$workInProgressThrownValue = null;
                        $f394edd4427d52c3$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $f394edd4427d52c3$var$workInProgressSuspendedReason && 9 !== $f394edd4427d52c3$var$workInProgressSuspendedReason || $f394edd4427d52c3$var$workInProgressRoot !== root || ($f394edd4427d52c3$var$workInProgressSuspendedReason = 7);
                        $f394edd4427d52c3$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $f394edd4427d52c3$var$isThenableResolved(thrownValue) ? ($f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$replaySuspendedUnitOfWork(lanes)) : ($f394edd4427d52c3$var$workInProgressSuspendedReason = 0, $f394edd4427d52c3$var$workInProgressThrownValue = null, $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($f394edd4427d52c3$var$workInProgress.tag){
                        case 26:
                            resource = $f394edd4427d52c3$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $f394edd4427d52c3$var$workInProgress;
                            if (resource ? $f394edd4427d52c3$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                                $f394edd4427d52c3$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $f394edd4427d52c3$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($f394edd4427d52c3$var$workInProgress = returnFiber, $f394edd4427d52c3$var$completeUnitOfWork(returnFiber)) : $f394edd4427d52c3$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $f394edd4427d52c3$var$workInProgressSuspendedReason = 0;
                    $f394edd4427d52c3$var$workInProgressThrownValue = null;
                    $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $f394edd4427d52c3$var$resetWorkInProgressStack();
                    $f394edd4427d52c3$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(462));
            }
        }
        $f394edd4427d52c3$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $f394edd4427d52c3$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null;
    $f394edd4427d52c3$var$ReactSharedInternals.H = prevDispatcher;
    $f394edd4427d52c3$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $f394edd4427d52c3$var$executionContext = prevExecutionContext;
    if (null !== $f394edd4427d52c3$var$workInProgress) return 0;
    $f394edd4427d52c3$var$workInProgressRoot = null;
    $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0;
    $f394edd4427d52c3$var$finishQueueingConcurrentUpdates();
    return $f394edd4427d52c3$var$workInProgressRootExitStatus;
}
function $f394edd4427d52c3$var$workLoopConcurrentByScheduler() {
    for(; null !== $f394edd4427d52c3$var$workInProgress && !$f394edd4427d52c3$var$shouldYield();)$f394edd4427d52c3$var$performUnitOfWork($f394edd4427d52c3$var$workInProgress);
}
function $f394edd4427d52c3$var$performUnitOfWork(unitOfWork) {
    var next = $f394edd4427d52c3$var$beginWork(unitOfWork.alternate, unitOfWork, $f394edd4427d52c3$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork) : $f394edd4427d52c3$var$workInProgress = next;
}
function $f394edd4427d52c3$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $f394edd4427d52c3$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $f394edd4427d52c3$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $f394edd4427d52c3$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $f394edd4427d52c3$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $f394edd4427d52c3$var$resetHooksOnUnwind(next);
        default:
            $f394edd4427d52c3$var$unwindInterruptedWork(current, next), next = $f394edd4427d52c3$var$workInProgress = $f394edd4427d52c3$var$resetWorkInProgress(next, $f394edd4427d52c3$var$entangledRenderLanes), next = $f394edd4427d52c3$var$beginWork(current, next, $f394edd4427d52c3$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork) : $f394edd4427d52c3$var$workInProgress = next;
}
function $f394edd4427d52c3$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $f394edd4427d52c3$var$lastContextDependency = $f394edd4427d52c3$var$currentlyRenderingFiber$1 = null;
    $f394edd4427d52c3$var$resetHooksOnUnwind(unitOfWork);
    $f394edd4427d52c3$var$thenableState$1 = null;
    $f394edd4427d52c3$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($f394edd4427d52c3$var$throwException(root, returnFiber, unitOfWork, thrownValue, $f394edd4427d52c3$var$workInProgressRootRenderLanes)) {
            $f394edd4427d52c3$var$workInProgressRootExitStatus = 1;
            $f394edd4427d52c3$var$logUncaughtError(root, $f394edd4427d52c3$var$createCapturedValueAtFiber(thrownValue, root.current));
            $f394edd4427d52c3$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $f394edd4427d52c3$var$workInProgress = returnFiber, error;
        $f394edd4427d52c3$var$workInProgressRootExitStatus = 1;
        $f394edd4427d52c3$var$logUncaughtError(root, $f394edd4427d52c3$var$createCapturedValueAtFiber(thrownValue, root.current));
        $f394edd4427d52c3$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($f394edd4427d52c3$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($f394edd4427d52c3$var$workInProgressRootIsPrerendering || 0 !== ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $f394edd4427d52c3$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $f394edd4427d52c3$var$unwindUnitOfWork(unitOfWork, root);
    } else $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork);
}
function $f394edd4427d52c3$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $f394edd4427d52c3$var$unwindUnitOfWork(completedWork, $f394edd4427d52c3$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $f394edd4427d52c3$var$completeWork(completedWork.alternate, completedWork, $f394edd4427d52c3$var$entangledRenderLanes);
        if (null !== next) {
            $f394edd4427d52c3$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $f394edd4427d52c3$var$workInProgress = completedWork;
            return;
        }
        $f394edd4427d52c3$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootExitStatus = 5);
}
function $f394edd4427d52c3$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $f394edd4427d52c3$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $f394edd4427d52c3$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $f394edd4427d52c3$var$workInProgress = unitOfWork;
            return;
        }
        $f394edd4427d52c3$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $f394edd4427d52c3$var$workInProgressRootExitStatus = 6;
    $f394edd4427d52c3$var$workInProgress = null;
}
function $f394edd4427d52c3$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $f394edd4427d52c3$var$flushPendingEffects();
    while (0 !== $f394edd4427d52c3$var$pendingEffectsStatus);
    if (0 !== ($f394edd4427d52c3$var$executionContext & 6)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $f394edd4427d52c3$var$concurrentlyUpdatedLanes;
        $f394edd4427d52c3$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $f394edd4427d52c3$var$workInProgressRoot && ($f394edd4427d52c3$var$workInProgress = $f394edd4427d52c3$var$workInProgressRoot = null, $f394edd4427d52c3$var$workInProgressRootRenderLanes = 0);
        $f394edd4427d52c3$var$pendingFinishedWork = finishedWork;
        $f394edd4427d52c3$var$pendingEffectsRoot = root;
        $f394edd4427d52c3$var$pendingEffectsLanes = lanes;
        $f394edd4427d52c3$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $f394edd4427d52c3$var$pendingPassiveTransitions = transitions;
        $f394edd4427d52c3$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $f394edd4427d52c3$var$scheduleCallback$1($f394edd4427d52c3$var$NormalPriority$1, function() {
            $f394edd4427d52c3$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $f394edd4427d52c3$var$ReactSharedInternals.T;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            transitions = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $f394edd4427d52c3$var$executionContext;
            $f394edd4427d52c3$var$executionContext |= 4;
            try {
                $f394edd4427d52c3$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $f394edd4427d52c3$var$executionContext = spawnedLane, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = transitions, $f394edd4427d52c3$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $f394edd4427d52c3$var$pendingEffectsStatus = 1;
        $f394edd4427d52c3$var$flushMutationEffects();
        $f394edd4427d52c3$var$flushLayoutEffects();
        $f394edd4427d52c3$var$flushSpawnedWork();
    }
}
function $f394edd4427d52c3$var$flushMutationEffects() {
    if (1 === $f394edd4427d52c3$var$pendingEffectsStatus) {
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        var root = $f394edd4427d52c3$var$pendingEffectsRoot, finishedWork = $f394edd4427d52c3$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $f394edd4427d52c3$var$ReactSharedInternals.T;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
            $f394edd4427d52c3$var$executionContext |= 4;
            try {
                $f394edd4427d52c3$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $f394edd4427d52c3$var$selectionInformation, curFocusedElem = $f394edd4427d52c3$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $f394edd4427d52c3$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $f394edd4427d52c3$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $f394edd4427d52c3$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $f394edd4427d52c3$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $f394edd4427d52c3$var$_enabled = !!$f394edd4427d52c3$var$eventsEnabled;
                $f394edd4427d52c3$var$selectionInformation = $f394edd4427d52c3$var$eventsEnabled = null;
            } finally{
                $f394edd4427d52c3$var$executionContext = prevExecutionContext, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $f394edd4427d52c3$var$pendingEffectsStatus = 2;
    }
}
function $f394edd4427d52c3$var$flushLayoutEffects() {
    if (2 === $f394edd4427d52c3$var$pendingEffectsStatus) {
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        var root = $f394edd4427d52c3$var$pendingEffectsRoot, finishedWork = $f394edd4427d52c3$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $f394edd4427d52c3$var$ReactSharedInternals.T;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
            $f394edd4427d52c3$var$executionContext |= 4;
            try {
                $f394edd4427d52c3$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $f394edd4427d52c3$var$executionContext = prevExecutionContext, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $f394edd4427d52c3$var$pendingEffectsStatus = 3;
    }
}
function $f394edd4427d52c3$var$flushSpawnedWork() {
    if (4 === $f394edd4427d52c3$var$pendingEffectsStatus || 3 === $f394edd4427d52c3$var$pendingEffectsStatus) {
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        $f394edd4427d52c3$var$requestPaint();
        var root = $f394edd4427d52c3$var$pendingEffectsRoot, finishedWork = $f394edd4427d52c3$var$pendingFinishedWork, lanes = $f394edd4427d52c3$var$pendingEffectsLanes, recoverableErrors = $f394edd4427d52c3$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $f394edd4427d52c3$var$pendingEffectsStatus = 5 : ($f394edd4427d52c3$var$pendingEffectsStatus = 0, $f394edd4427d52c3$var$pendingFinishedWork = $f394edd4427d52c3$var$pendingEffectsRoot = null, $f394edd4427d52c3$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $f394edd4427d52c3$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.onCommitFiberRoot) try {
            $f394edd4427d52c3$var$injectedHook.onCommitFiberRoot($f394edd4427d52c3$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $f394edd4427d52c3$var$ReactSharedInternals.T;
            remainingLanes = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
            $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2;
            $f394edd4427d52c3$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $f394edd4427d52c3$var$ReactSharedInternals.T = finishedWork, $f394edd4427d52c3$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($f394edd4427d52c3$var$pendingEffectsLanes & 3) && $f394edd4427d52c3$var$flushPendingEffects();
        $f394edd4427d52c3$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $f394edd4427d52c3$var$rootWithNestedUpdates ? $f394edd4427d52c3$var$nestedUpdateCount++ : ($f394edd4427d52c3$var$nestedUpdateCount = 0, $f394edd4427d52c3$var$rootWithNestedUpdates = root) : $f394edd4427d52c3$var$nestedUpdateCount = 0;
        $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $f394edd4427d52c3$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $f394edd4427d52c3$var$releaseCache(remainingLanes)));
}
function $f394edd4427d52c3$var$flushPendingEffects() {
    $f394edd4427d52c3$var$flushMutationEffects();
    $f394edd4427d52c3$var$flushLayoutEffects();
    $f394edd4427d52c3$var$flushSpawnedWork();
    return $f394edd4427d52c3$var$flushPassiveEffects();
}
function $f394edd4427d52c3$var$flushPassiveEffects() {
    if (5 !== $f394edd4427d52c3$var$pendingEffectsStatus) return !1;
    var root = $f394edd4427d52c3$var$pendingEffectsRoot, remainingLanes = $f394edd4427d52c3$var$pendingEffectsRemainingLanes;
    $f394edd4427d52c3$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $f394edd4427d52c3$var$lanesToEventPriority($f394edd4427d52c3$var$pendingEffectsLanes), prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T, previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $f394edd4427d52c3$var$ReactSharedInternals.T = null;
        renderPriority = $f394edd4427d52c3$var$pendingPassiveTransitions;
        $f394edd4427d52c3$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $f394edd4427d52c3$var$pendingEffectsRoot, lanes = $f394edd4427d52c3$var$pendingEffectsLanes;
        $f394edd4427d52c3$var$pendingEffectsStatus = 0;
        $f394edd4427d52c3$var$pendingFinishedWork = $f394edd4427d52c3$var$pendingEffectsRoot = null;
        $f394edd4427d52c3$var$pendingEffectsLanes = 0;
        if (0 !== ($f394edd4427d52c3$var$executionContext & 6)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(331));
        var prevExecutionContext = $f394edd4427d52c3$var$executionContext;
        $f394edd4427d52c3$var$executionContext |= 4;
        $f394edd4427d52c3$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $f394edd4427d52c3$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $f394edd4427d52c3$var$executionContext = prevExecutionContext;
        $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($f394edd4427d52c3$var$injectedHook && "function" === typeof $f394edd4427d52c3$var$injectedHook.onPostCommitFiberRoot) try {
            $f394edd4427d52c3$var$injectedHook.onPostCommitFiberRoot($f394edd4427d52c3$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition, $f394edd4427d52c3$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $f394edd4427d52c3$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $f394edd4427d52c3$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $f394edd4427d52c3$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $f394edd4427d52c3$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($f394edd4427d52c3$var$markRootUpdated$1(rootFiber, 2), $f394edd4427d52c3$var$ensureRootIsScheduled(rootFiber));
}
function $f394edd4427d52c3$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $f394edd4427d52c3$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $f394edd4427d52c3$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed || !$f394edd4427d52c3$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $f394edd4427d52c3$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $f394edd4427d52c3$var$createClassErrorUpdate(2);
                instance = $f394edd4427d52c3$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($f394edd4427d52c3$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $f394edd4427d52c3$var$markRootUpdated$1(instance, 2), $f394edd4427d52c3$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $f394edd4427d52c3$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $f394edd4427d52c3$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($f394edd4427d52c3$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $f394edd4427d52c3$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $f394edd4427d52c3$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $f394edd4427d52c3$var$workInProgressRoot === root && ($f394edd4427d52c3$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $f394edd4427d52c3$var$workInProgressRootExitStatus || 3 === $f394edd4427d52c3$var$workInProgressRootExitStatus && ($f394edd4427d52c3$var$workInProgressRootRenderLanes & 62914560) === $f394edd4427d52c3$var$workInProgressRootRenderLanes && 300 > $f394edd4427d52c3$var$now() - $f394edd4427d52c3$var$globalMostRecentFallbackTime ? 0 === ($f394edd4427d52c3$var$executionContext & 2) && $f394edd4427d52c3$var$prepareFreshStack(root, 0) : $f394edd4427d52c3$var$workInProgressRootPingedLanes |= pingedLanes, $f394edd4427d52c3$var$workInProgressSuspendedRetryLanes === $f394edd4427d52c3$var$workInProgressRootRenderLanes && ($f394edd4427d52c3$var$workInProgressSuspendedRetryLanes = 0));
    $f394edd4427d52c3$var$ensureRootIsScheduled(root);
}
function $f394edd4427d52c3$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $f394edd4427d52c3$var$claimNextRetryLane());
    boundaryFiber = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($f394edd4427d52c3$var$markRootUpdated$1(boundaryFiber, retryLane), $f394edd4427d52c3$var$ensureRootIsScheduled(boundaryFiber));
}
function $f394edd4427d52c3$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $f394edd4427d52c3$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f394edd4427d52c3$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $f394edd4427d52c3$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f394edd4427d52c3$var$scheduleCallback$1(priorityLevel, callback) {
    return $f394edd4427d52c3$var$scheduleCallback$3(priorityLevel, callback);
}
var $f394edd4427d52c3$var$firstScheduledRoot = null, $f394edd4427d52c3$var$lastScheduledRoot = null, $f394edd4427d52c3$var$didScheduleMicrotask = !1, $f394edd4427d52c3$var$mightHavePendingSyncWork = !1, $f394edd4427d52c3$var$isFlushingWork = !1, $f394edd4427d52c3$var$currentEventTransitionLane = 0;
function $f394edd4427d52c3$var$ensureRootIsScheduled(root) {
    root !== $f394edd4427d52c3$var$lastScheduledRoot && null === root.next && (null === $f394edd4427d52c3$var$lastScheduledRoot ? $f394edd4427d52c3$var$firstScheduledRoot = $f394edd4427d52c3$var$lastScheduledRoot = root : $f394edd4427d52c3$var$lastScheduledRoot = $f394edd4427d52c3$var$lastScheduledRoot.next = root);
    $f394edd4427d52c3$var$mightHavePendingSyncWork = !0;
    $f394edd4427d52c3$var$didScheduleMicrotask || ($f394edd4427d52c3$var$didScheduleMicrotask = !0, $f394edd4427d52c3$var$scheduleImmediateRootScheduleTask());
}
function $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$f394edd4427d52c3$var$isFlushingWork && $f394edd4427d52c3$var$mightHavePendingSyncWork) {
        $f394edd4427d52c3$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $f394edd4427d52c3$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $f394edd4427d52c3$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $f394edd4427d52c3$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $f394edd4427d52c3$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $f394edd4427d52c3$var$getNextLanes(root$170, root$170 === $f394edd4427d52c3$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $f394edd4427d52c3$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $f394edd4427d52c3$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $f394edd4427d52c3$var$isFlushingWork = !1;
    }
}
function $f394edd4427d52c3$var$processRootScheduleInImmediateTask() {
    $f394edd4427d52c3$var$processRootScheduleInMicrotask();
}
function $f394edd4427d52c3$var$processRootScheduleInMicrotask() {
    $f394edd4427d52c3$var$mightHavePendingSyncWork = $f394edd4427d52c3$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $f394edd4427d52c3$var$currentEventTransitionLane && $f394edd4427d52c3$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $f394edd4427d52c3$var$currentEventTransitionLane);
    for(var currentTime = $f394edd4427d52c3$var$now(), prev = null, root = $f394edd4427d52c3$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $f394edd4427d52c3$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $f394edd4427d52c3$var$firstScheduledRoot = next : prev.next = next, null === next && ($f394edd4427d52c3$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $f394edd4427d52c3$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $f394edd4427d52c3$var$pendingEffectsStatus && 5 !== $f394edd4427d52c3$var$pendingEffectsStatus || $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $f394edd4427d52c3$var$currentEventTransitionLane && ($f394edd4427d52c3$var$currentEventTransitionLane = 0);
}
function $f394edd4427d52c3$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $f394edd4427d52c3$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $f394edd4427d52c3$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $f394edd4427d52c3$var$workInProgressRoot;
    suspendedLanes = $f394edd4427d52c3$var$workInProgressRootRenderLanes;
    suspendedLanes = $f394edd4427d52c3$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $f394edd4427d52c3$var$workInProgressSuspendedReason || 9 === $f394edd4427d52c3$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $f394edd4427d52c3$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $f394edd4427d52c3$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $f394edd4427d52c3$var$cancelCallback$1(pingedLanes);
        switch($f394edd4427d52c3$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $f394edd4427d52c3$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $f394edd4427d52c3$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $f394edd4427d52c3$var$IdlePriority;
                break;
            default:
                suspendedLanes = $f394edd4427d52c3$var$NormalPriority$1;
        }
        pingedLanes = $f394edd4427d52c3$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $f394edd4427d52c3$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $f394edd4427d52c3$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $f394edd4427d52c3$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $f394edd4427d52c3$var$pendingEffectsStatus && 5 !== $f394edd4427d52c3$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($f394edd4427d52c3$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $f394edd4427d52c3$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $f394edd4427d52c3$var$getNextLanes(root, root === $f394edd4427d52c3$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $f394edd4427d52c3$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $f394edd4427d52c3$var$scheduleTaskForRootDuringMicrotask(root, $f394edd4427d52c3$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $f394edd4427d52c3$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $f394edd4427d52c3$var$performSyncWorkOnRoot(root, lanes) {
    if ($f394edd4427d52c3$var$flushPendingEffects()) return null;
    $f394edd4427d52c3$var$performWorkOnRoot(root, lanes, !0);
}
function $f394edd4427d52c3$var$scheduleImmediateRootScheduleTask() {
    $f394edd4427d52c3$var$scheduleMicrotask(function() {
        0 !== ($f394edd4427d52c3$var$executionContext & 6) ? $f394edd4427d52c3$var$scheduleCallback$3($f394edd4427d52c3$var$ImmediatePriority, $f394edd4427d52c3$var$processRootScheduleInImmediateTask) : $f394edd4427d52c3$var$processRootScheduleInMicrotask();
    });
}
function $f394edd4427d52c3$var$requestTransitionLane() {
    if (0 === $f394edd4427d52c3$var$currentEventTransitionLane) {
        var actionScopeLane = $f394edd4427d52c3$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $f394edd4427d52c3$var$nextTransitionUpdateLane, $f394edd4427d52c3$var$nextTransitionUpdateLane <<= 1, 0 === ($f394edd4427d52c3$var$nextTransitionUpdateLane & 261888) && ($f394edd4427d52c3$var$nextTransitionUpdateLane = 256));
        $f394edd4427d52c3$var$currentEventTransitionLane = actionScopeLane;
    }
    return $f394edd4427d52c3$var$currentEventTransitionLane;
}
function $f394edd4427d52c3$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $f394edd4427d52c3$var$sanitizeURL("" + actionProp);
}
function $f394edd4427d52c3$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $f394edd4427d52c3$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $f394edd4427d52c3$var$coerceFormActionProp((nativeEventTarget[$f394edd4427d52c3$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$f394edd4427d52c3$var$internalPropsKey] || null) ? $f394edd4427d52c3$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $f394edd4427d52c3$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $f394edd4427d52c3$var$currentEventTransitionLane) {
                                var formData = submitter ? $f394edd4427d52c3$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $f394edd4427d52c3$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $f394edd4427d52c3$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $f394edd4427d52c3$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $f394edd4427d52c3$var$i$jscomp$inline_1577 = 0; $f394edd4427d52c3$var$i$jscomp$inline_1577 < $f394edd4427d52c3$var$simpleEventPluginEvents.length; $f394edd4427d52c3$var$i$jscomp$inline_1577++){
    var $f394edd4427d52c3$var$eventName$jscomp$inline_1578 = $f394edd4427d52c3$var$simpleEventPluginEvents[$f394edd4427d52c3$var$i$jscomp$inline_1577], $f394edd4427d52c3$var$domEventName$jscomp$inline_1579 = $f394edd4427d52c3$var$eventName$jscomp$inline_1578.toLowerCase(), $f394edd4427d52c3$var$capitalizedEvent$jscomp$inline_1580 = $f394edd4427d52c3$var$eventName$jscomp$inline_1578[0].toUpperCase() + $f394edd4427d52c3$var$eventName$jscomp$inline_1578.slice(1);
    $f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$domEventName$jscomp$inline_1579, "on" + $f394edd4427d52c3$var$capitalizedEvent$jscomp$inline_1580);
}
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$ANIMATION_END, "onAnimationEnd");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$ANIMATION_ITERATION, "onAnimationIteration");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$ANIMATION_START, "onAnimationStart");
$f394edd4427d52c3$var$registerSimpleEvent("dblclick", "onDoubleClick");
$f394edd4427d52c3$var$registerSimpleEvent("focusin", "onFocus");
$f394edd4427d52c3$var$registerSimpleEvent("focusout", "onBlur");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_RUN, "onTransitionRun");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_START, "onTransitionStart");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_CANCEL, "onTransitionCancel");
$f394edd4427d52c3$var$registerSimpleEvent($f394edd4427d52c3$var$TRANSITION_END, "onTransitionEnd");
$f394edd4427d52c3$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f394edd4427d52c3$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f394edd4427d52c3$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f394edd4427d52c3$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f394edd4427d52c3$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f394edd4427d52c3$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f394edd4427d52c3$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f394edd4427d52c3$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f394edd4427d52c3$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($f394edd4427d52c3$var$mediaEventTypes));
function $f394edd4427d52c3$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f394edd4427d52c3$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f394edd4427d52c3$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $f394edd4427d52c3$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$f394edd4427d52c3$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$f394edd4427d52c3$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($f394edd4427d52c3$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $f394edd4427d52c3$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $f394edd4427d52c3$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $f394edd4427d52c3$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $f394edd4427d52c3$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$f394edd4427d52c3$var$listeningMarker]) {
        rootContainerElement[$f394edd4427d52c3$var$listeningMarker] = !0;
        $f394edd4427d52c3$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($f394edd4427d52c3$var$nonDelegatedEvents.has(domEventName) || $f394edd4427d52c3$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $f394edd4427d52c3$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$f394edd4427d52c3$var$listeningMarker] || (ownerDocument[$f394edd4427d52c3$var$listeningMarker] = !0, $f394edd4427d52c3$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $f394edd4427d52c3$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($f394edd4427d52c3$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $f394edd4427d52c3$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $f394edd4427d52c3$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $f394edd4427d52c3$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$f394edd4427d52c3$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $f394edd4427d52c3$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $f394edd4427d52c3$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $f394edd4427d52c3$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $f394edd4427d52c3$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $f394edd4427d52c3$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticTouchEvent;
                        break;
                    case $f394edd4427d52c3$var$ANIMATION_END:
                    case $f394edd4427d52c3$var$ANIMATION_ITERATION:
                    case $f394edd4427d52c3$var$ANIMATION_START:
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticAnimationEvent;
                        break;
                    case $f394edd4427d52c3$var$TRANSITION_END:
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $f394edd4427d52c3$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $f394edd4427d52c3$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($f394edd4427d52c3$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $f394edd4427d52c3$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($f394edd4427d52c3$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$f394edd4427d52c3$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $f394edd4427d52c3$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $f394edd4427d52c3$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $f394edd4427d52c3$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $f394edd4427d52c3$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $f394edd4427d52c3$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $f394edd4427d52c3$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $f394edd4427d52c3$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $f394edd4427d52c3$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $f394edd4427d52c3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $f394edd4427d52c3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $f394edd4427d52c3$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForChangeEvent;
                else if ($f394edd4427d52c3$var$isTextInputElement(reactName)) {
                    if ($f394edd4427d52c3$var$isInputEventSupported) getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $f394edd4427d52c3$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $f394edd4427d52c3$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForChangeEvent) : getTargetInstFunc = $f394edd4427d52c3$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $f394edd4427d52c3$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $f394edd4427d52c3$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $f394edd4427d52c3$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($f394edd4427d52c3$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $f394edd4427d52c3$var$activeElement = handleEventFunc, $f394edd4427d52c3$var$activeElementInst = targetInst, $f394edd4427d52c3$var$lastSelection = null;
                    break;
                case "focusout":
                    $f394edd4427d52c3$var$lastSelection = $f394edd4427d52c3$var$activeElementInst = $f394edd4427d52c3$var$activeElement = null;
                    break;
                case "mousedown":
                    $f394edd4427d52c3$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f394edd4427d52c3$var$mouseDown = !1;
                    $f394edd4427d52c3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($f394edd4427d52c3$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $f394edd4427d52c3$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($f394edd4427d52c3$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $f394edd4427d52c3$var$isComposing ? $f394edd4427d52c3$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($f394edd4427d52c3$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($f394edd4427d52c3$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $f394edd4427d52c3$var$isComposing && (fallbackData = $f394edd4427d52c3$var$getData()) : ($f394edd4427d52c3$var$root = nativeEventTarget, $f394edd4427d52c3$var$startText = "value" in $f394edd4427d52c3$var$root ? $f394edd4427d52c3$var$root.value : $f394edd4427d52c3$var$root.textContent, $f394edd4427d52c3$var$isComposing = !0)), handleEventFunc = $f394edd4427d52c3$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $f394edd4427d52c3$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $f394edd4427d52c3$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $f394edd4427d52c3$var$canUseTextInputEvent ? $f394edd4427d52c3$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $f394edd4427d52c3$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $f394edd4427d52c3$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $f394edd4427d52c3$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $f394edd4427d52c3$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $f394edd4427d52c3$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $f394edd4427d52c3$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $f394edd4427d52c3$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $f394edd4427d52c3$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($f394edd4427d52c3$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $f394edd4427d52c3$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($f394edd4427d52c3$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $f394edd4427d52c3$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $f394edd4427d52c3$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $f394edd4427d52c3$var$getListener(target, registrationName), null != stateNode && listeners.unshift($f394edd4427d52c3$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $f394edd4427d52c3$var$getListener(target, registrationName), null != stateNode && listeners.push($f394edd4427d52c3$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $f394edd4427d52c3$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $f394edd4427d52c3$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $f394edd4427d52c3$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($f394edd4427d52c3$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($f394edd4427d52c3$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $f394edd4427d52c3$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $f394edd4427d52c3$var$normalizeMarkupForTextOrAttribute(clientText);
    return $f394edd4427d52c3$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $f394edd4427d52c3$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $f394edd4427d52c3$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $f394edd4427d52c3$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $f394edd4427d52c3$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $f394edd4427d52c3$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f394edd4427d52c3$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $f394edd4427d52c3$var$setProp(domElement, tag, "name", props.name, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($f394edd4427d52c3$var$setProp(domElement, tag, "encType", props.encType, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "method", props.method, props, null), $f394edd4427d52c3$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f394edd4427d52c3$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f394edd4427d52c3$var$noop$1);
            break;
        case "onScroll":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $f394edd4427d52c3$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", domElement);
            $f394edd4427d52c3$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $f394edd4427d52c3$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $f394edd4427d52c3$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $f394edd4427d52c3$var$aliases.get(key) || key, $f394edd4427d52c3$var$setValueForAttribute(domElement, key, value);
    }
}
function $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $f394edd4427d52c3$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $f394edd4427d52c3$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $f394edd4427d52c3$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f394edd4427d52c3$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f394edd4427d52c3$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$f394edd4427d52c3$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$f394edd4427d52c3$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $f394edd4427d52c3$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $f394edd4427d52c3$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                    default:
                        $f394edd4427d52c3$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $f394edd4427d52c3$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $f394edd4427d52c3$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $f394edd4427d52c3$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $f394edd4427d52c3$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $f394edd4427d52c3$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $f394edd4427d52c3$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(91));
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $f394edd4427d52c3$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("cancel", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $f394edd4427d52c3$var$mediaEventTypes.length; hasSrc++)$f394edd4427d52c3$var$listenToNonDelegatedEvent($f394edd4427d52c3$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", domElement);
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $f394edd4427d52c3$var$listenToNonDelegatedEvent("error", domElement), $f394edd4427d52c3$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($f394edd4427d52c3$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $f394edd4427d52c3$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $f394edd4427d52c3$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $f394edd4427d52c3$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $f394edd4427d52c3$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $f394edd4427d52c3$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $f394edd4427d52c3$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $f394edd4427d52c3$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $f394edd4427d52c3$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $f394edd4427d52c3$var$updateOptions(domElement, !!lastProps, tag, !0) : $f394edd4427d52c3$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $f394edd4427d52c3$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $f394edd4427d52c3$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $f394edd4427d52c3$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $f394edd4427d52c3$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($f394edd4427d52c3$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $f394edd4427d52c3$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $f394edd4427d52c3$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $f394edd4427d52c3$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $f394edd4427d52c3$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $f394edd4427d52c3$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $f394edd4427d52c3$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $f394edd4427d52c3$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $f394edd4427d52c3$var$eventsEnabled = null, $f394edd4427d52c3$var$selectionInformation = null;
function $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $f394edd4427d52c3$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $f394edd4427d52c3$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $f394edd4427d52c3$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $f394edd4427d52c3$var$currentPopstateTransitionEvent = null;
function $f394edd4427d52c3$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $f394edd4427d52c3$var$currentPopstateTransitionEvent) return !1;
        $f394edd4427d52c3$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $f394edd4427d52c3$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $f394edd4427d52c3$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $f394edd4427d52c3$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $f394edd4427d52c3$var$localPromise = "function" === typeof Promise ? Promise : void 0, $f394edd4427d52c3$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f394edd4427d52c3$var$localPromise ? function(callback) {
    return $f394edd4427d52c3$var$localPromise.resolve(null).then(callback).catch($f394edd4427d52c3$var$handleErrorInNextTick);
} : $f394edd4427d52c3$var$scheduleTimeout;
function $f394edd4427d52c3$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $f394edd4427d52c3$var$isSingletonScope(type) {
    return "head" === type;
}
function $f394edd4427d52c3$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $f394edd4427d52c3$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $f394edd4427d52c3$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $f394edd4427d52c3$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$f394edd4427d52c3$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $f394edd4427d52c3$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $f394edd4427d52c3$var$retryIfBlockedOn(hydrationInstance);
}
function $f394edd4427d52c3$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $f394edd4427d52c3$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $f394edd4427d52c3$var$clearContainerSparingly(node);
                $f394edd4427d52c3$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $f394edd4427d52c3$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$f394edd4427d52c3$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $f394edd4427d52c3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $f394edd4427d52c3$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f394edd4427d52c3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f394edd4427d52c3$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f394edd4427d52c3$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f394edd4427d52c3$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $f394edd4427d52c3$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $f394edd4427d52c3$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $f394edd4427d52c3$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $f394edd4427d52c3$var$previousHydratableOnEnteringScopedSingleton = null;
function $f394edd4427d52c3$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $f394edd4427d52c3$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $f394edd4427d52c3$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $f394edd4427d52c3$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $f394edd4427d52c3$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(451));
    }
}
function $f394edd4427d52c3$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $f394edd4427d52c3$var$detachDeletedInstance(instance);
}
var $f394edd4427d52c3$var$preloadPropsMap = new Map(), $f394edd4427d52c3$var$preconnectsSet = new Set();
function $f394edd4427d52c3$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $f394edd4427d52c3$var$previousDispatcher = $f394edd4427d52c3$var$ReactDOMSharedInternals.d;
$f394edd4427d52c3$var$ReactDOMSharedInternals.d = {
    f: $f394edd4427d52c3$var$flushSyncWork,
    r: $f394edd4427d52c3$var$requestFormReset,
    D: $f394edd4427d52c3$var$prefetchDNS,
    C: $f394edd4427d52c3$var$preconnect,
    L: $f394edd4427d52c3$var$preload,
    m: $f394edd4427d52c3$var$preloadModule,
    X: $f394edd4427d52c3$var$preinitScript,
    S: $f394edd4427d52c3$var$preinitStyle,
    M: $f394edd4427d52c3$var$preinitModuleScript
};
function $f394edd4427d52c3$var$flushSyncWork() {
    var previousWasRendering = $f394edd4427d52c3$var$previousDispatcher.f(), wasRendering = $f394edd4427d52c3$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $f394edd4427d52c3$var$requestFormReset(form) {
    var formInst = $f394edd4427d52c3$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $f394edd4427d52c3$var$requestFormReset$1(formInst) : $f394edd4427d52c3$var$previousDispatcher.r(form);
}
var $f394edd4427d52c3$var$globalDocument = "undefined" === typeof document ? null : document;
function $f394edd4427d52c3$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $f394edd4427d52c3$var$preconnectsSet.has(limitedEscapedHref) || ($f394edd4427d52c3$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $f394edd4427d52c3$var$setInitialProperties(href, "link", rel), $f394edd4427d52c3$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $f394edd4427d52c3$var$prefetchDNS(href) {
    $f394edd4427d52c3$var$previousDispatcher.D(href);
    $f394edd4427d52c3$var$preconnectAs("dns-prefetch", href, null);
}
function $f394edd4427d52c3$var$preconnect(href, crossOrigin) {
    $f394edd4427d52c3$var$previousDispatcher.C(href, crossOrigin);
    $f394edd4427d52c3$var$preconnectAs("preconnect", href, crossOrigin);
}
function $f394edd4427d52c3$var$preload(href, as, options) {
    $f394edd4427d52c3$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $f394edd4427d52c3$var$getStyleKey(href);
                break;
            case "script":
                key = $f394edd4427d52c3$var$getScriptKey(href);
        }
        $f394edd4427d52c3$var$preloadPropsMap.has(key) || (href = $f394edd4427d52c3$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $f394edd4427d52c3$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $f394edd4427d52c3$var$setInitialProperties(as, "link", href), $f394edd4427d52c3$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $f394edd4427d52c3$var$preloadModule(href, options) {
    $f394edd4427d52c3$var$previousDispatcher.m(href, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $f394edd4427d52c3$var$getScriptKey(href);
        }
        if (!$f394edd4427d52c3$var$preloadPropsMap.has(key) && (href = $f394edd4427d52c3$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $f394edd4427d52c3$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $f394edd4427d52c3$var$setInitialProperties(as, "link", href);
            $f394edd4427d52c3$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $f394edd4427d52c3$var$preinitStyle(href, precedence, options) {
    $f394edd4427d52c3$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $f394edd4427d52c3$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $f394edd4427d52c3$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $f394edd4427d52c3$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $f394edd4427d52c3$var$markNodeAsHoistable(link);
                $f394edd4427d52c3$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $f394edd4427d52c3$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $f394edd4427d52c3$var$preinitScript(src, options) {
    $f394edd4427d52c3$var$previousDispatcher.X(src, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f394edd4427d52c3$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f394edd4427d52c3$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key)), resource || (src = $f394edd4427d52c3$var$assign({
            src: src,
            async: !0
        }, options), (options = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f394edd4427d52c3$var$markNodeAsHoistable(resource), $f394edd4427d52c3$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f394edd4427d52c3$var$preinitModuleScript(src, options) {
    $f394edd4427d52c3$var$previousDispatcher.M(src, options);
    var ownerDocument = $f394edd4427d52c3$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f394edd4427d52c3$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f394edd4427d52c3$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(key)), resource || (src = $f394edd4427d52c3$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f394edd4427d52c3$var$markNodeAsHoistable(resource), $f394edd4427d52c3$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f394edd4427d52c3$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $f394edd4427d52c3$var$rootInstanceStackCursor.current) ? $f394edd4427d52c3$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $f394edd4427d52c3$var$getStyleKey(pendingProps.href), pendingProps = $f394edd4427d52c3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $f394edd4427d52c3$var$getStyleKey(pendingProps.href);
                var styles$243 = $f394edd4427d52c3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $f394edd4427d52c3$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $f394edd4427d52c3$var$preloadPropsMap.set(type, pendingProps), styles$243 || $f394edd4427d52c3$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $f394edd4427d52c3$var$getScriptKey(pendingProps), pendingProps = $f394edd4427d52c3$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(444, type));
    }
}
function $f394edd4427d52c3$var$getStyleKey(href) {
    return 'href="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $f394edd4427d52c3$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $f394edd4427d52c3$var$stylesheetPropsFromRawProps(rawProps) {
    return $f394edd4427d52c3$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $f394edd4427d52c3$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $f394edd4427d52c3$var$setInitialProperties(key, "link", preloadProps), $f394edd4427d52c3$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $f394edd4427d52c3$var$getScriptKey(src) {
    return '[src="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $f394edd4427d52c3$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $f394edd4427d52c3$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $f394edd4427d52c3$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $f394edd4427d52c3$var$markNodeAsHoistable(instance), instance;
            var styleProps = $f394edd4427d52c3$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $f394edd4427d52c3$var$markNodeAsHoistable(instance);
            $f394edd4427d52c3$var$setInitialProperties(instance, "style", styleProps);
            $f394edd4427d52c3$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $f394edd4427d52c3$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $f394edd4427d52c3$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $f394edd4427d52c3$var$stylesheetPropsFromRawProps(props);
            (styleProps = $f394edd4427d52c3$var$preloadPropsMap.get(styleProps)) && $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $f394edd4427d52c3$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f394edd4427d52c3$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $f394edd4427d52c3$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $f394edd4427d52c3$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($f394edd4427d52c3$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $f394edd4427d52c3$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $f394edd4427d52c3$var$preloadPropsMap.get(instance$249)) instance = $f394edd4427d52c3$var$assign({}, props), $f394edd4427d52c3$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $f394edd4427d52c3$var$markNodeAsHoistable(styleProps);
            $f394edd4427d52c3$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($f394edd4427d52c3$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $f394edd4427d52c3$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $f394edd4427d52c3$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $f394edd4427d52c3$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $f394edd4427d52c3$var$tagCaches = null;
function $f394edd4427d52c3$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $f394edd4427d52c3$var$tagCaches) {
        var cache = new Map();
        var caches = $f394edd4427d52c3$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $f394edd4427d52c3$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$f394edd4427d52c3$var$internalHoistableMarker] || node[$f394edd4427d52c3$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $f394edd4427d52c3$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $f394edd4427d52c3$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $f394edd4427d52c3$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $f394edd4427d52c3$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $f394edd4427d52c3$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($f394edd4427d52c3$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $f394edd4427d52c3$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $f394edd4427d52c3$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $f394edd4427d52c3$var$stylesheetPropsFromRawProps(props);
            (key = $f394edd4427d52c3$var$preloadPropsMap.get(key)) && $f394edd4427d52c3$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $f394edd4427d52c3$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f394edd4427d52c3$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $f394edd4427d52c3$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $f394edd4427d52c3$var$estimatedBytesWithinLimit = 0;
function $f394edd4427d52c3$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $f394edd4427d52c3$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $f394edd4427d52c3$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $f394edd4427d52c3$var$estimatedBytesWithinLimit && ($f394edd4427d52c3$var$estimatedBytesWithinLimit = 62500 * $f394edd4427d52c3$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $f394edd4427d52c3$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $f394edd4427d52c3$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $f394edd4427d52c3$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $f394edd4427d52c3$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $f394edd4427d52c3$var$precedencesByRoot = null;
function $f394edd4427d52c3$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $f394edd4427d52c3$var$precedencesByRoot = new Map(), resources.forEach($f394edd4427d52c3$var$insertStylesheetIntoRoot, state), $f394edd4427d52c3$var$precedencesByRoot = null, $f394edd4427d52c3$var$onUnsuspend.call(state));
}
function $f394edd4427d52c3$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $f394edd4427d52c3$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $f394edd4427d52c3$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $f394edd4427d52c3$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $f394edd4427d52c3$var$HostTransitionContext = {
    $$typeof: $f394edd4427d52c3$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $f394edd4427d52c3$var$sharedNotPendingObject,
    _currentValue2: $f394edd4427d52c3$var$sharedNotPendingObject,
    _threadCount: 0
};
function $f394edd4427d52c3$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $f394edd4427d52c3$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f394edd4427d52c3$var$createLaneMap(0);
    this.hiddenUpdates = $f394edd4427d52c3$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $f394edd4427d52c3$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $f394edd4427d52c3$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $f394edd4427d52c3$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $f394edd4427d52c3$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $f394edd4427d52c3$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $f394edd4427d52c3$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $f394edd4427d52c3$var$emptyContextObject;
    parentComponent = $f394edd4427d52c3$var$emptyContextObject;
    return parentComponent;
}
function $f394edd4427d52c3$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $f394edd4427d52c3$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $f394edd4427d52c3$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $f394edd4427d52c3$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($f394edd4427d52c3$var$scheduleUpdateOnFiber(element, rootFiber, lane), $f394edd4427d52c3$var$entangleTransitions(element, rootFiber, lane));
}
function $f394edd4427d52c3$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $f394edd4427d52c3$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $f394edd4427d52c3$var$markRetryLaneImpl(fiber, retryLane);
}
function $f394edd4427d52c3$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $f394edd4427d52c3$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $f394edd4427d52c3$var$requestUpdateLane();
        lane = $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(lane);
        var root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, lane);
        $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $f394edd4427d52c3$var$_enabled = !0;
function $f394edd4427d52c3$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T;
    $f394edd4427d52c3$var$ReactSharedInternals.T = null;
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 2, $f394edd4427d52c3$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f394edd4427d52c3$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f394edd4427d52c3$var$ReactSharedInternals.T;
    $f394edd4427d52c3$var$ReactSharedInternals.T = null;
    var previousPriority = $f394edd4427d52c3$var$ReactDOMSharedInternals.p;
    try {
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = 8, $f394edd4427d52c3$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f394edd4427d52c3$var$ReactDOMSharedInternals.p = previousPriority, $f394edd4427d52c3$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f394edd4427d52c3$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($f394edd4427d52c3$var$_enabled) {
        var blockedOn = $f394edd4427d52c3$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f394edd4427d52c3$var$return_targetInst, targetContainer), $f394edd4427d52c3$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($f394edd4427d52c3$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($f394edd4427d52c3$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $f394edd4427d52c3$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $f394edd4427d52c3$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $f394edd4427d52c3$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $f394edd4427d52c3$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $f394edd4427d52c3$var$ensureRootIsScheduled(fiber);
                                0 === ($f394edd4427d52c3$var$executionContext & 6) && ($f394edd4427d52c3$var$workInProgressRootRenderTargetTime = $f394edd4427d52c3$var$now() + 500, $f394edd4427d52c3$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $f394edd4427d52c3$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $f394edd4427d52c3$var$scheduleUpdateOnFiber(root, fiber, 2), $f394edd4427d52c3$var$flushSyncWork$1(), $f394edd4427d52c3$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $f394edd4427d52c3$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f394edd4427d52c3$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $f394edd4427d52c3$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $f394edd4427d52c3$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $f394edd4427d52c3$var$getEventTarget(nativeEvent);
    return $f394edd4427d52c3$var$findInstanceBlockingTarget(nativeEvent);
}
var $f394edd4427d52c3$var$return_targetInst = null;
function $f394edd4427d52c3$var$findInstanceBlockingTarget(targetNode) {
    $f394edd4427d52c3$var$return_targetInst = null;
    targetNode = $f394edd4427d52c3$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $f394edd4427d52c3$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $f394edd4427d52c3$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $f394edd4427d52c3$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $f394edd4427d52c3$var$return_targetInst = targetNode;
    return null;
}
function $f394edd4427d52c3$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($f394edd4427d52c3$var$getCurrentPriorityLevel()){
                case $f394edd4427d52c3$var$ImmediatePriority:
                    return 2;
                case $f394edd4427d52c3$var$UserBlockingPriority:
                    return 8;
                case $f394edd4427d52c3$var$NormalPriority$1:
                case $f394edd4427d52c3$var$LowPriority:
                    return 32;
                case $f394edd4427d52c3$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $f394edd4427d52c3$var$hasScheduledReplayAttempt = !1, $f394edd4427d52c3$var$queuedFocus = null, $f394edd4427d52c3$var$queuedDrag = null, $f394edd4427d52c3$var$queuedMouse = null, $f394edd4427d52c3$var$queuedPointers = new Map(), $f394edd4427d52c3$var$queuedPointerCaptures = new Map(), $f394edd4427d52c3$var$queuedExplicitHydrationTargets = [], $f394edd4427d52c3$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $f394edd4427d52c3$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $f394edd4427d52c3$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $f394edd4427d52c3$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $f394edd4427d52c3$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $f394edd4427d52c3$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f394edd4427d52c3$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $f394edd4427d52c3$var$getInstanceFromNode(blockedOn), null !== blockedOn && $f394edd4427d52c3$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $f394edd4427d52c3$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $f394edd4427d52c3$var$queuedFocus = $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $f394edd4427d52c3$var$queuedDrag = $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $f394edd4427d52c3$var$queuedMouse = $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $f394edd4427d52c3$var$queuedPointers.set(pointerId, $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $f394edd4427d52c3$var$queuedPointerCaptures.set(pointerId, $f394edd4427d52c3$var$accumulateOrCreateContinuousQueuedReplayableEvent($f394edd4427d52c3$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $f394edd4427d52c3$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $f394edd4427d52c3$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $f394edd4427d52c3$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $f394edd4427d52c3$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f394edd4427d52c3$var$runWithPriority(queuedTarget.priority, function() {
                        $f394edd4427d52c3$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $f394edd4427d52c3$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f394edd4427d52c3$var$runWithPriority(queuedTarget.priority, function() {
                        $f394edd4427d52c3$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $f394edd4427d52c3$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $f394edd4427d52c3$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $f394edd4427d52c3$var$currentReplayingEvent = null;
        } else return targetContainers = $f394edd4427d52c3$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $f394edd4427d52c3$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $f394edd4427d52c3$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $f394edd4427d52c3$var$replayUnblockedEvents() {
    $f394edd4427d52c3$var$hasScheduledReplayAttempt = !1;
    null !== $f394edd4427d52c3$var$queuedFocus && $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent($f394edd4427d52c3$var$queuedFocus) && ($f394edd4427d52c3$var$queuedFocus = null);
    null !== $f394edd4427d52c3$var$queuedDrag && $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent($f394edd4427d52c3$var$queuedDrag) && ($f394edd4427d52c3$var$queuedDrag = null);
    null !== $f394edd4427d52c3$var$queuedMouse && $f394edd4427d52c3$var$attemptReplayContinuousQueuedEvent($f394edd4427d52c3$var$queuedMouse) && ($f394edd4427d52c3$var$queuedMouse = null);
    $f394edd4427d52c3$var$queuedPointers.forEach($f394edd4427d52c3$var$attemptReplayContinuousQueuedEventInMap);
    $f394edd4427d52c3$var$queuedPointerCaptures.forEach($f394edd4427d52c3$var$attemptReplayContinuousQueuedEventInMap);
}
function $f394edd4427d52c3$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $f394edd4427d52c3$var$hasScheduledReplayAttempt || ($f394edd4427d52c3$var$hasScheduledReplayAttempt = !0, $kkkYV.unstable_scheduleCallback($kkkYV.unstable_NormalPriority, $f394edd4427d52c3$var$replayUnblockedEvents)));
}
var $f394edd4427d52c3$var$lastScheduledReplayQueue = null;
function $f394edd4427d52c3$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $f394edd4427d52c3$var$lastScheduledReplayQueue !== formReplayingQueue && ($f394edd4427d52c3$var$lastScheduledReplayQueue = formReplayingQueue, $kkkYV.unstable_scheduleCallback($kkkYV.unstable_NormalPriority, function() {
        $f394edd4427d52c3$var$lastScheduledReplayQueue === formReplayingQueue && ($f394edd4427d52c3$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $f394edd4427d52c3$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $f394edd4427d52c3$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $f394edd4427d52c3$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $f394edd4427d52c3$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $f394edd4427d52c3$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $f394edd4427d52c3$var$queuedFocus && $f394edd4427d52c3$var$scheduleCallbackIfUnblocked($f394edd4427d52c3$var$queuedFocus, unblocked);
    null !== $f394edd4427d52c3$var$queuedDrag && $f394edd4427d52c3$var$scheduleCallbackIfUnblocked($f394edd4427d52c3$var$queuedDrag, unblocked);
    null !== $f394edd4427d52c3$var$queuedMouse && $f394edd4427d52c3$var$scheduleCallbackIfUnblocked($f394edd4427d52c3$var$queuedMouse, unblocked);
    $f394edd4427d52c3$var$queuedPointers.forEach(unblock);
    $f394edd4427d52c3$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $f394edd4427d52c3$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $f394edd4427d52c3$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $f394edd4427d52c3$var$queuedExplicitHydrationTargets.length && (i = $f394edd4427d52c3$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$f394edd4427d52c3$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $f394edd4427d52c3$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$f394edd4427d52c3$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $f394edd4427d52c3$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$f394edd4427d52c3$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $f394edd4427d52c3$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $f394edd4427d52c3$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $f394edd4427d52c3$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $f394edd4427d52c3$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f394edd4427d52c3$var$ReactDOMHydrationRoot.prototype.render = $f394edd4427d52c3$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(409));
    var current = root.current, lane = $f394edd4427d52c3$var$requestUpdateLane();
    $f394edd4427d52c3$var$updateContainerImpl(current, lane, children, root, null, null);
};
$f394edd4427d52c3$var$ReactDOMHydrationRoot.prototype.unmount = $f394edd4427d52c3$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $f394edd4427d52c3$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $f394edd4427d52c3$var$flushSyncWork$1();
        container[$f394edd4427d52c3$var$internalContainerInstanceKey] = null;
    }
};
function $f394edd4427d52c3$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f394edd4427d52c3$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $f394edd4427d52c3$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $f394edd4427d52c3$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $f394edd4427d52c3$var$queuedExplicitHydrationTargets[i].priority; i++);
        $f394edd4427d52c3$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $f394edd4427d52c3$var$attemptExplicitHydrationTarget(target);
    }
};
var $f394edd4427d52c3$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $7pfQ9.version;
if ("19.2.0" !== $f394edd4427d52c3$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(527, $f394edd4427d52c3$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
$f394edd4427d52c3$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($f394edd4427d52c3$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $f394edd4427d52c3$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $f394edd4427d52c3$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $f394edd4427d52c3$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $f394edd4427d52c3$var$ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f394edd4427d52c3$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f394edd4427d52c3$var$hook$jscomp$inline_2348.isDisabled && $f394edd4427d52c3$var$hook$jscomp$inline_2348.supportsFiber) try {
        $f394edd4427d52c3$var$rendererID = $f394edd4427d52c3$var$hook$jscomp$inline_2348.inject($f394edd4427d52c3$var$internals$jscomp$inline_2347), $f394edd4427d52c3$var$injectedHook = $f394edd4427d52c3$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$f394edd4427d52c3$export$882461b6382ed46c = function(container, options) {
    if (!$f394edd4427d52c3$var$isValidContainer(container)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f394edd4427d52c3$var$defaultOnUncaughtError, onCaughtError = $f394edd4427d52c3$var$defaultOnCaughtError, onRecoverableError = $f394edd4427d52c3$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $f394edd4427d52c3$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $f394edd4427d52c3$var$defaultOnDefaultTransitionIndicator);
    container[$f394edd4427d52c3$var$internalContainerInstanceKey] = options.current;
    $f394edd4427d52c3$var$listenToAllSupportedEvents(container);
    return new $f394edd4427d52c3$var$ReactDOMRoot(options);
};
$f394edd4427d52c3$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$f394edd4427d52c3$var$isValidContainer(container)) throw Error($f394edd4427d52c3$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f394edd4427d52c3$var$defaultOnUncaughtError, onCaughtError = $f394edd4427d52c3$var$defaultOnCaughtError, onRecoverableError = $f394edd4427d52c3$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $f394edd4427d52c3$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $f394edd4427d52c3$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $f394edd4427d52c3$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $f394edd4427d52c3$var$requestUpdateLane();
    isStrictMode = $f394edd4427d52c3$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $f394edd4427d52c3$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $f394edd4427d52c3$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $f394edd4427d52c3$var$markRootUpdated$1(initialChildren, options);
    $f394edd4427d52c3$var$ensureRootIsScheduled(initialChildren);
    container[$f394edd4427d52c3$var$internalContainerInstanceKey] = initialChildren.current;
    $f394edd4427d52c3$var$listenToAllSupportedEvents(container);
    return new $f394edd4427d52c3$var$ReactDOMHydrationRoot(initialChildren);
};
$f394edd4427d52c3$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("kkkYV", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3g8IH"));

});
parcelRegister("3g8IH", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $25f9a152cbcfee8e$export$c4744153514ff05d, (v) => $25f9a152cbcfee8e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $25f9a152cbcfee8e$export$3e506c1ccc9cc1a7, (v) => $25f9a152cbcfee8e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $25f9a152cbcfee8e$export$e26fe2ed2fa76875, (v) => $25f9a152cbcfee8e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $25f9a152cbcfee8e$export$502329bbf4b505b1, (v) => $25f9a152cbcfee8e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $25f9a152cbcfee8e$export$6e3807111c4874c4, (v) => $25f9a152cbcfee8e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $25f9a152cbcfee8e$export$c27134553091fb3a, (v) => $25f9a152cbcfee8e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $25f9a152cbcfee8e$export$33ee1acdc04fd2a2, (v) => $25f9a152cbcfee8e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $25f9a152cbcfee8e$export$b00a404bbd5edef2, (v) => $25f9a152cbcfee8e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $25f9a152cbcfee8e$export$d66a1c1c77bd778b, (v) => $25f9a152cbcfee8e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $25f9a152cbcfee8e$export$d3dfb8e4810cb555, (v) => $25f9a152cbcfee8e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $25f9a152cbcfee8e$export$72fdf0e06517287b, (v) => $25f9a152cbcfee8e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $25f9a152cbcfee8e$export$816d2913ae6b83b1, (v) => $25f9a152cbcfee8e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $25f9a152cbcfee8e$export$61bcfe829111a1d0, (v) => $25f9a152cbcfee8e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $25f9a152cbcfee8e$export$7ee8c9beb337bc3f, (v) => $25f9a152cbcfee8e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $25f9a152cbcfee8e$export$b5836b71941fa3ed, (v) => $25f9a152cbcfee8e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $25f9a152cbcfee8e$export$cf845f2c119da08a, (v) => $25f9a152cbcfee8e$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $25f9a152cbcfee8e$export$c4744153514ff05d;
var $25f9a152cbcfee8e$export$3e506c1ccc9cc1a7;
var $25f9a152cbcfee8e$export$e26fe2ed2fa76875;
var $25f9a152cbcfee8e$export$502329bbf4b505b1;
var $25f9a152cbcfee8e$export$6e3807111c4874c4;
var $25f9a152cbcfee8e$export$c27134553091fb3a;
var $25f9a152cbcfee8e$export$33ee1acdc04fd2a2;
var $25f9a152cbcfee8e$export$b00a404bbd5edef2;
var $25f9a152cbcfee8e$export$d66a1c1c77bd778b;
var $25f9a152cbcfee8e$export$d3dfb8e4810cb555;
var $25f9a152cbcfee8e$export$72fdf0e06517287b;
var $25f9a152cbcfee8e$export$816d2913ae6b83b1;
var $25f9a152cbcfee8e$export$61bcfe829111a1d0;
var $25f9a152cbcfee8e$export$7ee8c9beb337bc3f;
var $25f9a152cbcfee8e$export$b5836b71941fa3ed;
var $25f9a152cbcfee8e$export$cf845f2c119da08a;
"use strict";
function $25f9a152cbcfee8e$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $25f9a152cbcfee8e$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $25f9a152cbcfee8e$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $25f9a152cbcfee8e$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $25f9a152cbcfee8e$var$compare(left, last)) rightIndex < length && 0 > $25f9a152cbcfee8e$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $25f9a152cbcfee8e$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $25f9a152cbcfee8e$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$25f9a152cbcfee8e$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $25f9a152cbcfee8e$var$localPerformance = performance;
    $25f9a152cbcfee8e$export$c4744153514ff05d = function() {
        return $25f9a152cbcfee8e$var$localPerformance.now();
    };
} else {
    var $25f9a152cbcfee8e$var$localDate = Date, $25f9a152cbcfee8e$var$initialTime = $25f9a152cbcfee8e$var$localDate.now();
    $25f9a152cbcfee8e$export$c4744153514ff05d = function() {
        return $25f9a152cbcfee8e$var$localDate.now() - $25f9a152cbcfee8e$var$initialTime;
    };
}
var $25f9a152cbcfee8e$var$taskQueue = [], $25f9a152cbcfee8e$var$timerQueue = [], $25f9a152cbcfee8e$var$taskIdCounter = 1, $25f9a152cbcfee8e$var$currentTask = null, $25f9a152cbcfee8e$var$currentPriorityLevel = 3, $25f9a152cbcfee8e$var$isPerformingWork = !1, $25f9a152cbcfee8e$var$isHostCallbackScheduled = !1, $25f9a152cbcfee8e$var$isHostTimeoutScheduled = !1, $25f9a152cbcfee8e$var$needsPaint = !1, $25f9a152cbcfee8e$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $25f9a152cbcfee8e$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $25f9a152cbcfee8e$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $25f9a152cbcfee8e$var$advanceTimers(currentTime) {
    for(var timer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue); null !== timer;){
        if (null === timer.callback) $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$timerQueue);
        else if (timer.startTime <= currentTime) $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$timerQueue), timer.sortIndex = timer.expirationTime, $25f9a152cbcfee8e$var$push($25f9a152cbcfee8e$var$taskQueue, timer);
        else break;
        timer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue);
    }
}
function $25f9a152cbcfee8e$var$handleTimeout(currentTime) {
    $25f9a152cbcfee8e$var$isHostTimeoutScheduled = !1;
    $25f9a152cbcfee8e$var$advanceTimers(currentTime);
    if (!$25f9a152cbcfee8e$var$isHostCallbackScheduled) {
        if (null !== $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue)) $25f9a152cbcfee8e$var$isHostCallbackScheduled = !0, $25f9a152cbcfee8e$var$isMessageLoopRunning || ($25f9a152cbcfee8e$var$isMessageLoopRunning = !0, $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue);
            null !== firstTimer && $25f9a152cbcfee8e$var$requestHostTimeout($25f9a152cbcfee8e$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $25f9a152cbcfee8e$var$isMessageLoopRunning = !1, $25f9a152cbcfee8e$var$taskTimeoutID = -1, $25f9a152cbcfee8e$var$frameInterval = 5, $25f9a152cbcfee8e$var$startTime = -1;
function $25f9a152cbcfee8e$var$shouldYieldToHost() {
    return $25f9a152cbcfee8e$var$needsPaint ? !0 : $25f9a152cbcfee8e$export$c4744153514ff05d() - $25f9a152cbcfee8e$var$startTime < $25f9a152cbcfee8e$var$frameInterval ? !1 : !0;
}
function $25f9a152cbcfee8e$var$performWorkUntilDeadline() {
    $25f9a152cbcfee8e$var$needsPaint = !1;
    if ($25f9a152cbcfee8e$var$isMessageLoopRunning) {
        var currentTime = $25f9a152cbcfee8e$export$c4744153514ff05d();
        $25f9a152cbcfee8e$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $25f9a152cbcfee8e$var$isHostCallbackScheduled = !1;
                $25f9a152cbcfee8e$var$isHostTimeoutScheduled && ($25f9a152cbcfee8e$var$isHostTimeoutScheduled = !1, $25f9a152cbcfee8e$var$localClearTimeout($25f9a152cbcfee8e$var$taskTimeoutID), $25f9a152cbcfee8e$var$taskTimeoutID = -1);
                $25f9a152cbcfee8e$var$isPerformingWork = !0;
                var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
                try {
                    b: {
                        $25f9a152cbcfee8e$var$advanceTimers(currentTime);
                        for($25f9a152cbcfee8e$var$currentTask = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue); null !== $25f9a152cbcfee8e$var$currentTask && !($25f9a152cbcfee8e$var$currentTask.expirationTime > currentTime && $25f9a152cbcfee8e$var$shouldYieldToHost());){
                            var callback = $25f9a152cbcfee8e$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $25f9a152cbcfee8e$var$currentTask.callback = null;
                                $25f9a152cbcfee8e$var$currentPriorityLevel = $25f9a152cbcfee8e$var$currentTask.priorityLevel;
                                var continuationCallback = callback($25f9a152cbcfee8e$var$currentTask.expirationTime <= currentTime);
                                currentTime = $25f9a152cbcfee8e$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $25f9a152cbcfee8e$var$currentTask.callback = continuationCallback;
                                    $25f9a152cbcfee8e$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $25f9a152cbcfee8e$var$currentTask === $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue) && $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$taskQueue);
                                $25f9a152cbcfee8e$var$advanceTimers(currentTime);
                            } else $25f9a152cbcfee8e$var$pop($25f9a152cbcfee8e$var$taskQueue);
                            $25f9a152cbcfee8e$var$currentTask = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue);
                        }
                        if (null !== $25f9a152cbcfee8e$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue);
                            null !== firstTimer && $25f9a152cbcfee8e$var$requestHostTimeout($25f9a152cbcfee8e$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $25f9a152cbcfee8e$var$currentTask = null, $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel, $25f9a152cbcfee8e$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline() : $25f9a152cbcfee8e$var$isMessageLoopRunning = !1;
        }
    }
}
var $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $25f9a152cbcfee8e$var$localSetImmediate) $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline = function() {
    $25f9a152cbcfee8e$var$localSetImmediate($25f9a152cbcfee8e$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $25f9a152cbcfee8e$var$channel = new MessageChannel(), $25f9a152cbcfee8e$var$port = $25f9a152cbcfee8e$var$channel.port2;
    $25f9a152cbcfee8e$var$channel.port1.onmessage = $25f9a152cbcfee8e$var$performWorkUntilDeadline;
    $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline = function() {
        $25f9a152cbcfee8e$var$port.postMessage(null);
    };
} else $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline = function() {
    $25f9a152cbcfee8e$var$localSetTimeout($25f9a152cbcfee8e$var$performWorkUntilDeadline, 0);
};
function $25f9a152cbcfee8e$var$requestHostTimeout(callback, ms) {
    $25f9a152cbcfee8e$var$taskTimeoutID = $25f9a152cbcfee8e$var$localSetTimeout(function() {
        callback($25f9a152cbcfee8e$export$c4744153514ff05d());
    }, ms);
}
$25f9a152cbcfee8e$export$3e506c1ccc9cc1a7 = 5;
$25f9a152cbcfee8e$export$e26fe2ed2fa76875 = 1;
$25f9a152cbcfee8e$export$502329bbf4b505b1 = 4;
$25f9a152cbcfee8e$export$6e3807111c4874c4 = 3;
$25f9a152cbcfee8e$export$c27134553091fb3a = null;
$25f9a152cbcfee8e$export$33ee1acdc04fd2a2 = 2;
$25f9a152cbcfee8e$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$25f9a152cbcfee8e$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $25f9a152cbcfee8e$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$25f9a152cbcfee8e$export$d3dfb8e4810cb555 = function() {
    return $25f9a152cbcfee8e$var$currentPriorityLevel;
};
$25f9a152cbcfee8e$export$72fdf0e06517287b = function(eventHandler) {
    switch($25f9a152cbcfee8e$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    $25f9a152cbcfee8e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$25f9a152cbcfee8e$export$816d2913ae6b83b1 = function() {
    $25f9a152cbcfee8e$var$needsPaint = !0;
};
$25f9a152cbcfee8e$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    $25f9a152cbcfee8e$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$25f9a152cbcfee8e$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $25f9a152cbcfee8e$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $25f9a152cbcfee8e$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $25f9a152cbcfee8e$var$push($25f9a152cbcfee8e$var$timerQueue, priorityLevel), null === $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$taskQueue) && priorityLevel === $25f9a152cbcfee8e$var$peek($25f9a152cbcfee8e$var$timerQueue) && ($25f9a152cbcfee8e$var$isHostTimeoutScheduled ? ($25f9a152cbcfee8e$var$localClearTimeout($25f9a152cbcfee8e$var$taskTimeoutID), $25f9a152cbcfee8e$var$taskTimeoutID = -1) : $25f9a152cbcfee8e$var$isHostTimeoutScheduled = !0, $25f9a152cbcfee8e$var$requestHostTimeout($25f9a152cbcfee8e$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $25f9a152cbcfee8e$var$push($25f9a152cbcfee8e$var$taskQueue, priorityLevel), $25f9a152cbcfee8e$var$isHostCallbackScheduled || $25f9a152cbcfee8e$var$isPerformingWork || ($25f9a152cbcfee8e$var$isHostCallbackScheduled = !0, $25f9a152cbcfee8e$var$isMessageLoopRunning || ($25f9a152cbcfee8e$var$isMessageLoopRunning = !0, $25f9a152cbcfee8e$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$25f9a152cbcfee8e$export$b5836b71941fa3ed = $25f9a152cbcfee8e$var$shouldYieldToHost;
$25f9a152cbcfee8e$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $25f9a152cbcfee8e$var$currentPriorityLevel;
        $25f9a152cbcfee8e$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $25f9a152cbcfee8e$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("7pfQ9", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3WPYT"));

});

parcelRegister("3G714", function(module, exports) {
'use strict';
function $2adabca53da00ad0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2adabca53da00ad0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2adabca53da00ad0$var$checkDCE();

module.exports = (parcelRequire("5a5ch"));

});
parcelRegister("5a5ch", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $3c21eaf68ad38b13$export$69ce8ef3fe5cead0, (v) => $3c21eaf68ad38b13$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $3c21eaf68ad38b13$export$d39a5bbd09211389, (v) => $3c21eaf68ad38b13$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $3c21eaf68ad38b13$export$cd75ccfd720a3cd4, (v) => $3c21eaf68ad38b13$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $3c21eaf68ad38b13$export$a0816fa17a9e79be, (v) => $3c21eaf68ad38b13$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $3c21eaf68ad38b13$export$7292efcadded39f3, (v) => $3c21eaf68ad38b13$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $3c21eaf68ad38b13$export$da407abadb9b8f86, (v) => $3c21eaf68ad38b13$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $3c21eaf68ad38b13$export$314cfea32580671c, (v) => $3c21eaf68ad38b13$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $3c21eaf68ad38b13$export$513ccb98c53b8039, (v) => $3c21eaf68ad38b13$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $3c21eaf68ad38b13$export$dbca993bc2d264a, (v) => $3c21eaf68ad38b13$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $3c21eaf68ad38b13$export$4797a8006f0655d0, (v) => $3c21eaf68ad38b13$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $3c21eaf68ad38b13$export$c78a37762a8d58e1, (v) => $3c21eaf68ad38b13$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $3c21eaf68ad38b13$export$606f11b2eb45ecc6, (v) => $3c21eaf68ad38b13$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $3c21eaf68ad38b13$export$f7e8a0bf92324b1e, (v) => $3c21eaf68ad38b13$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $3c21eaf68ad38b13$export$83d89fbfd8236492, (v) => $3c21eaf68ad38b13$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c21eaf68ad38b13$export$69ce8ef3fe5cead0;
var $3c21eaf68ad38b13$export$d39a5bbd09211389;
var $3c21eaf68ad38b13$export$cd75ccfd720a3cd4;
var $3c21eaf68ad38b13$export$a0816fa17a9e79be;
var $3c21eaf68ad38b13$export$7292efcadded39f3;
var $3c21eaf68ad38b13$export$da407abadb9b8f86;
var $3c21eaf68ad38b13$export$314cfea32580671c;
var $3c21eaf68ad38b13$export$513ccb98c53b8039;
var $3c21eaf68ad38b13$export$dbca993bc2d264a;
var $3c21eaf68ad38b13$export$4797a8006f0655d0;
var $3c21eaf68ad38b13$export$c78a37762a8d58e1;
var $3c21eaf68ad38b13$export$606f11b2eb45ecc6;
var $3c21eaf68ad38b13$export$f7e8a0bf92324b1e;
var $3c21eaf68ad38b13$export$83d89fbfd8236492;
"use strict";

var $7pfQ9 = parcelRequire("7pfQ9");
function $3c21eaf68ad38b13$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $3c21eaf68ad38b13$var$noop() {}
var $3c21eaf68ad38b13$var$Internals = {
    d: {
        f: $3c21eaf68ad38b13$var$noop,
        r: function() {
            throw Error($3c21eaf68ad38b13$var$formatProdErrorMessage(522));
        },
        D: $3c21eaf68ad38b13$var$noop,
        C: $3c21eaf68ad38b13$var$noop,
        L: $3c21eaf68ad38b13$var$noop,
        m: $3c21eaf68ad38b13$var$noop,
        X: $3c21eaf68ad38b13$var$noop,
        S: $3c21eaf68ad38b13$var$noop,
        M: $3c21eaf68ad38b13$var$noop
    },
    p: 0,
    findDOMNode: null
}, $3c21eaf68ad38b13$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $3c21eaf68ad38b13$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $3c21eaf68ad38b13$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $3c21eaf68ad38b13$var$ReactSharedInternals = $7pfQ9.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $3c21eaf68ad38b13$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$3c21eaf68ad38b13$export$69ce8ef3fe5cead0 = $3c21eaf68ad38b13$var$Internals;
$3c21eaf68ad38b13$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($3c21eaf68ad38b13$var$formatProdErrorMessage(299));
    return $3c21eaf68ad38b13$var$createPortal$1(children, container, null, key);
};
$3c21eaf68ad38b13$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $3c21eaf68ad38b13$var$ReactSharedInternals.T, previousUpdatePriority = $3c21eaf68ad38b13$var$Internals.p;
    try {
        if ($3c21eaf68ad38b13$var$ReactSharedInternals.T = null, $3c21eaf68ad38b13$var$Internals.p = 2, fn) return fn();
    } finally{
        $3c21eaf68ad38b13$var$ReactSharedInternals.T = previousTransition, $3c21eaf68ad38b13$var$Internals.p = previousUpdatePriority, $3c21eaf68ad38b13$var$Internals.d.f();
    }
};
$3c21eaf68ad38b13$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $3c21eaf68ad38b13$var$Internals.d.C(href, options));
};
$3c21eaf68ad38b13$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $3c21eaf68ad38b13$var$Internals.d.D(href);
};
$3c21eaf68ad38b13$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $3c21eaf68ad38b13$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $3c21eaf68ad38b13$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$3c21eaf68ad38b13$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $3c21eaf68ad38b13$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $3c21eaf68ad38b13$var$Internals.d.M(href);
    }
};
$3c21eaf68ad38b13$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(as, options.crossOrigin);
        $3c21eaf68ad38b13$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$3c21eaf68ad38b13$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $3c21eaf68ad38b13$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $3c21eaf68ad38b13$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $3c21eaf68ad38b13$var$Internals.d.m(href);
    }
};
$3c21eaf68ad38b13$export$4797a8006f0655d0 = function(form) {
    $3c21eaf68ad38b13$var$Internals.d.r(form);
};
$3c21eaf68ad38b13$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$3c21eaf68ad38b13$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $3c21eaf68ad38b13$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$3c21eaf68ad38b13$export$f7e8a0bf92324b1e = function() {
    return $3c21eaf68ad38b13$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$3c21eaf68ad38b13$export$83d89fbfd8236492 = "19.2.0";

});



var $39a601ce4590a47e$exports = {};
'use strict';

$39a601ce4590a47e$exports = (parcelRequire("kQfpd"));



var $7pfQ9 = parcelRequire("7pfQ9");
var $9b36b21436e51e50$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $9b36b21436e51e50$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $9b36b21436e51e50$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $9b36b21436e51e50$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$9b36b21436e51e50$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($9b36b21436e51e50$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $9b36b21436e51e50$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $f606114e0294917e$export$71ad59f2e432cfe8 = "-ms-";
var $f606114e0294917e$export$2c0f367103c8d01c = "-moz-";
var $f606114e0294917e$export$39dfd62a25e0fe93 = "-webkit-";
var $f606114e0294917e$export$a29989082612d0d9 = "comm";
var $f606114e0294917e$export$aa3a2e812ca8570d = "rule";
var $f606114e0294917e$export$527d108ccf083c2b = "decl";
var $f606114e0294917e$export$d3d35020fa5b54f0 = "@page";
var $f606114e0294917e$export$500415a86c544f73 = "@media";
var $f606114e0294917e$export$a763edbf796b780a = "@import";
var $f606114e0294917e$export$2790aeb8b4e5c826 = "@charset";
var $f606114e0294917e$export$1cc683e23b84b133 = "@viewport";
var $f606114e0294917e$export$9447a5efea57e862 = "@supports";
var $f606114e0294917e$export$ef011b4e114b1fba = "@document";
var $f606114e0294917e$export$6aad947bda0f3f46 = "@namespace";
var $f606114e0294917e$export$b44a8529a35fcb60 = "@keyframes";
var $f606114e0294917e$export$2c16de31893252e6 = "@font-face";
var $f606114e0294917e$export$3d846dd52e150c6f = "@counter-style";
var $f606114e0294917e$export$22314bfbb57653fe = "@font-feature-values";
var $f606114e0294917e$export$d773506282b3cfe6 = "@layer";
var $f606114e0294917e$export$2335f513bbd82c6d = Math.abs;
var $f606114e0294917e$export$6788812c4e6611e6 = String.fromCharCode;
var $f606114e0294917e$export$e6e34fd1f2686227 = Object.assign;
function $f606114e0294917e$export$d6af199866bfb566(e, r) {
    return $f606114e0294917e$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 0)) << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 1)) << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 2)) << 2 ^ $f606114e0294917e$export$a9db5e087081082d(e, 3) : 0;
}
function $f606114e0294917e$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f606114e0294917e$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f606114e0294917e$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f606114e0294917e$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $f606114e0294917e$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f606114e0294917e$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f606114e0294917e$export$36776f635604f274(e) {
    return e.length;
}
function $f606114e0294917e$export$f9084667e487ed46(e) {
    return e.length;
}
function $f606114e0294917e$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f606114e0294917e$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $f606114e0294917e$export$53f1d5ea8de3d7c = 1;
var $f606114e0294917e$export$4e0c71f277ca26b3 = 1;
var $f606114e0294917e$export$f24224f1c91d8156 = 0;
var $f606114e0294917e$export$5880b8b5730aff45 = 0;
var $f606114e0294917e$export$c0306caf338ac095 = 0;
var $f606114e0294917e$export$30a86d91af8ff6e6 = "";
function $f606114e0294917e$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $f606114e0294917e$export$53f1d5ea8de3d7c,
        column: $f606114e0294917e$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $f606114e0294917e$export$784d13d8ee351f07(e, r) {
    return $f606114e0294917e$export$e6e34fd1f2686227($f606114e0294917e$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $f606114e0294917e$export$eba6f6f03b0a92e7() {
    return $f606114e0294917e$export$c0306caf338ac095;
}
function $f606114e0294917e$export$232faf9add678146() {
    $f606114e0294917e$export$c0306caf338ac095 = $f606114e0294917e$export$5880b8b5730aff45 > 0 ? $f606114e0294917e$export$a9db5e087081082d($f606114e0294917e$export$30a86d91af8ff6e6, --$f606114e0294917e$export$5880b8b5730aff45) : 0;
    if ($f606114e0294917e$export$4e0c71f277ca26b3--, $f606114e0294917e$export$c0306caf338ac095 === 10) $f606114e0294917e$export$4e0c71f277ca26b3 = 1, $f606114e0294917e$export$53f1d5ea8de3d7c--;
    return $f606114e0294917e$export$c0306caf338ac095;
}
function $f606114e0294917e$export$48cfd1e771a65c4f() {
    $f606114e0294917e$export$c0306caf338ac095 = $f606114e0294917e$export$5880b8b5730aff45 < $f606114e0294917e$export$f24224f1c91d8156 ? $f606114e0294917e$export$a9db5e087081082d($f606114e0294917e$export$30a86d91af8ff6e6, $f606114e0294917e$export$5880b8b5730aff45++) : 0;
    if ($f606114e0294917e$export$4e0c71f277ca26b3++, $f606114e0294917e$export$c0306caf338ac095 === 10) $f606114e0294917e$export$4e0c71f277ca26b3 = 1, $f606114e0294917e$export$53f1d5ea8de3d7c++;
    return $f606114e0294917e$export$c0306caf338ac095;
}
function $f606114e0294917e$export$4d3fb11e950abb9e() {
    return $f606114e0294917e$export$a9db5e087081082d($f606114e0294917e$export$30a86d91af8ff6e6, $f606114e0294917e$export$5880b8b5730aff45);
}
function $f606114e0294917e$export$e88cb2efb12ae807() {
    return $f606114e0294917e$export$5880b8b5730aff45;
}
function $f606114e0294917e$export$58adb3bec8346d0f(e, r) {
    return $f606114e0294917e$export$2f35ab04d2335697($f606114e0294917e$export$30a86d91af8ff6e6, e, r);
}
function $f606114e0294917e$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f606114e0294917e$export$2de70f21292aac9e(e) {
    return $f606114e0294917e$export$53f1d5ea8de3d7c = $f606114e0294917e$export$4e0c71f277ca26b3 = 1, $f606114e0294917e$export$f24224f1c91d8156 = $f606114e0294917e$export$36776f635604f274($f606114e0294917e$export$30a86d91af8ff6e6 = e), $f606114e0294917e$export$5880b8b5730aff45 = 0, [];
}
function $f606114e0294917e$export$45918ac1574455b1(e) {
    return $f606114e0294917e$export$30a86d91af8ff6e6 = "", e;
}
function $f606114e0294917e$export$410ac95b9ec204b8(e) {
    return $f606114e0294917e$export$87c2784dc9fc4ab($f606114e0294917e$export$58adb3bec8346d0f($f606114e0294917e$export$5880b8b5730aff45 - 1, $f606114e0294917e$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f606114e0294917e$export$660b2ee2d4fb4eff(e) {
    return $f606114e0294917e$export$45918ac1574455b1($f606114e0294917e$export$5f8c09e3ae6f64e1($f606114e0294917e$export$2de70f21292aac9e(e)));
}
function $f606114e0294917e$export$7af1228ff777d175(e) {
    while($f606114e0294917e$export$c0306caf338ac095 = $f606114e0294917e$export$4d3fb11e950abb9e())if ($f606114e0294917e$export$c0306caf338ac095 < 33) $f606114e0294917e$export$48cfd1e771a65c4f();
    else break;
    return $f606114e0294917e$export$9e1725a4cfeada27(e) > 2 || $f606114e0294917e$export$9e1725a4cfeada27($f606114e0294917e$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f606114e0294917e$export$5f8c09e3ae6f64e1(e) {
    while($f606114e0294917e$export$48cfd1e771a65c4f())switch($f606114e0294917e$export$9e1725a4cfeada27($f606114e0294917e$export$c0306caf338ac095)){
        case 0:
            $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$c2ab62c7bf24634($f606114e0294917e$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$410ac95b9ec204b8($f606114e0294917e$export$c0306caf338ac095), e);
            break;
        default:
            $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$6788812c4e6611e6($f606114e0294917e$export$c0306caf338ac095), e);
    }
    return e;
}
function $f606114e0294917e$export$955ba06d119e085e(e, r) {
    while(--r && $f606114e0294917e$export$48cfd1e771a65c4f())if ($f606114e0294917e$export$c0306caf338ac095 < 48 || $f606114e0294917e$export$c0306caf338ac095 > 102 || $f606114e0294917e$export$c0306caf338ac095 > 57 && $f606114e0294917e$export$c0306caf338ac095 < 65 || $f606114e0294917e$export$c0306caf338ac095 > 70 && $f606114e0294917e$export$c0306caf338ac095 < 97) break;
    return $f606114e0294917e$export$58adb3bec8346d0f(e, $f606114e0294917e$export$e88cb2efb12ae807() + (r < 6 && $f606114e0294917e$export$4d3fb11e950abb9e() == 32 && $f606114e0294917e$export$48cfd1e771a65c4f() == 32));
}
function $f606114e0294917e$export$c889f2fcc19dbf12(e) {
    while($f606114e0294917e$export$48cfd1e771a65c4f())switch($f606114e0294917e$export$c0306caf338ac095){
        case e:
            return $f606114e0294917e$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f606114e0294917e$export$c889f2fcc19dbf12($f606114e0294917e$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f606114e0294917e$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f606114e0294917e$export$48cfd1e771a65c4f();
            break;
    }
    return $f606114e0294917e$export$5880b8b5730aff45;
}
function $f606114e0294917e$export$4254d4e2b3745c4c(e, r) {
    while($f606114e0294917e$export$48cfd1e771a65c4f())if (e + $f606114e0294917e$export$c0306caf338ac095 === 57) break;
    else if (e + $f606114e0294917e$export$c0306caf338ac095 === 84 && $f606114e0294917e$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f606114e0294917e$export$58adb3bec8346d0f(r, $f606114e0294917e$export$5880b8b5730aff45 - 1) + "*" + $f606114e0294917e$export$6788812c4e6611e6(e === 47 ? e : $f606114e0294917e$export$48cfd1e771a65c4f());
}
function $f606114e0294917e$export$c2ab62c7bf24634(e) {
    while(!$f606114e0294917e$export$9e1725a4cfeada27($f606114e0294917e$export$4d3fb11e950abb9e()))$f606114e0294917e$export$48cfd1e771a65c4f();
    return $f606114e0294917e$export$58adb3bec8346d0f(e, $f606114e0294917e$export$5880b8b5730aff45);
}
function $f606114e0294917e$export$ef7acd7185315e22(e) {
    return $f606114e0294917e$export$45918ac1574455b1($f606114e0294917e$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f606114e0294917e$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f606114e0294917e$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $f606114e0294917e$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $f606114e0294917e$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($f606114e0294917e$export$f8e21b1e77979a08(j += $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $f606114e0294917e$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $f606114e0294917e$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $f606114e0294917e$export$955ba06d119e085e($f606114e0294917e$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f606114e0294917e$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$4a34f930e789283c($f606114e0294917e$export$4254d4e2b3745c4c($f606114e0294917e$export$48cfd1e771a65c4f(), $f606114e0294917e$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $f606114e0294917e$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $f606114e0294917e$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $f606114e0294917e$export$36776f635604f274(j) - l) $f606114e0294917e$export$10d8903dec122b9d(p > 32 ? $f606114e0294917e$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $f606114e0294917e$export$f8483753829ec8f3($f606114e0294917e$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $f606114e0294917e$export$10d8903dec122b9d(y = $f606114e0294917e$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $f606114e0294917e$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $f606114e0294917e$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $f606114e0294917e$export$98e6a39c04603d36(e, y, y, n && $f606114e0294917e$export$10d8903dec122b9d($f606114e0294917e$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $f606114e0294917e$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $f606114e0294917e$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $f606114e0294917e$export$232faf9add678146() == 125) continue;
            }
            switch(j += $f606114e0294917e$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($f606114e0294917e$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f606114e0294917e$export$4d3fb11e950abb9e() === 45) j += $f606114e0294917e$export$410ac95b9ec204b8($f606114e0294917e$export$48cfd1e771a65c4f());
                    v = $f606114e0294917e$export$4d3fb11e950abb9e(), o = l = $f606114e0294917e$export$36776f635604f274(g = j += $f606114e0294917e$export$c2ab62c7bf24634($f606114e0294917e$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $f606114e0294917e$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $f606114e0294917e$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $f606114e0294917e$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $f606114e0294917e$export$2f35ab04d2335697(e, v + 1, v = $f606114e0294917e$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $f606114e0294917e$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $f606114e0294917e$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $f606114e0294917e$export$35059013cd4a06db(e, r, a, s === 0 ? $f606114e0294917e$export$aa3a2e812ca8570d : i, f, o, l);
}
function $f606114e0294917e$export$4a34f930e789283c(e, r, a) {
    return $f606114e0294917e$export$35059013cd4a06db(e, r, a, $f606114e0294917e$export$a29989082612d0d9, $f606114e0294917e$export$6788812c4e6611e6($f606114e0294917e$export$eba6f6f03b0a92e7()), $f606114e0294917e$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $f606114e0294917e$export$f8483753829ec8f3(e, r, a, n) {
    return $f606114e0294917e$export$35059013cd4a06db(e, r, a, $f606114e0294917e$export$527d108ccf083c2b, $f606114e0294917e$export$2f35ab04d2335697(e, 0, n), $f606114e0294917e$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $f606114e0294917e$export$82e9f45cca5ba907(n, c, s) {
    switch($f606114e0294917e$export$d6af199866bfb566(n, c)){
        case 5103:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $f606114e0294917e$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$2c0f367103c8d01c + n + $f606114e0294917e$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($f606114e0294917e$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "box-$1$2" + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-item-" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$f606114e0294917e$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $f606114e0294917e$export$71ad59f2e432cfe8 + "grid-row-" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-line-pack" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + "box-" + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-grow", "") + $f606114e0294917e$export$39dfd62a25e0fe93 + n + $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $f606114e0294917e$export$39dfd62a25e0fe93 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "box-pack:$3" + $f606114e0294917e$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $f606114e0294917e$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$f606114e0294917e$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $f606114e0294917e$export$71ad59f2e432cfe8 + "grid-column-align" + $f606114e0294917e$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $f606114e0294917e$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f606114e0294917e$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $f606114e0294917e$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f606114e0294917e$export$f8e21b1e77979a08(s, "span") ? $f606114e0294917e$export$4659b591c19bdf3d(s, /\d+/) : +$f606114e0294917e$export$4659b591c19bdf3d(s, /\d+/) - +$f606114e0294917e$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f606114e0294917e$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $f606114e0294917e$export$71ad59f2e432cfe8 + $f606114e0294917e$export$77ad94ebf1c2b9ed($f606114e0294917e$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $f606114e0294917e$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f606114e0294917e$export$36776f635604f274(n) - 1 - c > 6) switch($f606114e0294917e$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($f606114e0294917e$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f606114e0294917e$export$2c0f367103c8d01c + ($f606114e0294917e$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$f606114e0294917e$export$f8e21b1e77979a08(n, "stretch") ? $f606114e0294917e$export$82e9f45cca5ba907($f606114e0294917e$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $f606114e0294917e$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $f606114e0294917e$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($f606114e0294917e$export$a9db5e087081082d(n, c + 6) === 121) return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, ":", ":" + $f606114e0294917e$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($f606114e0294917e$export$a9db5e087081082d(n, $f606114e0294917e$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + ($f606114e0294917e$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f606114e0294917e$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f606114e0294917e$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, ":", ":" + $f606114e0294917e$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f606114e0294917e$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $f606114e0294917e$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $f606114e0294917e$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f606114e0294917e$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f606114e0294917e$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $f606114e0294917e$export$a763edbf796b780a:
        case $f606114e0294917e$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f606114e0294917e$export$a29989082612d0d9:
            return "";
        case $f606114e0294917e$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f606114e0294917e$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f606114e0294917e$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $f606114e0294917e$export$36776f635604f274(a = $f606114e0294917e$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f606114e0294917e$export$5a7767152ae0305f(e) {
    var r = $f606114e0294917e$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $f606114e0294917e$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f606114e0294917e$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $f606114e0294917e$export$527d108ccf083c2b:
                n.return = $f606114e0294917e$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $f606114e0294917e$export$b44a8529a35fcb60:
                return $f606114e0294917e$export$dfdc1655ccc5b9cb([
                    $f606114e0294917e$export$784d13d8ee351f07(n, {
                        value: $f606114e0294917e$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $f606114e0294917e$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f606114e0294917e$export$aa3a2e812ca8570d:
                if (n.length) return $f606114e0294917e$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($f606114e0294917e$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $f606114e0294917e$export$dfdc1655ccc5b9cb([
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $f606114e0294917e$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $f606114e0294917e$export$dfdc1655ccc5b9cb([
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f606114e0294917e$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $f606114e0294917e$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $f606114e0294917e$export$784d13d8ee351f07(n, {
                                    props: [
                                        $f606114e0294917e$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $f606114e0294917e$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $f606114e0294917e$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f606114e0294917e$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f606114e0294917e$export$1be1fc439b849fdf($f606114e0294917e$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($f606114e0294917e$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f606114e0294917e$export$2f35ab04d2335697(r, 1, $f606114e0294917e$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $f606114e0294917e$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f606114e0294917e$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $f606114e0294917e$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $383a16c0af63619a$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $9af28dbc4ff027aa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $56efb59e443286cf$var$isBrowser = typeof document !== 'undefined';
var $56efb59e443286cf$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f606114e0294917e$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f606114e0294917e$export$9e1725a4cfeada27)(character)) break;
        (0, $f606114e0294917e$export$48cfd1e771a65c4f)();
    }
    return (0, $f606114e0294917e$export$58adb3bec8346d0f)(begin, (0, $f606114e0294917e$export$5880b8b5730aff45));
};
var $56efb59e443286cf$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f606114e0294917e$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f606114e0294917e$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $56efb59e443286cf$var$identifierWithPointTracking((0, $f606114e0294917e$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f606114e0294917e$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f606114e0294917e$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $f606114e0294917e$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f606114e0294917e$export$48cfd1e771a65c4f)());
    return parsed;
};
var $56efb59e443286cf$var$getRules = function getRules(value, points) {
    return (0, $f606114e0294917e$export$45918ac1574455b1)($56efb59e443286cf$var$toRules((0, $f606114e0294917e$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $56efb59e443286cf$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $56efb59e443286cf$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$56efb59e443286cf$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $56efb59e443286cf$var$fixedElements.set(element, true);
    var points = [];
    var rules = $56efb59e443286cf$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $56efb59e443286cf$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $56efb59e443286cf$var$prefix(value, length) {
    switch((0, $f606114e0294917e$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$2c0f367103c8d01c) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'box-' + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $f606114e0294917e$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $f606114e0294917e$export$2c0f367103c8d01c) + ((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $f606114e0294917e$export$f8e21b1e77979a08)(value, 'stretch') ? $56efb59e443286cf$var$prefix((0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $f606114e0294917e$export$a9db5e087081082d)(value, (0, $f606114e0294917e$export$36776f635604f274)(value) - 3 - (~(0, $f606114e0294917e$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $f606114e0294917e$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + ((0, $f606114e0294917e$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $f606114e0294917e$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $f606114e0294917e$export$39dfd62a25e0fe93) + value + (0, $f606114e0294917e$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $56efb59e443286cf$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $f606114e0294917e$export$527d108ccf083c2b:
                element["return"] = $56efb59e443286cf$var$prefix(element.value, element.length);
                break;
            case 0, $f606114e0294917e$export$b44a8529a35fcb60:
                return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)([
                    (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                        value: (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $f606114e0294917e$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $f606114e0294917e$export$aa3a2e812ca8570d:
                if (element.length) return (0, $f606114e0294917e$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $f606114e0294917e$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)([
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $f606114e0294917e$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)([
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f606114e0294917e$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $f606114e0294917e$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f606114e0294917e$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $f606114e0294917e$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $f606114e0294917e$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $56efb59e443286cf$var$getServerStylisCache = $56efb59e443286cf$var$isBrowser ? undefined : (0, $383a16c0af63619a$export$2e2bcd8739ae039)(function() {
    return (0, $9af28dbc4ff027aa$export$2e2bcd8739ae039)(function() {
        return {};
    });
});
var $56efb59e443286cf$var$defaultStylisPlugins = [
    $56efb59e443286cf$var$prefixer
];
var $56efb59e443286cf$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($56efb59e443286cf$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $56efb59e443286cf$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($56efb59e443286cf$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $56efb59e443286cf$var$compat,
        $56efb59e443286cf$var$removeLabel
    ];
    if (!$56efb59e443286cf$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $f606114e0294917e$export$fac44ee5b035f737),
            (0, $f606114e0294917e$export$38bcb760f1d4871c)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $f606114e0294917e$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)((0, $f606114e0294917e$export$ef7acd7185315e22)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $f606114e0294917e$export$fac44ee5b035f737)
        ];
        var _serializer = (0, $f606114e0294917e$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $f606114e0294917e$export$dfdc1655ccc5b9cb)((0, $f606114e0294917e$export$ef7acd7185315e22)(styles), _serializer);
        };
        var serverStylisCache = $56efb59e443286cf$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $9b36b21436e51e50$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $433b84e4025fc999$export$2e2bcd8739ae039() {
    return $433b84e4025fc999$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $433b84e4025fc999$export$2e2bcd8739ae039.apply(null, arguments);
}



var $04d7b12b010888af$exports = {};
'use strict';
var $d15216aaf08bc3c3$exports = {};
'use strict';

$d15216aaf08bc3c3$exports = (parcelRequire("hoNSH"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $04d7b12b010888af$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $04d7b12b010888af$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $04d7b12b010888af$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $04d7b12b010888af$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $04d7b12b010888af$var$TYPE_STATICS = {};
$04d7b12b010888af$var$TYPE_STATICS[$d15216aaf08bc3c3$exports.ForwardRef] = $04d7b12b010888af$var$FORWARD_REF_STATICS;
$04d7b12b010888af$var$TYPE_STATICS[$d15216aaf08bc3c3$exports.Memo] = $04d7b12b010888af$var$MEMO_STATICS;
function $04d7b12b010888af$var$getStatics(component) {
    // React v16.11 and below
    if ($d15216aaf08bc3c3$exports.isMemo(component)) return $04d7b12b010888af$var$MEMO_STATICS;
     // React v16.12 and above
    return $04d7b12b010888af$var$TYPE_STATICS[component['$$typeof']] || $04d7b12b010888af$var$REACT_STATICS;
}
var $04d7b12b010888af$var$defineProperty = Object.defineProperty;
var $04d7b12b010888af$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $04d7b12b010888af$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $04d7b12b010888af$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $04d7b12b010888af$var$getPrototypeOf = Object.getPrototypeOf;
var $04d7b12b010888af$var$objectPrototype = Object.prototype;
function $04d7b12b010888af$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($04d7b12b010888af$var$objectPrototype) {
            var inheritedComponent = $04d7b12b010888af$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $04d7b12b010888af$var$objectPrototype) $04d7b12b010888af$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $04d7b12b010888af$var$getOwnPropertyNames(sourceComponent);
        if ($04d7b12b010888af$var$getOwnPropertySymbols) keys = keys.concat($04d7b12b010888af$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $04d7b12b010888af$var$getStatics(targetComponent);
        var sourceStatics = $04d7b12b010888af$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$04d7b12b010888af$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $04d7b12b010888af$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $04d7b12b010888af$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$04d7b12b010888af$exports = $04d7b12b010888af$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $9bdfad1d9a53b75c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($04d7b12b010888af$exports)))(targetComponent, sourceComponent);
};


var $335a9ebca9ef05c6$var$isBrowser = typeof document !== 'undefined';
function $335a9ebca9ef05c6$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $335a9ebca9ef05c6$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $335a9ebca9ef05c6$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $335a9ebca9ef05c6$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $335a9ebca9ef05c6$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$335a9ebca9ef05c6$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$335a9ebca9ef05c6$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $cb67a2560fdadc97$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $df02772e6ff9e6f1$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $bc26ff461060f8a8$var$isDevelopment = false;
var $bc26ff461060f8a8$var$hyphenateRegex = /[A-Z]|^ms/g;
var $bc26ff461060f8a8$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $bc26ff461060f8a8$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $bc26ff461060f8a8$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $bc26ff461060f8a8$var$processStyleName = /* #__PURE__ */ (0, $9af28dbc4ff027aa$export$2e2bcd8739ae039)(function(styleName) {
    return $bc26ff461060f8a8$var$isCustomProperty(styleName) ? styleName : styleName.replace($bc26ff461060f8a8$var$hyphenateRegex, '-$&').toLowerCase();
});
var $bc26ff461060f8a8$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($bc26ff461060f8a8$var$animationRegex, function(match, p1, p2) {
                $bc26ff461060f8a8$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $bc26ff461060f8a8$var$cursor
                };
                return p1;
            });
    }
    if ((0, $df02772e6ff9e6f1$export$2e2bcd8739ae039)[key] !== 1 && !$bc26ff461060f8a8$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $bc26ff461060f8a8$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $bc26ff461060f8a8$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $bc26ff461060f8a8$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $bc26ff461060f8a8$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $bc26ff461060f8a8$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $bc26ff461060f8a8$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $bc26ff461060f8a8$var$cursor;
                var result = interpolation(mergedProps);
                $bc26ff461060f8a8$var$cursor = previousCursor;
                return $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $bc26ff461060f8a8$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($bc26ff461060f8a8$var$isProcessableValue(asString)) string += $bc26ff461060f8a8$var$processStyleName(key) + ":" + $bc26ff461060f8a8$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $bc26ff461060f8a8$var$isDevelopment) throw new Error($bc26ff461060f8a8$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($bc26ff461060f8a8$var$isProcessableValue(value[_i])) string += $bc26ff461060f8a8$var$processStyleName(key) + ":" + $bc26ff461060f8a8$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $bc26ff461060f8a8$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $bc26ff461060f8a8$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $bc26ff461060f8a8$var$cursor;
function $bc26ff461060f8a8$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $bc26ff461060f8a8$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $bc26ff461060f8a8$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $bc26ff461060f8a8$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $bc26ff461060f8a8$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $cb67a2560fdadc97$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $bc26ff461060f8a8$var$cursor
    };
}



var $7pfQ9 = parcelRequire("7pfQ9");
var $f888194713c25944$var$isBrowser = typeof document !== 'undefined';
var $f888194713c25944$var$syncFallback = function syncFallback(create) {
    return create();
};
var $f888194713c25944$var$useInsertionEffect = $7pfQ9.useInsertionEffect ? $7pfQ9.useInsertionEffect : false;
var $f888194713c25944$export$db21c7ffa21794e7 = !$f888194713c25944$var$isBrowser ? $f888194713c25944$var$syncFallback : $f888194713c25944$var$useInsertionEffect || $f888194713c25944$var$syncFallback;
var $f888194713c25944$export$811a713a7276cb9d = $f888194713c25944$var$useInsertionEffect || $7pfQ9.useLayoutEffect;


var $7b858e3eb153e419$export$407448d2b89b1813 = false;
var $7b858e3eb153e419$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $7b858e3eb153e419$var$EmotionCacheContext = /* #__PURE__ */ $7pfQ9.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $56efb59e443286cf$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $7b858e3eb153e419$export$e7094788287c5e9b = $7b858e3eb153e419$var$EmotionCacheContext.Provider;
var $7b858e3eb153e419$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7pfQ9.useContext)($7b858e3eb153e419$var$EmotionCacheContext);
};
var $7b858e3eb153e419$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7pfQ9.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7pfQ9.useContext)($7b858e3eb153e419$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$7b858e3eb153e419$export$23f2a1d2818174ef) $7b858e3eb153e419$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7pfQ9.useContext)($7b858e3eb153e419$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $56efb59e443286cf$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $7pfQ9.createElement($7b858e3eb153e419$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $7b858e3eb153e419$export$971d5caa766a69d7 = /* #__PURE__ */ $7pfQ9.createContext({});
var $7b858e3eb153e419$export$3b14a55fb2447963 = function useTheme() {
    return $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7);
};
var $7b858e3eb153e419$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $433b84e4025fc999$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $7b858e3eb153e419$var$createCacheWithTheme = /* #__PURE__ */ (0, $383a16c0af63619a$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $383a16c0af63619a$export$2e2bcd8739ae039)(function(theme) {
        return $7b858e3eb153e419$var$getTheme(outerTheme, theme);
    });
});
var $7b858e3eb153e419$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $7b858e3eb153e419$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7pfQ9.createElement($7b858e3eb153e419$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $7b858e3eb153e419$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7pfQ9.forwardRef(function render(props, ref) {
        var theme = $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7pfQ9.createElement(Component, (0, $433b84e4025fc999$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $9bdfad1d9a53b75c$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $7b858e3eb153e419$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $7b858e3eb153e419$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $7b858e3eb153e419$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($7b858e3eb153e419$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$7b858e3eb153e419$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $7b858e3eb153e419$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $335a9ebca9ef05c6$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    var rules = (0, $f888194713c25944$export$db21c7ffa21794e7)(function() {
        return (0, $335a9ebca9ef05c6$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    if (!$7b858e3eb153e419$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7pfQ9.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7b858e3eb153e419$var$Emotion = /* #__PURE__ */ $7b858e3eb153e419$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$7b858e3eb153e419$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $335a9ebca9ef05c6$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $bc26ff461060f8a8$export$6321afa313b251b5)(registeredStyles, undefined, $7pfQ9.useContext($7b858e3eb153e419$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($7b858e3eb153e419$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $7b858e3eb153e419$var$typePropName && !$7b858e3eb153e419$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7pfQ9.createElement($7pfQ9.Fragment, null, /*#__PURE__*/ $7pfQ9.createElement($7b858e3eb153e419$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7pfQ9.createElement(WrappedComponent, newProps));
});
var $7b858e3eb153e419$export$a9c23c6ac3fc3eca = $7b858e3eb153e419$var$Emotion;


parcelRequire("7pfQ9");

var $07d605927ce9b919$exports = {};
function $07d605927ce9b919$var$_extends() {
    return $07d605927ce9b919$exports = $07d605927ce9b919$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07d605927ce9b919$exports.__esModule = true, $07d605927ce9b919$exports["default"] = $07d605927ce9b919$exports, $07d605927ce9b919$var$_extends.apply(null, arguments);
}
$07d605927ce9b919$exports = $07d605927ce9b919$var$_extends, $07d605927ce9b919$exports.__esModule = true, $07d605927ce9b919$exports["default"] = $07d605927ce9b919$exports;








var $ee37356223c3448b$export$ffb0004e005737fa = $39a601ce4590a47e$exports.Fragment;
var $ee37356223c3448b$export$34b9dba7ce09269b = function jsx(type, props, key) {
    if (!(0, $7b858e3eb153e419$export$dda1d9f60106f0e9).call(props, 'css')) return $39a601ce4590a47e$exports.jsx(type, props, key);
    return $39a601ce4590a47e$exports.jsx((0, $7b858e3eb153e419$export$a9c23c6ac3fc3eca), (0, $7b858e3eb153e419$export$db3b6bfb95261072)(type, props), key);
};
var $ee37356223c3448b$export$25062201e9e25d76 = function jsxs(type, props, key) {
    if (!(0, $7b858e3eb153e419$export$dda1d9f60106f0e9).call(props, 'css')) return $39a601ce4590a47e$exports.jsxs(type, props, key);
    return $39a601ce4590a47e$exports.jsxs((0, $7b858e3eb153e419$export$a9c23c6ac3fc3eca), (0, $7b858e3eb153e419$export$db3b6bfb95261072)(type, props), key);
};


var $f8a33d11906b9b49$exports = {};
'use strict';
function $f8a33d11906b9b49$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f8a33d11906b9b49$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f8a33d11906b9b49$var$checkDCE();

$f8a33d11906b9b49$exports = (parcelRequire("kUzXm"));


/**
 * react-router v7.9.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7pfQ9 = parcelRequire("7pfQ9");
var $86cabefda0aacd74$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-UIGDSWPH.mjs"
});
var $86cabefda0aacd74$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $86cabefda0aacd74$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $86cabefda0aacd74$var$__typeError("Cannot " + msg);
var $86cabefda0aacd74$var$__privateGet = (obj, member, getter)=>($86cabefda0aacd74$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $86cabefda0aacd74$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $86cabefda0aacd74$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $86cabefda0aacd74$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($86cabefda0aacd74$export$e19cd5f9376f8cee || {});
var $86cabefda0aacd74$var$PopStateEventType = "popstate";
function $86cabefda0aacd74$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $86cabefda0aacd74$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $86cabefda0aacd74$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $86cabefda0aacd74$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $86cabefda0aacd74$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $86cabefda0aacd74$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $86cabefda0aacd74$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $86cabefda0aacd74$export$fe53371bee54353d(to);
    }
    return $86cabefda0aacd74$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $86cabefda0aacd74$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $86cabefda0aacd74$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $86cabefda0aacd74$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $86cabefda0aacd74$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $86cabefda0aacd74$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $86cabefda0aacd74$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $86cabefda0aacd74$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $86cabefda0aacd74$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $86cabefda0aacd74$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $86cabefda0aacd74$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $86cabefda0aacd74$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $86cabefda0aacd74$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $86cabefda0aacd74$var$createKey()
    };
    return location;
}
function $86cabefda0aacd74$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $86cabefda0aacd74$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $86cabefda0aacd74$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $86cabefda0aacd74$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $86cabefda0aacd74$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $86cabefda0aacd74$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $86cabefda0aacd74$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $86cabefda0aacd74$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($86cabefda0aacd74$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($86cabefda0aacd74$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $86cabefda0aacd74$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $86cabefda0aacd74$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $86cabefda0aacd74$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $86cabefda0aacd74$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $86cabefda0aacd74$var$_map;
var $86cabefda0aacd74$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $86cabefda0aacd74$var$__privateAdd(this, $86cabefda0aacd74$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($86cabefda0aacd74$var$__privateGet(this, $86cabefda0aacd74$var$_map).has(context)) return $86cabefda0aacd74$var$__privateGet(this, $86cabefda0aacd74$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $86cabefda0aacd74$var$__privateGet(this, $86cabefda0aacd74$var$_map).set(context, value);
    }
};
$86cabefda0aacd74$var$_map = new WeakMap();
var $86cabefda0aacd74$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $86cabefda0aacd74$var$isUnsupportedLazyRouteObjectKey(key) {
    return $86cabefda0aacd74$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $86cabefda0aacd74$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $86cabefda0aacd74$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $86cabefda0aacd74$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $86cabefda0aacd74$var$isIndexRoute(route) {
    return route.index === true;
}
function $86cabefda0aacd74$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $86cabefda0aacd74$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $86cabefda0aacd74$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($86cabefda0aacd74$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $86cabefda0aacd74$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $86cabefda0aacd74$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $86cabefda0aacd74$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $86cabefda0aacd74$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $86cabefda0aacd74$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $86cabefda0aacd74$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $86cabefda0aacd74$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $86cabefda0aacd74$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $86cabefda0aacd74$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $86cabefda0aacd74$var$flattenRoutes(routes);
    $86cabefda0aacd74$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $86cabefda0aacd74$var$decodePath(pathname);
        matches = $86cabefda0aacd74$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $86cabefda0aacd74$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $86cabefda0aacd74$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $86cabefda0aacd74$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $86cabefda0aacd74$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $86cabefda0aacd74$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $86cabefda0aacd74$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $86cabefda0aacd74$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $86cabefda0aacd74$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $86cabefda0aacd74$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $86cabefda0aacd74$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $86cabefda0aacd74$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $86cabefda0aacd74$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $86cabefda0aacd74$var$paramRe = /^:[\w-]+$/;
var $86cabefda0aacd74$var$dynamicSegmentValue = 3;
var $86cabefda0aacd74$var$indexRouteValue = 2;
var $86cabefda0aacd74$var$emptySegmentValue = 1;
var $86cabefda0aacd74$var$staticSegmentValue = 10;
var $86cabefda0aacd74$var$splatPenalty = -2;
var $86cabefda0aacd74$var$isSplat = (s)=>s === "*";
function $86cabefda0aacd74$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($86cabefda0aacd74$var$isSplat)) initialScore += $86cabefda0aacd74$var$splatPenalty;
    if (index) initialScore += $86cabefda0aacd74$var$indexRouteValue;
    return segments.filter((s)=>!$86cabefda0aacd74$var$isSplat(s)).reduce((score, segment)=>score + ($86cabefda0aacd74$var$paramRe.test(segment) ? $86cabefda0aacd74$var$dynamicSegmentValue : segment === "" ? $86cabefda0aacd74$var$emptySegmentValue : $86cabefda0aacd74$var$staticSegmentValue), initialScore);
}
function $86cabefda0aacd74$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $86cabefda0aacd74$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $86cabefda0aacd74$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $86cabefda0aacd74$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $86cabefda0aacd74$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $86cabefda0aacd74$var$normalizePathname($86cabefda0aacd74$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $86cabefda0aacd74$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $86cabefda0aacd74$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $86cabefda0aacd74$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $86cabefda0aacd74$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $86cabefda0aacd74$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $86cabefda0aacd74$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $86cabefda0aacd74$var$compilePath(path, caseSensitive = false, end = true) {
    $86cabefda0aacd74$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $86cabefda0aacd74$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $86cabefda0aacd74$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $86cabefda0aacd74$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $86cabefda0aacd74$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $86cabefda0aacd74$var$joinPaths([
        basename,
        pathname
    ]);
}
function $86cabefda0aacd74$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $86cabefda0aacd74$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $86cabefda0aacd74$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $86cabefda0aacd74$var$normalizeSearch(search),
        hash: $86cabefda0aacd74$var$normalizeHash(hash)
    };
}
function $86cabefda0aacd74$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $86cabefda0aacd74$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $86cabefda0aacd74$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $86cabefda0aacd74$var$getResolveToMatches(matches) {
    let pathMatches = $86cabefda0aacd74$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $86cabefda0aacd74$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $86cabefda0aacd74$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $86cabefda0aacd74$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $86cabefda0aacd74$var$getInvalidPathError("?", "pathname", "search", to));
        $86cabefda0aacd74$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $86cabefda0aacd74$var$getInvalidPathError("#", "pathname", "hash", to));
        $86cabefda0aacd74$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $86cabefda0aacd74$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $86cabefda0aacd74$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $86cabefda0aacd74$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $86cabefda0aacd74$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $86cabefda0aacd74$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $86cabefda0aacd74$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $86cabefda0aacd74$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $86cabefda0aacd74$export$4051a07651545597(data2, init) {
    return new $86cabefda0aacd74$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $86cabefda0aacd74$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $86cabefda0aacd74$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $86cabefda0aacd74$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $86cabefda0aacd74$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $86cabefda0aacd74$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $86cabefda0aacd74$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $86cabefda0aacd74$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $86cabefda0aacd74$var$getRoutePattern(paths) {
    return paths.filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var $86cabefda0aacd74$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $86cabefda0aacd74$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $86cabefda0aacd74$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $86cabefda0aacd74$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$86cabefda0aacd74$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $86cabefda0aacd74$var$wrapImpl(aggregated[key], original, (...args)=>$86cabefda0aacd74$var$getHandlerInfo(args[0]));
            if (instrumented) {
                instrumented[$86cabefda0aacd74$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$86cabefda0aacd74$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $86cabefda0aacd74$var$wrapImpl(aggregated.middleware, original, (...args)=>$86cabefda0aacd74$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$86cabefda0aacd74$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $86cabefda0aacd74$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$86cabefda0aacd74$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $86cabefda0aacd74$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $86cabefda0aacd74$export$fe53371bee54353d(to) : ".",
                ...$86cabefda0aacd74$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$86cabefda0aacd74$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$86cabefda0aacd74$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $86cabefda0aacd74$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$86cabefda0aacd74$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$86cabefda0aacd74$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $86cabefda0aacd74$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $86cabefda0aacd74$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $86cabefda0aacd74$var$getReadonlyRequest(request),
            context: context != null ? $86cabefda0aacd74$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $86cabefda0aacd74$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $86cabefda0aacd74$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $86cabefda0aacd74$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $86cabefda0aacd74$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $86cabefda0aacd74$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $86cabefda0aacd74$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $86cabefda0aacd74$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $86cabefda0aacd74$var$getReadonlyContext(context)
    };
}
function $86cabefda0aacd74$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $86cabefda0aacd74$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $86cabefda0aacd74$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $86cabefda0aacd74$var$getReadonlyContext(context) {
    if ($86cabefda0aacd74$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $86cabefda0aacd74$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $86cabefda0aacd74$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $86cabefda0aacd74$var$objectProtoNames;
}
// lib/router/router.ts
var $86cabefda0aacd74$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $86cabefda0aacd74$var$validMutationMethods = new Set($86cabefda0aacd74$var$validMutationMethodsArr);
var $86cabefda0aacd74$var$validRequestMethodsArr = [
    "GET",
    ...$86cabefda0aacd74$var$validMutationMethodsArr
];
var $86cabefda0aacd74$var$validRequestMethods = new Set($86cabefda0aacd74$var$validRequestMethodsArr);
var $86cabefda0aacd74$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $86cabefda0aacd74$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $86cabefda0aacd74$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $86cabefda0aacd74$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $86cabefda0aacd74$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $86cabefda0aacd74$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $86cabefda0aacd74$var$isAbsoluteUrl = (url)=>$86cabefda0aacd74$var$ABSOLUTE_URL_REGEX.test(url);
var $86cabefda0aacd74$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $86cabefda0aacd74$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $86cabefda0aacd74$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $86cabefda0aacd74$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $86cabefda0aacd74$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $86cabefda0aacd74$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$86cabefda0aacd74$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $86cabefda0aacd74$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $86cabefda0aacd74$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $86cabefda0aacd74$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $86cabefda0aacd74$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $86cabefda0aacd74$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$86cabefda0aacd74$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$86cabefda0aacd74$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$86cabefda0aacd74$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $86cabefda0aacd74$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $86cabefda0aacd74$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $86cabefda0aacd74$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $86cabefda0aacd74$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$86cabefda0aacd74$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $86cabefda0aacd74$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $86cabefda0aacd74$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $86cabefda0aacd74$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $86cabefda0aacd74$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $86cabefda0aacd74$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $86cabefda0aacd74$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $86cabefda0aacd74$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $86cabefda0aacd74$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $86cabefda0aacd74$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $86cabefda0aacd74$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $86cabefda0aacd74$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $86cabefda0aacd74$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $86cabefda0aacd74$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $86cabefda0aacd74$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $86cabefda0aacd74$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $86cabefda0aacd74$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $86cabefda0aacd74$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $86cabefda0aacd74$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($86cabefda0aacd74$var$isErrorResult(result) && $86cabefda0aacd74$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $86cabefda0aacd74$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $86cabefda0aacd74$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$86cabefda0aacd74$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $86cabefda0aacd74$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $86cabefda0aacd74$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $86cabefda0aacd74$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $86cabefda0aacd74$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $86cabefda0aacd74$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($86cabefda0aacd74$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $86cabefda0aacd74$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($86cabefda0aacd74$var$isErrorResult(result)) {
            let boundaryMatch = $86cabefda0aacd74$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $86cabefda0aacd74$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $86cabefda0aacd74$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $86cabefda0aacd74$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $86cabefda0aacd74$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $86cabefda0aacd74$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $86cabefda0aacd74$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$86cabefda0aacd74$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $86cabefda0aacd74$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $86cabefda0aacd74$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $86cabefda0aacd74$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$86cabefda0aacd74$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $86cabefda0aacd74$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $86cabefda0aacd74$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $86cabefda0aacd74$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $86cabefda0aacd74$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $86cabefda0aacd74$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $86cabefda0aacd74$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $86cabefda0aacd74$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $86cabefda0aacd74$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $86cabefda0aacd74$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $86cabefda0aacd74$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $86cabefda0aacd74$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $86cabefda0aacd74$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($86cabefda0aacd74$var$isRedirectResult(actionResult) || $86cabefda0aacd74$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $86cabefda0aacd74$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($86cabefda0aacd74$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $86cabefda0aacd74$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $86cabefda0aacd74$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($86cabefda0aacd74$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $86cabefda0aacd74$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $86cabefda0aacd74$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $86cabefda0aacd74$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $86cabefda0aacd74$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $86cabefda0aacd74$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $86cabefda0aacd74$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $86cabefda0aacd74$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $86cabefda0aacd74$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $86cabefda0aacd74$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $86cabefda0aacd74$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $86cabefda0aacd74$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $86cabefda0aacd74$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $86cabefda0aacd74$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $86cabefda0aacd74$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $86cabefda0aacd74$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $86cabefda0aacd74$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $86cabefda0aacd74$var$getDoneFetcher(void 0));
            return;
        }
        if ($86cabefda0aacd74$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $86cabefda0aacd74$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($86cabefda0aacd74$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $86cabefda0aacd74$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $86cabefda0aacd74$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $86cabefda0aacd74$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $86cabefda0aacd74$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($86cabefda0aacd74$var$isAbsoluteUrl(location)) {
                const url = $86cabefda0aacd74$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $86cabefda0aacd74$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $86cabefda0aacd74$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($86cabefda0aacd74$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $86cabefda0aacd74$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $86cabefda0aacd74$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $86cabefda0aacd74$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($86cabefda0aacd74$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $86cabefda0aacd74$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $86cabefda0aacd74$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $86cabefda0aacd74$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $86cabefda0aacd74$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $86cabefda0aacd74$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $86cabefda0aacd74$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $86cabefda0aacd74$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $86cabefda0aacd74$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $86cabefda0aacd74$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $86cabefda0aacd74$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $86cabefda0aacd74$export$386d57f03f0b2883;
        $86cabefda0aacd74$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $86cabefda0aacd74$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $86cabefda0aacd74$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $86cabefda0aacd74$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $86cabefda0aacd74$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$86cabefda0aacd74$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $86cabefda0aacd74$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $86cabefda0aacd74$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $86cabefda0aacd74$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $86cabefda0aacd74$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $86cabefda0aacd74$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $86cabefda0aacd74$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $86cabefda0aacd74$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $86cabefda0aacd74$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $86cabefda0aacd74$export$3336b097a6fbc59a(routes, opts) {
    $86cabefda0aacd74$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $86cabefda0aacd74$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$86cabefda0aacd74$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $86cabefda0aacd74$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $86cabefda0aacd74$var$createLocation("", $86cabefda0aacd74$export$fe53371bee54353d(url), null, "default");
        let matches = $86cabefda0aacd74$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $86cabefda0aacd74$export$b8d3e69d4b3eff04();
        if (!$86cabefda0aacd74$var$isValidMethod(method) && method !== "HEAD") {
            let error = $86cabefda0aacd74$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $86cabefda0aacd74$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $86cabefda0aacd74$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $86cabefda0aacd74$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $86cabefda0aacd74$export$f5708dca728d7177(requestContext instanceof $86cabefda0aacd74$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $86cabefda0aacd74$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $86cabefda0aacd74$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $86cabefda0aacd74$var$getRoutePattern(matches.map((m)=>m.route.path)),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($86cabefda0aacd74$export$6e80290866a84dd4(error)) return error;
                    if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $86cabefda0aacd74$export$f2680fa305b734ca(error.status, error.statusText, await $86cabefda0aacd74$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($86cabefda0aacd74$export$e0163cfdf7bc9cfa(error)) error = $86cabefda0aacd74$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $86cabefda0aacd74$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $86cabefda0aacd74$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $86cabefda0aacd74$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $86cabefda0aacd74$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $86cabefda0aacd74$export$f5708dca728d7177($86cabefda0aacd74$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $86cabefda0aacd74$var$createLocation("", $86cabefda0aacd74$export$fe53371bee54353d(url), null, "default");
        let matches = $86cabefda0aacd74$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $86cabefda0aacd74$export$b8d3e69d4b3eff04();
        if (!$86cabefda0aacd74$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $86cabefda0aacd74$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $86cabefda0aacd74$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $86cabefda0aacd74$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $86cabefda0aacd74$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $86cabefda0aacd74$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $86cabefda0aacd74$export$f5708dca728d7177(requestContext instanceof $86cabefda0aacd74$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $86cabefda0aacd74$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $86cabefda0aacd74$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $86cabefda0aacd74$var$getRoutePattern(matches.map((m)=>m.route.path)),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $86cabefda0aacd74$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($86cabefda0aacd74$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($86cabefda0aacd74$var$dataWithResponseInitToResponse(error));
                if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $86cabefda0aacd74$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($86cabefda0aacd74$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $86cabefda0aacd74$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $86cabefda0aacd74$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($86cabefda0aacd74$var$isDataStrategyResult(e) && $86cabefda0aacd74$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($86cabefda0aacd74$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $86cabefda0aacd74$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $86cabefda0aacd74$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($86cabefda0aacd74$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($86cabefda0aacd74$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($86cabefda0aacd74$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $86cabefda0aacd74$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $86cabefda0aacd74$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($86cabefda0aacd74$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $86cabefda0aacd74$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $86cabefda0aacd74$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $86cabefda0aacd74$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $86cabefda0aacd74$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $86cabefda0aacd74$var$getRoutePattern(matches.map((m)=>m.route.path));
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $86cabefda0aacd74$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $86cabefda0aacd74$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $86cabefda0aacd74$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $86cabefda0aacd74$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $86cabefda0aacd74$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $86cabefda0aacd74$var$callDataStrategyImpl(dataStrategy || $86cabefda0aacd74$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($86cabefda0aacd74$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $86cabefda0aacd74$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($86cabefda0aacd74$export$e0163cfdf7bc9cfa(result.result)) throw $86cabefda0aacd74$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $86cabefda0aacd74$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $86cabefda0aacd74$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $86cabefda0aacd74$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $86cabefda0aacd74$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $86cabefda0aacd74$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $86cabefda0aacd74$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $86cabefda0aacd74$var$resolveTo(to ? to : ".", $86cabefda0aacd74$var$getResolveToMatches(contextualMatches), $86cabefda0aacd74$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $86cabefda0aacd74$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $86cabefda0aacd74$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $86cabefda0aacd74$export$fe53371bee54353d(path);
}
function $86cabefda0aacd74$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$86cabefda0aacd74$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$86cabefda0aacd74$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $86cabefda0aacd74$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $86cabefda0aacd74$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $86cabefda0aacd74$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$86cabefda0aacd74$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$86cabefda0aacd74$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $86cabefda0aacd74$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $86cabefda0aacd74$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $86cabefda0aacd74$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $86cabefda0aacd74$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $86cabefda0aacd74$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($86cabefda0aacd74$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $86cabefda0aacd74$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $86cabefda0aacd74$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $86cabefda0aacd74$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $86cabefda0aacd74$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    let actionResult = pendingActionResult ? $86cabefda0aacd74$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $86cabefda0aacd74$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $86cabefda0aacd74$var$getRoutePattern(matches.map((m)=>m.route.path));
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$86cabefda0aacd74$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $86cabefda0aacd74$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($86cabefda0aacd74$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $86cabefda0aacd74$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $86cabefda0aacd74$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $86cabefda0aacd74$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $86cabefda0aacd74$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $86cabefda0aacd74$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $86cabefda0aacd74$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $86cabefda0aacd74$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($86cabefda0aacd74$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $86cabefda0aacd74$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $86cabefda0aacd74$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$86cabefda0aacd74$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $86cabefda0aacd74$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $86cabefda0aacd74$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $86cabefda0aacd74$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $86cabefda0aacd74$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $86cabefda0aacd74$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$86cabefda0aacd74$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $86cabefda0aacd74$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $86cabefda0aacd74$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $86cabefda0aacd74$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$86cabefda0aacd74$var$isSameRoute(aChild, bChild)));
}
var $86cabefda0aacd74$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $86cabefda0aacd74$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $86cabefda0aacd74$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $86cabefda0aacd74$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $86cabefda0aacd74$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $86cabefda0aacd74$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $86cabefda0aacd74$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $86cabefda0aacd74$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $86cabefda0aacd74$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $86cabefda0aacd74$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $86cabefda0aacd74$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $86cabefda0aacd74$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $86cabefda0aacd74$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $86cabefda0aacd74$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $86cabefda0aacd74$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $86cabefda0aacd74$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $86cabefda0aacd74$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $86cabefda0aacd74$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $86cabefda0aacd74$var$isNonNullable(value) {
    return value !== void 0;
}
function $86cabefda0aacd74$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $86cabefda0aacd74$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($86cabefda0aacd74$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $86cabefda0aacd74$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $86cabefda0aacd74$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $86cabefda0aacd74$var$defaultDataStrategy(args);
    return $86cabefda0aacd74$var$runClientMiddlewarePipeline(args, ()=>$86cabefda0aacd74$var$defaultDataStrategy(args));
}
function $86cabefda0aacd74$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $86cabefda0aacd74$var$runMiddlewarePipeline(args, handler, processResult, $86cabefda0aacd74$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $86cabefda0aacd74$export$e0163cfdf7bc9cfa(result) ? $86cabefda0aacd74$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $86cabefda0aacd74$var$runClientMiddlewarePipeline(args, handler) {
    return $86cabefda0aacd74$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $86cabefda0aacd74$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.unstable_shouldCallHandler()), 0));
            let boundaryRouteId = $86cabefda0aacd74$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $86cabefda0aacd74$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $86cabefda0aacd74$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $86cabefda0aacd74$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $86cabefda0aacd74$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $86cabefda0aacd74$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $86cabefda0aacd74$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $86cabefda0aacd74$var$loadLazyRoute(match.route, $86cabefda0aacd74$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $86cabefda0aacd74$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, unstable_shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $86cabefda0aacd74$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        unstable_shouldRevalidateArgs: unstable_shouldRevalidateArgs,
        unstable_shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!unstable_shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $86cabefda0aacd74$var$shouldRevalidateLoader(match, {
                ...unstable_shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $86cabefda0aacd74$var$shouldRevalidateLoader(match, unstable_shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$86cabefda0aacd74$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($86cabefda0aacd74$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $86cabefda0aacd74$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $86cabefda0aacd74$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            unstable_shouldRevalidateArgs: shouldRevalidateArgs,
            unstable_shouldCallHandler: ()=>false,
            _lazyPromises: $86cabefda0aacd74$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $86cabefda0aacd74$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $86cabefda0aacd74$var$getRoutePattern(matches.map((m)=>m.route.path)), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $86cabefda0aacd74$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $86cabefda0aacd74$var$getRoutePattern(matches.map((m)=>m.route.path)),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $86cabefda0aacd74$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $86cabefda0aacd74$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $86cabefda0aacd74$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $86cabefda0aacd74$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $86cabefda0aacd74$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $86cabefda0aacd74$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $86cabefda0aacd74$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $86cabefda0aacd74$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $86cabefda0aacd74$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($86cabefda0aacd74$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: new $86cabefda0aacd74$export$f2680fa305b734ca(result.init?.status || 500, void 0, result.data),
                statusCode: $86cabefda0aacd74$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $86cabefda0aacd74$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($86cabefda0aacd74$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $86cabefda0aacd74$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $86cabefda0aacd74$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$86cabefda0aacd74$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $86cabefda0aacd74$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $86cabefda0aacd74$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($86cabefda0aacd74$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $86cabefda0aacd74$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $86cabefda0aacd74$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($86cabefda0aacd74$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $86cabefda0aacd74$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $86cabefda0aacd74$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $86cabefda0aacd74$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $86cabefda0aacd74$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $86cabefda0aacd74$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $86cabefda0aacd74$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $86cabefda0aacd74$export$f5708dca728d7177(!$86cabefda0aacd74$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($86cabefda0aacd74$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $86cabefda0aacd74$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $86cabefda0aacd74$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $86cabefda0aacd74$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $86cabefda0aacd74$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $86cabefda0aacd74$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $86cabefda0aacd74$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($86cabefda0aacd74$var$isErrorResult(result)) {
            let boundaryMatch = $86cabefda0aacd74$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($86cabefda0aacd74$var$isRedirectResult(result)) $86cabefda0aacd74$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $86cabefda0aacd74$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $86cabefda0aacd74$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $86cabefda0aacd74$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $86cabefda0aacd74$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $86cabefda0aacd74$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $86cabefda0aacd74$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $86cabefda0aacd74$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $86cabefda0aacd74$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $86cabefda0aacd74$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $86cabefda0aacd74$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($86cabefda0aacd74$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $86cabefda0aacd74$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $86cabefda0aacd74$export$8ccf933b0513f8d0(path) : path;
    return $86cabefda0aacd74$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $86cabefda0aacd74$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $86cabefda0aacd74$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $86cabefda0aacd74$var$dataWithResponseInitToErrorResponse(data2) {
    return new $86cabefda0aacd74$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $86cabefda0aacd74$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $86cabefda0aacd74$var$isDataStrategyResult(value));
}
function $86cabefda0aacd74$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $86cabefda0aacd74$var$isRedirectDataStrategyResult(result) {
    return $86cabefda0aacd74$export$3f1eb41d9a6a6a27(result.result) && $86cabefda0aacd74$var$redirectStatusCodes.has(result.result.status);
}
function $86cabefda0aacd74$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $86cabefda0aacd74$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $86cabefda0aacd74$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $86cabefda0aacd74$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $86cabefda0aacd74$export$794b2760043cf8cd(statusCode) {
    return $86cabefda0aacd74$var$redirectStatusCodes.has(statusCode);
}
function $86cabefda0aacd74$export$6e80290866a84dd4(result) {
    return $86cabefda0aacd74$export$3f1eb41d9a6a6a27(result) && $86cabefda0aacd74$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $86cabefda0aacd74$var$isValidMethod(method) {
    return $86cabefda0aacd74$var$validRequestMethods.has(method.toUpperCase());
}
function $86cabefda0aacd74$export$cbae47800eb95bc3(method) {
    return $86cabefda0aacd74$var$validMutationMethods.has(method.toUpperCase());
}
function $86cabefda0aacd74$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $86cabefda0aacd74$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $86cabefda0aacd74$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $86cabefda0aacd74$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $86cabefda0aacd74$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $86cabefda0aacd74$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $86cabefda0aacd74$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $86cabefda0aacd74$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $86cabefda0aacd74$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $86cabefda0aacd74$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $86cabefda0aacd74$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $86cabefda0aacd74$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($86cabefda0aacd74$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $86cabefda0aacd74$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($86cabefda0aacd74$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $86cabefda0aacd74$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $86cabefda0aacd74$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $86cabefda0aacd74$export$2eeee58951ff3c1c = $7pfQ9.createContext(null);
$86cabefda0aacd74$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $86cabefda0aacd74$export$315e3ffb01f217 = $7pfQ9.createContext(null);
$86cabefda0aacd74$export$315e3ffb01f217.displayName = "DataRouterState";
var $86cabefda0aacd74$export$717f757c655223f1 = $7pfQ9.createContext(false);
function $86cabefda0aacd74$var$useIsRSCRouterContext() {
    return $7pfQ9.useContext($86cabefda0aacd74$export$717f757c655223f1);
}
var $86cabefda0aacd74$export$3681f408decb40d1 = $7pfQ9.createContext({
    isTransitioning: false
});
$86cabefda0aacd74$export$3681f408decb40d1.displayName = "ViewTransition";
var $86cabefda0aacd74$export$cb3f1df1bef00a39 = $7pfQ9.createContext(/* @__PURE__ */ new Map());
$86cabefda0aacd74$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $86cabefda0aacd74$var$AwaitContext = $7pfQ9.createContext(null);
$86cabefda0aacd74$var$AwaitContext.displayName = "Await";
var $86cabefda0aacd74$export$2666c20e15407622 = (props)=>$7pfQ9.createElement($86cabefda0aacd74$var$AwaitContext.Provider, props);
var $86cabefda0aacd74$export$3044ab7fdabeaee6 = $7pfQ9.createContext(null);
$86cabefda0aacd74$export$3044ab7fdabeaee6.displayName = "Navigation";
var $86cabefda0aacd74$export$e6a44b110a0c44d3 = $7pfQ9.createContext(null);
$86cabefda0aacd74$export$e6a44b110a0c44d3.displayName = "Location";
var $86cabefda0aacd74$export$aac280ed165a4397 = $7pfQ9.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$86cabefda0aacd74$export$aac280ed165a4397.displayName = "Route";
var $86cabefda0aacd74$var$RouteErrorContext = $7pfQ9.createContext(null);
$86cabefda0aacd74$var$RouteErrorContext.displayName = "RouteError";
var $86cabefda0aacd74$export$945fecf35a8ef089 = true;
function $86cabefda0aacd74$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $86cabefda0aacd74$export$f5708dca728d7177($86cabefda0aacd74$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $86cabefda0aacd74$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $86cabefda0aacd74$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $86cabefda0aacd74$export$9c954a9d03d32f4a() {
    return $7pfQ9.useContext($86cabefda0aacd74$export$e6a44b110a0c44d3) != null;
}
function $86cabefda0aacd74$export$45d76561a5302f2b() {
    $86cabefda0aacd74$export$f5708dca728d7177($86cabefda0aacd74$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7pfQ9.useContext($86cabefda0aacd74$export$e6a44b110a0c44d3).location;
}
function $86cabefda0aacd74$export$1b3f31771c5d07c() {
    return $7pfQ9.useContext($86cabefda0aacd74$export$e6a44b110a0c44d3).navigationType;
}
function $86cabefda0aacd74$export$6c330e8992e8a295(pattern) {
    $86cabefda0aacd74$export$f5708dca728d7177($86cabefda0aacd74$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $86cabefda0aacd74$export$45d76561a5302f2b();
    return $7pfQ9.useMemo(()=>$86cabefda0aacd74$export$81336c211d5ff295(pattern, $86cabefda0aacd74$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $86cabefda0aacd74$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $86cabefda0aacd74$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7pfQ9.useLayoutEffect(cb);
}
function $86cabefda0aacd74$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    return isDataRoute ? $86cabefda0aacd74$var$useNavigateStable() : $86cabefda0aacd74$var$useNavigateUnstable();
}
function $86cabefda0aacd74$var$useNavigateUnstable() {
    $86cabefda0aacd74$export$f5708dca728d7177($86cabefda0aacd74$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7pfQ9.useContext($86cabefda0aacd74$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let { matches: matches } = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    let { pathname: locationPathname } = $86cabefda0aacd74$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($86cabefda0aacd74$var$getResolveToMatches(matches));
    let activeRef = $7pfQ9.useRef(false);
    $86cabefda0aacd74$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7pfQ9.useCallback((to, options = {})=>{
        $86cabefda0aacd74$var$warning(activeRef.current, $86cabefda0aacd74$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $86cabefda0aacd74$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $86cabefda0aacd74$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $86cabefda0aacd74$var$OutletContext = $7pfQ9.createContext(null);
function $86cabefda0aacd74$export$4138103a3ae699cc() {
    return $7pfQ9.useContext($86cabefda0aacd74$var$OutletContext);
}
function $86cabefda0aacd74$export$a3be3530d8e40d0b(context) {
    let outlet = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397).outlet;
    return $7pfQ9.useMemo(()=>outlet && /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $86cabefda0aacd74$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $86cabefda0aacd74$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    let { pathname: locationPathname } = $86cabefda0aacd74$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($86cabefda0aacd74$var$getResolveToMatches(matches));
    return $7pfQ9.useMemo(()=>$86cabefda0aacd74$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $86cabefda0aacd74$export$5d3fca4a98652595(routes, locationArg) {
    return $86cabefda0aacd74$var$useRoutesImpl(routes, locationArg);
}
function $86cabefda0aacd74$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $86cabefda0aacd74$export$f5708dca728d7177($86cabefda0aacd74$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($86cabefda0aacd74$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $86cabefda0aacd74$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $86cabefda0aacd74$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $86cabefda0aacd74$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $86cabefda0aacd74$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $86cabefda0aacd74$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($86cabefda0aacd74$export$945fecf35a8ef089) {
        $86cabefda0aacd74$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $86cabefda0aacd74$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $86cabefda0aacd74$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $86cabefda0aacd74$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $86cabefda0aacd74$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $86cabefda0aacd74$var$DefaultErrorComponent() {
    let error = $86cabefda0aacd74$export$ed527bf60f6e05f2();
    let message = $86cabefda0aacd74$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($86cabefda0aacd74$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7pfQ9.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7pfQ9.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7pfQ9.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7pfQ9.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7pfQ9.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $86cabefda0aacd74$var$defaultErrorElement = /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$DefaultErrorComponent, null);
var $86cabefda0aacd74$var$RenderErrorBoundary = class extends $7pfQ9.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
};
function $86cabefda0aacd74$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7pfQ9.useContext($86cabefda0aacd74$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $86cabefda0aacd74$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $86cabefda0aacd74$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $86cabefda0aacd74$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $86cabefda0aacd74$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7pfQ9.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            unstable_onError: unstable_onError
        }) : getChildren();
    }, null);
}
function $86cabefda0aacd74$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $86cabefda0aacd74$var$useDataRouterContext(hookName) {
    let ctx = $7pfQ9.useContext($86cabefda0aacd74$export$2eeee58951ff3c1c);
    $86cabefda0aacd74$export$f5708dca728d7177(ctx, $86cabefda0aacd74$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $86cabefda0aacd74$var$useDataRouterState(hookName) {
    let state = $7pfQ9.useContext($86cabefda0aacd74$export$315e3ffb01f217);
    $86cabefda0aacd74$export$f5708dca728d7177(state, $86cabefda0aacd74$var$getDataRouterConsoleError(hookName));
    return state;
}
function $86cabefda0aacd74$var$useRouteContext(hookName) {
    let route = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    $86cabefda0aacd74$export$f5708dca728d7177(route, $86cabefda0aacd74$var$getDataRouterConsoleError(hookName));
    return route;
}
function $86cabefda0aacd74$var$useCurrentRouteId(hookName) {
    let route = $86cabefda0aacd74$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $86cabefda0aacd74$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $86cabefda0aacd74$var$useRouteId() {
    return $86cabefda0aacd74$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $86cabefda0aacd74$export$d0fd4b7106de2769() {
    let state = $86cabefda0aacd74$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $86cabefda0aacd74$export$600dc272ed516c15() {
    let dataRouterContext = $86cabefda0aacd74$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $86cabefda0aacd74$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7pfQ9.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7pfQ9.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $86cabefda0aacd74$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $86cabefda0aacd74$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7pfQ9.useMemo(()=>matches.map((m)=>$86cabefda0aacd74$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $86cabefda0aacd74$export$1448a5050d252c4d() {
    let state = $86cabefda0aacd74$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $86cabefda0aacd74$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $86cabefda0aacd74$export$fd5d37484eab868d(routeId) {
    let state = $86cabefda0aacd74$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $86cabefda0aacd74$export$fdc00f3f26066d5e() {
    let state = $86cabefda0aacd74$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $86cabefda0aacd74$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $86cabefda0aacd74$export$ed527bf60f6e05f2() {
    let error = $7pfQ9.useContext($86cabefda0aacd74$var$RouteErrorContext);
    let state = $86cabefda0aacd74$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $86cabefda0aacd74$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $86cabefda0aacd74$export$78a72ddb39bdd145() {
    let value = $7pfQ9.useContext($86cabefda0aacd74$var$AwaitContext);
    return value?._data;
}
function $86cabefda0aacd74$export$17f53340677d5831() {
    let value = $7pfQ9.useContext($86cabefda0aacd74$var$AwaitContext);
    return value?._error;
}
var $86cabefda0aacd74$var$blockerId = 0;
function $86cabefda0aacd74$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $86cabefda0aacd74$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $86cabefda0aacd74$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7pfQ9.useState("");
    let blockerFunction = $7pfQ9.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $86cabefda0aacd74$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $86cabefda0aacd74$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7pfQ9.useEffect(()=>{
        let key = String(++$86cabefda0aacd74$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7pfQ9.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $86cabefda0aacd74$export$386d57f03f0b2883;
}
function $86cabefda0aacd74$var$useNavigateStable() {
    let { router: router } = $86cabefda0aacd74$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $86cabefda0aacd74$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7pfQ9.useRef(false);
    $86cabefda0aacd74$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7pfQ9.useCallback(async (to, options = {})=>{
        $86cabefda0aacd74$var$warning(activeRef.current, $86cabefda0aacd74$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $86cabefda0aacd74$var$alreadyWarned = {};
function $86cabefda0aacd74$var$warningOnce(key, cond, message) {
    if (!cond && !$86cabefda0aacd74$var$alreadyWarned[key]) {
        $86cabefda0aacd74$var$alreadyWarned[key] = true;
        $86cabefda0aacd74$var$warning(false, message);
    }
}
function $86cabefda0aacd74$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $86cabefda0aacd74$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $86cabefda0aacd74$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $86cabefda0aacd74$var$alreadyWarned2 = {};
function $86cabefda0aacd74$export$5b28268982f175ba(condition, message) {
    if (!condition && !$86cabefda0aacd74$var$alreadyWarned2[message]) {
        $86cabefda0aacd74$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
function $86cabefda0aacd74$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($86cabefda0aacd74$export$945fecf35a8ef089) {
            if (route.element) $86cabefda0aacd74$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7pfQ9.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($86cabefda0aacd74$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $86cabefda0aacd74$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7pfQ9.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($86cabefda0aacd74$export$945fecf35a8ef089) {
            if (route.errorElement) $86cabefda0aacd74$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7pfQ9.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $86cabefda0aacd74$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $86cabefda0aacd74$export$f30f7e456d254e83(routes, opts) {
    return $86cabefda0aacd74$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $86cabefda0aacd74$var$createMemoryHistory({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $86cabefda0aacd74$export$e2fd2c03906469db,
        mapRouteProperties: $86cabefda0aacd74$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $86cabefda0aacd74$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $86cabefda0aacd74$var$shallowDiff(a, b) {
    if (a === b) return false;
    let aKeys = Object.keys(a);
    let bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return true;
    for (let key of aKeys){
        if (a[key] !== b[key]) return true;
    }
    return false;
}
function $86cabefda0aacd74$export$b23aa17f1e546c5e({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let fetcherData = $7pfQ9.useRef(/* @__PURE__ */ new Map());
    let [revalidating, startRevalidation] = $7pfQ9.useTransition();
    let [state, setState] = $7pfQ9.useState(router.state);
    router.__setPendingRerender = (promise)=>startRevalidation(// @ts-expect-error - need react 19 types for this to be async
        async ()=>{
            const rerender = await promise;
            startRevalidation(()=>{
                rerender();
            });
        });
    let navigator = $7pfQ9.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7pfQ9.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    $7pfQ9.useLayoutEffect(()=>{
        return router.subscribe((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
            newState.fetchers.forEach((fetcher, key)=>{
                if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
            });
            deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
            const diff = $86cabefda0aacd74$var$shallowDiff(state, newState);
            if (!diff) return;
            if (flushSync) {
                if (reactDomFlushSyncImpl) reactDomFlushSyncImpl(()=>setState(newState));
                else setState(newState);
            } else $7pfQ9.startTransition(()=>{
                setState(newState);
            });
        });
    }, [
        router,
        reactDomFlushSyncImpl,
        state
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$315e3ffb01f217.Provider, {
        value: {
            ...state,
            revalidation: revalidating ? "loading" : state.revalidation
        }
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    }))))), null);
}
function $86cabefda0aacd74$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError }) {
    let [state, setStateImpl] = $7pfQ9.useState(router.state);
    let [pendingState, setPendingState] = $7pfQ9.useState();
    let [vtContext, setVtContext] = $7pfQ9.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7pfQ9.useState();
    let [transition, setTransition] = $7pfQ9.useState();
    let [interruption, setInterruption] = $7pfQ9.useState();
    let fetcherData = $7pfQ9.useRef(/* @__PURE__ */ new Map());
    let logErrorsAndSetState = $7pfQ9.useCallback((newState)=>{
        setStateImpl((prevState)=>{
            if (newState.errors && unstable_onError) Object.entries(newState.errors).forEach(([routeId, error])=>{
                if (prevState.errors?.[routeId] !== error) unstable_onError(error);
            });
            return newState;
        });
    }, [
        unstable_onError
    ]);
    let setState = $7pfQ9.useCallback((newState, { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $86cabefda0aacd74$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $86cabefda0aacd74$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            else $7pfQ9.startTransition(()=>logErrorsAndSetState(newState));
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>logErrorsAndSetState(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        logErrorsAndSetState
    ]);
    $7pfQ9.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7pfQ9.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $86cabefda0aacd74$var$Deferred());
    }, [
        vtContext
    ]);
    $7pfQ9.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                $7pfQ9.startTransition(()=>logErrorsAndSetState(newState));
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        logErrorsAndSetState
    ]);
    $7pfQ9.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7pfQ9.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7pfQ9.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7pfQ9.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
var $86cabefda0aacd74$var$MemoizedDataRoutes = $7pfQ9.memo($86cabefda0aacd74$var$DataRoutes);
function $86cabefda0aacd74$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $86cabefda0aacd74$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $86cabefda0aacd74$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex }) {
    let historyRef = $7pfQ9.useRef();
    if (historyRef.current == null) historyRef.current = $86cabefda0aacd74$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $86cabefda0aacd74$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $86cabefda0aacd74$export$f5708dca728d7177($86cabefda0aacd74$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    $86cabefda0aacd74$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    let { pathname: locationPathname } = $86cabefda0aacd74$export$45d76561a5302f2b();
    let navigate = $86cabefda0aacd74$export$9770f232ac06a008();
    let path = $86cabefda0aacd74$var$resolveTo(to, $86cabefda0aacd74$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7pfQ9.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $86cabefda0aacd74$export$910ae8079b2c2852(props) {
    return $86cabefda0aacd74$export$a3be3530d8e40d0b(props.context);
}
function $86cabefda0aacd74$export$e7b0ac011bb776c6(props) {
    $86cabefda0aacd74$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $86cabefda0aacd74$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false }) {
    $86cabefda0aacd74$export$f5708dca728d7177(!$86cabefda0aacd74$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7pfQ9.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: {}
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = $86cabefda0aacd74$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7pfQ9.useMemo(()=>{
        let trailingPathname = $86cabefda0aacd74$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $86cabefda0aacd74$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $86cabefda0aacd74$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $86cabefda0aacd74$export$5d3fca4a98652595($86cabefda0aacd74$export$16da398f5434bdec(children), location);
}
function $86cabefda0aacd74$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7pfQ9.useContext($86cabefda0aacd74$export$2eeee58951ff3c1c);
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        unstable_onError: dataRouterContext?.unstable_onError
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$ResolveAwait, null, children));
}
var $86cabefda0aacd74$var$AwaitErrorBoundary = class extends $7pfQ9.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.unstable_onError) this.props.unstable_onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.unstable_onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $86cabefda0aacd74$var$ResolveAwait({ children: children }) {
    let data2 = $86cabefda0aacd74$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, toRender);
}
function $86cabefda0aacd74$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7pfQ9.Children.forEach(children, (element, index)=>{
        if (!$7pfQ9.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7pfQ9.Fragment) {
            routes.push.apply(routes, $86cabefda0aacd74$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $86cabefda0aacd74$export$f5708dca728d7177(element.type === $86cabefda0aacd74$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $86cabefda0aacd74$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $86cabefda0aacd74$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $86cabefda0aacd74$export$9b5b6d122dea0c88 = $86cabefda0aacd74$export$16da398f5434bdec;
function $86cabefda0aacd74$export$daf73786167a7f72(matches) {
    return $86cabefda0aacd74$var$_renderMatches(matches);
}
function $86cabefda0aacd74$var$useRouteComponentProps() {
    return {
        params: $86cabefda0aacd74$export$99eaa27ddbbb95ef(),
        loaderData: $86cabefda0aacd74$export$1448a5050d252c4d(),
        actionData: $86cabefda0aacd74$export$fdc00f3f26066d5e(),
        matches: $86cabefda0aacd74$export$2378eb7f5ff86053()
    };
}
function $86cabefda0aacd74$export$6c4f3826290c37af({ children: children }) {
    const props = $86cabefda0aacd74$var$useRouteComponentProps();
    return $7pfQ9.cloneElement(children, props);
}
function $86cabefda0aacd74$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $86cabefda0aacd74$var$useRouteComponentProps();
        return $7pfQ9.createElement(Component4, props);
    };
}
function $86cabefda0aacd74$var$useHydrateFallbackProps() {
    return {
        params: $86cabefda0aacd74$export$99eaa27ddbbb95ef(),
        loaderData: $86cabefda0aacd74$export$1448a5050d252c4d(),
        actionData: $86cabefda0aacd74$export$fdc00f3f26066d5e()
    };
}
function $86cabefda0aacd74$export$f8cff34f39c1932a({ children: children }) {
    const props = $86cabefda0aacd74$var$useHydrateFallbackProps();
    return $7pfQ9.cloneElement(children, props);
}
function $86cabefda0aacd74$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $86cabefda0aacd74$var$useHydrateFallbackProps();
        return $7pfQ9.createElement(HydrateFallback, props);
    };
}
function $86cabefda0aacd74$var$useErrorBoundaryProps() {
    return {
        params: $86cabefda0aacd74$export$99eaa27ddbbb95ef(),
        loaderData: $86cabefda0aacd74$export$1448a5050d252c4d(),
        actionData: $86cabefda0aacd74$export$fdc00f3f26066d5e(),
        error: $86cabefda0aacd74$export$ed527bf60f6e05f2()
    };
}
function $86cabefda0aacd74$export$e5afde5c4b6d747b({ children: children }) {
    const props = $86cabefda0aacd74$var$useErrorBoundaryProps();
    return $7pfQ9.cloneElement(children, props);
}
function $86cabefda0aacd74$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $86cabefda0aacd74$var$useErrorBoundaryProps();
        return $7pfQ9.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $86cabefda0aacd74$var$defaultMethod = "get";
var $86cabefda0aacd74$var$defaultEncType = "application/x-www-form-urlencoded";
function $86cabefda0aacd74$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $86cabefda0aacd74$var$isButtonElement(object) {
    return $86cabefda0aacd74$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $86cabefda0aacd74$var$isFormElement(object) {
    return $86cabefda0aacd74$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $86cabefda0aacd74$var$isInputElement(object) {
    return $86cabefda0aacd74$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $86cabefda0aacd74$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $86cabefda0aacd74$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$86cabefda0aacd74$var$isModifiedEvent(event);
}
function $86cabefda0aacd74$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $86cabefda0aacd74$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $86cabefda0aacd74$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $86cabefda0aacd74$var$_formDataSupportsSubmitter = null;
function $86cabefda0aacd74$var$isFormDataSubmitterSupported() {
    if ($86cabefda0aacd74$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $86cabefda0aacd74$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $86cabefda0aacd74$var$_formDataSupportsSubmitter = true;
    }
    return $86cabefda0aacd74$var$_formDataSupportsSubmitter;
}
var $86cabefda0aacd74$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $86cabefda0aacd74$var$getFormEncType(encType) {
    if (encType != null && !$86cabefda0aacd74$var$supportedFormEncTypes.has(encType)) {
        $86cabefda0aacd74$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$86cabefda0aacd74$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $86cabefda0aacd74$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($86cabefda0aacd74$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $86cabefda0aacd74$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $86cabefda0aacd74$var$defaultMethod;
        encType = $86cabefda0aacd74$var$getFormEncType(target.getAttribute("enctype")) || $86cabefda0aacd74$var$defaultEncType;
        formData = new FormData(target);
    } else if ($86cabefda0aacd74$var$isButtonElement(target) || $86cabefda0aacd74$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $86cabefda0aacd74$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $86cabefda0aacd74$var$defaultMethod;
        encType = $86cabefda0aacd74$var$getFormEncType(target.getAttribute("formenctype")) || $86cabefda0aacd74$var$getFormEncType(form.getAttribute("enctype")) || $86cabefda0aacd74$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$86cabefda0aacd74$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($86cabefda0aacd74$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $86cabefda0aacd74$var$defaultMethod;
        action = null;
        encType = $86cabefda0aacd74$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $86cabefda0aacd74$var$HOLE = -1;
var $86cabefda0aacd74$var$NAN = -2;
var $86cabefda0aacd74$var$NEGATIVE_INFINITY = -3;
var $86cabefda0aacd74$var$NEGATIVE_ZERO = -4;
var $86cabefda0aacd74$var$NULL = -5;
var $86cabefda0aacd74$var$POSITIVE_INFINITY = -6;
var $86cabefda0aacd74$var$UNDEFINED = -7;
var $86cabefda0aacd74$var$TYPE_BIGINT = "B";
var $86cabefda0aacd74$var$TYPE_DATE = "D";
var $86cabefda0aacd74$var$TYPE_ERROR = "E";
var $86cabefda0aacd74$var$TYPE_MAP = "M";
var $86cabefda0aacd74$var$TYPE_NULL_OBJECT = "N";
var $86cabefda0aacd74$var$TYPE_PROMISE = "P";
var $86cabefda0aacd74$var$TYPE_REGEXP = "R";
var $86cabefda0aacd74$var$TYPE_SET = "S";
var $86cabefda0aacd74$var$TYPE_SYMBOL = "Y";
var $86cabefda0aacd74$var$TYPE_URL = "U";
var $86cabefda0aacd74$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $86cabefda0aacd74$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $86cabefda0aacd74$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $86cabefda0aacd74$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $86cabefda0aacd74$var$UNDEFINED;
    if (input === null) return $86cabefda0aacd74$var$NULL;
    if (Number.isNaN(input)) return $86cabefda0aacd74$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $86cabefda0aacd74$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $86cabefda0aacd74$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $86cabefda0aacd74$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $86cabefda0aacd74$var$stringify.call(this, input, index);
    return index;
}
function $86cabefda0aacd74$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$86cabefda0aacd74$var$flatten.call(this, k)}":${$86cabefda0aacd74$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$86cabefda0aacd74$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$86cabefda0aacd74$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$86cabefda0aacd74$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$86cabefda0aacd74$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $86cabefda0aacd74$var$flatten.call(this, input2[i]) : $86cabefda0aacd74$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$86cabefda0aacd74$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$86cabefda0aacd74$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$86cabefda0aacd74$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$86cabefda0aacd74$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$86cabefda0aacd74$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$86cabefda0aacd74$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$86cabefda0aacd74$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $86cabefda0aacd74$var$flatten.call(this, k),
                                    $86cabefda0aacd74$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$86cabefda0aacd74$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$86cabefda0aacd74$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$86cabefda0aacd74$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$86cabefda0aacd74$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($86cabefda0aacd74$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$86cabefda0aacd74$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$86cabefda0aacd74$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $86cabefda0aacd74$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $86cabefda0aacd74$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $86cabefda0aacd74$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $86cabefda0aacd74$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $86cabefda0aacd74$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $86cabefda0aacd74$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $86cabefda0aacd74$var$hydrate.call(this, startIndex);
}
function $86cabefda0aacd74$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $86cabefda0aacd74$var$UNDEFINED:
                set(void 0);
                continue;
            case $86cabefda0aacd74$var$NULL:
                set(null);
                continue;
            case $86cabefda0aacd74$var$NAN:
                set(NaN);
                continue;
            case $86cabefda0aacd74$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $86cabefda0aacd74$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $86cabefda0aacd74$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $86cabefda0aacd74$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $86cabefda0aacd74$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $86cabefda0aacd74$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $86cabefda0aacd74$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $86cabefda0aacd74$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $86cabefda0aacd74$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $86cabefda0aacd74$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $86cabefda0aacd74$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $86cabefda0aacd74$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $86cabefda0aacd74$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $86cabefda0aacd74$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $86cabefda0aacd74$var$globalObj && $86cabefda0aacd74$var$globalObj[errorType] ? new $86cabefda0aacd74$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $86cabefda0aacd74$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $86cabefda0aacd74$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $86cabefda0aacd74$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $86cabefda0aacd74$var$Deferred2();
    const reader = readable.pipeThrough($86cabefda0aacd74$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $86cabefda0aacd74$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $86cabefda0aacd74$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $86cabefda0aacd74$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $86cabefda0aacd74$var$unflatten.call(this, line)
    };
}
async function $86cabefda0aacd74$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $86cabefda0aacd74$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $86cabefda0aacd74$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $86cabefda0aacd74$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $86cabefda0aacd74$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $86cabefda0aacd74$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $86cabefda0aacd74$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $86cabefda0aacd74$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$86cabefda0aacd74$var$TYPE_PROMISE}${deferredId}:[["${$86cabefda0aacd74$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$86cabefda0aacd74$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$86cabefda0aacd74$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $86cabefda0aacd74$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$86cabefda0aacd74$var$TYPE_ERROR}${deferredId}:[["${$86cabefda0aacd74$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$86cabefda0aacd74$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$86cabefda0aacd74$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $86cabefda0aacd74$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $86cabefda0aacd74$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $86cabefda0aacd74$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $86cabefda0aacd74$export$4cf11838cdc2a8a8(html) {
    return html.replace($86cabefda0aacd74$var$ESCAPE_REGEX, (match)=>$86cabefda0aacd74$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $86cabefda0aacd74$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $86cabefda0aacd74$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $86cabefda0aacd74$var$SingleFetchNoResultError = class extends Error {
};
var $86cabefda0aacd74$export$ae9272e641ead836 = 202;
var $86cabefda0aacd74$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $86cabefda0aacd74$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$86cabefda0aacd74$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, scriptTag, /* @__PURE__ */ $7pfQ9.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, scriptTag, /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Suspense, null, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $86cabefda0aacd74$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $86cabefda0aacd74$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $86cabefda0aacd74$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $86cabefda0aacd74$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $86cabefda0aacd74$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $86cabefda0aacd74$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.unstable_shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $86cabefda0aacd74$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $86cabefda0aacd74$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $86cabefda0aacd74$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $86cabefda0aacd74$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $86cabefda0aacd74$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $86cabefda0aacd74$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($86cabefda0aacd74$export$3f1eb41d9a6a6a27(result.result) || $86cabefda0aacd74$export$972111febbeef05b(result.result) || $86cabefda0aacd74$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $86cabefda0aacd74$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $86cabefda0aacd74$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.unstable_shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $86cabefda0aacd74$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $86cabefda0aacd74$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$86cabefda0aacd74$var$createDeferred2());
    let singleFetchDfd = $86cabefda0aacd74$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.unstable_shouldRevalidateArgs || m.unstable_shouldRevalidateArgs.actionStatus == null || m.unstable_shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.unstable_shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.unstable_shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $86cabefda0aacd74$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $86cabefda0aacd74$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $86cabefda0aacd74$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $86cabefda0aacd74$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $86cabefda0aacd74$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $86cabefda0aacd74$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.unstable_shouldCallHandler());
    $86cabefda0aacd74$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $86cabefda0aacd74$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $86cabefda0aacd74$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $86cabefda0aacd74$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $86cabefda0aacd74$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $86cabefda0aacd74$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $86cabefda0aacd74$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $86cabefda0aacd74$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $86cabefda0aacd74$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $86cabefda0aacd74$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $86cabefda0aacd74$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($86cabefda0aacd74$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $86cabefda0aacd74$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $86cabefda0aacd74$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($86cabefda0aacd74$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$86cabefda0aacd74$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $86cabefda0aacd74$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $86cabefda0aacd74$export$4023ad4ecd4126a2(body, global) {
    return $86cabefda0aacd74$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $86cabefda0aacd74$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$86cabefda0aacd74$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $86cabefda0aacd74$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $86cabefda0aacd74$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $86cabefda0aacd74$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $86cabefda0aacd74$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $86cabefda0aacd74$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $86cabefda0aacd74$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $86cabefda0aacd74$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $86cabefda0aacd74$var$getModuleLinkHrefs(matches, manifest);
    return $86cabefda0aacd74$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $86cabefda0aacd74$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $86cabefda0aacd74$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $86cabefda0aacd74$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($86cabefda0aacd74$var$prefetchStyleLink));
}
async function $86cabefda0aacd74$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$86cabefda0aacd74$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$86cabefda0aacd74$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$86cabefda0aacd74$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($86cabefda0aacd74$var$prefetchStyleLink));
}
async function $86cabefda0aacd74$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $86cabefda0aacd74$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $86cabefda0aacd74$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $86cabefda0aacd74$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $86cabefda0aacd74$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $86cabefda0aacd74$var$dedupeLinkDescriptors(links.flat(1).filter($86cabefda0aacd74$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $86cabefda0aacd74$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $86cabefda0aacd74$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $86cabefda0aacd74$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $86cabefda0aacd74$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $86cabefda0aacd74$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $86cabefda0aacd74$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$86cabefda0aacd74$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($86cabefda0aacd74$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $86cabefda0aacd74$var$_isPreloadSupported;
function $86cabefda0aacd74$var$isPreloadSupported() {
    if ($86cabefda0aacd74$var$_isPreloadSupported !== void 0) return $86cabefda0aacd74$var$_isPreloadSupported;
    let el = document.createElement("link");
    $86cabefda0aacd74$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $86cabefda0aacd74$var$_isPreloadSupported;
}
function $86cabefda0aacd74$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $86cabefda0aacd74$export$945fecf35a8ef089 ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $86cabefda0aacd74$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $86cabefda0aacd74$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $86cabefda0aacd74$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $86cabefda0aacd74$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$RemixRootDefaultErrorBoundary, {
            error: $86cabefda0aacd74$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $7pfQ9.createElement(routeModule.Layout, null, /* @__PURE__ */ $7pfQ9.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $7pfQ9.createElement(routeModule.Layout, null, /* @__PURE__ */ $7pfQ9.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $7pfQ9.createElement(routeModule.Layout, null, /* @__PURE__ */ $7pfQ9.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $86cabefda0aacd74$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $86cabefda0aacd74$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $86cabefda0aacd74$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$86cabefda0aacd74$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $86cabefda0aacd74$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $86cabefda0aacd74$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $86cabefda0aacd74$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $86cabefda0aacd74$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $86cabefda0aacd74$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $86cabefda0aacd74$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $86cabefda0aacd74$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $86cabefda0aacd74$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $86cabefda0aacd74$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $86cabefda0aacd74$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $86cabefda0aacd74$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $86cabefda0aacd74$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $86cabefda0aacd74$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$86cabefda0aacd74$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $86cabefda0aacd74$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $86cabefda0aacd74$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $86cabefda0aacd74$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $86cabefda0aacd74$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $86cabefda0aacd74$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $86cabefda0aacd74$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $86cabefda0aacd74$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $86cabefda0aacd74$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $86cabefda0aacd74$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $86cabefda0aacd74$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $86cabefda0aacd74$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $86cabefda0aacd74$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $86cabefda0aacd74$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $86cabefda0aacd74$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $86cabefda0aacd74$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $86cabefda0aacd74$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $86cabefda0aacd74$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $86cabefda0aacd74$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $86cabefda0aacd74$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    if (ssr && route.shouldRevalidate) {
        let fn = route.shouldRevalidate;
        return (opts)=>fn({
                ...opts,
                defaultShouldRevalidate: true
            });
    }
    return route.shouldRevalidate;
}
function $86cabefda0aacd74$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $86cabefda0aacd74$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $86cabefda0aacd74$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $86cabefda0aacd74$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $86cabefda0aacd74$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $86cabefda0aacd74$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $86cabefda0aacd74$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $86cabefda0aacd74$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $86cabefda0aacd74$var$nextPaths = /* @__PURE__ */ new Set();
var $86cabefda0aacd74$var$discoveredPathsMaxSize = 1e3;
var $86cabefda0aacd74$var$discoveredPaths = /* @__PURE__ */ new Set();
var $86cabefda0aacd74$var$URL_LIMIT = 7680;
function $86cabefda0aacd74$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $86cabefda0aacd74$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $86cabefda0aacd74$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $86cabefda0aacd74$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$86cabefda0aacd74$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($86cabefda0aacd74$var$discoveredPaths.has(path)) return;
        await $86cabefda0aacd74$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $86cabefda0aacd74$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7pfQ9.useEffect(()=>{
        if (!$86cabefda0aacd74$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$86cabefda0aacd74$var$discoveredPaths.has(pathname)) $86cabefda0aacd74$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($86cabefda0aacd74$var$nextPaths.keys()).filter((path)=>{
                if ($86cabefda0aacd74$var$discoveredPaths.has(path)) {
                    $86cabefda0aacd74$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $86cabefda0aacd74$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $86cabefda0aacd74$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $86cabefda0aacd74$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $86cabefda0aacd74$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $86cabefda0aacd74$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($86cabefda0aacd74$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $86cabefda0aacd74$var$URL_LIMIT) {
        $86cabefda0aacd74$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($86cabefda0aacd74$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($86cabefda0aacd74$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($86cabefda0aacd74$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$86cabefda0aacd74$var$addToFifoQueue(p, $86cabefda0aacd74$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $86cabefda0aacd74$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $86cabefda0aacd74$var$addToFifoQueue(path, queue) {
    if (queue.size >= $86cabefda0aacd74$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $86cabefda0aacd74$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $86cabefda0aacd74$var$useDataRouterContext2() {
    let context = $7pfQ9.useContext($86cabefda0aacd74$export$2eeee58951ff3c1c);
    $86cabefda0aacd74$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $86cabefda0aacd74$var$useDataRouterStateContext() {
    let context = $7pfQ9.useContext($86cabefda0aacd74$export$315e3ffb01f217);
    $86cabefda0aacd74$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $86cabefda0aacd74$export$208d6a3bc3aa62bd = $7pfQ9.createContext(void 0);
$86cabefda0aacd74$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $86cabefda0aacd74$var$useFrameworkContext() {
    let context = $7pfQ9.useContext($86cabefda0aacd74$export$208d6a3bc3aa62bd);
    $86cabefda0aacd74$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $86cabefda0aacd74$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7pfQ9.useContext($86cabefda0aacd74$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7pfQ9.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7pfQ9.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7pfQ9.useRef(null);
    $7pfQ9.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7pfQ9.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $86cabefda0aacd74$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $86cabefda0aacd74$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $86cabefda0aacd74$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $86cabefda0aacd74$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $86cabefda0aacd74$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $86cabefda0aacd74$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $86cabefda0aacd74$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$86cabefda0aacd74$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $86cabefda0aacd74$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $86cabefda0aacd74$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $86cabefda0aacd74$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $86cabefda0aacd74$var$useDataRouterStateContext();
    let matches = $86cabefda0aacd74$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7pfQ9.useMemo(()=>$86cabefda0aacd74$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7pfQ9.createElement("style", {
        [$86cabefda0aacd74$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7pfQ9.createElement("link", {
        [$86cabefda0aacd74$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$86cabefda0aacd74$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $7pfQ9.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $86cabefda0aacd74$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $86cabefda0aacd74$var$useDataRouterContext2();
    let matches = $7pfQ9.useMemo(()=>$86cabefda0aacd74$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $86cabefda0aacd74$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $86cabefda0aacd74$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7pfQ9.useState([]);
    $7pfQ9.useEffect(()=>{
        let interrupted = false;
        $86cabefda0aacd74$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $86cabefda0aacd74$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $86cabefda0aacd74$var$useFrameworkContext();
    let { basename: basename } = $86cabefda0aacd74$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $86cabefda0aacd74$var$useDataRouterStateContext();
    let newMatchesForData = $7pfQ9.useMemo(()=>$86cabefda0aacd74$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7pfQ9.useMemo(()=>$86cabefda0aacd74$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7pfQ9.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $86cabefda0aacd74$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7pfQ9.useMemo(()=>$86cabefda0aacd74$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $86cabefda0aacd74$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7pfQ9.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $7pfQ9.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7pfQ9.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $86cabefda0aacd74$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $86cabefda0aacd74$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $86cabefda0aacd74$var$useDataRouterStateContext();
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    let _matches = $86cabefda0aacd74$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$86cabefda0aacd74$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7pfQ9.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7pfQ9.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7pfQ9.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7pfQ9.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $86cabefda0aacd74$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $7pfQ9.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $86cabefda0aacd74$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $86cabefda0aacd74$var$isHydrated = false;
function $86cabefda0aacd74$export$3be068dde909e563() {
    $86cabefda0aacd74$var$isHydrated = true;
}
function $86cabefda0aacd74$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $86cabefda0aacd74$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $86cabefda0aacd74$var$useDataRouterContext2();
    let { matches: routerMatches } = $86cabefda0aacd74$var$useDataRouterStateContext();
    let isRSCRouterContext = $86cabefda0aacd74$var$useIsRSCRouterContext();
    let enableFogOfWar = $86cabefda0aacd74$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $86cabefda0aacd74$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7pfQ9.useEffect(()=>{
        $86cabefda0aacd74$export$3be068dde909e563();
    }, []);
    let initialScripts = $7pfQ9.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $86cabefda0aacd74$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($86cabefda0aacd74$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $7pfQ9.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $86cabefda0aacd74$var$isHydrated || isRSCRouterContext ? [] : $86cabefda0aacd74$var$dedupe(manifest.entry.imports.concat($86cabefda0aacd74$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $86cabefda0aacd74$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $86cabefda0aacd74$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $7pfQ9.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7pfQ9.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7pfQ9.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $86cabefda0aacd74$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $86cabefda0aacd74$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $86cabefda0aacd74$export$32e57f52df4b6e34 = class extends $7pfQ9.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $86cabefda0aacd74$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7pfQ9.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($86cabefda0aacd74$export$972111febbeef05b(error)) return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7pfQ9.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $86cabefda0aacd74$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7pfQ9.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7pfQ9.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $86cabefda0aacd74$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $86cabefda0aacd74$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7pfQ9.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7pfQ9.createElement("head", null, /* @__PURE__ */ $7pfQ9.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7pfQ9.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7pfQ9.createElement("title", null, title)), /* @__PURE__ */ $7pfQ9.createElement("body", null, /* @__PURE__ */ $7pfQ9.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$ff0bf87698939488, null) : null)));
}
var $86cabefda0aacd74$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($86cabefda0aacd74$var$isBrowser) window.__reactRouterVersion = "7.9.5";
} catch (e) {}
function $86cabefda0aacd74$export$1f3f55432a00e06d(routes, opts) {
    return $86cabefda0aacd74$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $86cabefda0aacd74$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $86cabefda0aacd74$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $86cabefda0aacd74$export$9269a41d8c4635e,
        hydrationRouteProperties: $86cabefda0aacd74$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $86cabefda0aacd74$export$1ba7ed8a3a7b3765(routes, opts) {
    return $86cabefda0aacd74$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $86cabefda0aacd74$var$createHashHistory({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $86cabefda0aacd74$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $86cabefda0aacd74$export$9269a41d8c4635e,
        hydrationRouteProperties: $86cabefda0aacd74$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $86cabefda0aacd74$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $86cabefda0aacd74$var$deserializeErrors(state.errors)
    };
    return state;
}
function $86cabefda0aacd74$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $86cabefda0aacd74$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $86cabefda0aacd74$export$9ba4e89fdfa1fc54({ basename: basename, children: children, window: window2 }) {
    let historyRef = $7pfQ9.useRef();
    if (historyRef.current == null) historyRef.current = $86cabefda0aacd74$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $86cabefda0aacd74$export$7221d69dcfc8e36b({ basename: basename, children: children, window: window2 }) {
    let historyRef = $7pfQ9.useRef();
    if (historyRef.current == null) historyRef.current = $86cabefda0aacd74$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $86cabefda0aacd74$export$de73885c9336221c({ basename: basename, children: children, history: history }) {
    let [state, setStateImpl] = $7pfQ9.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7pfQ9.useCallback((newState)=>{
        $7pfQ9.startTransition(()=>setStateImpl(newState));
    }, [
        setStateImpl
    ]);
    $7pfQ9.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
$86cabefda0aacd74$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $86cabefda0aacd74$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $86cabefda0aacd74$export$a6c7ac8248d6e38a = $7pfQ9.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $86cabefda0aacd74$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($86cabefda0aacd74$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $86cabefda0aacd74$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $86cabefda0aacd74$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $86cabefda0aacd74$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $86cabefda0aacd74$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $86cabefda0aacd74$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7pfQ9.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $86cabefda0aacd74$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, link, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$86cabefda0aacd74$export$a6c7ac8248d6e38a.displayName = "Link";
var $86cabefda0aacd74$export$b0d92dbee9b5b60d = $7pfQ9.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $86cabefda0aacd74$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    let routerState = $7pfQ9.useContext($86cabefda0aacd74$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $86cabefda0aacd74$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $86cabefda0aacd74$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$86cabefda0aacd74$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $86cabefda0aacd74$export$a7fed597f4b8afd8 = $7pfQ9.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $86cabefda0aacd74$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let submit = $86cabefda0aacd74$export$47c85c6e3a081d3();
    let formAction = $86cabefda0aacd74$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $86cabefda0aacd74$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace2,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /* @__PURE__ */ $7pfQ9.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$86cabefda0aacd74$export$a7fed597f4b8afd8.displayName = "Form";
function $86cabefda0aacd74$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $7pfQ9.useContext($86cabefda0aacd74$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    let matches = $86cabefda0aacd74$export$2378eb7f5ff86053();
    $86cabefda0aacd74$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7pfQ9.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $86cabefda0aacd74$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $7pfQ9.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $86cabefda0aacd74$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$86cabefda0aacd74$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $86cabefda0aacd74$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $86cabefda0aacd74$var$useDataRouterContext3(hookName) {
    let ctx = $7pfQ9.useContext($86cabefda0aacd74$export$2eeee58951ff3c1c);
    $86cabefda0aacd74$export$f5708dca728d7177(ctx, $86cabefda0aacd74$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $86cabefda0aacd74$var$useDataRouterState2(hookName) {
    let state = $7pfQ9.useContext($86cabefda0aacd74$export$315e3ffb01f217);
    $86cabefda0aacd74$export$f5708dca728d7177(state, $86cabefda0aacd74$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $86cabefda0aacd74$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = {}) {
    let navigate = $86cabefda0aacd74$export$9770f232ac06a008();
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    let path = $86cabefda0aacd74$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7pfQ9.useCallback((event)=>{
        if ($86cabefda0aacd74$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $86cabefda0aacd74$export$fe53371bee54353d(location) === $86cabefda0aacd74$export$fe53371bee54353d(path);
            navigate(to, {
                replace: replace2,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
function $86cabefda0aacd74$export$f1a78c17382fe22a(defaultInit) {
    $86cabefda0aacd74$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7pfQ9.useRef($86cabefda0aacd74$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7pfQ9.useRef(false);
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    let searchParams = $7pfQ9.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $86cabefda0aacd74$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $86cabefda0aacd74$export$9770f232ac06a008();
    let setSearchParams = $7pfQ9.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $86cabefda0aacd74$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $86cabefda0aacd74$var$fetcherId = 0;
var $86cabefda0aacd74$var$getUniqueFetcherId = ()=>`__${String(++$86cabefda0aacd74$var$fetcherId)}__`;
function $86cabefda0aacd74$export$47c85c6e3a081d3() {
    let { router: router } = $86cabefda0aacd74$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let currentRouteId = $86cabefda0aacd74$var$useRouteId();
    return $7pfQ9.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $86cabefda0aacd74$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $86cabefda0aacd74$var$getUniqueFetcherId();
            await router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
function $86cabefda0aacd74$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let routeContext = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    $86cabefda0aacd74$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$86cabefda0aacd74$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $86cabefda0aacd74$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $86cabefda0aacd74$export$fe53371bee54353d(path);
}
function $86cabefda0aacd74$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $86cabefda0aacd74$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $86cabefda0aacd74$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7pfQ9.useContext($86cabefda0aacd74$export$cb3f1df1bef00a39);
    let route = $7pfQ9.useContext($86cabefda0aacd74$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $86cabefda0aacd74$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $86cabefda0aacd74$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $86cabefda0aacd74$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7pfQ9.useId();
    let [fetcherKey, setFetcherKey] = $7pfQ9.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    $7pfQ9.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>router.deleteFetcher(fetcherKey);
    }, [
        router,
        fetcherKey
    ]);
    let load = $7pfQ9.useCallback(async (href, opts)=>{
        $86cabefda0aacd74$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $86cabefda0aacd74$export$47c85c6e3a081d3();
    let submit = $7pfQ9.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let unstable_reset = $7pfQ9.useCallback((opts)=>router.resetFetcher(fetcherKey, opts), [
        router,
        fetcherKey
    ]);
    let FetcherForm = $7pfQ9.useMemo(()=>{
        let FetcherForm2 = $7pfQ9.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $86cabefda0aacd74$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7pfQ9.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            unstable_reset: unstable_reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        unstable_reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $86cabefda0aacd74$export$fa996778a3a31087() {
    let state = $86cabefda0aacd74$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $86cabefda0aacd74$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $86cabefda0aacd74$var$savedScrollPositions = {};
function $86cabefda0aacd74$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $86cabefda0aacd74$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $86cabefda0aacd74$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $86cabefda0aacd74$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $86cabefda0aacd74$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7pfQ9.useContext($86cabefda0aacd74$export$3044ab7fdabeaee6);
    let location = $86cabefda0aacd74$export$45d76561a5302f2b();
    let matches = $86cabefda0aacd74$export$2378eb7f5ff86053();
    let navigation = $86cabefda0aacd74$export$d0fd4b7106de2769();
    $7pfQ9.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $86cabefda0aacd74$var$usePageHide($7pfQ9.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $86cabefda0aacd74$var$getScrollRestorationKey(location, matches, basename, getKey);
            $86cabefda0aacd74$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $86cabefda0aacd74$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($86cabefda0aacd74$var$savedScrollPositions));
        } catch (error) {
            $86cabefda0aacd74$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7pfQ9.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $86cabefda0aacd74$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $86cabefda0aacd74$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7pfQ9.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($86cabefda0aacd74$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$86cabefda0aacd74$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7pfQ9.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $86cabefda0aacd74$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $86cabefda0aacd74$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7pfQ9.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $86cabefda0aacd74$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7pfQ9.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $86cabefda0aacd74$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $86cabefda0aacd74$export$b273b3273281a049(when);
    $7pfQ9.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7pfQ9.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $86cabefda0aacd74$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7pfQ9.useContext($86cabefda0aacd74$export$3681f408decb40d1);
    $86cabefda0aacd74$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $86cabefda0aacd74$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $86cabefda0aacd74$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $86cabefda0aacd74$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $86cabefda0aacd74$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $86cabefda0aacd74$export$81336c211d5ff295(path.pathname, nextPath) != null || $86cabefda0aacd74$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $86cabefda0aacd74$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $86cabefda0aacd74$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $86cabefda0aacd74$var$getStatelessNavigator();
    return /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true
    });
}
function $86cabefda0aacd74$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $86cabefda0aacd74$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $86cabefda0aacd74$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $86cabefda0aacd74$var$serializeErrors(context.errors)
        };
        let json = $86cabefda0aacd74$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7pfQ9.createElement($7pfQ9.Fragment, null, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static
    }, /* @__PURE__ */ $7pfQ9.createElement($86cabefda0aacd74$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $7pfQ9.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $86cabefda0aacd74$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $86cabefda0aacd74$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $86cabefda0aacd74$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($86cabefda0aacd74$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $86cabefda0aacd74$var$getStatelessNavigator() {
    return {
        createHref: $86cabefda0aacd74$var$createHref,
        encodeLocation: $86cabefda0aacd74$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $86cabefda0aacd74$export$69163f0b72ec60d9(routes, opts) {
    return $86cabefda0aacd74$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $86cabefda0aacd74$export$9269a41d8c4635e
    });
}
function $86cabefda0aacd74$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $86cabefda0aacd74$export$87cb1a9238dc3fba(routes, $86cabefda0aacd74$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $86cabefda0aacd74$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $86cabefda0aacd74$var$createHref,
        encodeLocation: $86cabefda0aacd74$var$encodeLocation,
        getFetcher () {
            return $86cabefda0aacd74$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $86cabefda0aacd74$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $86cabefda0aacd74$var$createHref(to) {
    return typeof to === "string" ? to : $86cabefda0aacd74$export$fe53371bee54353d(to);
}
function $86cabefda0aacd74$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $86cabefda0aacd74$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $86cabefda0aacd74$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $86cabefda0aacd74$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $86cabefda0aacd74$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $86cabefda0aacd74$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $86cabefda0aacd74$var$htmlEscape(str) {
    return str.replace($86cabefda0aacd74$var$ESCAPE_REGEX2, (match)=>$86cabefda0aacd74$var$ESCAPE_LOOKUP2[match]);
}




var $7pfQ9 = parcelRequire("7pfQ9");




var $7pfQ9 = parcelRequire("7pfQ9");








var $98dbebeb6ce3dfb0$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $7b858e3eb153e419$export$dda1d9f60106f0e9).call(props, 'css')) return $7pfQ9.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $7b858e3eb153e419$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $7b858e3eb153e419$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7pfQ9.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($98dbebeb6ce3dfb0$export$c8a8987d4410bf2d || ($98dbebeb6ce3dfb0$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $98dbebeb6ce3dfb0$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $7b858e3eb153e419$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $bc26ff461060f8a8$export$6321afa313b251b5)([
        styles
    ], undefined, $7pfQ9.useContext((0, $7b858e3eb153e419$export$971d5caa766a69d7)));
    if (!(0, $7b858e3eb153e419$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7pfQ9.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7pfQ9.useRef();
    (0, $f888194713c25944$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $f888194713c25944$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $335a9ebca9ef05c6$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $98dbebeb6ce3dfb0$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $bc26ff461060f8a8$export$6321afa313b251b5)(args);
}
function $98dbebeb6ce3dfb0$export$d25ddfdf17c3ad3e() {
    var insertable = $98dbebeb6ce3dfb0$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $98dbebeb6ce3dfb0$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $98dbebeb6ce3dfb0$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $335a9ebca9ef05c6$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $98dbebeb6ce3dfb0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $f888194713c25944$export$db21c7ffa21794e7)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $335a9ebca9ef05c6$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
            if (!(0, $7b858e3eb153e419$export$23f2a1d2818174ef) && res !== undefined) rules += res;
        }
        if (!(0, $7b858e3eb153e419$export$23f2a1d2818174ef)) return rules;
    });
    if (!(0, $7b858e3eb153e419$export$23f2a1d2818174ef) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7pfQ9.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $98dbebeb6ce3dfb0$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $7b858e3eb153e419$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $7b858e3eb153e419$export$407448d2b89b1813)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $bc26ff461060f8a8$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $335a9ebca9ef05c6$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $7b858e3eb153e419$export$407448d2b89b1813)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $98dbebeb6ce3dfb0$var$merge(cache.registered, css, $98dbebeb6ce3dfb0$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7pfQ9.useContext((0, $7b858e3eb153e419$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7pfQ9.createElement($7pfQ9.Fragment, null, /*#__PURE__*/ $7pfQ9.createElement($98dbebeb6ce3dfb0$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});





const $c6f3eebe3403b5cb$var$Icon_download = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("svg", {
        width: 22,
        height: 24,
        viewBox: "0 0 22 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 5H4C1.79086 5 0 6.79086 0 9V20C0 22.2091 1.79086 24 4 24H18C20.2091 24 22 22.2091 22 20V9C22 6.79086 20.2091 5 18 5H14V7H18C19.1046 7 20 7.89543 20 9V20C20 21.1046 19.1046 22 18 22H4C2.89543 22 2 21.1046 2 20V9C2 7.89543 2.89543 7 4 7H8V5Z",
                fill: "white",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                d: "M7 13L11 17M11 17V1M11 17L15 13",
                stroke: "white",
                strokeOpacity: "0.85",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $c6f3eebe3403b5cb$export$2e2bcd8739ae039 = $c6f3eebe3403b5cb$var$Icon_download;



function $5c19c940e9865a1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5c19c940e9865a1c$var$_ref = {
    name: "1s4w3d8",
    styles: "width:40px;aspect-ratio:1;border-radius:50%;background:radial-gradient(farthest-side,#a4faff 94%,#0000) top/8px 8px no-repeat,\n    conic-gradient(#0000 30%,#a4faff);mask:radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);animation:l13 1s infinite linear;@keyframes l13{100%{transform:rotate(1turn);}}"
};
// https://css-loaders.com/spinner/
const $5c19c940e9865a1c$var$Spinner = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        css: $5c19c940e9865a1c$var$_ref
    });
var $5c19c940e9865a1c$export$2e2bcd8739ae039 = $5c19c940e9865a1c$var$Spinner;


function $4fb2a739aaca8fcf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4fb2a739aaca8fcf$var$_ref = {
    name: "qmlmpf",
    styles: "align-self:stretch;margin:auto 0"
};
const $4fb2a739aaca8fcf$var$ActionButton = ({ label: label, onClick: onClick, isCaching: isCaching, isChristmas: isChristmas = true })=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("button", {
        onClick: ()=>{
            if (!isCaching) onClick();
        },
        tabIndex: 0,
        css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
            userSelect: "none",
            display: "flex",
            minHeight: 48,
            width: "100%",
            alignItems: "center",
            gap: 8,
            justifyContent: "center",
            cursor: "pointer",
            borderRadius: 32,
            border: 0,
            outline: "none",
            // backgroundColor: "black",
            transition: "transform 150ms ease, box-shadow 150ms ease, filter 150ms ease, opacity 150ms ease, background 150ms ease",
            background: "radial-gradient(39.3% 100% at 51.88% 0%, #6684DF 0%, #5E67D7 44.07%, #513CCC 100%), radial-gradient(40.5% 100% at 47.83% 100%, #6684DF 0%, #513CCC 100%)",
            boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.20) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.40) inset",
            "&:focus": {
                outline: "2px solid rgba(35, 8, 113, 0.5)"
            },
            // keyboard focus visible
            "&:focus-visible": {
                outline: "3px solid rgba(35, 8, 113, 0.65)"
            },
            // pointer active (pressed) visual
            "&:active": {
                transform: "translateY(1px) scale(0.99)",
                boxShadow: "0px -1px 0px 0px rgba(0, 0, 0, 0.20) inset",
                filter: "brightness(0.97)",
                opacity: 0.9
            },
            // Christmas
            ...isChristmas && {
                background: "radial-gradient(48.59% 100% at 51.88% 0%, #F05CA6 6.29%, #D11053 43.06%, #7A0027 100%), radial-gradient(40.5% 100% at 47.83% 100%, #D11053 0%, #7A0027 100%)",
                boxShadow: "0 -1px 0 0 #4C0101 inset, 0 1px 0 0 rgba(255, 255, 255, 0.19) inset, 0 0 365.012px 0 #091518",
                "&:hover": {
                    filter: "brightness(1.1)",
                    boxShadow: "0 -1px 0 0 #4C0101 inset, 0 1px 0 0 rgba(255, 255, 255, 0.25) inset, 0 0 200px 0 #E94F93"
                },
                "&:focus-visible": {
                    outline: "3px solid rgba(255, 20, 147, 0.6)"
                },
                "&:active": {
                    transform: "translateY(1px) scale(0.99)",
                    filter: "brightness(0.95)",
                    boxShadow: "0 -1px 0 0 #4C0101 inset, 0 1px 0 0 rgba(255, 255, 255, 0.12) inset"
                }
            },
            color: "#FFF",
            textAlign: "center",
            textShadow: "0px 4px 4px rgba(0, 0, 0, 0.16)",
            fontFamily: "Montserrat, sans-serif",
            fontSize: 17,
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "normal"
        }, "", ""),
        children: isCaching ? /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $5c19c940e9865a1c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)((0, $ee37356223c3448b$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $c6f3eebe3403b5cb$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
                    css: $4fb2a739aaca8fcf$var$_ref,
                    children: label
                })
            ]
        })
    });
var $4fb2a739aaca8fcf$export$2e2bcd8739ae039 = $4fb2a739aaca8fcf$var$ActionButton;






var $7pfQ9 = parcelRequire("7pfQ9");
class $bcba141b6d9ebcd4$export$63bc083c14074060 {
    constructor(animations){
        // Bound to accomadate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        return Promise.all(this.animations.map((animation)=>animation.finished));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const subscriptions = this.animations.map((animation)=>animation.attachTimeline(timeline));
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get state() {
        return this.getAll("state");
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        return $bcba141b6d9ebcd4$var$getMax(this.animations, "duration");
    }
    get iterationDuration() {
        return $bcba141b6d9ebcd4$var$getMax(this.animations, "iterationDuration");
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}
function $bcba141b6d9ebcd4$var$getMax(animations, propName) {
    let max = 0;
    for(let i = 0; i < animations.length; i++){
        const value = animations[i][propName];
        if (value !== null && value > max) max = value;
    }
    return max;
}


class $31e52f994e0d6043$export$77cf9b7b4d0397cf extends (0, $bcba141b6d9ebcd4$export$63bc083c14074060) {
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
}


function $548352845a3e7ab6$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $548352845a3e7ab6$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $548352845a3e7ab6$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


const $5df3f3653b3a545e$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $13f337be73603b05$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $13f337be73603b05$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $3051f92cf1709f60$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $3956e0d3b99eacbd$export$f4ff70a5b4808fd8 = 20000;
function $3956e0d3b99eacbd$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $3956e0d3b99eacbd$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $3956e0d3b99eacbd$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $b67f74f96b469bae$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $3956e0d3b99eacbd$export$cbdd6b3d40ea54e2)(generator), (0, $3956e0d3b99eacbd$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(duration)
    };
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $63e6791b1c2a8923$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $b4c64a343d3cd7d2$var$velocitySampleDuration = 5; // ms
function $b4c64a343d3cd7d2$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $b4c64a343d3cd7d2$var$velocitySampleDuration, 0);
    return (0, $63e6791b1c2a8923$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $3e65190bc36179cc$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};



let $5715ab007f2f3ff6$export$491112666e282270 = ()=>{};
let $5715ab007f2f3ff6$export$f5708dca728d7177 = ()=>{};
var $5715ab007f2f3ff6$var$check, $5715ab007f2f3ff6$var$message, $5715ab007f2f3ff6$var$errorCode, $5715ab007f2f3ff6$var$check1, $5715ab007f2f3ff6$var$message1, $5715ab007f2f3ff6$var$errorCode1;



const $03a20b6b79246b27$var$safeMin = 0.001;
function $03a20b6b79246b27$export$b15f158dc6d6f458({ duration: duration = (0, $3e65190bc36179cc$export$86436497e7b05d16).duration, bounce: bounce = (0, $3e65190bc36179cc$export$86436497e7b05d16).bounce, velocity: velocity = (0, $3e65190bc36179cc$export$86436497e7b05d16).velocity, mass: mass = (0, $3e65190bc36179cc$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $5715ab007f2f3ff6$export$491112666e282270)(duration <= (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)((0, $3e65190bc36179cc$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $5df3f3653b3a545e$export$7d15b64cf5a3a4c4)((0, $3e65190bc36179cc$export$86436497e7b05d16).minDamping, (0, $3e65190bc36179cc$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $5df3f3653b3a545e$export$7d15b64cf5a3a4c4)((0, $3e65190bc36179cc$export$86436497e7b05d16).minDuration, (0, $3e65190bc36179cc$export$86436497e7b05d16).maxDuration, (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $03a20b6b79246b27$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $03a20b6b79246b27$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $03a20b6b79246b27$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $03a20b6b79246b27$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$03a20b6b79246b27$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $03a20b6b79246b27$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $3e65190bc36179cc$export$86436497e7b05d16).stiffness,
        damping: (0, $3e65190bc36179cc$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $03a20b6b79246b27$var$rootIterations = 12;
function $03a20b6b79246b27$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $03a20b6b79246b27$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $03a20b6b79246b27$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $6d2fcbad75549209$var$durationKeys = [
    "duration",
    "bounce"
];
const $6d2fcbad75549209$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $6d2fcbad75549209$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $6d2fcbad75549209$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $3e65190bc36179cc$export$86436497e7b05d16).velocity,
        stiffness: (0, $3e65190bc36179cc$export$86436497e7b05d16).stiffness,
        damping: (0, $3e65190bc36179cc$export$86436497e7b05d16).damping,
        mass: (0, $3e65190bc36179cc$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$6d2fcbad75549209$var$isSpringType(options, $6d2fcbad75549209$var$physicsKeys) && $6d2fcbad75549209$var$isSpringType(options, $6d2fcbad75549209$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $5df3f3653b3a545e$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $3e65190bc36179cc$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $03a20b6b79246b27$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $3e65190bc36179cc$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $6d2fcbad75549209$export$b36281d89752ae66(optionsOrVisualDuration = (0, $3e65190bc36179cc$export$86436497e7b05d16).visualDuration, bounce = (0, $3e65190bc36179cc$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $6d2fcbad75549209$var$getSpringOptions({
        ...options,
        velocity: -(0, $13f337be73603b05$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $3e65190bc36179cc$export$86436497e7b05d16).restSpeed.granular : (0, $3e65190bc36179cc$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $3e65190bc36179cc$export$86436497e7b05d16).restDelta.granular : (0, $3e65190bc36179cc$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $03a20b6b79246b27$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $b4c64a343d3cd7d2$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $3956e0d3b99eacbd$export$cbdd6b3d40ea54e2)(generator), (0, $3956e0d3b99eacbd$export$f4ff70a5b4808fd8));
            const easing = (0, $3051f92cf1709f60$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$6d2fcbad75549209$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $b67f74f96b469bae$export$7f1511d09ee75a99)(options, 100, $6d2fcbad75549209$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $0a5a3db2bfc4c788$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $f1c6668106314c85$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $4921a89987178a7f$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $0a5a3db2bfc4c788$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $f1c6668106314c85$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $1edf474125e36ca8$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $4921a89987178a7f$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}

function $404cd6e0223f57f0$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

const $b279c3253337dc6e$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


const $82d4f93c4f5e1d1a$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};


const $15e2f59585b48cc8$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


function $2a6e608976fd321e$export$41c5e731255a462(easing, i) {
    return (0, $15e2f59585b48cc8$export$216948827bbdc797)(easing) ? easing[(0, $82d4f93c4f5e1d1a$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}


function $aed0eec13fe9852c$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $00ba89f728c711c4$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}


function $880833e8796d6ef5$export$92b2aefc56600400(subject, keyframes, scope, selectorCache) {
    if (typeof subject === "string" && (0, $00ba89f728c711c4$export$d276bfce3b1077ca)(keyframes)) return (0, $aed0eec13fe9852c$export$90ceba2564a894f8)(subject, scope, selectorCache);
    else if (subject instanceof NodeList) return Array.from(subject);
    else if (Array.isArray(subject)) return subject;
    else return [
        subject
    ];
}


function $5216f407bf685f35$export$fcfa02e469c39006(duration, repeat, _repeatDelay) {
    return duration * (repeat + 1);
}


/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $910cca6bdab0df7c$export$83ccd85155ba9791(current, next, prev, labels) {
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else if (next.startsWith("<")) return Math.max(0, prev + parseFloat(next.slice(1)));
    else return labels.get(next) ?? current;
}




function $2fc467c97bb6ed79$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $548352845a3e7ab6$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $2fc467c97bb6ed79$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $2fc467c97bb6ed79$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $f1c6668106314c85$export$3bb0b4ff1037b8dd)(startTime, endTime, offset[i]),
        easing: (0, $2a6e608976fd321e$export$41c5e731255a462)(easing, i)
    });
}


/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 */ function $65d61306c1edb7f8$export$989461f373b2c60a(times, repeat) {
    for(let i = 0; i < times.length; i++)times[i] = times[i] / (repeat + 1);
}


function $a84767ba4ab892bc$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $3f8d0a040f73ff2d$var$defaultSegmentEasing = "easeInOut";
const $3f8d0a040f73ff2d$var$MAX_REPEAT = 20;
function $3f8d0a040f73ff2d$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope, generators) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $910cca6bdab0df7c$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $910cca6bdab0df7c$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numSubjects = 0)=>{
            const valueKeyframesAsList = $3f8d0a040f73ff2d$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $1edf474125e36ca8$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay = 0, ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            const createGenerator = (0, $404cd6e0223f57f0$export$6ab7812f1bac68be)(type) ? type : generators?.[type || "keyframes"];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $3f8d0a040f73ff2d$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $b67f74f96b469bae$export$7f1511d09ee75a99)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration ?? (duration = defaultDuration);
            const startTime = currentTime + calculatedDelay;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $4921a89987178a7f$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Handle repeat options
             */ if (repeat) {
                (0, $5715ab007f2f3ff6$export$f5708dca728d7177)(repeat < $3f8d0a040f73ff2d$var$MAX_REPEAT, "Repeat count too high, must be less than 20", "repeat-count-high");
                duration = (0, $5216f407bf685f35$export$fcfa02e469c39006)(duration, repeat);
                const originalKeyframes = [
                    ...valueKeyframesAsList
                ];
                const originalTimes = [
                    ...times
                ];
                ease = Array.isArray(ease) ? [
                    ...ease
                ] : [
                    ease
                ];
                const originalEase = [
                    ...ease
                ];
                for(let repeatIndex = 0; repeatIndex < repeat; repeatIndex++){
                    valueKeyframesAsList.push(...originalKeyframes);
                    for(let keyframeIndex = 0; keyframeIndex < originalKeyframes.length; keyframeIndex++){
                        times.push(originalTimes[keyframeIndex] + (repeatIndex + 1));
                        ease.push(keyframeIndex === 0 ? "linear" : (0, $2a6e608976fd321e$export$41c5e731255a462)(originalEase, keyframeIndex - 1));
                    }
                }
                (0, $65d61306c1edb7f8$export$989461f373b2c60a)(times, repeat);
            }
            const targetTime = startTime + duration;
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $2fc467c97bb6ed79$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $b279c3253337dc6e$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $3f8d0a040f73ff2d$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $3f8d0a040f73ff2d$var$getValueSequence("default", subjectSequence));
        } else {
            const subjects = (0, $880833e8796d6ef5$export$92b2aefc56600400)(subject, keyframes, scope, elementCache);
            const numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const thisSubject = subjects[subjectIndex];
                const subjectSequence = $3f8d0a040f73ff2d$var$getSubjectSequence(thisSubject, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $3f8d0a040f73ff2d$export$7c1391340308742e(transition, key), $3f8d0a040f73ff2d$var$getValueSequence(key, subjectSequence), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $a84767ba4ab892bc$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $0a5a3db2bfc4c788$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($3f8d0a040f73ff2d$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $3f8d0a040f73ff2d$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $3f8d0a040f73ff2d$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $3f8d0a040f73ff2d$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $3f8d0a040f73ff2d$export$7c1391340308742e(transition, key) {
    return transition && transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $3f8d0a040f73ff2d$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $3f8d0a040f73ff2d$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($3f8d0a040f73ff2d$var$isNumber);




const $16faa5f004c69398$export$bc2a978a17abfdde = new WeakMap();


/*#__NO_SIDE_EFFECTS__*/ const $187276fdf26e32e9$export$8793edee2d425525 = (any)=>any;


const $5307ae8e13473f87$export$dd826089e3c5e502 = {};


const $b2b898ea61fcad0a$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $399eb9257aaaafa4$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $f6a200831dad8c32$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $399eb9257aaaafa4$export$84ce9a476f53d110).value) (0, $399eb9257aaaafa4$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $a964d2b71d3196e4$var$maxElapsed = 40;
function $a964d2b71d3196e4$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $b2b898ea61fcad0a$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $f6a200831dad8c32$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $5307ae8e13473f87$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $5307ae8e13473f87$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $a964d2b71d3196e4$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $b2b898ea61fcad0a$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $b2b898ea61fcad0a$export$71ecace0a033b35a).length; i++)steps[(0, $b2b898ea61fcad0a$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $3a37505ff497f7d6$export$2cef06c20297c17d, cancel: $3a37505ff497f7d6$export$ec99c0ef4978dccb, state: $3a37505ff497f7d6$export$fff89137e9e818ce, steps: $3a37505ff497f7d6$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $a964d2b71d3196e4$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $187276fdf26e32e9$export$8793edee2d425525), true);

function $e833df00d0677e67$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}

/**
 * Generate a list of every possible transform key.
 */ const $0ef9286a4a60708b$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $0ef9286a4a60708b$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($0ef9286a4a60708b$export$280dc01950909d86))();


const $835d291f72f72cf2$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $0ef9286a4a60708b$export$280dc01950909d86)
]);



class $bb689e39c55bb40d$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $548352845a3e7ab6$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $548352845a3e7ab6$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}




let $5837500e5d1b699e$var$now;
function $5837500e5d1b699e$var$clearTime() {
    $5837500e5d1b699e$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $5837500e5d1b699e$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($5837500e5d1b699e$var$now === undefined) $5837500e5d1b699e$export$2da9be4cfdb689b1.set((0, $3a37505ff497f7d6$export$fff89137e9e818ce).isProcessing || (0, $5307ae8e13473f87$export$dd826089e3c5e502).useManualTiming ? (0, $3a37505ff497f7d6$export$fff89137e9e818ce).timestamp : performance.now());
        return $5837500e5d1b699e$var$now;
    },
    set: (newTime)=>{
        $5837500e5d1b699e$var$now = newTime;
        queueMicrotask($5837500e5d1b699e$var$clearTime);
    }
};



/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $6865c108953f1506$var$MAX_VELOCITY_DELTA = 30;
const $6865c108953f1506$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $6865c108953f1506$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $6865c108953f1506$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $6865c108953f1506$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $bb689e39c55bb40d$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $3a37505ff497f7d6$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($6865c108953f1506$export$67fcd818a264039d.current) $6865c108953f1506$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $6865c108953f1506$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $6865c108953f1506$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $63e6791b1c2a8923$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $6865c108953f1506$export$ce8bdc721e76545f(init, options) {
    return new $6865c108953f1506$export$8cea36d14ee64562(init, options);
}


const $573ea74918d349ef$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $e55b185c7f69489f$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $e55b185c7f69489f$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $e55b185c7f69489f$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $e55b185c7f69489f$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $9106fa2f7c19702a$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $e55b185c7f69489f$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $20af5efaff3d7130$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $6865c108953f1506$export$ce8bdc721e76545f)(value));
}
function $20af5efaff3d7130$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $573ea74918d349ef$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $20af5efaff3d7130$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $9106fa2f7c19702a$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $20af5efaff3d7130$var$resolveFinalValueInKeyframes(target[key]);
        $20af5efaff3d7130$var$setMotionValue(visualElement, key, value);
    }
}




function $f4051d5a4fa07378$export$98397f3adbf6259f(value) {
    return Boolean((0, $b279c3253337dc6e$export$605d60a2578142d3)(value) && value.add);
}


function $af54aa49998a8508$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $f4051d5a4fa07378$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $5307ae8e13473f87$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $5307ae8e13473f87$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}


/**
 * Convert camelCase to dash-case properties.
 */ const $48edb1f5b7615c5e$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $a40e4073bcd7eb6e$export$ed7b8fa9dbf0105d = "framerAppearId";
const $a40e4073bcd7eb6e$export$8592e1c077c890a6 = "data-" + (0, $48edb1f5b7615c5e$export$9fd24a634729c672)($a40e4073bcd7eb6e$export$ed7b8fa9dbf0105d);


function $0ba62879d3ef9f9f$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $a40e4073bcd7eb6e$export$8592e1c077c890a6];
}




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $17cffd2b0a5223ed$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $17cffd2b0a5223ed$export$a4627e546088548d = (...transformers)=>transformers.reduce($17cffd2b0a5223ed$var$combineFunctions);



const $043854fd4c8eebe1$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};



const $2f34ad5531da63e4$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $2f34ad5531da63e4$export$9de1236619d9e756 = /*@__PURE__*/ $2f34ad5531da63e4$var$checkStringStartsWith("--");
const $2f34ad5531da63e4$var$startsAsVariableToken = /*@__PURE__*/ $2f34ad5531da63e4$var$checkStringStartsWith("var(--");
const $2f34ad5531da63e4$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $2f34ad5531da63e4$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $2f34ad5531da63e4$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $2f34ad5531da63e4$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;




const $be3a6b347526c47f$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $be3a6b347526c47f$export$58f0f39f63f3cf42 = {
    ...$be3a6b347526c47f$export$98e628dec113755e,
    transform: (v)=>(0, $5df3f3653b3a545e$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $be3a6b347526c47f$export$dcdf75081b88279d = {
    ...$be3a6b347526c47f$export$98e628dec113755e,
    default: 1
};


// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $69f5db9f8a2a0f41$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $73862cb53334334d$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $6dc38ba7c5741d6a$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $96f50b7584418227$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $cf479fd2a44b5072$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $96f50b7584418227$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $6dc38ba7c5741d6a$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $cf479fd2a44b5072$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $73862cb53334334d$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $e37a4c40a07c9047$var$clampRgbUnit = (v)=>(0, $5df3f3653b3a545e$export$7d15b64cf5a3a4c4)(0, 255, v);
const $e37a4c40a07c9047$export$7a99c86b5b1f4c9e = {
    ...(0, $be3a6b347526c47f$export$98e628dec113755e),
    transform: (v)=>Math.round($e37a4c40a07c9047$var$clampRgbUnit(v))
};
const $e37a4c40a07c9047$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $cf479fd2a44b5072$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $cf479fd2a44b5072$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $e37a4c40a07c9047$export$7a99c86b5b1f4c9e.transform(red) + ", " + $e37a4c40a07c9047$export$7a99c86b5b1f4c9e.transform(green) + ", " + $e37a4c40a07c9047$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $69f5db9f8a2a0f41$export$83d2e9e3e4ee39ed)((0, $be3a6b347526c47f$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $5c37b2e5aeb5c0ad$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $5c37b2e5aeb5c0ad$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $cf479fd2a44b5072$export$2c8400d58aca05e)("#"),
    parse: $5c37b2e5aeb5c0ad$var$parseHex,
    transform: (0, $e37a4c40a07c9047$export$4e46ac54fc82cf3b).transform
};



/*#__NO_SIDE_EFFECTS__*/ const $8b13469ab9495da7$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $8b13469ab9495da7$export$41fc368e1a942b97 = /*@__PURE__*/ $8b13469ab9495da7$var$createUnitType("deg");
const $8b13469ab9495da7$export$626336c2cd4b14de = /*@__PURE__*/ $8b13469ab9495da7$var$createUnitType("%");
const $8b13469ab9495da7$export$91c0eda1d06bf008 = /*@__PURE__*/ $8b13469ab9495da7$var$createUnitType("px");
const $8b13469ab9495da7$export$f91e8c45a95a32f2 = /*@__PURE__*/ $8b13469ab9495da7$var$createUnitType("vh");
const $8b13469ab9495da7$export$aed3d7b7d206c196 = /*@__PURE__*/ $8b13469ab9495da7$var$createUnitType("vw");
const $8b13469ab9495da7$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$8b13469ab9495da7$export$626336c2cd4b14de,
        parse: (v)=>$8b13469ab9495da7$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$8b13469ab9495da7$export$626336c2cd4b14de.transform(v * 100)
    }))();




const $e2ae1a35a633ea06$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $cf479fd2a44b5072$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $cf479fd2a44b5072$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $8b13469ab9495da7$export$626336c2cd4b14de).transform((0, $69f5db9f8a2a0f41$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $8b13469ab9495da7$export$626336c2cd4b14de).transform((0, $69f5db9f8a2a0f41$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $69f5db9f8a2a0f41$export$83d2e9e3e4ee39ed)((0, $be3a6b347526c47f$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d466179cec798c3c$export$35e9368ef982300f = {
    test: (v)=>(0, $e37a4c40a07c9047$export$4e46ac54fc82cf3b).test(v) || (0, $5c37b2e5aeb5c0ad$export$834dfc94dde4b3d8).test(v) || (0, $e2ae1a35a633ea06$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $e37a4c40a07c9047$export$4e46ac54fc82cf3b).test(v)) return (0, $e37a4c40a07c9047$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $e2ae1a35a633ea06$export$810b04175080204c).test(v)) return (0, $e2ae1a35a633ea06$export$810b04175080204c).parse(v);
        else return (0, $5c37b2e5aeb5c0ad$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $e37a4c40a07c9047$export$4e46ac54fc82cf3b).transform(v) : (0, $e2ae1a35a633ea06$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $d466179cec798c3c$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $d466179cec798c3c$export$35e9368ef982300f.transform(parsed);
    }
};



const $966cdd6ca60a403a$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $da66d44caf26473a$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $73862cb53334334d$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $966cdd6ca60a403a$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $da66d44caf26473a$var$NUMBER_TOKEN = "number";
const $da66d44caf26473a$var$COLOR_TOKEN = "color";
const $da66d44caf26473a$var$VAR_TOKEN = "var";
const $da66d44caf26473a$var$VAR_FUNCTION_TOKEN = "var(";
const $da66d44caf26473a$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $da66d44caf26473a$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $da66d44caf26473a$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($da66d44caf26473a$var$complexRegex, (parsedValue)=>{
        if ((0, $d466179cec798c3c$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($da66d44caf26473a$var$COLOR_TOKEN);
            values.push((0, $d466179cec798c3c$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($da66d44caf26473a$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($da66d44caf26473a$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($da66d44caf26473a$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $da66d44caf26473a$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($da66d44caf26473a$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $da66d44caf26473a$var$parseComplexValue(v) {
    return $da66d44caf26473a$export$b61fc7c44bf646d5(v).values;
}
function $da66d44caf26473a$var$createTransformer(source) {
    const { split: split, types: types } = $da66d44caf26473a$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $da66d44caf26473a$var$NUMBER_TOKEN) output += (0, $69f5db9f8a2a0f41$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $da66d44caf26473a$var$COLOR_TOKEN) output += (0, $d466179cec798c3c$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $da66d44caf26473a$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $d466179cec798c3c$export$35e9368ef982300f).test(v) ? (0, $d466179cec798c3c$export$35e9368ef982300f).getAnimatableNone(v) : v;
function $da66d44caf26473a$var$getAnimatableNone(v) {
    const parsed = $da66d44caf26473a$var$parseComplexValue(v);
    const transformer = $da66d44caf26473a$var$createTransformer(v);
    return transformer(parsed.map($da66d44caf26473a$var$convertNumbersToZero));
}
const $da66d44caf26473a$export$83a0e34f1302825b = {
    test: $da66d44caf26473a$var$test,
    parse: $da66d44caf26473a$var$parseComplexValue,
    createTransformer: $da66d44caf26473a$var$createTransformer,
    getAnimatableNone: $da66d44caf26473a$var$getAnimatableNone
};





// Adapted from https://gist.github.com/mjackson/5311256
function $7a9697154f87bfb8$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $7a9697154f87bfb8$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $7a9697154f87bfb8$var$hueToRgb(p, q, hue + 1 / 3);
        green = $7a9697154f87bfb8$var$hueToRgb(p, q, hue);
        blue = $7a9697154f87bfb8$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $f60937a808067e12$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $2cccac2be3dd7c7c$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $2cccac2be3dd7c7c$var$colorTypes = [
    (0, $5c37b2e5aeb5c0ad$export$834dfc94dde4b3d8),
    (0, $e37a4c40a07c9047$export$4e46ac54fc82cf3b),
    (0, $e2ae1a35a633ea06$export$810b04175080204c)
];
const $2cccac2be3dd7c7c$var$getColorType = (v)=>$2cccac2be3dd7c7c$var$colorTypes.find((type)=>type.test(v));
function $2cccac2be3dd7c7c$var$asRGBA(color) {
    const type = $2cccac2be3dd7c7c$var$getColorType(color);
    (0, $5715ab007f2f3ff6$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $e2ae1a35a633ea06$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $7a9697154f87bfb8$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $2cccac2be3dd7c7c$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $2cccac2be3dd7c7c$var$asRGBA(from);
    const toRGBA = $2cccac2be3dd7c7c$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $f60937a808067e12$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $2cccac2be3dd7c7c$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $2cccac2be3dd7c7c$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $2cccac2be3dd7c7c$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $f1c6668106314c85$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $e37a4c40a07c9047$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $535b5ba7f49828c3$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $535b5ba7f49828c3$export$fed62ccc3fb1a568(origin, target) {
    if ($535b5ba7f49828c3$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $38efea316d8657b0$var$mixNumber(a, b) {
    return (p)=>(0, $f1c6668106314c85$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $38efea316d8657b0$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $38efea316d8657b0$var$mixNumber;
    else if (typeof a === "string") return (0, $2f34ad5531da63e4$export$31f9caa2600b5723)(a) ? (0, $f60937a808067e12$export$a6f92d4bae65c0f1) : (0, $d466179cec798c3c$export$35e9368ef982300f).test(a) ? (0, $2cccac2be3dd7c7c$export$51e568cf5c039bac) : $38efea316d8657b0$export$65516310a87d8205;
    else if (Array.isArray(a)) return $38efea316d8657b0$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $d466179cec798c3c$export$35e9368ef982300f).test(a) ? (0, $2cccac2be3dd7c7c$export$51e568cf5c039bac) : $38efea316d8657b0$export$ebc23b6840c51ba1;
    return 0, $f60937a808067e12$export$a6f92d4bae65c0f1;
}
function $38efea316d8657b0$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$38efea316d8657b0$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $38efea316d8657b0$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $38efea316d8657b0$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $38efea316d8657b0$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $38efea316d8657b0$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $da66d44caf26473a$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $da66d44caf26473a$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $da66d44caf26473a$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $535b5ba7f49828c3$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $535b5ba7f49828c3$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $535b5ba7f49828c3$export$fed62ccc3fb1a568)(origin, target);
        return (0, $17cffd2b0a5223ed$export$a4627e546088548d)($38efea316d8657b0$export$3bbefa2f402845c4($38efea316d8657b0$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $5715ab007f2f3ff6$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $f60937a808067e12$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $dd79cb9670082604$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $f1c6668106314c85$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $38efea316d8657b0$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $9cda3d176e277a67$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $3a37505ff497f7d6$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $3a37505ff497f7d6$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $3a37505ff497f7d6$export$fff89137e9e818ce).isProcessing ? (0, $3a37505ff497f7d6$export$fff89137e9e818ce).timestamp : (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now()
    };
};




function $40f40d6d57faec16$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $6d2fcbad75549209$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $b4c64a343d3cd7d2$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $4034fea678cea370$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $4034fea678cea370$var$subdivisionPrecision = 0.0000001;
const $4034fea678cea370$var$subdivisionMaxIterations = 12;
function $4034fea678cea370$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $4034fea678cea370$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $4034fea678cea370$var$subdivisionPrecision && ++i < $4034fea678cea370$var$subdivisionMaxIterations);
    return currentT;
}
function $4034fea678cea370$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $187276fdf26e32e9$export$8793edee2d425525;
    const getTForX = (aX)=>$4034fea678cea370$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $4034fea678cea370$var$calcBezier(getTForX(t), mY1, mY2);
}


const $74cc8c29aa367805$export$929e5a82286172a6 = /*@__PURE__*/ (0, $4034fea678cea370$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $74cc8c29aa367805$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $4034fea678cea370$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $74cc8c29aa367805$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $4034fea678cea370$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $dd06fe2807815df3$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $53941947badb7e56$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $afd7f3dc5dbf9c7d$export$77edfce482316a60 = /*@__PURE__*/ (0, $4034fea678cea370$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $afd7f3dc5dbf9c7d$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $53941947badb7e56$export$2c07eeff45156d4d)($afd7f3dc5dbf9c7d$export$77edfce482316a60);
const $afd7f3dc5dbf9c7d$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $dd06fe2807815df3$export$f946554fb8aeaf0d)($afd7f3dc5dbf9c7d$export$b01116c84cdfe1a2);


const $ef88505ccdd24ce3$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $afd7f3dc5dbf9c7d$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $6651bcaed230c718$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $6651bcaed230c718$export$c8d67a19199d1a50 = (0, $53941947badb7e56$export$2c07eeff45156d4d)($6651bcaed230c718$export$e444123e42d03385);
const $6651bcaed230c718$export$30d3455eee55bed5 = (0, $dd06fe2807815df3$export$f946554fb8aeaf0d)($6651bcaed230c718$export$e444123e42d03385);




const $58570f68da4ec886$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $dbb073533fdad4ca$var$easingLookup = {
    linear: (0, $187276fdf26e32e9$export$8793edee2d425525),
    easeIn: $74cc8c29aa367805$export$929e5a82286172a6,
    easeInOut: $74cc8c29aa367805$export$c07234257a03d5e9,
    easeOut: $74cc8c29aa367805$export$57636bb43b1ccbb0,
    circIn: $6651bcaed230c718$export$e444123e42d03385,
    circInOut: $6651bcaed230c718$export$30d3455eee55bed5,
    circOut: $6651bcaed230c718$export$c8d67a19199d1a50,
    backIn: $afd7f3dc5dbf9c7d$export$b01116c84cdfe1a2,
    backInOut: $afd7f3dc5dbf9c7d$export$ddc5fd596f6c71b2,
    backOut: $afd7f3dc5dbf9c7d$export$77edfce482316a60,
    anticipate: $ef88505ccdd24ce3$export$6b0af63b873d419e
};
const $dbb073533fdad4ca$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $dbb073533fdad4ca$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $58570f68da4ec886$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $5715ab007f2f3ff6$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $4034fea678cea370$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($dbb073533fdad4ca$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $5715ab007f2f3ff6$export$f5708dca728d7177)($dbb073533fdad4ca$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $dbb073533fdad4ca$var$easingLookup[definition];
    }
    return definition;
};




function $76606bf6cb455128$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $5307ae8e13473f87$export$dd826089e3c5e502).mix || (0, $dd79cb9670082604$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $187276fdf26e32e9$export$8793edee2d425525) : ease;
            mixer = (0, $17cffd2b0a5223ed$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $76606bf6cb455128$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $5715ab007f2f3ff6$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $76606bf6cb455128$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $0a5a3db2bfc4c788$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $5df3f3653b3a545e$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}



function $fb3d168d76cf580f$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $6c8f3775c772e1b8$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $74cc8c29aa367805$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $6c8f3775c772e1b8$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $15e2f59585b48cc8$export$216948827bbdc797)(ease) ? ease.map((0, $dbb073533fdad4ca$export$ef97fe084f156ca4)) : (0, $dbb073533fdad4ca$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $fb3d168d76cf580f$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $1edf474125e36ca8$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $76606bf6cb455128$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $6c8f3775c772e1b8$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



const $dd64f8597630f9e4$var$isNotNull = (value)=>value !== null;
function $dd64f8597630f9e4$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($dd64f8597630f9e4$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $7a38eee8b3d14d13$var$transitionTypeMap = {
    decay: (0, $40f40d6d57faec16$export$ee3ff3a17106998),
    inertia: $40f40d6d57faec16$export$ee3ff3a17106998,
    tween: (0, $6c8f3775c772e1b8$export$d25ddfdf17c3ad3e),
    keyframes: (0, $6c8f3775c772e1b8$export$d25ddfdf17c3ad3e),
    spring: $6d2fcbad75549209$export$b36281d89752ae66
};
function $7a38eee8b3d14d13$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $7a38eee8b3d14d13$var$transitionTypeMap[transition.type];
}


class $2e535ff85a98abf3$export$655db786091c33e0 {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}


const $cce6fb859b6dfeb2$var$percentToProgress = (percent)=>percent / 100;
class $cce6fb859b6dfeb2$export$3394f837405475c7 extends (0, $2e535ff85a98abf3$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now()) this.tick((0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, $043854fd4c8eebe1$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $7a38eee8b3d14d13$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $6c8f3775c772e1b8$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $6c8f3775c772e1b8$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $6c8f3775c772e1b8$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $17cffd2b0a5223ed$export$a4627e546088548d)($cce6fb859b6dfeb2$var$percentToProgress, (0, $dd79cb9670082604$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $3956e0d3b99eacbd$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $5df3f3653b3a545e$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $40f40d6d57faec16$export$ee3ff3a17106998)) state.value = (0, $dd64f8597630f9e4$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        this.driver?.start(false);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $9cda3d176e277a67$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $043854fd4c8eebe1$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function $cce6fb859b6dfeb2$export$ee9b76de7353d815(options) {
    return new $cce6fb859b6dfeb2$export$3394f837405475c7(options);
}



function $9633c5d0924ff846$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}


const $4e99f1c12b1f00dc$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $4e99f1c12b1f00dc$var$rotate = (v)=>{
    const angle = $4e99f1c12b1f00dc$var$radToDeg(Math.atan2(v[1], v[0]));
    return $4e99f1c12b1f00dc$var$rebaseAngle(angle);
};
const $4e99f1c12b1f00dc$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $4e99f1c12b1f00dc$var$rotate,
    rotateZ: $4e99f1c12b1f00dc$var$rotate,
    skewX: (v)=>$4e99f1c12b1f00dc$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$4e99f1c12b1f00dc$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $4e99f1c12b1f00dc$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $4e99f1c12b1f00dc$var$rotateZ = $4e99f1c12b1f00dc$var$rotate;
const $4e99f1c12b1f00dc$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $4e99f1c12b1f00dc$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $4e99f1c12b1f00dc$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $4e99f1c12b1f00dc$var$scaleX,
    scaleY: $4e99f1c12b1f00dc$var$scaleY,
    scale: (v)=>($4e99f1c12b1f00dc$var$scaleX(v) + $4e99f1c12b1f00dc$var$scaleY(v)) / 2,
    rotateX: (v)=>$4e99f1c12b1f00dc$var$rebaseAngle($4e99f1c12b1f00dc$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$4e99f1c12b1f00dc$var$rebaseAngle($4e99f1c12b1f00dc$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $4e99f1c12b1f00dc$var$rotateZ,
    rotate: $4e99f1c12b1f00dc$var$rotateZ,
    skewX: (v)=>$4e99f1c12b1f00dc$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$4e99f1c12b1f00dc$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $4e99f1c12b1f00dc$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $4e99f1c12b1f00dc$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $4e99f1c12b1f00dc$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $4e99f1c12b1f00dc$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $4e99f1c12b1f00dc$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $4e99f1c12b1f00dc$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($4e99f1c12b1f00dc$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $4e99f1c12b1f00dc$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $4e99f1c12b1f00dc$export$f9111f9e16b73a26(transform, name);
};
function $4e99f1c12b1f00dc$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}





const $5fc3c64aec3176f0$export$8e5250d1aa9bf370 = (v)=>v === (0, $be3a6b347526c47f$export$98e628dec113755e) || v === (0, $8b13469ab9495da7$export$91c0eda1d06bf008);
const $5fc3c64aec3176f0$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $5fc3c64aec3176f0$var$nonTranslationalTransformKeys = (0, $0ef9286a4a60708b$export$280dc01950909d86).filter((key)=>!$5fc3c64aec3176f0$var$transformKeys.has(key));
function $5fc3c64aec3176f0$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $5fc3c64aec3176f0$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $5fc3c64aec3176f0$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $4e99f1c12b1f00dc$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $4e99f1c12b1f00dc$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$5fc3c64aec3176f0$export$781d46a8aa670d52.translateX = $5fc3c64aec3176f0$export$781d46a8aa670d52.x;
$5fc3c64aec3176f0$export$781d46a8aa670d52.translateY = $5fc3c64aec3176f0$export$781d46a8aa670d52.y;



const $619dc629a101c405$var$toResolve = new Set();
let $619dc629a101c405$var$isScheduled = false;
let $619dc629a101c405$var$anyNeedsMeasurement = false;
let $619dc629a101c405$var$isForced = false;
function $619dc629a101c405$var$measureAllKeyframes() {
    if ($619dc629a101c405$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($619dc629a101c405$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $5fc3c64aec3176f0$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $619dc629a101c405$var$anyNeedsMeasurement = false;
    $619dc629a101c405$var$isScheduled = false;
    $619dc629a101c405$var$toResolve.forEach((resolver)=>resolver.complete($619dc629a101c405$var$isForced));
    $619dc629a101c405$var$toResolve.clear();
}
function $619dc629a101c405$var$readAllKeyframes() {
    $619dc629a101c405$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $619dc629a101c405$var$anyNeedsMeasurement = true;
    });
}
function $619dc629a101c405$export$78b96d2a12593b05() {
    $619dc629a101c405$var$isForced = true;
    $619dc629a101c405$var$readAllKeyframes();
    $619dc629a101c405$var$measureAllKeyframes();
    $619dc629a101c405$var$isForced = false;
}
class $619dc629a101c405$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $619dc629a101c405$var$toResolve.add(this);
            if (!$619dc629a101c405$var$isScheduled) {
                $619dc629a101c405$var$isScheduled = true;
                (0, $3a37505ff497f7d6$export$2cef06c20297c17d).read($619dc629a101c405$var$readAllKeyframes);
                (0, $3a37505ff497f7d6$export$2cef06c20297c17d).resolveKeyframes($619dc629a101c405$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $9633c5d0924ff846$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $619dc629a101c405$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $619dc629a101c405$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}





const $583582a6dd398c51$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $aa41f26642c74b4b$export$37a5fde709c1db82(element, name, value) {
    (0, $583582a6dd398c51$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $f3a58f0a08108c82$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $4408cf3b1b6580d4$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $f3a58f0a08108c82$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);








/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $06e5e2b4b162732e$export$e3ad02c335474dee = {};


function $b38dbbc9e6d625de$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $f3a58f0a08108c82$export$7c73462e0d25e514)(callback);
    return ()=>(0, $06e5e2b4b162732e$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $461eb9f5aed079fb$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $b38dbbc9e6d625de$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $1421f8af0ae164d6$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $92317adbfa135a8d$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $1421f8af0ae164d6$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $1421f8af0ae164d6$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $1421f8af0ae164d6$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $1421f8af0ae164d6$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $7d63f2eed3e47428$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $461eb9f5aed079fb$export$866c1d07a1ac2ab)() ? (0, $3051f92cf1709f60$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $58570f68da4ec886$export$ff43f99925d7366b)(easing)) return (0, $1421f8af0ae164d6$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$7d63f2eed3e47428$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $92317adbfa135a8d$export$2cf569f5e2221176).easeOut);
    else return (0, $92317adbfa135a8d$export$2cf569f5e2221176)[easing];
}


function $7274e7246bbe1bb7$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $7d63f2eed3e47428$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $399eb9257aaaafa4$export$84ce9a476f53d110).value) (0, $043854fd4c8eebe1$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $399eb9257aaaafa4$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $043854fd4c8eebe1$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}




function $2628618d859c8c07$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $404cd6e0223f57f0$export$6ab7812f1bac68be)(type) && (0, $461eb9f5aed079fb$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $775017ed67dbd7ac$export$6c0f9803d8aa7219 extends (0, $2e535ff85a98abf3$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $5715ab007f2f3ff6$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $2628618d859c8c07$export$a31269144d66b4a)(options);
        this.animation = (0, $7274e7246bbe1bb7$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $dd64f8597630f9e4$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $aa41f26642c74b4b$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $13f337be73603b05$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $4408cf3b1b6580d4$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            return 0, $187276fdf26e32e9$export$8793edee2d425525;
        } else return observe(this);
    }
}




const $241e178065479217$var$unsupportedEasingFunctions = {
    anticipate: $ef88505ccdd24ce3$export$6b0af63b873d419e,
    backInOut: $afd7f3dc5dbf9c7d$export$ddc5fd596f6c71b2,
    circInOut: $6651bcaed230c718$export$30d3455eee55bed5
};
function $241e178065479217$var$isUnsupportedEase(key) {
    return key in $241e178065479217$var$unsupportedEasingFunctions;
}
function $241e178065479217$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $241e178065479217$var$isUnsupportedEase(transition.ease)) transition.ease = $241e178065479217$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $06a2d47a7cdce7cb$var$sampleDelta = 10; //ms
class $06a2d47a7cdce7cb$export$bd2cd6a048093d96 extends (0, $775017ed67dbd7ac$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $241e178065479217$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $7a38eee8b3d14d13$export$98db6ef1242dfa2)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $cce6fb859b6dfeb2$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $06a2d47a7cdce7cb$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $06a2d47a7cdce7cb$var$sampleDelta);
        sampleAnimation.stop();
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $293c27347e327d4b$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $da66d44caf26473a$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $0b548bdb9fc31cb5$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $0b548bdb9fc31cb5$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $293c27347e327d4b$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $293c27347e327d4b$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $5715ab007f2f3ff6$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $0b548bdb9fc31cb5$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $404cd6e0223f57f0$export$6ab7812f1bac68be)(type)) && velocity;
}


function $2b122be51d2ff815$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $6091b01ed727978b$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $6091b01ed727978b$var$supportsWaapi = /*@__PURE__*/ (0, $f3a58f0a08108c82$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $6091b01ed727978b$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $6091b01ed727978b$var$supportsWaapi() && name && $6091b01ed727978b$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $9d7c60bb64103435$var$MAX_RESOLVE_DELAY = 40;
class $9d7c60bb64103435$export$b9855e2a7dee3dd2 extends (0, $2e535ff85a98abf3$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $619dc629a101c405$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $0b548bdb9fc31cb5$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            if ((0, $5307ae8e13473f87$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $dd64f8597630f9e4$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $2b122be51d2ff815$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $9d7c60bb64103435$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $6091b01ed727978b$export$ea92bde116fda821)(resolvedOptions) ? new (0, $06a2d47a7cdce7cb$export$bd2cd6a048093d96)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $cce6fb859b6dfeb2$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>this.notifyFinished()).catch((0, $187276fdf26e32e9$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, $619dc629a101c405$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}



const $cbbb850b063253dc$var$isNotNull = (value)=>value !== null;
function $cbbb850b063253dc$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($cbbb850b063253dc$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}



const $cae6fd33d66f3ec9$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $cae6fd33d66f3ec9$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $cae6fd33d66f3ec9$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $cae6fd33d66f3ec9$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $cae6fd33d66f3ec9$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $cae6fd33d66f3ec9$var$keyframesTransition;
    else if ((0, $0ef9286a4a60708b$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $cae6fd33d66f3ec9$var$criticallyDampedSpring(keyframes[1]) : $cae6fd33d66f3ec9$var$underDampedSpring;
    return $cae6fd33d66f3ec9$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $47b1c3e17b8967fe$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $d45179c80875e863$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $e833df00d0677e67$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $47b1c3e17b8967fe$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $cae6fd33d66f3ec9$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $13f337be73603b05$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $2b122be51d2ff815$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $5307ae8e13473f87$export$dd826089e3c5e502).instantAnimations || (0, $5307ae8e13473f87$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            (0, $2b122be51d2ff815$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $cbbb850b063253dc$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $3a37505ff497f7d6$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $cce6fb859b6dfeb2$export$3394f837405475c7)(options) : new (0, $9d7c60bb64103435$export$b9855e2a7dee3dd2)(options);
    };


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $9616cf66448da947$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $9616cf66448da947$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $9616cf66448da947$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $e833df00d0677e67$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) continue;
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $0ba62879d3ef9f9f$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $3a37505ff497f7d6$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $af54aa49998a8508$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $d45179c80875e863$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $835d291f72f72cf2$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $3a37505ff497f7d6$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $20af5efaff3d7130$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}


function $0c45665a46be8314$export$a6cdc56e425d0d0a(value) {
    return typeof value === "object" && value !== null;
}


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $cca41eeec9c91fb5$export$17eda790a720ec57(element) {
    return (0, $0c45665a46be8314$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $ce4ab429a773d73a$export$66957ea77182581d(element) {
    return (0, $cca41eeec9c91fb5$export$17eda790a720ec57)(element) && element.tagName === "svg";
}



/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $7ec26c04517679a6$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $7ec26c04517679a6$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $7ec26c04517679a6$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $eaa5f7482d59521d$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $eaa5f7482d59521d$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$eaa5f7482d59521d$var$isIdentityScale(scale) || !$eaa5f7482d59521d$var$isIdentityScale(scaleX) || !$eaa5f7482d59521d$var$isIdentityScale(scaleY);
}
function $eaa5f7482d59521d$export$a545127cf1fbb600(values) {
    return $eaa5f7482d59521d$export$bdf30dca883ea463(values) || $eaa5f7482d59521d$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $eaa5f7482d59521d$export$bf80f5f8f4dc327f(values) {
    return $eaa5f7482d59521d$var$is2DTranslate(values.x) || $eaa5f7482d59521d$var$is2DTranslate(values.y);
}
function $eaa5f7482d59521d$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $553e46ddfb94c195$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $553e46ddfb94c195$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $553e46ddfb94c195$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $553e46ddfb94c195$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $553e46ddfb94c195$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $553e46ddfb94c195$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $553e46ddfb94c195$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $553e46ddfb94c195$export$d80074982803af5c(box, { x: x, y: y }) {
    $553e46ddfb94c195$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $553e46ddfb94c195$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $553e46ddfb94c195$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $553e46ddfb94c195$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $553e46ddfb94c195$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $553e46ddfb94c195$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $553e46ddfb94c195$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $eaa5f7482d59521d$export$a545127cf1fbb600)(node.latestValues)) $553e46ddfb94c195$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $553e46ddfb94c195$var$TREE_SCALE_SNAP_MAX && treeScale.x > $553e46ddfb94c195$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $553e46ddfb94c195$var$TREE_SCALE_SNAP_MAX && treeScale.y > $553e46ddfb94c195$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $553e46ddfb94c195$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $553e46ddfb94c195$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $f1c6668106314c85$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $553e46ddfb94c195$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $553e46ddfb94c195$export$58b16271041fbfb(box, transform) {
    $553e46ddfb94c195$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $553e46ddfb94c195$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $e1f5aa914ac996a3$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $7ec26c04517679a6$export$d3955c6a8f65a36b)((0, $7ec26c04517679a6$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $e1f5aa914ac996a3$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $e1f5aa914ac996a3$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $553e46ddfb94c195$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $553e46ddfb94c195$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}



/**
 * ValueType for "auto"
 */ const $057402fbc6e1e301$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};




/**
 * Tests a provided value against a ValueType
 */ const $aec887ddcc75161c$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $3f4309aed74e4edf$export$d176691c1998a1f5 = [
    (0, $be3a6b347526c47f$export$98e628dec113755e),
    (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    (0, $8b13469ab9495da7$export$626336c2cd4b14de),
    (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    (0, $8b13469ab9495da7$export$aed3d7b7d206c196),
    (0, $8b13469ab9495da7$export$f91e8c45a95a32f2),
    (0, $057402fbc6e1e301$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $3f4309aed74e4edf$export$eefdd52e3ccae428 = (v)=>$3f4309aed74e4edf$export$d176691c1998a1f5.find((0, $aec887ddcc75161c$export$6eae4d0a6a7ca7cd)(v));


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $4b11e99a5066e2e9$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $cd72c2634adbdddf$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $cd72c2634adbdddf$export$b9f0c1f373aee2b0(current) {
    const match = $cd72c2634adbdddf$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $cd72c2634adbdddf$var$maxDepth = 4;
function $cd72c2634adbdddf$export$289398774300c991(current, element, depth = 1) {
    (0, $5715ab007f2f3ff6$export$f5708dca728d7177)(depth <= $cd72c2634adbdddf$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $cd72c2634adbdddf$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $4b11e99a5066e2e9$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $2f34ad5531da63e4$export$31f9caa2600b5723)(fallback) ? $cd72c2634adbdddf$export$289398774300c991(fallback, element, depth + 1) : fallback;
}




/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $fee1ec3c9d80354a$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $1a37cfd94b5576a2$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $fee1ec3c9d80354a$export$ade84c85e44a6cb1)(value);
    else return true;
}






/**
 * Properties that should default to 1 or 100%
 */ const $7d22ce67774b2e33$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $7d22ce67774b2e33$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $73862cb53334334d$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $7d22ce67774b2e33$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $7d22ce67774b2e33$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $7d22ce67774b2e33$export$3dea766d36a8935f = {
    ...(0, $da66d44caf26473a$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($7d22ce67774b2e33$var$functionRegex);
        return functions ? functions.map($7d22ce67774b2e33$var$applyDefaultFilter).join(" ") : v;
    }
};





const $776fd51729849688$export$7d260a2a5f8bc19e = {
    ...(0, $be3a6b347526c47f$export$98e628dec113755e),
    transform: Math.round
};






const $25479d4f74b9edc4$export$f2e4285fee37e26 = {
    rotate: (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    rotateX: (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    rotateY: (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    rotateZ: (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    scale: $be3a6b347526c47f$export$dcdf75081b88279d,
    scaleX: (0, $be3a6b347526c47f$export$dcdf75081b88279d),
    scaleY: (0, $be3a6b347526c47f$export$dcdf75081b88279d),
    scaleZ: (0, $be3a6b347526c47f$export$dcdf75081b88279d),
    skew: (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    skewX: (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    skewY: (0, $8b13469ab9495da7$export$41fc368e1a942b97),
    distance: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    translateX: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    translateY: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    translateZ: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    x: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    y: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    z: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    perspective: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    transformPerspective: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    opacity: (0, $be3a6b347526c47f$export$58f0f39f63f3cf42),
    originX: (0, $8b13469ab9495da7$export$44e2e1705876d7ed),
    originY: (0, $8b13469ab9495da7$export$44e2e1705876d7ed),
    originZ: (0, $8b13469ab9495da7$export$91c0eda1d06bf008)
};


const $0899f2e6098c3809$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderTopWidth: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderRightWidth: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderRadius: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    radius: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    maxWidth: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    height: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    maxHeight: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    top: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    right: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    bottom: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    left: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    paddingTop: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    paddingRight: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    paddingBottom: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    paddingLeft: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    margin: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    marginTop: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    marginRight: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    marginBottom: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    marginLeft: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $8b13469ab9495da7$export$91c0eda1d06bf008),
    ...(0, $25479d4f74b9edc4$export$f2e4285fee37e26),
    zIndex: (0, $776fd51729849688$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $be3a6b347526c47f$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $be3a6b347526c47f$export$58f0f39f63f3cf42),
    numOctaves: (0, $776fd51729849688$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $ef269e80109c212d$export$98cd7c72c5a731fb = {
    ...(0, $0899f2e6098c3809$export$eec14432cd1cb67b),
    color: // Color props
    $d466179cec798c3c$export$35e9368ef982300f,
    backgroundColor: (0, $d466179cec798c3c$export$35e9368ef982300f),
    outlineColor: (0, $d466179cec798c3c$export$35e9368ef982300f),
    fill: (0, $d466179cec798c3c$export$35e9368ef982300f),
    stroke: (0, $d466179cec798c3c$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d466179cec798c3c$export$35e9368ef982300f),
    borderTopColor: (0, $d466179cec798c3c$export$35e9368ef982300f),
    borderRightColor: (0, $d466179cec798c3c$export$35e9368ef982300f),
    borderBottomColor: (0, $d466179cec798c3c$export$35e9368ef982300f),
    borderLeftColor: (0, $d466179cec798c3c$export$35e9368ef982300f),
    filter: $7d22ce67774b2e33$export$3dea766d36a8935f,
    WebkitFilter: (0, $7d22ce67774b2e33$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $ef269e80109c212d$export$67d1babe0338d23b = (key)=>$ef269e80109c212d$export$98cd7c72c5a731fb[key];


function $8cbd9f55ff9ce564$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $ef269e80109c212d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $7d22ce67774b2e33$export$3dea766d36a8935f)) defaultValueType = (0, $da66d44caf26473a$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $6647e9552acbd44f$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $6647e9552acbd44f$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$6647e9552acbd44f$var$invalidTemplates.has(keyframe) && (0, $da66d44caf26473a$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $8cbd9f55ff9ce564$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $d2cc0fb9e05038d9$export$4983792d11b61017 extends (0, $619dc629a101c405$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $2f34ad5531da63e4$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $cd72c2634adbdddf$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $835d291f72f72cf2$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $3f4309aed74e4edf$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $3f4309aed74e4edf$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $5fc3c64aec3176f0$export$8e5250d1aa9bf370)(originType) && (0, $5fc3c64aec3176f0$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $5fc3c64aec3176f0$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $1a37cfd94b5576a2$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $6647e9552acbd44f$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $5fc3c64aec3176f0$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $5fc3c64aec3176f0$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}






/**
 * A list of all ValueTypes
 */ const $74ea6938173a6db1$var$valueTypes = [
    ...(0, $3f4309aed74e4edf$export$d176691c1998a1f5),
    (0, $d466179cec798c3c$export$35e9368ef982300f),
    (0, $da66d44caf26473a$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $74ea6938173a6db1$export$950e7e59ea1ffed7 = (v)=>$74ea6938173a6db1$var$valueTypes.find((0, $aec887ddcc75161c$export$6eae4d0a6a7ca7cd)(v));


const { schedule: $330a77ee8a3dfb8a$export$bb76eed83315504c, cancel: $330a77ee8a3dfb8a$export$3252729004b8456e } = /* @__PURE__ */ (0, $a964d2b71d3196e4$export$510b0596a933801a)(queueMicrotask, false);



const $e8e914f2e202bfde$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $e8e914f2e202bfde$export$65570e08d843624d = {};
for(const key in $e8e914f2e202bfde$var$featureProps)$e8e914f2e202bfde$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$e8e914f2e202bfde$var$featureProps[key].some((name)=>!!props[name])
};


const $90fb9d5526f96365$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $90fb9d5526f96365$export$3d227df54007d73a = ()=>({
        x: $90fb9d5526f96365$export$ff25708b37f72782(),
        y: $90fb9d5526f96365$export$ff25708b37f72782()
    });
const $90fb9d5526f96365$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $90fb9d5526f96365$export$6459fc9e86be362e = ()=>({
        x: $90fb9d5526f96365$export$6db76765312617ac(),
        y: $90fb9d5526f96365$export$6db76765312617ac()
    });


const $ab6f1c5247c3527b$export$4e09c449d6c407f7 = typeof window !== "undefined";


// Does this device prefer reduced motion? Returns `null` server-side.
const $a37ca63f2a0a97c4$export$ff7706047246b98b = {
    current: null
};
const $a37ca63f2a0a97c4$export$6476d16e2fd2d0db = {
    current: false
};


function $c8d852c4d86e7778$export$ca9f41fb23dded3d() {
    (0, $a37ca63f2a0a97c4$export$6476d16e2fd2d0db).current = true;
    if (!(0, $ab6f1c5247c3527b$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $a37ca63f2a0a97c4$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $a37ca63f2a0a97c4$export$ff7706047246b98b).current = false;
}




function $248ad32ecb6498aa$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $661c902914c1e017$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $87ad8a421e1fade3$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $87ad8a421e1fade3$export$1405a65085f40b9 = [
    "initial",
    ...$87ad8a421e1fade3$export$16e45afcc206d3a8
];


function $7a23ab4a75712418$export$4b3c3bd8d910d78d(props) {
    return (0, $248ad32ecb6498aa$export$aa71198ceeaf53ce)(props.animate) || (0, $87ad8a421e1fade3$export$1405a65085f40b9).some((name)=>(0, $661c902914c1e017$export$720b90e312cea233)(props[name]));
}
function $7a23ab4a75712418$export$ce46fa4165cdec40(props) {
    return Boolean($7a23ab4a75712418$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $222e47350ac3a021$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $b279c3253337dc6e$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $b279c3253337dc6e$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $6865c108953f1506$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $6865c108953f1506$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}



const $9c1a1bc01b394a66$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $9c1a1bc01b394a66$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $619dc629a101c405$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $5837500e5d1b699e$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $3a37505ff497f7d6$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $7a23ab4a75712418$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $7a23ab4a75712418$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $b279c3253337dc6e$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $16faa5f004c69398$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $a37ca63f2a0a97c4$export$6476d16e2fd2d0db).current) (0, $c8d852c4d86e7778$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $a37ca63f2a0a97c4$export$ff7706047246b98b).current;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $3a37505ff497f7d6$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $3a37505ff497f7d6$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $0ef9286a4a60708b$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $3a37505ff497f7d6$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $e8e914f2e202bfde$export$65570e08d843624d){
            const featureDefinition = (0, $e8e914f2e202bfde$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $90fb9d5526f96365$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $9c1a1bc01b394a66$var$propEventHandlers.length; i++){
            const key = $9c1a1bc01b394a66$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $222e47350ac3a021$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $6865c108953f1506$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $4b11e99a5066e2e9$export$65583ed5a868f2d9)(value) || (0, $fee1ec3c9d80354a$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $74ea6938173a6db1$export$950e7e59ea1ffed7)(value) && (0, $da66d44caf26473a$export$83a0e34f1302825b).test(target)) value = (0, $8cbd9f55ff9ce564$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $b279c3253337dc6e$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $b279c3253337dc6e$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $e55b185c7f69489f$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $b279c3253337dc6e$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $bb689e39c55bb40d$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $330a77ee8a3dfb8a$export$bb76eed83315504c).render(this.render);
    }
}


class $e9daedc8d55b0c83$export$e49735c2a366bdc7 extends (0, $9c1a1bc01b394a66$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $d2cc0fb9e05038d9$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $b279c3253337dc6e$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $7ea4e75cd72f4af0$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $a7d516760616d36c$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $a7d516760616d36c$var$numTransforms = (0, $0ef9286a4a60708b$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $a7d516760616d36c$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $a7d516760616d36c$var$numTransforms; i++){
        const key = (0, $0ef9286a4a60708b$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $7ea4e75cd72f4af0$export$453ef540a9a1bd6b)(value, (0, $0899f2e6098c3809$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $a7d516760616d36c$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $9130c4e7796453e9$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $0ef9286a4a60708b$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $2f34ad5531da63e4$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $7ea4e75cd72f4af0$export$453ef540a9a1bd6b)(value, (0, $0899f2e6098c3809$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $a7d516760616d36c$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $1353cd49329258e7$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}





const $c63db1534519c09d$export$91ddd985b97788d1 = {};
function $c63db1534519c09d$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $c63db1534519c09d$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $2f34ad5531da63e4$export$9de1236619d9e756)(key)) $c63db1534519c09d$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $3314d4de0c39d4c4$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $0ef9286a4a60708b$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $c63db1534519c09d$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $94b8067f12e39506$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $b279c3253337dc6e$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $b279c3253337dc6e$export$605d60a2578142d3)(prevProps.style[key]) || (0, $3314d4de0c39d4c4$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}


function $540242a0512a4145$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $540242a0512a4145$export$23fea75b03ac16b3 extends (0, $e9daedc8d55b0c83$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $1353cd49329258e7$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $0ef9286a4a60708b$export$7b42a0094fb00b6e).has(key)) return this.projection?.isProjecting ? (0, $4e99f1c12b1f00dc$export$1f10c01143b9f089)(key) : (0, $4e99f1c12b1f00dc$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $540242a0512a4145$export$3735103072e4a80(instance);
            const value = ((0, $2f34ad5531da63e4$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $e1f5aa914ac996a3$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $9130c4e7796453e9$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $94b8067f12e39506$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}




function $eca09a356c44482b$var$isObjectKey(key, object) {
    return key in object;
}
class $eca09a356c44482b$export$fe67a5eca4e986d6 extends (0, $9c1a1bc01b394a66$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.type = "object";
    }
    readValueFromInstance(instance, key) {
        if ($eca09a356c44482b$var$isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") return value;
        }
        return undefined;
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    removeValueFromRenderState(key, renderState) {
        delete renderState.output[key];
    }
    measureInstanceViewportBox() {
        return (0, $90fb9d5526f96365$export$6459fc9e86be362e)();
    }
    build(renderState, latestValues) {
        Object.assign(renderState.output, latestValues);
    }
    renderInstance(instance, { output: output }) {
        Object.assign(instance, output);
    }
    sortInstanceNodePosition() {
        return 0;
    }
}









const $4d8431001c667e6d$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $4d8431001c667e6d$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $4d8431001c667e6d$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $4d8431001c667e6d$var$dashKeys : $4d8431001c667e6d$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $8b13469ab9495da7$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $8b13469ab9495da7$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $8b13469ab9495da7$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $2b444eb7408bb421$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, $9130c4e7796453e9$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $4d8431001c667e6d$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $04f03b98fe249b0a$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $c66153bbe319ee16$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $76f1053e335a6161$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $1353cd49329258e7$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $04f03b98fe249b0a$export$28931db5d57958e5).has(key) ? (0, $48edb1f5b7615c5e$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




function $cb8d65dcc3cb9440$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $94b8067f12e39506$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $b279c3253337dc6e$export$605d60a2578142d3)(props[key]) || (0, $b279c3253337dc6e$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $0ef9286a4a60708b$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $867de98127b83009$export$86bcdffbaf733d84 extends (0, $e9daedc8d55b0c83$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $90fb9d5526f96365$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $0ef9286a4a60708b$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $ef269e80109c212d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $04f03b98fe249b0a$export$28931db5d57958e5).has(key) ? (0, $48edb1f5b7615c5e$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $cb8d65dcc3cb9440$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $2b444eb7408bb421$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $76f1053e335a6161$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $c66153bbe319ee16$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}


function $1e4492732d0a2b3d$export$602bd1946a6d1d47(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $cca41eeec9c91fb5$export$17eda790a720ec57)(element) && !(0, $ce4ab429a773d73a$export$66957ea77182581d)(element) ? new (0, $867de98127b83009$export$86bcdffbaf733d84)(options) : new (0, $540242a0512a4145$export$23fea75b03ac16b3)(options);
    node.mount(element);
    (0, $16faa5f004c69398$export$bc2a978a17abfdde).set(element, node);
}
function $1e4492732d0a2b3d$export$69c3b8be1812d4ee(subject) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    const node = new (0, $eca09a356c44482b$export$fe67a5eca4e986d6)(options);
    node.mount(subject);
    (0, $16faa5f004c69398$export$bc2a978a17abfdde).set(subject, node);
}






function $4b15b4ae991c770e$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $b279c3253337dc6e$export$605d60a2578142d3)(value) ? value : (0, $6865c108953f1506$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $d45179c80875e863$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}


function $22f0e9d282a900db$var$isSingleValue(subject, keyframes) {
    return (0, $b279c3253337dc6e$export$605d60a2578142d3)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, $00ba89f728c711c4$export$d276bfce3b1077ca)(keyframes);
}
/**
 * Implementation
 */ function $22f0e9d282a900db$export$7f91f5969506fd92(subject, keyframes, options, scope) {
    const animations = [];
    if ($22f0e9d282a900db$var$isSingleValue(subject, keyframes)) animations.push((0, $4b15b4ae991c770e$export$335a17c977067b99)(subject, (0, $00ba89f728c711c4$export$d276bfce3b1077ca)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        const subjects = (0, $880833e8796d6ef5$export$92b2aefc56600400)(subject, keyframes, scope);
        const numSubjects = subjects.length;
        (0, $5715ab007f2f3ff6$export$f5708dca728d7177)(Boolean(numSubjects), "No valid elements provided.", "no-valid-elements");
        for(let i = 0; i < numSubjects; i++){
            const thisSubject = subjects[i];
            (0, $5715ab007f2f3ff6$export$f5708dca728d7177)(thisSubject !== null, "You're trying to perform an animation on null. Ensure that selectors are correctly finding elements and refs are correctly hydrated.", "animate-null");
            const createVisualElement = thisSubject instanceof Element ? (0, $1e4492732d0a2b3d$export$602bd1946a6d1d47) : (0, $1e4492732d0a2b3d$export$69c3b8be1812d4ee);
            if (!(0, $16faa5f004c69398$export$bc2a978a17abfdde).has(thisSubject)) createVisualElement(thisSubject);
            const visualElement = (0, $16faa5f004c69398$export$bc2a978a17abfdde).get(thisSubject);
            const transition = {
                ...options
            };
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            animations.push(...(0, $9616cf66448da947$export$68cacfeee78d98d2)(visualElement, {
                ...keyframes,
                transition: transition
            }, {}));
        }
    }
    return animations;
}


function $90124848467d6054$export$82a013c5b12ef57f(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $3f8d0a040f73ff2d$export$1f0f44b51a4b2f73)(sequence, options, scope, {
        spring: $6d2fcbad75549209$export$b36281d89752ae66
    });
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        animations.push(...(0, $22f0e9d282a900db$export$7f91f5969506fd92)(subject, keyframes, transition));
    });
    return animations;
}



function $db863407d733375e$var$isSequence(value) {
    return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function $db863407d733375e$export$c17e592002be9b90(scope) {
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        let animations = [];
        let animationOnComplete;
        if ($db863407d733375e$var$isSequence(subjectOrSequence)) animations = (0, $90124848467d6054$export$82a013c5b12ef57f)(subjectOrSequence, optionsOrKeyframes, scope);
        else {
            // Extract top-level onComplete so it doesn't get applied per-value
            const { onComplete: onComplete, ...rest } = options || {};
            if (typeof onComplete === "function") animationOnComplete = onComplete;
            animations = (0, $22f0e9d282a900db$export$7f91f5969506fd92)(subjectOrSequence, optionsOrKeyframes, rest, scope);
        }
        const animation = new (0, $31e52f994e0d6043$export$77cf9b7b4d0397cf)(animations);
        if (animationOnComplete) animation.finished.then(animationOnComplete);
        if (scope) {
            scope.animations.push(animation);
            animation.finished.then(()=>{
                (0, $548352845a3e7ab6$export$fe2d9b4e03920b4c)(scope.animations, animation);
            });
        }
        return animation;
    }
    return scopedAnimate;
}
const $db863407d733375e$export$e3607ec2d7a891c4 = $db863407d733375e$export$c17e592002be9b90();


const $421a126d1698b5e0$var$TypingEffect = ({ text: text, speed: speed = 35, delay: delay = 0 })=>{
    const textRef = (0, $7pfQ9.useRef)();
    (0, $7pfQ9.useEffect)(()=>{
        const textArray = text.split("");
        const textContainer = textRef.current;
        if (textContainer) {
            textContainer.innerHTML = ""; // Clear existing content
            setTimeout(()=>{
                textArray.forEach((char, index)=>{
                    // Create a span for each character
                    const span = document.createElement("span");
                    span.textContent = char;
                    span.style.opacity = "0";
                    textContainer.appendChild(span);
                    // Animate the opacity of each character
                    (0, $db863407d733375e$export$e3607ec2d7a891c4)(span, {
                        opacity: [
                            0,
                            1
                        ]
                    }, {
                        delay: index * (speed / 1000),
                        duration: 0.2
                    });
                });
            }, delay);
        }
    }, [
        text,
        speed
    ]);
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        ref: textRef
    });
// return <div ref={textRef} style={{ fontFamily: "monospace", fontSize: "24px" }} />
};
var $421a126d1698b5e0$export$2e2bcd8739ae039 = $421a126d1698b5e0$var$TypingEffect;


const $ad547a3e175225db$var$Title = ({ title: title })=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("h1", {
        css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
            fontFamily: "Montserrat, serif",
            color: "white",
            width: "100%",
            fontSize: 24,
            minHeight: 29,
            fontWeight: 700,
            textAlign: "center",
            alignSelf: "start",
            margin: 0,
            whiteSpace: `pre-line`
        }, "", ""),
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $421a126d1698b5e0$export$2e2bcd8739ae039), {
            text: title
        })
    });
var $ad547a3e175225db$export$2e2bcd8739ae039 = $ad547a3e175225db$var$Title;



function $f89d8ae7195dcbac$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
            fill: "#fff",
            d: "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"
        })
    });
}



function $7e0829f89fe06196$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("svg", {
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("circle", {
                cx: 12,
                cy: 12,
                r: 12,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                fill: "#0866ff",
                d: "M9.101 23.734v-8.01H6.627v-3.68h2.474v-1.586c0-4.1 1.848-6 5.858-6 .401 0 .955.042 1.468.104q.577.06 1.141.195v3.337a9 9 0 0 0-.653-.036q-.367-.01-.733-.008c-.707 0-1.259.096-1.675.31-.28.14-.515.357-.679.624-.258.421-.374.999-.374 1.758v1.302h3.919l-.386 2.11-.287 1.57h-3.246V24C19.396 23.28 24 18.203 24 12.045 24 5.393 18.627 0 12 0S0 5.393 0 12.044a12.04 12.04 0 0 0 9.101 11.69"
            })
        ]
    });
}



const $07992010a5fedac1$var$Img_instagram = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("g", {
                clipPath: "url(#clip0_20_94)",
                children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                    d: "M7.86333 0.0940266C6.58653 0.154227 5.71463 0.358027 4.95233 0.657427C4.16353 0.964927 3.49483 1.37743 2.82953 2.04513C2.16433 2.71283 1.75453 3.38193 1.44933 4.17213C1.15393 4.93593 0.953734 5.80863 0.897334 7.08613C0.840934 8.36363 0.828434 8.77433 0.834734 12.0331C0.840934 15.2917 0.855334 15.7002 0.917234 16.9804C0.978234 18.2569 1.18123 19.1286 1.48073 19.8911C1.78873 20.68 2.20073 21.3484 2.86873 22.0139C3.53663 22.6794 4.20523 23.0882 4.99723 23.3939C5.76043 23.6889 6.63333 23.89 7.91063 23.9459C9.18793 24.0019 9.59903 24.0149 12.8568 24.0086C16.1146 24.0024 16.5248 23.9879 17.8046 23.9272C19.0846 23.8665 19.9516 23.662 20.7144 23.3639C21.5033 23.0553 22.1722 22.6439 22.8372 21.9758C23.5022 21.3076 23.9117 20.638 24.2167 19.8474C24.5124 19.0842 24.7133 18.2114 24.7687 16.935C24.8247 15.6541 24.8379 15.2452 24.8317 11.987C24.8254 8.72873 24.8107 8.32023 24.75 7.04053C24.6893 5.76083 24.486 4.89183 24.1867 4.12883C23.8783 3.33993 23.4667 2.67203 22.7991 2.00603C22.1314 1.34003 21.4612 0.930827 20.671 0.626527C19.9072 0.331027 19.0349 0.129727 17.7576 0.0745265C16.4803 0.0193265 16.0692 0.00502656 12.8102 0.0114266C9.55123 0.0176266 9.14323 0.0316266 7.86333 0.0940266ZM8.00353 21.7871C6.83353 21.7362 6.19823 21.5418 5.77483 21.3791C5.21423 21.1631 4.81483 20.902 4.39293 20.4841C3.97093 20.0663 3.71183 19.6655 3.49293 19.1061C3.32853 18.6827 3.13053 18.0481 3.07583 16.8781C3.01633 15.6136 3.00383 15.2339 2.99683 12.0301C2.98983 8.82643 3.00213 8.44713 3.05753 7.18213C3.10753 6.01313 3.30313 5.37713 3.46553 4.95393C3.68153 4.39263 3.94173 3.99393 4.36053 3.57233C4.77933 3.15063 5.17893 2.89093 5.73883 2.67203C6.16183 2.50693 6.79633 2.31063 7.96583 2.25493C9.23133 2.19493 9.61053 2.18293 12.8138 2.17593C16.0171 2.16893 16.3973 2.18093 17.6633 2.23673C18.8323 2.28753 19.4686 2.48123 19.8913 2.64473C20.4521 2.86073 20.8513 3.12013 21.2729 3.53973C21.6946 3.95913 21.9545 4.35733 22.1734 4.91843C22.3387 5.34013 22.5351 5.97443 22.5903 7.14473C22.6505 8.41023 22.6642 8.78973 22.6699 11.9927C22.6757 15.1957 22.6644 15.5761 22.6089 16.8407C22.5579 18.0107 22.3639 18.6462 22.2009 19.0701C21.9849 19.6305 21.7246 20.0301 21.3055 20.4515C20.8865 20.873 20.4874 21.1326 19.9272 21.3515C19.5048 21.5164 18.8695 21.7132 17.701 21.7689C16.4354 21.8284 16.0562 21.8409 12.8517 21.8479C9.64723 21.8549 9.26903 21.8419 8.00353 21.7871ZM17.7862 5.59643C17.7867 5.88126 17.8716 6.15955 18.0303 6.3961C18.1889 6.63266 18.4142 6.81685 18.6775 6.92538C18.9409 7.03392 19.2305 7.06192 19.5097 7.00584C19.789 6.94976 20.0453 6.81213 20.2464 6.61035C20.4474 6.40856 20.5841 6.1517 20.6391 5.87223C20.6941 5.59277 20.665 5.30326 20.5555 5.04033C20.446 4.7774 20.261 4.55285 20.0238 4.39509C19.7867 4.23732 19.5081 4.15343 19.2232 4.15403C18.8414 4.15482 18.4756 4.30722 18.2061 4.5777C17.9366 4.84819 17.7856 5.21462 17.7862 5.59643ZM6.67173 12.022C6.67843 15.4252 9.44233 18.1777 12.8447 18.1713C16.2473 18.1648 19.0017 15.4012 18.9953 11.998C18.9888 8.59483 16.2243 5.84153 12.8213 5.84823C9.41833 5.85493 6.66533 8.61923 6.67173 12.022ZM8.83323 12.0177C8.83167 11.2266 9.06474 10.4528 9.50296 9.79413C9.94118 9.13547 10.5649 8.62155 11.2952 8.31736C12.0255 8.01316 12.8296 7.93235 13.6058 8.08515C14.382 8.23795 15.0955 8.6175 15.656 9.17579C16.2165 9.73409 16.5989 10.4461 16.7548 11.2217C16.9107 11.9973 16.8331 12.8017 16.5318 13.5332C16.2305 14.2647 15.7191 14.8904 15.0621 15.3313C14.4052 15.7721 13.6324 16.0082 12.8412 16.0098C12.3159 16.0109 11.7955 15.9085 11.3098 15.7085C10.8241 15.5085 10.3825 15.2147 10.0103 14.844C9.63812 14.4733 9.3426 14.0329 9.14064 13.5479C8.93867 13.063 8.83422 12.543 8.83323 12.0177Z",
                    fill: "#FF0069"
                })
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("defs", {
                children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("clipPath", {
                    id: "clip0_20_94",
                    children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("rect", {
                        width: 24,
                        height: 24,
                        fill: "white",
                        transform: "translate(0.833252 0.0100098)"
                    })
                })
            })
        ]
    });
var $07992010a5fedac1$export$2e2bcd8739ae039 = $07992010a5fedac1$var$Img_instagram;



const $1dbd99818ef7e5e2$var$Img_tiktok = ()=>{
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("g", {
                clipPath: "url(#clip0_20_88)",
                children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                    d: "M13.0251 0.0300098C14.3351 0.0100098 15.6351 0.0200098 16.9351 0.0100098C17.0151 1.54001 17.5651 3.10001 18.6851 4.18001C19.8051 5.29001 21.3851 5.80001 22.9251 5.97001V10C21.4851 9.95001 20.0351 9.65001 18.7251 9.03001C18.1551 8.77001 17.6251 8.44001 17.1051 8.10001C17.0951 11.02 17.1151 13.94 17.0851 16.85C17.0051 18.25 16.5451 19.64 15.7351 20.79C14.4251 22.71 12.1551 23.96 9.82512 24C8.39512 24.08 6.96512 23.69 5.74512 22.97C3.72512 21.78 2.30512 19.6 2.09512 17.26C2.07512 16.76 2.06512 16.26 2.08512 15.77C2.26512 13.87 3.20512 12.05 4.66512 10.81C6.32512 9.37001 8.64512 8.68001 10.8151 9.09001C10.8351 10.57 10.7751 12.05 10.7751 13.53C9.78512 13.21 8.62512 13.3 7.75512 13.9C7.12512 14.31 6.64512 14.94 6.39512 15.65C6.18512 16.16 6.24512 16.72 6.25512 17.26C6.49512 18.9 8.07512 20.28 9.75512 20.13C10.8751 20.12 11.9451 19.47 12.5251 18.52C12.7151 18.19 12.9251 17.85 12.9351 17.46C13.0351 15.67 12.9951 13.89 13.0051 12.1C13.0151 8.07001 12.9951 4.05001 13.0251 0.0300098Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("defs", {
                children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("clipPath", {
                    id: "clip0_20_88",
                    children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("rect", {
                        width: 24,
                        height: 24,
                        transform: "translate(0.5 0.0100098)"
                    })
                })
            })
        ]
    });
};
var $1dbd99818ef7e5e2$export$2e2bcd8739ae039 = $1dbd99818ef7e5e2$var$Img_tiktok;


function $7b52c13f12b5f4d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b52c13f12b5f4d4$var$listProps = {
    margin: "auto",
    color: "#CEC8FE",
    // fallback color
    // background: "linear-gradient(180deg, #E2E6FD -17.86%, #CEC8FE 111.9%)",
    // backgroundClip: "text",
    // WebkitBackgroundClip: "text",
    // WebkitTextFillColor: "transparent",
    display: "flex",
    alignItems: "center",
    gap: 8
};
var $7b52c13f12b5f4d4$var$_ref = {
    name: "huhir7",
    styles: "display:flex;flex-direction:column;justify-content:start;gap:12px"
};
var $7b52c13f12b5f4d4$var$_ref2 = {
    name: "1ufx5lo",
    styles: "width:100%;display:flex;flex-direction:column;justify-content:center;gap:24px"
};
var $7b52c13f12b5f4d4$var$_ref3 = {
    name: "mjsl8v",
    styles: "width:100%;display:flex;flex-direction:column;justify-content:center;gap:12px"
};
var $7b52c13f12b5f4d4$var$_ref4 = {
    name: "1b7ou1i",
    styles: "margin:0;text-align:center;font-family:Montserrat, sans-serif;font-size:19px;font-weight:500;color:#CEC8FE"
};
var $7b52c13f12b5f4d4$var$_ref5 = {
    name: "13pafcp",
    styles: "list-style:none;margin:0;text-align:left;font-family:Montserrat, sans-serif;font-style:normal;padding:0;display:flex;flex-direction:column;align-items:flex-start;gap:12px;align-self:stretch"
};
const $7b52c13f12b5f4d4$var$VideoShare = ({ shareVideo: shareVideo, isCaching: isCaching })=>{
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: $7b52c13f12b5f4d4$var$_ref,
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ad547a3e175225db$export$2e2bcd8739ae039), {
                title: "Your Video is Ready"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
                css: $7b52c13f12b5f4d4$var$_ref2,
                children: [
                    /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
                        css: $7b52c13f12b5f4d4$var$_ref3,
                        children: [
                            /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("h3", {
                                css: $7b52c13f12b5f4d4$var$_ref4,
                                children: [
                                    "Share your ",
                                    /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("b", {
                                        children: "#HolidayHologram"
                                    }),
                                    " and\xa0spread\xa0some festive cheer!"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("ul", {
                                css: $7b52c13f12b5f4d4$var$_ref5,
                                children: [
                                    /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("li", {
                                        css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
                                            ...$7b52c13f12b5f4d4$var$listProps
                                        }, "", ""),
                                        children: [
                                            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $07992010a5fedac1$export$2e2bcd8739ae039), {}),
                                            " ",
                                            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $1dbd99818ef7e5e2$export$2e2bcd8739ae039), {}),
                                            "@hypervsn_uk"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("li", {
                                        css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
                                            ...$7b52c13f12b5f4d4$var$listProps
                                        }, "", ""),
                                        children: [
                                            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $f89d8ae7195dcbac$export$2e2bcd8739ae039), {}),
                                            " ",
                                            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $7e0829f89fe06196$export$2e2bcd8739ae039), {}),
                                            " @hypervsn"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $4fb2a739aaca8fcf$export$2e2bcd8739ae039), {
                        label: "Download Video",
                        onClick: shareVideo,
                        isCaching: isCaching
                    })
                ]
            })
        ]
    });
};
var $7b52c13f12b5f4d4$export$2e2bcd8739ae039 = $7b52c13f12b5f4d4$var$VideoShare;





var $7pfQ9 = parcelRequire("7pfQ9");

var $2305b7cdeafa4e99$exports = {};
Object.defineProperty($2305b7cdeafa4e99$exports, "__esModule", {
    value: !0
});

var $7pfQ9 = parcelRequire("7pfQ9");
var $fae66df3ca4d9b5e$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $fae66df3ca4d9b5e$exports = factory();
})($fae66df3ca4d9b5e$exports, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                var Rive = (()=>{
                    var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
                    return function(moduleArg = {}) {
                        var moduleRtn;
                        var m = moduleArg, ba, ca, da = new Promise((a, b)=>{
                            ba = a;
                            ca = b;
                        }), ea = "object" == typeof window, fa = "function" == typeof importScripts;
                        function ha() {
                            function a(g) {
                                const k = d;
                                c = b = 0;
                                d = new Map();
                                k.forEach((p)=>{
                                    try {
                                        p(g);
                                    } catch (n) {
                                        console.error(n);
                                    }
                                });
                                this.nb();
                                e && e.Pb();
                            }
                            let b = 0, c = 0, d = new Map(), e = null, f = null;
                            this.requestAnimationFrame = function(g) {
                                b ||= requestAnimationFrame(a.bind(this));
                                const k = ++c;
                                d.set(k, g);
                                return k;
                            };
                            this.cancelAnimationFrame = function(g) {
                                d.delete(g);
                                b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
                            };
                            this.Nb = function(g) {
                                f && (document.body.remove(f), f = null);
                                g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(k) {
                                    f.innerHTML = "RIVE FPS " + k.toFixed(1);
                                }, document.body.appendChild(f));
                                e = new function() {
                                    let k = 0, p = 0;
                                    this.Pb = function() {
                                        var n = performance.now();
                                        p ? (++k, n -= p, 1000 < n && (g(1000 * k / n), k = p = 0)) : (p = n, k = 0);
                                    };
                                }();
                            };
                            this.Kb = function() {
                                f && (document.body.remove(f), f = null);
                                e = null;
                            };
                            this.nb = function() {};
                        }
                        function ia(a) {
                            console.assert(!0);
                            const b = new Map();
                            let c = -Infinity;
                            this.push = function(d) {
                                d = d + ((1 << a) - 1) >> a;
                                b.has(d) && clearTimeout(b.get(d));
                                b.set(d, setTimeout(function() {
                                    b.delete(d);
                                    0 == b.length ? c = -Infinity : d == c && (c = Math.max(...b.keys()), console.assert(c < d));
                                }, 1000));
                                c = Math.max(d, c);
                                return c << a;
                            };
                        }
                        const ja = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            ja && ja();
                            let a = m.decodeAudio;
                            m.decodeAudio = function(e, f) {
                                e = a(e);
                                f(e);
                            };
                            let b = m.decodeFont;
                            m.decodeFont = function(e, f) {
                                e = b(e);
                                f(e);
                            };
                            const c = m.FileAssetLoader;
                            m.ptrToAsset = (e)=>{
                                let f = m.ptrToFileAsset(e);
                                return f.isImage ? m.ptrToImageAsset(e) : f.isFont ? m.ptrToFontAsset(e) : f.isAudio ? m.ptrToAudioAsset(e) : f;
                            };
                            m.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {
                                __construct: function({ loadContents: e }) {
                                    this.__parent.__construct.call(this);
                                    this.Db = e;
                                },
                                loadContents: function(e, f) {
                                    e = m.ptrToAsset(e);
                                    return this.Db(e, f);
                                }
                            });
                            m.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                },
                                loadContents: function(e) {
                                    let f = m.ptrToAsset(e);
                                    e = f.cdnUuid;
                                    if ("" === e) return !1;
                                    (function(g, k) {
                                        var p = new XMLHttpRequest();
                                        p.responseType = "arraybuffer";
                                        p.onreadystatechange = function() {
                                            4 == p.readyState && 200 == p.status && k(p);
                                        };
                                        p.open("GET", g, !0);
                                        p.send(null);
                                    })(f.cdnBaseUrl + "/" + e, (g)=>{
                                        f.decode(new Uint8Array(g.response));
                                    });
                                    return !0;
                                }
                            });
                            m.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.jb = [];
                                },
                                addLoader: function(e) {
                                    this.jb.push(e);
                                },
                                loadContents: function(e, f) {
                                    for (let g of this.jb){
                                        if (g.loadContents(e, f)) return !0;
                                    }
                                    return !1;
                                }
                            });
                            let d = m.computeAlignment;
                            m.computeAlignment = function(e, f, g, k, p = 1.0) {
                                return d.call(this, e, f, g, k, p);
                            };
                        };
                        const ka = "createConicGradient createImageData createLinearGradient createPattern createRadialGradient getContextAttributes getImageData getLineDash getTransform isContextLost isPointInPath isPointInStroke measureText".split(" "), la = new function() {
                            function a() {
                                if (!b) {
                                    var l = document.createElement("canvas"), u = {
                                        alpha: 1,
                                        depth: 0,
                                        stencil: 0,
                                        antialias: 0,
                                        premultipliedAlpha: 1,
                                        preserveDrawingBuffer: 0,
                                        powerPreference: "high-performance",
                                        failIfMajorPerformanceCaveat: 0,
                                        enableExtensionsByDefault: 1,
                                        explicitSwapControl: 1,
                                        renderViaOffscreenBackBuffer: 1
                                    };
                                    let q;
                                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                                        if (q = l.getContext("webgl", u), c = 1, !q) return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    } else if (q = l.getContext("webgl2", u)) c = 2;
                                    else {
                                        if (q = l.getContext("webgl", u)) c = 1;
                                        else return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    }
                                    q = new Proxy(q, {
                                        get (E, w) {
                                            if (E.isContextLost()) {
                                                if (p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to invoke ", w), p = !0), "function" === typeof E[w]) return function() {};
                                            } else return "function" === typeof E[w] ? function(...L) {
                                                return E[w].apply(E, L);
                                            } : E[w];
                                        },
                                        set (E, w, L) {
                                            if (E.isContextLost()) p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to set property " + w), p = !0);
                                            else return E[w] = L, !0;
                                        }
                                    });
                                    d = Math.min(q.getParameter(q.MAX_RENDERBUFFER_SIZE), q.getParameter(q.MAX_TEXTURE_SIZE));
                                    function C(E, w, L) {
                                        w = q.createShader(w);
                                        q.shaderSource(w, L);
                                        q.compileShader(w);
                                        L = q.getShaderInfoLog(w);
                                        if (0 < (L || "").length) throw L;
                                        q.attachShader(E, w);
                                    }
                                    l = q.createProgram();
                                    C(l, q.VERTEX_SHADER, "attribute vec2 vertex;\n                attribute vec2 uv;\n                uniform vec4 mat;\n                uniform vec2 translate;\n                varying vec2 st;\n                void main() {\n                    st = uv;\n                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);\n                }");
                                    C(l, q.FRAGMENT_SHADER, "precision highp float;\n                uniform sampler2D image;\n                varying vec2 st;\n                void main() {\n                    gl_FragColor = texture2D(image, st);\n                }");
                                    q.bindAttribLocation(l, 0, "vertex");
                                    q.bindAttribLocation(l, 1, "uv");
                                    q.linkProgram(l);
                                    u = q.getProgramInfoLog(l);
                                    if (0 < (u || "").trim().length) throw u;
                                    e = q.getUniformLocation(l, "mat");
                                    f = q.getUniformLocation(l, "translate");
                                    q.useProgram(l);
                                    q.bindBuffer(q.ARRAY_BUFFER, q.createBuffer());
                                    q.enableVertexAttribArray(0);
                                    q.enableVertexAttribArray(1);
                                    q.bindBuffer(q.ELEMENT_ARRAY_BUFFER, q.createBuffer());
                                    q.uniform1i(q.getUniformLocation(l, "image"), 0);
                                    q.pixelStorei(q.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
                                    b = q;
                                }
                                return !0;
                            }
                            let b = null, c = 0, d = 0, e = null, f = null, g = 0, k = 0, p = !1;
                            a();
                            this.ac = function() {
                                a();
                                return d;
                            };
                            this.Jb = function(l) {
                                b.deleteTexture && b.deleteTexture(l);
                            };
                            this.Ib = function(l) {
                                if (!a()) return null;
                                const u = b.createTexture();
                                if (!u) return null;
                                b.bindTexture(b.TEXTURE_2D, u);
                                b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, b.RGBA, b.UNSIGNED_BYTE, l);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MAG_FILTER, b.LINEAR);
                                2 == c ? (b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR_MIPMAP_LINEAR), b.generateMipmap(b.TEXTURE_2D)) : b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR);
                                return u;
                            };
                            const n = new ia(8), t = new ia(8), x = new ia(10), y = new ia(10);
                            this.Mb = function(l, u, q, C, E) {
                                if (a()) {
                                    var w = n.push(l), L = t.push(u);
                                    if (b.canvas) {
                                        if (b.canvas.width != w || b.canvas.height != L) b.canvas.width = w, b.canvas.height = L;
                                        b.viewport(0, L - u, l, u);
                                        b.disable(b.SCISSOR_TEST);
                                        b.clearColor(0, 0, 0, 0);
                                        b.clear(b.COLOR_BUFFER_BIT);
                                        b.enable(b.SCISSOR_TEST);
                                        q.sort((H, aa)=>aa.ub - H.ub);
                                        w = x.push(C);
                                        g != w && (b.bufferData(b.ARRAY_BUFFER, 8 * w, b.DYNAMIC_DRAW), g = w);
                                        w = 0;
                                        for (var R of q)b.bufferSubData(b.ARRAY_BUFFER, w, R.Sa), w += 4 * R.Sa.length;
                                        console.assert(w == 4 * C);
                                        for (var W of q)b.bufferSubData(b.ARRAY_BUFFER, w, W.Ab), w += 4 * W.Ab.length;
                                        console.assert(w == 8 * C);
                                        w = y.push(E);
                                        k != w && (b.bufferData(b.ELEMENT_ARRAY_BUFFER, 2 * w, b.DYNAMIC_DRAW), k = w);
                                        R = 0;
                                        for (var pa of q)b.bufferSubData(b.ELEMENT_ARRAY_BUFFER, R, pa.indices), R += 2 * pa.indices.length;
                                        console.assert(R == 2 * E);
                                        pa = 0;
                                        W = !0;
                                        w = R = 0;
                                        for (const H of q){
                                            H.image.Ia != pa && (b.bindTexture(b.TEXTURE_2D, H.image.Ha || null), pa = H.image.Ia);
                                            H.fc ? (b.scissor(H.Ya, L - H.Za - H.ib, H.tc, H.ib), W = !0) : W && (b.scissor(0, L - u, l, u), W = !1);
                                            q = 2 / l;
                                            const aa = -2 / u;
                                            b.uniform4f(e, H.ga[0] * q * H.za, H.ga[1] * aa * H.Aa, H.ga[2] * q * H.za, H.ga[3] * aa * H.Aa);
                                            b.uniform2f(f, H.ga[4] * q * H.za + q * (H.Ya - H.bc * H.za) - 1, H.ga[5] * aa * H.Aa + aa * (H.Za - H.cc * H.Aa) + 1);
                                            b.vertexAttribPointer(0, 2, b.FLOAT, !1, 0, w);
                                            b.vertexAttribPointer(1, 2, b.FLOAT, !1, 0, w + 4 * C);
                                            b.drawElements(b.TRIANGLES, H.indices.length, b.UNSIGNED_SHORT, R);
                                            w += 4 * H.Sa.length;
                                            R += 2 * H.indices.length;
                                        }
                                        console.assert(w == 4 * C);
                                        console.assert(R == 2 * E);
                                    }
                                }
                            };
                            this.canvas = function() {
                                return a() && b.canvas;
                            };
                        }(), ma = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            function a(r) {
                                switch(r){
                                    case n.srcOver:
                                        return "source-over";
                                    case n.screen:
                                        return "screen";
                                    case n.overlay:
                                        return "overlay";
                                    case n.darken:
                                        return "darken";
                                    case n.lighten:
                                        return "lighten";
                                    case n.colorDodge:
                                        return "color-dodge";
                                    case n.colorBurn:
                                        return "color-burn";
                                    case n.hardLight:
                                        return "hard-light";
                                    case n.softLight:
                                        return "soft-light";
                                    case n.difference:
                                        return "difference";
                                    case n.exclusion:
                                        return "exclusion";
                                    case n.multiply:
                                        return "multiply";
                                    case n.hue:
                                        return "hue";
                                    case n.saturation:
                                        return "saturation";
                                    case n.color:
                                        return "color";
                                    case n.luminosity:
                                        return "luminosity";
                                }
                            }
                            function b(r) {
                                return "rgba(" + ((16711680 & r) >>> 16) + "," + ((65280 & r) >>> 8) + "," + ((255 & r) >>> 0) + "," + ((4278190080 & r) >>> 24) / 255 + ")";
                            }
                            function c() {
                                0 < L.length && (la.Mb(w.drawWidth(), w.drawHeight(), L, R, W), L = [], W = R = 0, w.reset(512, 512));
                                for (const r of E){
                                    for (const v of r.H)v();
                                    r.H = [];
                                }
                                E.clear();
                            }
                            ma && ma();
                            var d = m.RenderPaintStyle;
                            const e = m.RenderPath, f = m.RenderPaint, g = m.Renderer, k = m.StrokeCap, p = m.StrokeJoin, n = m.BlendMode, t = d.fill, x = d.stroke, y = m.FillRule.evenOdd;
                            let l = 1;
                            var u = m.RenderImage.extend("CanvasRenderImage", {
                                __construct: function({ ka: r, va: v } = {}) {
                                    this.__parent.__construct.call(this);
                                    this.Ia = l;
                                    l = l + 1 & 2147483647 || 1;
                                    this.ka = r;
                                    this.va = v;
                                },
                                __destruct: function() {
                                    this.Ha && (la.Jb(this.Ha), URL.revokeObjectURL(this.Va));
                                    this.__parent.__destruct.call(this);
                                },
                                decode: function(r) {
                                    var v = this;
                                    v.va && v.va(v);
                                    var F = new Image();
                                    v.Va = URL.createObjectURL(new Blob([
                                        r
                                    ], {
                                        type: "image/png"
                                    }));
                                    F.onload = function() {
                                        v.Cb = F;
                                        v.Ha = la.Ib(F);
                                        v.size(F.width, F.height);
                                        v.ka && v.ka(v);
                                    };
                                    F.src = v.Va;
                                }
                            }), q = e.extend("CanvasRenderPath", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.T = new Path2D();
                                },
                                rewind: function() {
                                    this.T = new Path2D();
                                },
                                addPath: function(r, v, F, I, B, G, J) {
                                    var K = this.T, Z = K.addPath;
                                    r = r.T;
                                    const S = new DOMMatrix();
                                    S.a = v;
                                    S.b = F;
                                    S.c = I;
                                    S.d = B;
                                    S.e = G;
                                    S.f = J;
                                    Z.call(K, r, S);
                                },
                                fillRule: function(r) {
                                    this.Ua = r;
                                },
                                moveTo: function(r, v) {
                                    this.T.moveTo(r, v);
                                },
                                lineTo: function(r, v) {
                                    this.T.lineTo(r, v);
                                },
                                cubicTo: function(r, v, F, I, B, G) {
                                    this.T.bezierCurveTo(r, v, F, I, B, G);
                                },
                                close: function() {
                                    this.T.closePath();
                                }
                            }), C = f.extend("CanvasRenderPaint", {
                                color: function(r) {
                                    this.Wa = b(r);
                                },
                                thickness: function(r) {
                                    this.Fb = r;
                                },
                                join: function(r) {
                                    switch(r){
                                        case p.miter:
                                            this.Ga = "miter";
                                            break;
                                        case p.round:
                                            this.Ga = "round";
                                            break;
                                        case p.bevel:
                                            this.Ga = "bevel";
                                    }
                                },
                                cap: function(r) {
                                    switch(r){
                                        case k.butt:
                                            this.Fa = "butt";
                                            break;
                                        case k.round:
                                            this.Fa = "round";
                                            break;
                                        case k.square:
                                            this.Fa = "square";
                                    }
                                },
                                style: function(r) {
                                    this.Eb = r;
                                },
                                blendMode: function(r) {
                                    this.Bb = a(r);
                                },
                                clearGradient: function() {
                                    this.ia = null;
                                },
                                linearGradient: function(r, v, F, I) {
                                    this.ia = {
                                        wb: r,
                                        xb: v,
                                        bb: F,
                                        cb: I,
                                        Pa: []
                                    };
                                },
                                radialGradient: function(r, v, F, I) {
                                    this.ia = {
                                        wb: r,
                                        xb: v,
                                        bb: F,
                                        cb: I,
                                        Pa: [],
                                        $b: !0
                                    };
                                },
                                addStop: function(r, v) {
                                    this.ia.Pa.push({
                                        color: r,
                                        stop: v
                                    });
                                },
                                completeGradient: function() {},
                                draw: function(r, v, F) {
                                    let I = this.Eb;
                                    var B = this.Wa, G = this.ia;
                                    r.globalCompositeOperation = this.Bb;
                                    if (null != G) {
                                        B = G.wb;
                                        var J = G.xb;
                                        const Z = G.bb;
                                        var K = G.cb;
                                        const S = G.Pa;
                                        G.$b ? (G = Z - B, K -= J, B = r.createRadialGradient(B, J, 0, B, J, Math.sqrt(G * G + K * K))) : B = r.createLinearGradient(B, J, Z, K);
                                        for(let Y = 0, T = S.length; Y < T; Y++)J = S[Y], B.addColorStop(J.stop, b(J.color));
                                        this.Wa = B;
                                        this.ia = null;
                                    }
                                    switch(I){
                                        case x:
                                            r.strokeStyle = B;
                                            r.lineWidth = this.Fb;
                                            r.lineCap = this.Fa;
                                            r.lineJoin = this.Ga;
                                            r.stroke(v);
                                            break;
                                        case t:
                                            r.fillStyle = B, r.fill(v, F);
                                    }
                                }
                            });
                            const E = new Set();
                            let w = null, L = [], R = 0, W = 0;
                            var pa = m.CanvasRenderer = g.extend("Renderer", {
                                __construct: function(r) {
                                    this.__parent.__construct.call(this);
                                    this.S = [
                                        1,
                                        0,
                                        0,
                                        1,
                                        0,
                                        0
                                    ];
                                    this.B = r.getContext("2d");
                                    this.Ta = r;
                                    this.H = [];
                                },
                                save: function() {
                                    this.S.push(...this.S.slice(this.S.length - 6));
                                    this.H.push(this.B.save.bind(this.B));
                                },
                                restore: function() {
                                    const r = this.S.length - 6;
                                    if (6 > r) throw "restore() called without matching save().";
                                    this.S.splice(r);
                                    this.H.push(this.B.restore.bind(this.B));
                                },
                                transform: function(r, v, F, I, B, G) {
                                    const J = this.S, K = J.length - 6;
                                    J.splice(K, 6, J[K] * r + J[K + 2] * v, J[K + 1] * r + J[K + 3] * v, J[K] * F + J[K + 2] * I, J[K + 1] * F + J[K + 3] * I, J[K] * B + J[K + 2] * G + J[K + 4], J[K + 1] * B + J[K + 3] * G + J[K + 5]);
                                    this.H.push(this.B.transform.bind(this.B, r, v, F, I, B, G));
                                },
                                rotate: function(r) {
                                    const v = Math.sin(r);
                                    r = Math.cos(r);
                                    this.transform(r, v, -v, r, 0, 0);
                                },
                                _drawPath: function(r, v) {
                                    this.H.push(v.draw.bind(v, this.B, r.T, r.Ua === y ? "evenodd" : "nonzero"));
                                },
                                _drawRiveImage: function(r, v, F, I) {
                                    var B = r.Cb;
                                    if (B) {
                                        var G = this.B, J = a(F);
                                        this.H.push(function() {
                                            G.globalCompositeOperation = J;
                                            G.globalAlpha = I;
                                            G.drawImage(B, 0, 0);
                                            G.globalAlpha = 1;
                                        });
                                    }
                                },
                                _getMatrix: function(r) {
                                    const v = this.S, F = v.length - 6;
                                    for(let I = 0; 6 > I; ++I)r[I] = v[F + I];
                                },
                                _drawImageMesh: function(r, v, F, I, B, G, J, K, Z, S, Y) {
                                    v = this.B.canvas.width;
                                    var T = this.B.canvas.height;
                                    const Wb = S - K, Xb = Y - Z;
                                    K = Math.max(K, 0);
                                    Z = Math.max(Z, 0);
                                    S = Math.min(S, v);
                                    Y = Math.min(Y, T);
                                    const Da = S - K, Ea = Y - Z;
                                    console.assert(Da <= Math.min(Wb, v));
                                    console.assert(Ea <= Math.min(Xb, T));
                                    if (!(0 >= Da || 0 >= Ea)) {
                                        S = Da < Wb || Ea < Xb;
                                        v = Y = 1;
                                        var qa = Math.ceil(Da * Y), ra = Math.ceil(Ea * v);
                                        T = la.ac();
                                        qa > T && (Y *= T / qa, qa = T);
                                        ra > T && (v *= T / ra, ra = T);
                                        w || (w = new m.DynamicRectanizer(T), w.reset(512, 512));
                                        T = w.addRect(qa, ra);
                                        0 > T && (c(), E.add(this), T = w.addRect(qa, ra), console.assert(0 <= T));
                                        var Yb = T & 65535, Zb = T >> 16;
                                        L.push({
                                            ga: this.S.slice(this.S.length - 6),
                                            image: r,
                                            Ya: Yb,
                                            Za: Zb,
                                            bc: K,
                                            cc: Z,
                                            tc: qa,
                                            ib: ra,
                                            za: Y,
                                            Aa: v,
                                            Sa: new Float32Array(B),
                                            Ab: new Float32Array(G),
                                            indices: new Uint16Array(J),
                                            fc: S,
                                            ub: r.Ia << 1 | (S ? 1 : 0)
                                        });
                                        R += B.length;
                                        W += J.length;
                                        var xa = this.B, kd = a(F);
                                        this.H.push(function() {
                                            xa.save();
                                            xa.resetTransform();
                                            xa.globalCompositeOperation = kd;
                                            xa.globalAlpha = I;
                                            const $b = la.canvas();
                                            $b && xa.drawImage($b, Yb, Zb, qa, ra, K, Z, Da, Ea);
                                            xa.restore();
                                        });
                                    }
                                },
                                _clipPath: function(r) {
                                    this.H.push(this.B.clip.bind(this.B, r.T, r.Ua === y ? "evenodd" : "nonzero"));
                                },
                                clear: function() {
                                    E.add(this);
                                    this.H.push(this.B.clearRect.bind(this.B, 0, 0, this.Ta.width, this.Ta.height));
                                },
                                flush: function() {},
                                translate: function(r, v) {
                                    this.transform(1, 0, 0, 1, r, v);
                                }
                            });
                            m.makeRenderer = function(r) {
                                const v = new pa(r), F = v.B;
                                return new Proxy(v, {
                                    get (I, B) {
                                        if ("function" === typeof I[B]) return function(...G) {
                                            return I[B].apply(I, G);
                                        };
                                        if ("function" === typeof F[B]) {
                                            if (-1 < ka.indexOf(B)) throw Error("RiveException: Method call to '" + B + "()' is not allowed, as the renderer cannot immediately pass through the return                 values of any canvas 2d context methods.");
                                            return function(...G) {
                                                v.H.push(F[B].bind(F, ...G));
                                            };
                                        }
                                        return I[B];
                                    },
                                    set (I, B, G) {
                                        if (B in F) return v.H.push(()=>{
                                            F[B] = G;
                                        }), !0;
                                    }
                                });
                            };
                            m.decodeImage = function(r, v) {
                                new u({
                                    ka: v
                                }).decode(r);
                            };
                            m.renderFactory = {
                                makeRenderPaint: function() {
                                    return new C();
                                },
                                makeRenderPath: function() {
                                    return new q();
                                },
                                makeRenderImage: function() {
                                    let r = aa;
                                    return new u({
                                        va: ()=>{
                                            r.total++;
                                        },
                                        ka: ()=>{
                                            r.loaded++;
                                            if (r.loaded === r.total) {
                                                const v = r.ready;
                                                v && (v(), r.ready = null);
                                            }
                                        }
                                    });
                                }
                            };
                            let H = m.load, aa = null;
                            m.load = function(r, v, F = !0) {
                                const I = new m.FallbackFileAssetLoader();
                                void 0 !== v && I.addLoader(v);
                                F && (v = new m.CDNFileAssetLoader(), I.addLoader(v));
                                return new Promise(function(B) {
                                    let G = null;
                                    aa = {
                                        total: 0,
                                        loaded: 0,
                                        ready: function() {
                                            B(G);
                                        }
                                    };
                                    G = H(r, I);
                                    0 == aa.total && B(G);
                                });
                            };
                            let ld = m.RendererWrapper.prototype.align;
                            m.RendererWrapper.prototype.align = function(r, v, F, I, B = 1.0) {
                                ld.call(this, r, v, F, I, B);
                            };
                            d = new ha();
                            m.requestAnimationFrame = d.requestAnimationFrame.bind(d);
                            m.cancelAnimationFrame = d.cancelAnimationFrame.bind(d);
                            m.enableFPSCounter = d.Nb.bind(d);
                            m.disableFPSCounter = d.Kb;
                            d.nb = c;
                            m.resolveAnimationFrame = c;
                            m.cleanup = function() {
                                w && w.delete();
                            };
                        };
                        var na = Object.assign({}, m), oa = "./this.program", sa = "", ta, ua;
                        if (ea || fa) fa ? sa = self.location.href : "undefined" != typeof document && document.currentScript && (sa = document.currentScript.src), _scriptName && (sa = _scriptName), sa.startsWith("blob:") ? sa = "" : sa = sa.substr(0, sa.replace(/[?#].*/, "").lastIndexOf("/") + 1), fa && (ua = (a)=>{
                            var b = new XMLHttpRequest();
                            b.open("GET", a, !1);
                            b.responseType = "arraybuffer";
                            b.send(null);
                            return new Uint8Array(b.response);
                        }), ta = (a, b, c)=>{
                            if (va(a)) {
                                var d = new XMLHttpRequest();
                                d.open("GET", a, !0);
                                d.responseType = "arraybuffer";
                                d.onload = ()=>{
                                    200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
                                };
                                d.onerror = c;
                                d.send(null);
                            } else fetch(a, {
                                credentials: "same-origin"
                            }).then((e)=>e.ok ? e.arrayBuffer() : Promise.reject(Error(e.status + " : " + e.url))).then(b, c);
                        };
                        var wa = m.print || console.log.bind(console), ya = m.printErr || console.error.bind(console);
                        Object.assign(m, na);
                        na = null;
                        m.thisProgram && (oa = m.thisProgram);
                        var za;
                        m.wasmBinary && (za = m.wasmBinary);
                        var Aa, Ba = !1, z, A, Ca, Fa, D, M, Ga, Ha;
                        function Ia() {
                            var a = Aa.buffer;
                            m.HEAP8 = z = new Int8Array(a);
                            m.HEAP16 = Ca = new Int16Array(a);
                            m.HEAPU8 = A = new Uint8Array(a);
                            m.HEAPU16 = Fa = new Uint16Array(a);
                            m.HEAP32 = D = new Int32Array(a);
                            m.HEAPU32 = M = new Uint32Array(a);
                            m.HEAPF32 = Ga = new Float32Array(a);
                            m.HEAPF64 = Ha = new Float64Array(a);
                        }
                        var Ja = [], Ka = [], La = [];
                        function Ma() {
                            var a = m.preRun.shift();
                            Ja.unshift(a);
                        }
                        var Na = 0, Oa = null, Pa = null;
                        function Qa(a) {
                            m.onAbort?.(a);
                            a = "Aborted(" + a + ")";
                            ya(a);
                            Ba = !0;
                            a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
                            ca(a);
                            throw a;
                        }
                        var Ra = (a)=>a.startsWith("data:application/octet-stream;base64,"), va = (a)=>a.startsWith("file://"), Sa;
                        function Ta(a) {
                            if (a == Sa && za) return new Uint8Array(za);
                            if (ua) return ua(a);
                            throw "both async and sync fetching of the wasm failed";
                        }
                        function Ua(a) {
                            return za ? Promise.resolve().then(()=>Ta(a)) : new Promise((b, c)=>{
                                ta(a, (d)=>b(new Uint8Array(d)), ()=>{
                                    try {
                                        b(Ta(a));
                                    } catch (d) {
                                        c(d);
                                    }
                                });
                            });
                        }
                        function Va(a, b, c) {
                            return Ua(a).then((d)=>WebAssembly.instantiate(d, b)).then(c, (d)=>{
                                ya(`failed to asynchronously prepare wasm: ${d}`);
                                Qa(d);
                            });
                        }
                        function Wa(a, b) {
                            var c = Sa;
                            return za || "function" != typeof WebAssembly.instantiateStreaming || Ra(c) || va(c) || "function" != typeof fetch ? Va(c, a, b) : fetch(c, {
                                credentials: "same-origin"
                            }).then((d)=>WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
                                    ya(`wasm streaming compile failed: ${e}`);
                                    ya("falling back to ArrayBuffer instantiation");
                                    return Va(c, a, b);
                                }));
                        }
                        var Xa, Ya, bb = {
                            464256: (a, b, c, d, e)=>{
                                if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) return 0;
                                if ("undefined" === typeof window.h) {
                                    window.h = {
                                        ya: 0
                                    };
                                    window.h.I = {};
                                    window.h.I.wa = a;
                                    window.h.I.capture = b;
                                    window.h.I.Ja = c;
                                    window.h.fa = {};
                                    window.h.fa.stopped = d;
                                    window.h.fa.vb = e;
                                    let f = window.h;
                                    f.D = [];
                                    f.rc = function(g) {
                                        for(var k = 0; k < f.D.length; ++k){
                                            if (null == f.D[k]) return f.D[k] = g, k;
                                        }
                                        f.D.push(g);
                                        return f.D.length - 1;
                                    };
                                    f.zb = function(g) {
                                        for(f.D[g] = null; 0 < f.D.length;){
                                            if (null == f.D[f.D.length - 1]) f.D.pop();
                                            else break;
                                        }
                                    };
                                    f.Oc = function(g) {
                                        for(var k = 0; k < f.D.length; ++k){
                                            if (f.D[k] == g) return f.zb(k);
                                        }
                                    };
                                    f.pa = function(g) {
                                        return f.D[g];
                                    };
                                    f.Ra = [
                                        "touchend",
                                        "click"
                                    ];
                                    f.unlock = function() {
                                        for(var g = 0; g < f.D.length; ++g){
                                            var k = f.D[g];
                                            null != k && null != k.K && k.state === f.fa.vb && k.K.resume().then(()=>{
                                                Za(k.ob);
                                            }, (p)=>{
                                                console.error("Failed to resume audiocontext", p);
                                            });
                                        }
                                        f.Ra.map(function(p) {
                                            document.removeEventListener(p, f.unlock, !0);
                                        });
                                    };
                                    f.Ra.map(function(g) {
                                        document.addEventListener(g, f.unlock, !0);
                                    });
                                }
                                window.h.ya += 1;
                                return 1;
                            },
                            466434: ()=>{
                                "undefined" !== typeof window.h && (window.h.Ra.map(function(a) {
                                    document.removeEventListener(a, window.h.unlock, !0);
                                }), --window.h.ya, 0 === window.h.ya && delete window.h);
                            },
                            466738: ()=>void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia,
                            466842: ()=>{
                                try {
                                    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
                                    a.close();
                                    return b;
                                } catch (c) {
                                    return 0;
                                }
                            },
                            467013: (a, b, c, d, e, f)=>{
                                if ("undefined" === typeof window.h) return -1;
                                var g = {}, k = {};
                                a == window.h.I.wa && 0 != c && (k.sampleRate = c);
                                g.K = new (window.AudioContext || window.webkitAudioContext)(k);
                                g.K.suspend();
                                g.state = window.h.fa.stopped;
                                c = 0;
                                a != window.h.I.wa && (c = b);
                                g.Y = g.K.createScriptProcessor(d, c, b);
                                g.Y.onaudioprocess = function(p) {
                                    if (null == g.qa || 0 == g.qa.length) g.qa = new Float32Array(Ga.buffer, e, d * b);
                                    if (a == window.h.I.capture || a == window.h.I.Ja) {
                                        for(var n = 0; n < b; n += 1)for(var t = p.inputBuffer.getChannelData(n), x = g.qa, y = 0; y < d; y += 1)x[y * b + n] = t[y];
                                        $a(f, d, e);
                                    }
                                    if (a == window.h.I.wa || a == window.h.I.Ja) {
                                        for(ab(f, d, e), n = 0; n < p.outputBuffer.numberOfChannels; ++n)for(t = p.outputBuffer.getChannelData(n), x = g.qa, y = 0; y < d; y += 1)t[y] = x[y * b + n];
                                    } else for(n = 0; n < p.outputBuffer.numberOfChannels; ++n)p.outputBuffer.getChannelData(n).fill(0.0);
                                };
                                a != window.h.I.capture && a != window.h.I.Ja || navigator.mediaDevices.getUserMedia({
                                    audio: !0,
                                    video: !1
                                }).then(function(p) {
                                    g.Ba = g.K.createMediaStreamSource(p);
                                    g.Ba.connect(g.Y);
                                    g.Y.connect(g.K.destination);
                                }).catch(function(p) {
                                    console.log("Failed to get user media: " + p);
                                });
                                a == window.h.I.wa && g.Y.connect(g.K.destination);
                                g.ob = f;
                                return window.h.rc(g);
                            },
                            469890: (a)=>window.h.pa(a).K.sampleRate,
                            469963: (a)=>{
                                a = window.h.pa(a);
                                void 0 !== a.Y && (a.Y.onaudioprocess = function() {}, a.Y.disconnect(), a.Y = void 0);
                                void 0 !== a.Ba && (a.Ba.disconnect(), a.Ba = void 0);
                                a.K.close();
                                a.K = void 0;
                                a.ob = void 0;
                            },
                            470363: (a)=>{
                                window.h.zb(a);
                            },
                            470413: (a)=>{
                                a = window.h.pa(a);
                                a.K.resume();
                                a.state = window.h.fa.vb;
                            },
                            470552: (a)=>{
                                a = window.h.pa(a);
                                a.K.suspend();
                                a.state = window.h.fa.stopped;
                            }
                        }, cb = (a)=>{
                            for(; 0 < a.length;)a.shift()(m);
                        };
                        function db() {
                            var a = D[+eb >> 2];
                            eb += 4;
                            return a;
                        }
                        var fb = (a, b)=>{
                            for(var c = 0, d = a.length - 1; 0 <= d; d--){
                                var e = a[d];
                                "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
                            }
                            if (b) for(; c; c--)a.unshift("..");
                            return a;
                        }, gb = (a)=>{
                            var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
                            (a = fb(a.split("/").filter((d)=>!!d), !b).join("/")) || b || (a = ".");
                            a && c && (a += "/");
                            return (b ? "/" : "") + a;
                        }, hb = (a)=>{
                            var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
                            a = b[0];
                            b = b[1];
                            if (!a && !b) return ".";
                            b &&= b.substr(0, b.length - 1);
                            return a + b;
                        }, ib = (a)=>{
                            if ("/" === a) return "/";
                            a = gb(a);
                            a = a.replace(/\/$/, "");
                            var b = a.lastIndexOf("/");
                            return -1 === b ? a : a.substr(b + 1);
                        }, jb = ()=>{
                            if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) return (a)=>crypto.getRandomValues(a);
                            Qa("initRandomDevice");
                        }, kb = (a)=>(kb = jb())(a), lb = (...a)=>{
                            for(var b = "", c = !1, d = a.length - 1; -1 <= d && !c; d--){
                                c = 0 <= d ? a[d] : "/";
                                if ("string" != typeof c) throw new TypeError("Arguments to path.resolve must be strings");
                                if (!c) return "";
                                b = c + "/" + b;
                                c = "/" === c.charAt(0);
                            }
                            b = fb(b.split("/").filter((e)=>!!e), !c).join("/");
                            return (c ? "/" : "") + b || ".";
                        }, mb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, nb = (a, b, c)=>{
                            var d = b + c;
                            for(c = b; a[c] && !(c >= d);)++c;
                            if (16 < c - b && a.buffer && mb) return mb.decode(a.subarray(b, c));
                            for(d = ""; b < c;){
                                var e = a[b++];
                                if (e & 128) {
                                    var f = a[b++] & 63;
                                    if (192 == (e & 224)) d += String.fromCharCode((e & 31) << 6 | f);
                                    else {
                                        var g = a[b++] & 63;
                                        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
                                        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
                                    }
                                } else d += String.fromCharCode(e);
                            }
                            return d;
                        }, ob = [], pb = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
                            }
                            return b;
                        }, qb = (a, b, c, d)=>{
                            if (!(0 < d)) return 0;
                            var e = c;
                            d = c + d - 1;
                            for(var f = 0; f < a.length; ++f){
                                var g = a.charCodeAt(f);
                                if (55296 <= g && 57343 >= g) {
                                    var k = a.charCodeAt(++f);
                                    g = 65536 + ((g & 1023) << 10) | k & 1023;
                                }
                                if (127 >= g) {
                                    if (c >= d) break;
                                    b[c++] = g;
                                } else {
                                    if (2047 >= g) {
                                        if (c + 1 >= d) break;
                                        b[c++] = 192 | g >> 6;
                                    } else {
                                        if (65535 >= g) {
                                            if (c + 2 >= d) break;
                                            b[c++] = 224 | g >> 12;
                                        } else {
                                            if (c + 3 >= d) break;
                                            b[c++] = 240 | g >> 18;
                                            b[c++] = 128 | g >> 12 & 63;
                                        }
                                        b[c++] = 128 | g >> 6 & 63;
                                    }
                                    b[c++] = 128 | g & 63;
                                }
                            }
                            b[c] = 0;
                            return c - e;
                        };
                        function rb(a, b) {
                            var c = Array(pb(a) + 1);
                            a = qb(a, c, 0, c.length);
                            b && (c.length = a);
                            return c;
                        }
                        var sb = [];
                        function tb(a, b) {
                            sb[a] = {
                                input: [],
                                G: [],
                                V: b
                            };
                            ub(a, vb);
                        }
                        var vb = {
                            open (a) {
                                var b = sb[a.node.xa];
                                if (!b) throw new N(43);
                                a.s = b;
                                a.seekable = !1;
                            },
                            close (a) {
                                a.s.V.oa(a.s);
                            },
                            oa (a) {
                                a.s.V.oa(a.s);
                            },
                            read (a, b, c, d) {
                                if (!a.s || !a.s.V.hb) throw new N(60);
                                for(var e = 0, f = 0; f < d; f++){
                                    try {
                                        var g = a.s.V.hb(a.s);
                                    } catch (k) {
                                        throw new N(29);
                                    }
                                    if (void 0 === g && 0 === e) throw new N(6);
                                    if (null === g || void 0 === g) break;
                                    e++;
                                    b[c + f] = g;
                                }
                                e && (a.node.timestamp = Date.now());
                                return e;
                            },
                            write (a, b, c, d) {
                                if (!a.s || !a.s.V.Ma) throw new N(60);
                                try {
                                    for(var e = 0; e < d; e++)a.s.V.Ma(a.s, b[c + e]);
                                } catch (f) {
                                    throw new N(29);
                                }
                                d && (a.node.timestamp = Date.now());
                                return e;
                            }
                        }, wb = {
                            hb () {
                                a: {
                                    if (!ob.length) {
                                        var a = null;
                                        "undefined" != typeof window && "function" == typeof window.prompt && (a = window.prompt("Input: "), null !== a && (a += "\n"));
                                        if (!a) {
                                            a = null;
                                            break a;
                                        }
                                        ob = rb(a, !0);
                                    }
                                    a = ob.shift();
                                }
                                return a;
                            },
                            Ma (a, b) {
                                null === b || 10 === b ? (wa(nb(a.G, 0)), a.G = []) : 0 != b && a.G.push(b);
                            },
                            oa (a) {
                                a.G && 0 < a.G.length && (wa(nb(a.G, 0)), a.G = []);
                            },
                            Xb () {
                                return {
                                    zc: 25856,
                                    Bc: 5,
                                    yc: 191,
                                    Ac: 35387,
                                    xc: [
                                        3,
                                        28,
                                        127,
                                        21,
                                        4,
                                        0,
                                        1,
                                        0,
                                        17,
                                        19,
                                        26,
                                        0,
                                        18,
                                        15,
                                        23,
                                        22,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ]
                                };
                            },
                            Yb () {
                                return 0;
                            },
                            Zb () {
                                return [
                                    24,
                                    80
                                ];
                            }
                        }, xb = {
                            Ma (a, b) {
                                null === b || 10 === b ? (ya(nb(a.G, 0)), a.G = []) : 0 != b && a.G.push(b);
                            },
                            oa (a) {
                                a.G && 0 < a.G.length && (ya(nb(a.G, 0)), a.G = []);
                            }
                        };
                        function yb(a, b) {
                            var c = a.l ? a.l.length : 0;
                            c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.l, a.l = new Uint8Array(b), 0 < a.v && a.l.set(c.subarray(0, a.v), 0));
                        }
                        var O = {
                            N: null,
                            U () {
                                return O.createNode(null, "/", 16895, 0);
                            },
                            createNode (a, b, c, d) {
                                if (24576 === (c & 61440) || 4096 === (c & 61440)) throw new N(63);
                                O.N || (O.N = {
                                    dir: {
                                        node: {
                                            X: O.j.X,
                                            P: O.j.P,
                                            ja: O.j.ja,
                                            ta: O.j.ta,
                                            sb: O.j.sb,
                                            yb: O.j.yb,
                                            tb: O.j.tb,
                                            rb: O.j.rb,
                                            Ca: O.j.Ca
                                        },
                                        stream: {
                                            aa: O.m.aa
                                        }
                                    },
                                    file: {
                                        node: {
                                            X: O.j.X,
                                            P: O.j.P
                                        },
                                        stream: {
                                            aa: O.m.aa,
                                            read: O.m.read,
                                            write: O.m.write,
                                            Xa: O.m.Xa,
                                            kb: O.m.kb,
                                            mb: O.m.mb
                                        }
                                    },
                                    link: {
                                        node: {
                                            X: O.j.X,
                                            P: O.j.P,
                                            la: O.j.la
                                        },
                                        stream: {}
                                    },
                                    $a: {
                                        node: {
                                            X: O.j.X,
                                            P: O.j.P
                                        },
                                        stream: zb
                                    }
                                });
                                c = Ab(a, b, c, d);
                                16384 === (c.mode & 61440) ? (c.j = O.N.dir.node, c.m = O.N.dir.stream, c.l = {}) : 32768 === (c.mode & 61440) ? (c.j = O.N.file.node, c.m = O.N.file.stream, c.v = 0, c.l = null) : 40960 === (c.mode & 61440) ? (c.j = O.N.link.node, c.m = O.N.link.stream) : 8192 === (c.mode & 61440) && (c.j = O.N.$a.node, c.m = O.N.$a.stream);
                                c.timestamp = Date.now();
                                a && (a.l[b] = c, a.timestamp = c.timestamp);
                                return c;
                            },
                            Fc (a) {
                                return a.l ? a.l.subarray ? a.l.subarray(0, a.v) : new Uint8Array(a.l) : new Uint8Array(0);
                            },
                            j: {
                                X (a) {
                                    var b = {};
                                    b.Dc = 8192 === (a.mode & 61440) ? a.id : 1;
                                    b.Hc = a.id;
                                    b.mode = a.mode;
                                    b.Kc = 1;
                                    b.uid = 0;
                                    b.Gc = 0;
                                    b.xa = a.xa;
                                    16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
                                    b.vc = new Date(a.timestamp);
                                    b.Jc = new Date(a.timestamp);
                                    b.Cc = new Date(a.timestamp);
                                    b.Gb = 4096;
                                    b.wc = Math.ceil(b.size / b.Gb);
                                    return b;
                                },
                                P (a, b) {
                                    void 0 !== b.mode && (a.mode = b.mode);
                                    void 0 !== b.timestamp && (a.timestamp = b.timestamp);
                                    if (void 0 !== b.size && (b = b.size, a.v != b)) {
                                        if (0 == b) a.l = null, a.v = 0;
                                        else {
                                            var c = a.l;
                                            a.l = new Uint8Array(b);
                                            c && a.l.set(c.subarray(0, Math.min(b, a.v)));
                                            a.v = b;
                                        }
                                    }
                                },
                                ja () {
                                    throw Bb[44];
                                },
                                ta (a, b, c, d) {
                                    return O.createNode(a, b, c, d);
                                },
                                sb (a, b, c) {
                                    if (16384 === (a.mode & 61440)) {
                                        try {
                                            var d = Cb(b, c);
                                        } catch (f) {}
                                        if (d) {
                                            for(var e in d.l)throw new N(55);
                                        }
                                    }
                                    delete a.parent.l[a.name];
                                    a.parent.timestamp = Date.now();
                                    a.name = c;
                                    b.l[c] = a;
                                    b.timestamp = a.parent.timestamp;
                                },
                                yb (a, b) {
                                    delete a.l[b];
                                    a.timestamp = Date.now();
                                },
                                tb (a, b) {
                                    var c = Cb(a, b), d;
                                    for(d in c.l)throw new N(55);
                                    delete a.l[b];
                                    a.timestamp = Date.now();
                                },
                                rb (a) {
                                    var b = [
                                        ".",
                                        ".."
                                    ], c;
                                    for (c of Object.keys(a.l))b.push(c);
                                    return b;
                                },
                                Ca (a, b, c) {
                                    a = O.createNode(a, b, 41471, 0);
                                    a.link = c;
                                    return a;
                                },
                                la (a) {
                                    if (40960 !== (a.mode & 61440)) throw new N(28);
                                    return a.link;
                                }
                            },
                            m: {
                                read (a, b, c, d, e) {
                                    var f = a.node.l;
                                    if (e >= a.node.v) return 0;
                                    a = Math.min(a.node.v - e, d);
                                    if (8 < a && f.subarray) b.set(f.subarray(e, e + a), c);
                                    else for(d = 0; d < a; d++)b[c + d] = f[e + d];
                                    return a;
                                },
                                write (a, b, c, d, e, f) {
                                    b.buffer === z.buffer && (f = !1);
                                    if (!d) return 0;
                                    a = a.node;
                                    a.timestamp = Date.now();
                                    if (b.subarray && (!a.l || a.l.subarray)) {
                                        if (f) return a.l = b.subarray(c, c + d), a.v = d;
                                        if (0 === a.v && 0 === e) return a.l = b.slice(c, c + d), a.v = d;
                                        if (e + d <= a.v) return a.l.set(b.subarray(c, c + d), e), d;
                                    }
                                    yb(a, e + d);
                                    if (a.l.subarray && b.subarray) a.l.set(b.subarray(c, c + d), e);
                                    else for(f = 0; f < d; f++)a.l[e + f] = b[c + f];
                                    a.v = Math.max(a.v, e + d);
                                    return d;
                                },
                                aa (a, b, c) {
                                    1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
                                    if (0 > b) throw new N(28);
                                    return b;
                                },
                                Xa (a, b, c) {
                                    yb(a.node, b + c);
                                    a.node.v = Math.max(a.node.v, b + c);
                                },
                                kb (a, b, c, d, e) {
                                    if (32768 !== (a.node.mode & 61440)) throw new N(43);
                                    a = a.node.l;
                                    if (e & 2 || a.buffer !== z.buffer) {
                                        if (0 < c || c + b < a.length) a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
                                        c = !0;
                                        Qa();
                                        b = void 0;
                                        if (!b) throw new N(48);
                                        z.set(a, b);
                                    } else c = !1, b = a.byteOffset;
                                    return {
                                        o: b,
                                        uc: c
                                    };
                                },
                                mb (a, b, c, d) {
                                    O.m.write(a, b, 0, d, c, !1);
                                    return 0;
                                }
                            }
                        }, Db = (a, b)=>{
                            var c = 0;
                            a && (c |= 365);
                            b && (c |= 146);
                            return c;
                        }, Eb = null, Fb = {}, Gb = [], Hb = 1, Ib = null, Jb = !0, N = class {
                            constructor(a){
                                this.name = "ErrnoError";
                                this.$ = a;
                            }
                        }, Bb = {}, Kb = class {
                            constructor(){
                                this.h = {};
                                this.node = null;
                            }
                            get flags() {
                                return this.h.flags;
                            }
                            set flags(a) {
                                this.h.flags = a;
                            }
                            get position() {
                                return this.h.position;
                            }
                            set position(a) {
                                this.h.position = a;
                            }
                        }, Lb = class {
                            constructor(a, b, c, d){
                                a ||= this;
                                this.parent = a;
                                this.U = a.U;
                                this.ua = null;
                                this.id = Hb++;
                                this.name = b;
                                this.mode = c;
                                this.j = {};
                                this.m = {};
                                this.xa = d;
                            }
                            get read() {
                                return 365 === (this.mode & 365);
                            }
                            set read(a) {
                                a ? this.mode |= 365 : this.mode &= -366;
                            }
                            get write() {
                                return 146 === (this.mode & 146);
                            }
                            set write(a) {
                                a ? this.mode |= 146 : this.mode &= -147;
                            }
                        };
                        function Mb(a, b = {}) {
                            a = lb(a);
                            if (!a) return {
                                path: "",
                                node: null
                            };
                            b = Object.assign({
                                gb: !0,
                                Oa: 0
                            }, b);
                            if (8 < b.Oa) throw new N(32);
                            a = a.split("/").filter((g)=>!!g);
                            for(var c = Eb, d = "/", e = 0; e < a.length; e++){
                                var f = e === a.length - 1;
                                if (f && b.parent) break;
                                c = Cb(c, a[e]);
                                d = gb(d + "/" + a[e]);
                                c.ua && (!f || f && b.gb) && (c = c.ua.root);
                                if (!f || b.fb) for(f = 0; 40960 === (c.mode & 61440);){
                                    if (c = Nb(d), d = lb(hb(d), c), c = Mb(d, {
                                        Oa: b.Oa + 1
                                    }).node, 40 < f++) throw new N(32);
                                }
                            }
                            return {
                                path: d,
                                node: c
                            };
                        }
                        function Ob(a) {
                            for(var b;;){
                                if (a === a.parent) return a = a.U.lb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
                                b = b ? `${a.name}/${b}` : a.name;
                                a = a.parent;
                            }
                        }
                        function Pb(a, b) {
                            for(var c = 0, d = 0; d < b.length; d++)c = (c << 5) - c + b.charCodeAt(d) | 0;
                            return (a + c >>> 0) % Ib.length;
                        }
                        function Cb(a, b) {
                            var c = 16384 === (a.mode & 61440) ? (c = Qb(a, "x")) ? c : a.j.ja ? 0 : 2 : 54;
                            if (c) throw new N(c);
                            for(c = Ib[Pb(a.id, b)]; c; c = c.ec){
                                var d = c.name;
                                if (c.parent.id === a.id && d === b) return c;
                            }
                            return a.j.ja(a, b);
                        }
                        function Ab(a, b, c, d) {
                            a = new Lb(a, b, c, d);
                            b = Pb(a.parent.id, a.name);
                            a.ec = Ib[b];
                            return Ib[b] = a;
                        }
                        function Rb(a) {
                            var b = [
                                "r",
                                "w",
                                "rw"
                            ][a & 3];
                            a & 512 && (b += "w");
                            return b;
                        }
                        function Qb(a, b) {
                            if (Jb) return 0;
                            if (!b.includes("r") || a.mode & 292) {
                                if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) return 2;
                            } else return 2;
                            return 0;
                        }
                        function Sb(a, b) {
                            try {
                                return Cb(a, b), 20;
                            } catch (c) {}
                            return Qb(a, "wx");
                        }
                        function Tb(a) {
                            a = Gb[a];
                            if (!a) throw new N(8);
                            return a;
                        }
                        function Ub(a, b = -1) {
                            a = Object.assign(new Kb(), a);
                            if (-1 == b) a: {
                                for(b = 0; 4096 >= b; b++){
                                    if (!Gb[b]) break a;
                                }
                                throw new N(33);
                            }
                            a.W = b;
                            return Gb[b] = a;
                        }
                        function Vb(a, b = -1) {
                            a = Ub(a, b);
                            a.m?.Ec?.(a);
                            return a;
                        }
                        var zb = {
                            open (a) {
                                a.m = Fb[a.node.xa].m;
                                a.m.open?.(a);
                            },
                            aa () {
                                throw new N(70);
                            }
                        };
                        function ub(a, b) {
                            Fb[a] = {
                                m: b
                            };
                        }
                        function ac(a, b) {
                            var c = "/" === b;
                            if (c && Eb) throw new N(10);
                            if (!c && b) {
                                var d = Mb(b, {
                                    gb: !1
                                });
                                b = d.path;
                                d = d.node;
                                if (d.ua) throw new N(10);
                                if (16384 !== (d.mode & 61440)) throw new N(54);
                            }
                            b = {
                                type: a,
                                Mc: {},
                                lb: b,
                                dc: []
                            };
                            a = a.U(b);
                            a.U = b;
                            b.root = a;
                            c ? Eb = a : d && (d.ua = b, d.U && d.U.dc.push(b));
                        }
                        function bc(a, b, c) {
                            var d = Mb(a, {
                                parent: !0
                            }).node;
                            a = ib(a);
                            if (!a || "." === a || ".." === a) throw new N(28);
                            var e = Sb(d, a);
                            if (e) throw new N(e);
                            if (!d.j.ta) throw new N(63);
                            return d.j.ta(d, a, b, c);
                        }
                        function cc(a) {
                            return bc(a, 16895, 0);
                        }
                        function dc(a, b, c) {
                            "undefined" == typeof c && (c = b, b = 438);
                            bc(a, b | 8192, c);
                        }
                        function ec(a, b) {
                            if (!lb(a)) throw new N(44);
                            var c = Mb(b, {
                                parent: !0
                            }).node;
                            if (!c) throw new N(44);
                            b = ib(b);
                            var d = Sb(c, b);
                            if (d) throw new N(d);
                            if (!c.j.Ca) throw new N(63);
                            c.j.Ca(c, b, a);
                        }
                        function Nb(a) {
                            a = Mb(a).node;
                            if (!a) throw new N(44);
                            if (!a.j.la) throw new N(28);
                            return lb(Ob(a.parent), a.j.la(a));
                        }
                        function fc(a, b, c) {
                            if ("" === a) throw new N(44);
                            if ("string" == typeof b) {
                                var d = {
                                    r: 0,
                                    "r+": 2,
                                    w: 577,
                                    "w+": 578,
                                    a: 1089,
                                    "a+": 1090
                                }[b];
                                if ("undefined" == typeof d) throw Error(`Unknown file open mode: ${b}`);
                                b = d;
                            }
                            c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
                            if ("object" == typeof a) var e = a;
                            else {
                                a = gb(a);
                                try {
                                    e = Mb(a, {
                                        fb: !(b & 131072)
                                    }).node;
                                } catch (f) {}
                            }
                            d = !1;
                            if (b & 64) {
                                if (e) {
                                    if (b & 128) throw new N(20);
                                } else e = bc(a, c, 0), d = !0;
                            }
                            if (!e) throw new N(44);
                            8192 === (e.mode & 61440) && (b &= -513);
                            if (b & 65536 && 16384 !== (e.mode & 61440)) throw new N(54);
                            if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Rb(b) || b & 512) ? 31 : Qb(e, Rb(b)) : 44)) throw new N(c);
                            if (b & 512 && !d) {
                                c = e;
                                c = "string" == typeof c ? Mb(c, {
                                    fb: !0
                                }).node : c;
                                if (!c.j.P) throw new N(63);
                                if (16384 === (c.mode & 61440)) throw new N(31);
                                if (32768 !== (c.mode & 61440)) throw new N(28);
                                if (d = Qb(c, "w")) throw new N(d);
                                c.j.P(c, {
                                    size: 0,
                                    timestamp: Date.now()
                                });
                            }
                            b &= -131713;
                            e = Ub({
                                node: e,
                                path: Ob(e),
                                flags: b,
                                seekable: !0,
                                position: 0,
                                m: e.m,
                                sc: [],
                                error: !1
                            });
                            e.m.open && e.m.open(e);
                            !m.logReadFiles || b & 1 || (gc ||= {}, a in gc || (gc[a] = 1));
                            return e;
                        }
                        function hc(a, b, c) {
                            if (null === a.W) throw new N(8);
                            if (!a.seekable || !a.m.aa) throw new N(70);
                            if (0 != c && 1 != c && 2 != c) throw new N(28);
                            a.position = a.m.aa(a, b, c);
                            a.sc = [];
                        }
                        var ic;
                        function jc(a, b, c) {
                            a = gb("/dev/" + a);
                            var d = Db(!!b, !!c);
                            kc ||= 64;
                            var e = kc++ << 8 | 0;
                            ub(e, {
                                open (f) {
                                    f.seekable = !1;
                                },
                                close () {
                                    c?.buffer?.length && c(10);
                                },
                                read (f, g, k, p) {
                                    for(var n = 0, t = 0; t < p; t++){
                                        try {
                                            var x = b();
                                        } catch (y) {
                                            throw new N(29);
                                        }
                                        if (void 0 === x && 0 === n) throw new N(6);
                                        if (null === x || void 0 === x) break;
                                        n++;
                                        g[k + t] = x;
                                    }
                                    n && (f.node.timestamp = Date.now());
                                    return n;
                                },
                                write (f, g, k, p) {
                                    for(var n = 0; n < p; n++)try {
                                        c(g[k + n]);
                                    } catch (t) {
                                        throw new N(29);
                                    }
                                    p && (f.node.timestamp = Date.now());
                                    return n;
                                }
                            });
                            dc(a, d, e);
                        }
                        var kc, lc = {}, gc, eb = void 0, mc = (a, b)=>Object.defineProperty(b, "name", {
                                value: a
                            }), nc = [], oc = [], P, pc = (a)=>{
                            if (!a) throw new P("Cannot use deleted val. handle = " + a);
                            return oc[a];
                        }, qc = (a)=>{
                            switch(a){
                                case void 0:
                                    return 2;
                                case null:
                                    return 4;
                                case !0:
                                    return 6;
                                case !1:
                                    return 8;
                                default:
                                    const b = nc.pop() || oc.length;
                                    oc[b] = a;
                                    oc[b + 1] = 1;
                                    return b;
                            }
                        }, rc = (a)=>{
                            var b = Error, c = mc(a, function(d) {
                                this.name = a;
                                this.message = d;
                                d = Error(d).stack;
                                void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
                            });
                            c.prototype = Object.create(b.prototype);
                            c.prototype.constructor = c;
                            c.prototype.toString = function() {
                                return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
                            };
                            return c;
                        }, sc, tc, Q = (a)=>{
                            for(var b = ""; A[a];)b += tc[A[a++]];
                            return b;
                        }, uc = [], vc = ()=>{
                            for(; uc.length;){
                                var a = uc.pop();
                                a.g.ea = !1;
                                a["delete"]();
                            }
                        }, wc, xc = {}, yc = (a, b)=>{
                            if (void 0 === b) throw new P("ptr should not be undefined");
                            for(; a.C;)b = a.ma(b), a = a.C;
                            return b;
                        }, zc = {}, Cc = (a)=>{
                            a = Ac(a);
                            var b = Q(a);
                            Bc(a);
                            return b;
                        }, Dc = (a, b)=>{
                            var c = zc[a];
                            if (void 0 === c) throw a = `${b} has unknown type ${Cc(a)}`, new P(a);
                            return c;
                        }, Ec = ()=>{}, Fc = !1, Gc = (a, b, c)=>{
                            if (b === c) return a;
                            if (void 0 === c.C) return null;
                            a = Gc(a, b, c.C);
                            return null === a ? null : c.Lb(a);
                        }, Hc = {}, Ic = (a, b)=>{
                            b = yc(a, b);
                            return xc[b];
                        }, Jc, Lc = (a, b)=>{
                            if (!b.u || !b.o) throw new Jc("makeClassHandle requires ptr and ptrType");
                            if (!!b.J !== !!b.F) throw new Jc("Both smartPtrType and smartPtr must be specified");
                            b.count = {
                                value: 1
                            };
                            return Kc(Object.create(a, {
                                g: {
                                    value: b,
                                    writable: !0
                                }
                            }));
                        }, Kc = (a)=>{
                            if ("undefined" === typeof FinalizationRegistry) return Kc = (b)=>b, a;
                            Fc = new FinalizationRegistry((b)=>{
                                b = b.g;
                                --b.count.value;
                                0 === b.count.value && (b.F ? b.J.O(b.F) : b.u.i.O(b.o));
                            });
                            Kc = (b)=>{
                                var c = b.g;
                                c.F && Fc.register(b, {
                                    g: c
                                }, b);
                                return b;
                            };
                            Ec = (b)=>{
                                Fc.unregister(b);
                            };
                            return Kc(a);
                        }, Mc = {}, Nc = (a)=>{
                            for(; a.length;){
                                var b = a.pop();
                                a.pop()(b);
                            }
                        };
                        function Oc(a) {
                            return this.fromWireType(M[a >> 2]);
                        }
                        var Pc = {}, Qc = {}, U = (a, b, c)=>{
                            function d(k) {
                                k = c(k);
                                if (k.length !== a.length) throw new Jc("Mismatched type converter count");
                                for(var p = 0; p < a.length; ++p)Rc(a[p], k[p]);
                            }
                            a.forEach(function(k) {
                                Qc[k] = b;
                            });
                            var e = Array(b.length), f = [], g = 0;
                            b.forEach((k, p)=>{
                                zc.hasOwnProperty(k) ? e[p] = zc[k] : (f.push(k), Pc.hasOwnProperty(k) || (Pc[k] = []), Pc[k].push(()=>{
                                    e[p] = zc[k];
                                    ++g;
                                    g === f.length && d(e);
                                }));
                            });
                            0 === f.length && d(e);
                        };
                        function Sc(a, b, c = {}) {
                            var d = b.name;
                            if (!a) throw new P(`type "${d}" must have a positive integer typeid pointer`);
                            if (zc.hasOwnProperty(a)) {
                                if (c.Vb) return;
                                throw new P(`Cannot register type '${d}' twice`);
                            }
                            zc[a] = b;
                            delete Qc[a];
                            Pc.hasOwnProperty(a) && (b = Pc[a], delete Pc[a], b.forEach((e)=>e()));
                        }
                        function Rc(a, b, c = {}) {
                            if (!("argPackAdvance" in b)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                            return Sc(a, b, c);
                        }
                        var Tc = (a)=>{
                            throw new P(a.g.u.i.name + " instance already deleted");
                        };
                        function Uc() {}
                        var Vc = (a, b, c)=>{
                            if (void 0 === a[b].A) {
                                var d = a[b];
                                a[b] = function(...e) {
                                    if (!a[b].A.hasOwnProperty(e.length)) throw new P(`Function '${c}' called with an invalid number of arguments (${e.length}) - expects one of (${a[b].A})!`);
                                    return a[b].A[e.length].apply(this, e);
                                };
                                a[b].A = [];
                                a[b].A[d.da] = d;
                            }
                        }, Wc = (a, b, c)=>{
                            if (m.hasOwnProperty(a)) {
                                if (void 0 === c || void 0 !== m[a].A && void 0 !== m[a].A[c]) throw new P(`Cannot register public name '${a}' twice`);
                                Vc(m, a, a);
                                if (m.hasOwnProperty(c)) throw new P(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`);
                                m[a].A[c] = b;
                            } else m[a] = b, void 0 !== c && (m[a].Lc = c);
                        }, Xc = (a)=>{
                            if (void 0 === a) return "_unknown";
                            a = a.replace(/[^a-zA-Z0-9_]/g, "$");
                            var b = a.charCodeAt(0);
                            return 48 <= b && 57 >= b ? `_${a}` : a;
                        };
                        function Yc(a, b, c, d, e, f, g, k) {
                            this.name = a;
                            this.constructor = b;
                            this.M = c;
                            this.O = d;
                            this.C = e;
                            this.Qb = f;
                            this.ma = g;
                            this.Lb = k;
                            this.pb = [];
                        }
                        var Zc = (a, b, c)=>{
                            for(; b !== c;){
                                if (!b.ma) throw new P(`Expected null or instance of ${c.name}, got an instance of ${b.name}`);
                                a = b.ma(a);
                                b = b.C;
                            }
                            return a;
                        };
                        function $c(a, b) {
                            if (null === b) {
                                if (this.La) throw new P(`null is not a valid ${this.name}`);
                                return 0;
                            }
                            if (!b.g) throw new P(`Cannot pass "${ad(b)}" as a ${this.name}`);
                            if (!b.g.o) throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            return Zc(b.g.o, b.g.u.i, this.i);
                        }
                        function bd(a, b) {
                            if (null === b) {
                                if (this.La) throw new P(`null is not a valid ${this.name}`);
                                if (this.sa) {
                                    var c = this.Na();
                                    null !== a && a.push(this.O, c);
                                    return c;
                                }
                                return 0;
                            }
                            if (!b || !b.g) throw new P(`Cannot pass "${ad(b)}" as a ${this.name}`);
                            if (!b.g.o) throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            if (!this.ra && b.g.u.ra) throw new P(`Cannot convert argument of type ${b.g.J ? b.g.J.name : b.g.u.name} to parameter type ${this.name}`);
                            c = Zc(b.g.o, b.g.u.i, this.i);
                            if (this.sa) {
                                if (void 0 === b.g.F) throw new P("Passing raw pointer to smart pointer is illegal");
                                switch(this.mc){
                                    case 0:
                                        if (b.g.J === this) c = b.g.F;
                                        else throw new P(`Cannot convert argument of type ${b.g.J ? b.g.J.name : b.g.u.name} to parameter type ${this.name}`);
                                        break;
                                    case 1:
                                        c = b.g.F;
                                        break;
                                    case 2:
                                        if (b.g.J === this) c = b.g.F;
                                        else {
                                            var d = b.clone();
                                            c = this.ic(c, qc(()=>d["delete"]()));
                                            null !== a && a.push(this.O, c);
                                        }
                                        break;
                                    default:
                                        throw new P("Unsupporting sharing policy");
                                }
                            }
                            return c;
                        }
                        function cd(a, b) {
                            if (null === b) {
                                if (this.La) throw new P(`null is not a valid ${this.name}`);
                                return 0;
                            }
                            if (!b.g) throw new P(`Cannot pass "${ad(b)}" as a ${this.name}`);
                            if (!b.g.o) throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            if (b.g.u.ra) throw new P(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
                            return Zc(b.g.o, b.g.u.i, this.i);
                        }
                        function dd(a, b, c, d, e, f, g, k, p, n, t) {
                            this.name = a;
                            this.i = b;
                            this.La = c;
                            this.ra = d;
                            this.sa = e;
                            this.hc = f;
                            this.mc = g;
                            this.qb = k;
                            this.Na = p;
                            this.ic = n;
                            this.O = t;
                            e || void 0 !== b.C ? this.toWireType = bd : (this.toWireType = d ? $c : cd, this.L = null);
                        }
                        var ed = (a, b, c)=>{
                            if (!m.hasOwnProperty(a)) throw new Jc("Replacing nonexistent public symbol");
                            void 0 !== m[a].A && void 0 !== c ? m[a].A[c] = b : (m[a] = b, m[a].da = c);
                        }, fd = [], gd, hd = (a)=>{
                            var b = fd[a];
                            b || (a >= fd.length && (fd.length = a + 1), fd[a] = b = gd.get(a));
                            return b;
                        }, jd = (a, b, c = [])=>{
                            a.includes("j") ? (a = a.replace(/p/g, "i"), b = (0, m["dynCall_" + a])(b, ...c)) : b = hd(b)(...c);
                            return b;
                        }, md = (a, b)=>(...c)=>jd(a, b, c), V = (a, b)=>{
                            a = Q(a);
                            var c = a.includes("j") ? md(a, b) : hd(b);
                            if ("function" != typeof c) throw new P(`unknown function pointer with signature ${a}: ${b}`);
                            return c;
                        }, nd, od = (a, b)=>{
                            function c(f) {
                                e[f] || zc[f] || (Qc[f] ? Qc[f].forEach(c) : (d.push(f), e[f] = !0));
                            }
                            var d = [], e = {};
                            b.forEach(c);
                            throw new nd(`${a}: ` + d.map(Cc).join([
                                ", "
                            ]));
                        };
                        function pd(a) {
                            for(var b = 1; b < a.length; ++b){
                                if (null !== a[b] && void 0 === a[b].L) return !0;
                            }
                            return !1;
                        }
                        function qd(a, b, c, d, e) {
                            var f = b.length;
                            if (2 > f) throw new P("argTypes array size mismatch! Must at least get return value and 'this' types!");
                            var g = null !== b[1] && null !== c, k = pd(b), p = "void" !== b[0].name, n = f - 2, t = Array(n), x = [], y = [];
                            return mc(a, function(...l) {
                                if (l.length !== n) throw new P(`function ${a} called with ${l.length} arguments, expected ${n}`);
                                y.length = 0;
                                x.length = g ? 2 : 1;
                                x[0] = e;
                                if (g) {
                                    var u = b[1].toWireType(y, this);
                                    x[1] = u;
                                }
                                for(var q = 0; q < n; ++q)t[q] = b[q + 2].toWireType(y, l[q]), x.push(t[q]);
                                l = d(...x);
                                if (k) Nc(y);
                                else for(q = g ? 1 : 2; q < b.length; q++){
                                    var C = 1 === q ? u : t[q - 2];
                                    null !== b[q].L && b[q].L(C);
                                }
                                u = p ? b[0].fromWireType(l) : void 0;
                                return u;
                            });
                        }
                        var rd = (a, b)=>{
                            for(var c = [], d = 0; d < a; d++)c.push(M[b + 4 * d >> 2]);
                            return c;
                        }, sd = (a)=>{
                            a = a.trim();
                            const b = a.indexOf("(");
                            return -1 !== b ? a.substr(0, b) : a;
                        }, td = (a, b, c)=>{
                            if (!(a instanceof Object)) throw new P(`${c} with invalid "this": ${a}`);
                            if (!(a instanceof b.i.constructor)) throw new P(`${c} incompatible with "this" of type ${a.constructor.name}`);
                            if (!a.g.o) throw new P(`cannot call emscripten binding method ${c} on deleted object`);
                            return Zc(a.g.o, a.g.u.i, b.i);
                        }, ud = (a)=>{
                            9 < a && 0 === --oc[a + 1] && (oc[a] = void 0, nc.push(a));
                        }, vd = {
                            name: "emscripten::val",
                            fromWireType: (a)=>{
                                var b = pc(a);
                                ud(a);
                                return b;
                            },
                            toWireType: (a, b)=>qc(b),
                            argPackAdvance: 8,
                            readValueFromPointer: Oc,
                            L: null
                        }, wd = (a, b, c)=>{
                            switch(b){
                                case 1:
                                    return c ? function(d) {
                                        return this.fromWireType(z[d]);
                                    } : function(d) {
                                        return this.fromWireType(A[d]);
                                    };
                                case 2:
                                    return c ? function(d) {
                                        return this.fromWireType(Ca[d >> 1]);
                                    } : function(d) {
                                        return this.fromWireType(Fa[d >> 1]);
                                    };
                                case 4:
                                    return c ? function(d) {
                                        return this.fromWireType(D[d >> 2]);
                                    } : function(d) {
                                        return this.fromWireType(M[d >> 2]);
                                    };
                                default:
                                    throw new TypeError(`invalid integer width (${b}): ${a}`);
                            }
                        }, ad = (a)=>{
                            if (null === a) return "null";
                            var b = typeof a;
                            return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
                        }, xd = (a, b)=>{
                            switch(b){
                                case 4:
                                    return function(c) {
                                        return this.fromWireType(Ga[c >> 2]);
                                    };
                                case 8:
                                    return function(c) {
                                        return this.fromWireType(Ha[c >> 3]);
                                    };
                                default:
                                    throw new TypeError(`invalid float width (${b}): ${a}`);
                            }
                        }, yd = (a, b, c)=>{
                            switch(b){
                                case 1:
                                    return c ? (d)=>z[d] : (d)=>A[d];
                                case 2:
                                    return c ? (d)=>Ca[d >> 1] : (d)=>Fa[d >> 1];
                                case 4:
                                    return c ? (d)=>D[d >> 2] : (d)=>M[d >> 2];
                                default:
                                    throw new TypeError(`invalid integer width (${b}): ${a}`);
                            }
                        }, zd = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, Ad = (a, b)=>{
                            var c = a >> 1;
                            for(var d = c + b / 2; !(c >= d) && Fa[c];)++c;
                            c <<= 1;
                            if (32 < c - a && zd) return zd.decode(A.subarray(a, c));
                            c = "";
                            for(d = 0; !(d >= b / 2); ++d){
                                var e = Ca[a + 2 * d >> 1];
                                if (0 == e) break;
                                c += String.fromCharCode(e);
                            }
                            return c;
                        }, Bd = (a, b, c)=>{
                            c ??= 2147483647;
                            if (2 > c) return 0;
                            c -= 2;
                            var d = b;
                            c = c < 2 * a.length ? c / 2 : a.length;
                            for(var e = 0; e < c; ++e)Ca[b >> 1] = a.charCodeAt(e), b += 2;
                            Ca[b >> 1] = 0;
                            return b - d;
                        }, Cd = (a)=>2 * a.length, Dd = (a, b)=>{
                            for(var c = 0, d = ""; !(c >= b / 4);){
                                var e = D[a + 4 * c >> 2];
                                if (0 == e) break;
                                ++c;
                                65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
                            }
                            return d;
                        }, Ed = (a, b, c)=>{
                            c ??= 2147483647;
                            if (4 > c) return 0;
                            var d = b;
                            c = d + c - 4;
                            for(var e = 0; e < a.length; ++e){
                                var f = a.charCodeAt(e);
                                if (55296 <= f && 57343 >= f) {
                                    var g = a.charCodeAt(++e);
                                    f = 65536 + ((f & 1023) << 10) | g & 1023;
                                }
                                D[b >> 2] = f;
                                b += 4;
                                if (b + 4 > c) break;
                            }
                            D[b >> 2] = 0;
                            return b - d;
                        }, Fd = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                55296 <= d && 57343 >= d && ++c;
                                b += 4;
                            }
                            return b;
                        }, Gd = (a, b, c)=>{
                            var d = [];
                            a = a.toWireType(d, c);
                            d.length && (M[b >> 2] = qc(d));
                            return a;
                        }, Hd = {}, Id = (a)=>{
                            var b = Hd[a];
                            return void 0 === b ? Q(a) : b;
                        }, Jd = [], Kd = (a)=>{
                            var b = Jd.length;
                            Jd.push(a);
                            return b;
                        }, Ld = (a, b)=>{
                            for(var c = Array(a), d = 0; d < a; ++d)c[d] = Dc(M[b + 4 * d >> 2], "parameter " + d);
                            return c;
                        }, Md = Reflect.construct, Nd = [], Od = {}, Qd = ()=>{
                            if (!Pd) {
                                var a = {
                                    USER: "web_user",
                                    LOGNAME: "web_user",
                                    PATH: "/",
                                    PWD: "/",
                                    HOME: "/home/web_user",
                                    LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                                    _: oa || "./this.program"
                                }, b;
                                for(b in Od)void 0 === Od[b] ? delete a[b] : a[b] = Od[b];
                                var c = [];
                                for(b in a)c.push(`${b}=${a[b]}`);
                                Pd = c;
                            }
                            return Pd;
                        }, Pd, Rd = (a)=>0 === a % 4 && (0 !== a % 100 || 0 === a % 400), Sd = [
                            31,
                            29,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Td = [
                            31,
                            28,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Ud = (a, b, c, d)=>{
                            function e(l, u, q) {
                                for(l = "number" == typeof l ? l.toString() : l || ""; l.length < u;)l = q[0] + l;
                                return l;
                            }
                            function f(l, u) {
                                return e(l, u, "0");
                            }
                            function g(l, u) {
                                function q(E) {
                                    return 0 > E ? -1 : 0 < E ? 1 : 0;
                                }
                                var C;
                                0 === (C = q(l.getFullYear() - u.getFullYear())) && 0 === (C = q(l.getMonth() - u.getMonth())) && (C = q(l.getDate() - u.getDate()));
                                return C;
                            }
                            function k(l) {
                                switch(l.getDay()){
                                    case 0:
                                        return new Date(l.getFullYear() - 1, 11, 29);
                                    case 1:
                                        return l;
                                    case 2:
                                        return new Date(l.getFullYear(), 0, 3);
                                    case 3:
                                        return new Date(l.getFullYear(), 0, 2);
                                    case 4:
                                        return new Date(l.getFullYear(), 0, 1);
                                    case 5:
                                        return new Date(l.getFullYear() - 1, 11, 31);
                                    case 6:
                                        return new Date(l.getFullYear() - 1, 11, 30);
                                }
                            }
                            function p(l) {
                                var u = l.ba;
                                for(l = new Date(new Date(l.ca + 1900, 0, 1).getTime()); 0 < u;){
                                    var q = l.getMonth(), C = (Rd(l.getFullYear()) ? Sd : Td)[q];
                                    if (u > C - l.getDate()) u -= C - l.getDate() + 1, l.setDate(1), 11 > q ? l.setMonth(q + 1) : (l.setMonth(0), l.setFullYear(l.getFullYear() + 1));
                                    else {
                                        l.setDate(l.getDate() + u);
                                        break;
                                    }
                                }
                                q = new Date(l.getFullYear() + 1, 0, 4);
                                u = k(new Date(l.getFullYear(), 0, 4));
                                q = k(q);
                                return 0 >= g(u, l) ? 0 >= g(q, l) ? l.getFullYear() + 1 : l.getFullYear() : l.getFullYear() - 1;
                            }
                            var n = M[d + 40 >> 2];
                            d = {
                                pc: D[d >> 2],
                                oc: D[d + 4 >> 2],
                                Da: D[d + 8 >> 2],
                                Qa: D[d + 12 >> 2],
                                Ea: D[d + 16 >> 2],
                                ca: D[d + 20 >> 2],
                                R: D[d + 24 >> 2],
                                ba: D[d + 28 >> 2],
                                Nc: D[d + 32 >> 2],
                                nc: D[d + 36 >> 2],
                                qc: n ? n ? nb(A, n) : "" : ""
                            };
                            c = c ? nb(A, c) : "";
                            n = {
                                "%c": "%a %b %d %H:%M:%S %Y",
                                "%D": "%m/%d/%y",
                                "%F": "%Y-%m-%d",
                                "%h": "%b",
                                "%r": "%I:%M:%S %p",
                                "%R": "%H:%M",
                                "%T": "%H:%M:%S",
                                "%x": "%m/%d/%y",
                                "%X": "%H:%M:%S",
                                "%Ec": "%c",
                                "%EC": "%C",
                                "%Ex": "%m/%d/%y",
                                "%EX": "%H:%M:%S",
                                "%Ey": "%y",
                                "%EY": "%Y",
                                "%Od": "%d",
                                "%Oe": "%e",
                                "%OH": "%H",
                                "%OI": "%I",
                                "%Om": "%m",
                                "%OM": "%M",
                                "%OS": "%S",
                                "%Ou": "%u",
                                "%OU": "%U",
                                "%OV": "%V",
                                "%Ow": "%w",
                                "%OW": "%W",
                                "%Oy": "%y"
                            };
                            for(var t in n)c = c.replace(new RegExp(t, "g"), n[t]);
                            var x = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), y = "January February March April May June July August September October November December".split(" ");
                            n = {
                                "%a": (l)=>x[l.R].substring(0, 3),
                                "%A": (l)=>x[l.R],
                                "%b": (l)=>y[l.Ea].substring(0, 3),
                                "%B": (l)=>y[l.Ea],
                                "%C": (l)=>f((l.ca + 1900) / 100 | 0, 2),
                                "%d": (l)=>f(l.Qa, 2),
                                "%e": (l)=>e(l.Qa, 2, " "),
                                "%g": (l)=>p(l).toString().substring(2),
                                "%G": p,
                                "%H": (l)=>f(l.Da, 2),
                                "%I": (l)=>{
                                    l = l.Da;
                                    0 == l ? l = 12 : 12 < l && (l -= 12);
                                    return f(l, 2);
                                },
                                "%j": (l)=>{
                                    for(var u = 0, q = 0; q <= l.Ea - 1; u += (Rd(l.ca + 1900) ? Sd : Td)[q++]);
                                    return f(l.Qa + u, 3);
                                },
                                "%m": (l)=>f(l.Ea + 1, 2),
                                "%M": (l)=>f(l.oc, 2),
                                "%n": ()=>"\n",
                                "%p": (l)=>0 <= l.Da && 12 > l.Da ? "AM" : "PM",
                                "%S": (l)=>f(l.pc, 2),
                                "%t": ()=>"\t",
                                "%u": (l)=>l.R || 7,
                                "%U": (l)=>f(Math.floor((l.ba + 7 - l.R) / 7), 2),
                                "%V": (l)=>{
                                    var u = Math.floor((l.ba + 7 - (l.R + 6) % 7) / 7);
                                    2 >= (l.R + 371 - l.ba - 2) % 7 && u++;
                                    if (u) 53 == u && (q = (l.R + 371 - l.ba) % 7, 4 == q || 3 == q && Rd(l.ca) || (u = 1));
                                    else {
                                        u = 52;
                                        var q = (l.R + 7 - l.ba - 1) % 7;
                                        (4 == q || 5 == q && Rd(l.ca % 400 - 1)) && u++;
                                    }
                                    return f(u, 2);
                                },
                                "%w": (l)=>l.R,
                                "%W": (l)=>f(Math.floor((l.ba + 7 - (l.R + 6) % 7) / 7), 2),
                                "%y": (l)=>(l.ca + 1900).toString().substring(2),
                                "%Y": (l)=>l.ca + 1900,
                                "%z": (l)=>{
                                    l = l.nc;
                                    var u = 0 <= l;
                                    l = Math.abs(l) / 60;
                                    return (u ? "+" : "-") + String("0000" + (l / 60 * 100 + l % 60)).slice(-4);
                                },
                                "%Z": (l)=>l.qc,
                                "%%": ()=>"%"
                            };
                            c = c.replace(/%%/g, "\x00\x00");
                            for(t in n)c.includes(t) && (c = c.replace(new RegExp(t, "g"), n[t](d)));
                            c = c.replace(/\0\0/g, "%");
                            t = rb(c, !1);
                            if (t.length > b) return 0;
                            z.set(t, a);
                            return t.length - 1;
                        };
                        [
                            44
                        ].forEach((a)=>{
                            Bb[a] = new N(a);
                            Bb[a].stack = "<generic error, no stack>";
                        });
                        Ib = Array(4096);
                        ac(O, "/");
                        cc("/tmp");
                        cc("/home");
                        cc("/home/web_user");
                        (function() {
                            cc("/dev");
                            ub(259, {
                                read: ()=>0,
                                write: (d, e, f, g)=>g
                            });
                            dc("/dev/null", 259);
                            tb(1280, wb);
                            tb(1536, xb);
                            dc("/dev/tty", 1280);
                            dc("/dev/tty1", 1536);
                            var a = new Uint8Array(1024), b = 0, c = ()=>{
                                0 === b && (b = kb(a).byteLength);
                                return a[--b];
                            };
                            jc("random", c);
                            jc("urandom", c);
                            cc("/dev/shm");
                            cc("/dev/shm/tmp");
                        })();
                        (function() {
                            cc("/proc");
                            var a = cc("/proc/self");
                            cc("/proc/self/fd");
                            ac({
                                U () {
                                    var b = Ab(a, "fd", 16895, 73);
                                    b.j = {
                                        ja (c, d) {
                                            var e = Tb(+d);
                                            c = {
                                                parent: null,
                                                U: {
                                                    lb: "fake"
                                                },
                                                j: {
                                                    la: ()=>e.path
                                                }
                                            };
                                            return c.parent = c;
                                        }
                                    };
                                    return b;
                                }
                            }, "/proc/self/fd");
                        })();
                        P = m.BindingError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "BindingError";
                            }
                        };
                        oc.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1);
                        m.count_emval_handles = ()=>oc.length / 2 - 5 - nc.length;
                        sc = m.PureVirtualError = rc("PureVirtualError");
                        for(var Vd = Array(256), Wd = 0; 256 > Wd; ++Wd)Vd[Wd] = String.fromCharCode(Wd);
                        tc = Vd;
                        m.getInheritedInstanceCount = ()=>Object.keys(xc).length;
                        m.getLiveInheritedInstances = ()=>{
                            var a = [], b;
                            for(b in xc)xc.hasOwnProperty(b) && a.push(xc[b]);
                            return a;
                        };
                        m.flushPendingDeletes = vc;
                        m.setDelayFunction = (a)=>{
                            wc = a;
                            uc.length && wc && wc(vc);
                        };
                        Jc = m.InternalError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "InternalError";
                            }
                        };
                        Object.assign(Uc.prototype, {
                            isAliasOf: function(a) {
                                if (!(this instanceof Uc && a instanceof Uc)) return !1;
                                var b = this.g.u.i, c = this.g.o;
                                a.g = a.g;
                                var d = a.g.u.i;
                                for(a = a.g.o; b.C;)c = b.ma(c), b = b.C;
                                for(; d.C;)a = d.ma(a), d = d.C;
                                return b === d && c === a;
                            },
                            clone: function() {
                                this.g.o || Tc(this);
                                if (this.g.ha) return this.g.count.value += 1, this;
                                var a = Kc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
                                a = a(c.call(b, d, {
                                    g: {
                                        value: {
                                            count: e.count,
                                            ea: e.ea,
                                            ha: e.ha,
                                            o: e.o,
                                            u: e.u,
                                            F: e.F,
                                            J: e.J
                                        }
                                    }
                                }));
                                a.g.count.value += 1;
                                a.g.ea = !1;
                                return a;
                            },
                            ["delete"] () {
                                this.g.o || Tc(this);
                                if (this.g.ea && !this.g.ha) throw new P("Object already scheduled for deletion");
                                Ec(this);
                                var a = this.g;
                                --a.count.value;
                                0 === a.count.value && (a.F ? a.J.O(a.F) : a.u.i.O(a.o));
                                this.g.ha || (this.g.F = void 0, this.g.o = void 0);
                            },
                            isDeleted: function() {
                                return !this.g.o;
                            },
                            deleteLater: function() {
                                this.g.o || Tc(this);
                                if (this.g.ea && !this.g.ha) throw new P("Object already scheduled for deletion");
                                uc.push(this);
                                1 === uc.length && wc && wc(vc);
                                this.g.ea = !0;
                                return this;
                            }
                        });
                        Object.assign(dd.prototype, {
                            Rb (a) {
                                this.qb && (a = this.qb(a));
                                return a;
                            },
                            ab (a) {
                                this.O?.(a);
                            },
                            argPackAdvance: 8,
                            readValueFromPointer: Oc,
                            fromWireType: function(a) {
                                function b() {
                                    return this.sa ? Lc(this.i.M, {
                                        u: this.hc,
                                        o: c,
                                        J: this,
                                        F: a
                                    }) : Lc(this.i.M, {
                                        u: this,
                                        o: a
                                    });
                                }
                                var c = this.Rb(a);
                                if (!c) return this.ab(a), null;
                                var d = Ic(this.i, c);
                                if (void 0 !== d) {
                                    if (0 === d.g.count.value) return d.g.o = c, d.g.F = a, d.clone();
                                    d = d.clone();
                                    this.ab(a);
                                    return d;
                                }
                                d = this.i.Qb(c);
                                d = Hc[d];
                                if (!d) return b.call(this);
                                d = this.ra ? d.Hb : d.pointerType;
                                var e = Gc(c, this.i, d.i);
                                return null === e ? b.call(this) : this.sa ? Lc(d.i.M, {
                                    u: d,
                                    o: e,
                                    J: this,
                                    F: a
                                }) : Lc(d.i.M, {
                                    u: d,
                                    o: e
                                });
                            }
                        });
                        nd = m.UnboundTypeError = rc("UnboundTypeError");
                        var Yd = {
                            __syscall_fcntl64: function(a, b, c) {
                                eb = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 0:
                                            var e = db();
                                            if (0 > e) break;
                                            for(; Gb[e];)e++;
                                            return Vb(d, e).W;
                                        case 1:
                                        case 2:
                                            return 0;
                                        case 3:
                                            return d.flags;
                                        case 4:
                                            return e = db(), d.flags |= e, 0;
                                        case 12:
                                            return e = db(), Ca[e + 0 >> 1] = 2, 0;
                                        case 13:
                                        case 14:
                                            return 0;
                                    }
                                    return -28;
                                } catch (f) {
                                    if ("undefined" == typeof lc || "ErrnoError" !== f.name) throw f;
                                    return -f.$;
                                }
                            },
                            __syscall_ioctl: function(a, b, c) {
                                eb = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 21509:
                                            return d.s ? 0 : -59;
                                        case 21505:
                                            if (!d.s) return -59;
                                            if (d.s.V.Xb) {
                                                a = [
                                                    3,
                                                    28,
                                                    127,
                                                    21,
                                                    4,
                                                    0,
                                                    1,
                                                    0,
                                                    17,
                                                    19,
                                                    26,
                                                    0,
                                                    18,
                                                    15,
                                                    23,
                                                    22,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                var e = db();
                                                D[e >> 2] = 25856;
                                                D[e + 4 >> 2] = 5;
                                                D[e + 8 >> 2] = 191;
                                                D[e + 12 >> 2] = 35387;
                                                for(var f = 0; 32 > f; f++)z[e + f + 17] = a[f] || 0;
                                            }
                                            return 0;
                                        case 21510:
                                        case 21511:
                                        case 21512:
                                            return d.s ? 0 : -59;
                                        case 21506:
                                        case 21507:
                                        case 21508:
                                            if (!d.s) return -59;
                                            if (d.s.V.Yb) for(e = db(), a = [], f = 0; 32 > f; f++)a.push(z[e + f + 17]);
                                            return 0;
                                        case 21519:
                                            if (!d.s) return -59;
                                            e = db();
                                            return D[e >> 2] = 0;
                                        case 21520:
                                            return d.s ? -28 : -59;
                                        case 21531:
                                            e = db();
                                            if (!d.m.Wb) throw new N(59);
                                            return d.m.Wb(d, b, e);
                                        case 21523:
                                            if (!d.s) return -59;
                                            d.s.V.Zb && (f = [
                                                24,
                                                80
                                            ], e = db(), Ca[e >> 1] = f[0], Ca[e + 2 >> 1] = f[1]);
                                            return 0;
                                        case 21524:
                                            return d.s ? 0 : -59;
                                        case 21515:
                                            return d.s ? 0 : -59;
                                        default:
                                            return -28;
                                    }
                                } catch (g) {
                                    if ("undefined" == typeof lc || "ErrnoError" !== g.name) throw g;
                                    return -g.$;
                                }
                            },
                            __syscall_openat: function(a, b, c, d) {
                                eb = d;
                                try {
                                    b = b ? nb(A, b) : "";
                                    var e = b;
                                    if ("/" === e.charAt(0)) b = e;
                                    else {
                                        var f = -100 === a ? "/" : Tb(a).path;
                                        if (0 == e.length) throw new N(44);
                                        b = gb(f + "/" + e);
                                    }
                                    var g = d ? db() : 0;
                                    return fc(b, c, g).W;
                                } catch (k) {
                                    if ("undefined" == typeof lc || "ErrnoError" !== k.name) throw k;
                                    return -k.$;
                                }
                            },
                            _abort_js: ()=>{
                                Qa("");
                            },
                            _embind_create_inheriting_constructor: (a, b, c)=>{
                                a = Q(a);
                                b = Dc(b, "wrapper");
                                c = pc(c);
                                var d = b.i, e = d.M, f = d.C.M, g = d.C.constructor;
                                a = mc(a, function(...k) {
                                    d.C.pb.forEach((function(p) {
                                        if (this[p] === f[p]) throw new sc(`Pure virtual function ${p} must be implemented in JavaScript`);
                                    }).bind(this));
                                    Object.defineProperty(this, "__parent", {
                                        value: e
                                    });
                                    this.__construct(...k);
                                });
                                e.__construct = function(...k) {
                                    if (this === e) throw new P("Pass correct 'this' to __construct");
                                    k = g.implement(this, ...k);
                                    Ec(k);
                                    var p = k.g;
                                    k.notifyOnDestruction();
                                    p.ha = !0;
                                    Object.defineProperties(this, {
                                        g: {
                                            value: p
                                        }
                                    });
                                    Kc(this);
                                    k = p.o;
                                    k = yc(d, k);
                                    if (xc.hasOwnProperty(k)) throw new P(`Tried to register registered instance: ${k}`);
                                    xc[k] = this;
                                };
                                e.__destruct = function() {
                                    if (this === e) throw new P("Pass correct 'this' to __destruct");
                                    Ec(this);
                                    var k = this.g.o;
                                    k = yc(d, k);
                                    if (xc.hasOwnProperty(k)) delete xc[k];
                                    else throw new P(`Tried to unregister unregistered instance: ${k}`);
                                };
                                a.prototype = Object.create(e);
                                Object.assign(a.prototype, c);
                                return qc(a);
                            },
                            _embind_finalize_value_object: (a)=>{
                                var b = Mc[a];
                                delete Mc[a];
                                var c = b.Na, d = b.O, e = b.eb, f = e.map((g)=>g.Ub).concat(e.map((g)=>g.kc));
                                U([
                                    a
                                ], f, (g)=>{
                                    var k = {};
                                    e.forEach((p, n)=>{
                                        var t = g[n], x = p.Sb, y = p.Tb, l = g[n + e.length], u = p.jc, q = p.lc;
                                        k[p.Ob] = {
                                            read: (C)=>t.fromWireType(x(y, C)),
                                            write: (C, E)=>{
                                                var w = [];
                                                u(q, C, l.toWireType(w, E));
                                                Nc(w);
                                            }
                                        };
                                    });
                                    return [
                                        {
                                            name: b.name,
                                            fromWireType: (p)=>{
                                                var n = {}, t;
                                                for(t in k)n[t] = k[t].read(p);
                                                d(p);
                                                return n;
                                            },
                                            toWireType: (p, n)=>{
                                                for(var t in k){
                                                    if (!(t in n)) throw new TypeError(`Missing field: "${t}"`);
                                                }
                                                var x = c();
                                                for(t in k)k[t].write(x, n[t]);
                                                null !== p && p.push(d, x);
                                                return x;
                                            },
                                            argPackAdvance: 8,
                                            readValueFromPointer: Oc,
                                            L: d
                                        }
                                    ];
                                });
                            },
                            _embind_register_bigint: ()=>{},
                            _embind_register_bool: (a, b, c, d)=>{
                                b = Q(b);
                                Rc(a, {
                                    name: b,
                                    fromWireType: function(e) {
                                        return !!e;
                                    },
                                    toWireType: function(e, f) {
                                        return f ? c : d;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: function(e) {
                                        return this.fromWireType(A[e]);
                                    },
                                    L: null
                                });
                            },
                            _embind_register_class: (a, b, c, d, e, f, g, k, p, n, t, x, y)=>{
                                t = Q(t);
                                f = V(e, f);
                                k &&= V(g, k);
                                n &&= V(p, n);
                                y = V(x, y);
                                var l = Xc(t);
                                Wc(l, function() {
                                    od(`Cannot construct ${t} due to unbound types`, [
                                        d
                                    ]);
                                });
                                U([
                                    a,
                                    b,
                                    c
                                ], d ? [
                                    d
                                ] : [], (u)=>{
                                    u = u[0];
                                    if (d) {
                                        var q = u.i;
                                        var C = q.M;
                                    } else C = Uc.prototype;
                                    u = mc(t, function(...R) {
                                        if (Object.getPrototypeOf(this) !== E) throw new P("Use 'new' to construct " + t);
                                        if (void 0 === w.Z) throw new P(t + " has no accessible constructor");
                                        var W = w.Z[R.length];
                                        if (void 0 === W) throw new P(`Tried to invoke ctor of ${t} with invalid number of parameters (${R.length}) - expected (${Object.keys(w.Z).toString()}) parameters instead!`);
                                        return W.apply(this, R);
                                    });
                                    var E = Object.create(C, {
                                        constructor: {
                                            value: u
                                        }
                                    });
                                    u.prototype = E;
                                    var w = new Yc(t, u, E, y, q, f, k, n);
                                    if (w.C) {
                                        var L;
                                        (L = w.C).na ?? (L.na = []);
                                        w.C.na.push(w);
                                    }
                                    q = new dd(t, w, !0, !1, !1);
                                    L = new dd(t + "*", w, !1, !1, !1);
                                    C = new dd(t + " const*", w, !1, !0, !1);
                                    Hc[a] = {
                                        pointerType: L,
                                        Hb: C
                                    };
                                    ed(l, u);
                                    return [
                                        q,
                                        L,
                                        C
                                    ];
                                });
                            },
                            _embind_register_class_class_function: (a, b, c, d, e, f, g)=>{
                                var k = rd(c, d);
                                b = Q(b);
                                b = sd(b);
                                f = V(e, f);
                                U([], [
                                    a
                                ], (p)=>{
                                    function n() {
                                        od(`Cannot call ${t} due to unbound types`, k);
                                    }
                                    p = p[0];
                                    var t = `${p.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    var x = p.i.constructor;
                                    void 0 === x[b] ? (n.da = c - 1, x[b] = n) : (Vc(x, b, t), x[b].A[c - 1] = n);
                                    U([], k, (y)=>{
                                        y = qd(t, [
                                            y[0],
                                            null
                                        ].concat(y.slice(1)), null, f, g);
                                        void 0 === x[b].A ? (y.da = c - 1, x[b] = y) : x[b].A[c - 1] = y;
                                        if (p.i.na) for (const l of p.i.na)l.constructor.hasOwnProperty(b) || (l.constructor[b] = y);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_class_property: (a, b, c, d, e, f, g, k)=>{
                                b = Q(b);
                                f = V(e, f);
                                U([], [
                                    a
                                ], (p)=>{
                                    p = p[0];
                                    var n = `${p.name}.${b}`, t = {
                                        get () {
                                            od(`Cannot access ${n} due to unbound types`, [
                                                c
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    t.set = k ? ()=>{
                                        od(`Cannot access ${n} due to unbound types`, [
                                            c
                                        ]);
                                    } : ()=>{
                                        throw new P(`${n} is a read-only property`);
                                    };
                                    Object.defineProperty(p.i.constructor, b, t);
                                    U([], [
                                        c
                                    ], (x)=>{
                                        x = x[0];
                                        var y = {
                                            get () {
                                                return x.fromWireType(f(d));
                                            },
                                            enumerable: !0
                                        };
                                        k && (k = V(g, k), y.set = (l)=>{
                                            var u = [];
                                            k(d, x.toWireType(u, l));
                                            Nc(u);
                                        });
                                        Object.defineProperty(p.i.constructor, b, y);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_constructor: (a, b, c, d, e, f)=>{
                                var g = rd(b, c);
                                e = V(d, e);
                                U([], [
                                    a
                                ], (k)=>{
                                    k = k[0];
                                    var p = `constructor ${k.name}`;
                                    void 0 === k.i.Z && (k.i.Z = []);
                                    if (void 0 !== k.i.Z[b - 1]) throw new P(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${k.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                                    k.i.Z[b - 1] = ()=>{
                                        od(`Cannot construct ${k.name} due to unbound types`, g);
                                    };
                                    U([], g, (n)=>{
                                        n.splice(1, 0, null);
                                        k.i.Z[b - 1] = qd(p, n, null, e, f);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_function: (a, b, c, d, e, f, g, k)=>{
                                var p = rd(c, d);
                                b = Q(b);
                                b = sd(b);
                                f = V(e, f);
                                U([], [
                                    a
                                ], (n)=>{
                                    function t() {
                                        od(`Cannot call ${x} due to unbound types`, p);
                                    }
                                    n = n[0];
                                    var x = `${n.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    k && n.i.pb.push(b);
                                    var y = n.i.M, l = y[b];
                                    void 0 === l || void 0 === l.A && l.className !== n.name && l.da === c - 2 ? (t.da = c - 2, t.className = n.name, y[b] = t) : (Vc(y, b, x), y[b].A[c - 2] = t);
                                    U([], p, (u)=>{
                                        u = qd(x, u, n, f, g);
                                        void 0 === y[b].A ? (u.da = c - 2, y[b] = u) : y[b].A[c - 2] = u;
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_property: (a, b, c, d, e, f, g, k, p, n)=>{
                                b = Q(b);
                                e = V(d, e);
                                U([], [
                                    a
                                ], (t)=>{
                                    t = t[0];
                                    var x = `${t.name}.${b}`, y = {
                                        get () {
                                            od(`Cannot access ${x} due to unbound types`, [
                                                c,
                                                g
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    y.set = p ? ()=>od(`Cannot access ${x} due to unbound types`, [
                                            c,
                                            g
                                        ]) : ()=>{
                                        throw new P(x + " is a read-only property");
                                    };
                                    Object.defineProperty(t.i.M, b, y);
                                    U([], p ? [
                                        c,
                                        g
                                    ] : [
                                        c
                                    ], (l)=>{
                                        var u = l[0], q = {
                                            get () {
                                                var E = td(this, t, x + " getter");
                                                return u.fromWireType(e(f, E));
                                            },
                                            enumerable: !0
                                        };
                                        if (p) {
                                            p = V(k, p);
                                            var C = l[1];
                                            q.set = function(E) {
                                                var w = td(this, t, x + " setter"), L = [];
                                                p(n, w, C.toWireType(L, E));
                                                Nc(L);
                                            };
                                        }
                                        Object.defineProperty(t.i.M, b, q);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_emval: (a)=>Rc(a, vd),
                            _embind_register_enum: (a, b, c, d)=>{
                                function e() {}
                                b = Q(b);
                                e.values = {};
                                Rc(a, {
                                    name: b,
                                    constructor: e,
                                    fromWireType: function(f) {
                                        return this.constructor.values[f];
                                    },
                                    toWireType: (f, g)=>g.value,
                                    argPackAdvance: 8,
                                    readValueFromPointer: wd(b, c, d),
                                    L: null
                                });
                                Wc(b, e);
                            },
                            _embind_register_enum_value: (a, b, c)=>{
                                var d = Dc(a, "enum");
                                b = Q(b);
                                a = d.constructor;
                                d = Object.create(d.constructor.prototype, {
                                    value: {
                                        value: c
                                    },
                                    constructor: {
                                        value: mc(`${d.name}_${b}`, function() {})
                                    }
                                });
                                a.values[c] = d;
                                a[b] = d;
                            },
                            _embind_register_float: (a, b, c)=>{
                                b = Q(b);
                                Rc(a, {
                                    name: b,
                                    fromWireType: (d)=>d,
                                    toWireType: (d, e)=>e,
                                    argPackAdvance: 8,
                                    readValueFromPointer: xd(b, c),
                                    L: null
                                });
                            },
                            _embind_register_function: (a, b, c, d, e, f)=>{
                                var g = rd(b, c);
                                a = Q(a);
                                a = sd(a);
                                e = V(d, e);
                                Wc(a, function() {
                                    od(`Cannot call ${a} due to unbound types`, g);
                                }, b - 1);
                                U([], g, (k)=>{
                                    ed(a, qd(a, [
                                        k[0],
                                        null
                                    ].concat(k.slice(1)), null, e, f), b - 1);
                                    return [];
                                });
                            },
                            _embind_register_integer: (a, b, c, d, e)=>{
                                b = Q(b);
                                -1 === e && (e = 4294967295);
                                e = (k)=>k;
                                if (0 === d) {
                                    var f = 32 - 8 * c;
                                    e = (k)=>k << f >>> f;
                                }
                                var g = b.includes("unsigned") ? function(k, p) {
                                    return p >>> 0;
                                } : function(k, p) {
                                    return p;
                                };
                                Rc(a, {
                                    name: b,
                                    fromWireType: e,
                                    toWireType: g,
                                    argPackAdvance: 8,
                                    readValueFromPointer: yd(b, c, 0 !== d),
                                    L: null
                                });
                            },
                            _embind_register_memory_view: (a, b, c)=>{
                                function d(f) {
                                    return new e(z.buffer, M[f + 4 >> 2], M[f >> 2]);
                                }
                                var e = [
                                    Int8Array,
                                    Uint8Array,
                                    Int16Array,
                                    Uint16Array,
                                    Int32Array,
                                    Uint32Array,
                                    Float32Array,
                                    Float64Array
                                ][b];
                                c = Q(c);
                                Rc(a, {
                                    name: c,
                                    fromWireType: d,
                                    argPackAdvance: 8,
                                    readValueFromPointer: d
                                }, {
                                    Vb: !0
                                });
                            },
                            _embind_register_std_string: (a, b)=>{
                                b = Q(b);
                                var c = "std::string" === b;
                                Rc(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        var e = M[d >> 2], f = d + 4;
                                        if (c) for(var g = f, k = 0; k <= e; ++k){
                                            var p = f + k;
                                            if (k == e || 0 == A[p]) {
                                                g = g ? nb(A, g, p - g) : "";
                                                if (void 0 === n) var n = g;
                                                else n += String.fromCharCode(0), n += g;
                                                g = p + 1;
                                            }
                                        }
                                        else {
                                            n = Array(e);
                                            for(k = 0; k < e; ++k)n[k] = String.fromCharCode(A[f + k]);
                                            n = n.join("");
                                        }
                                        Bc(d);
                                        return n;
                                    },
                                    toWireType: function(d, e) {
                                        e instanceof ArrayBuffer && (e = new Uint8Array(e));
                                        var f = "string" == typeof e;
                                        if (!(f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array)) throw new P("Cannot pass non-string to std::string");
                                        var g = c && f ? pb(e) : e.length;
                                        var k = Xd(4 + g + 1), p = k + 4;
                                        M[k >> 2] = g;
                                        if (c && f) qb(e, A, p, g + 1);
                                        else {
                                            if (f) for(f = 0; f < g; ++f){
                                                var n = e.charCodeAt(f);
                                                if (255 < n) throw Bc(p), new P("String has UTF-16 code units that do not fit in 8 bits");
                                                A[p + f] = n;
                                            }
                                            else for(f = 0; f < g; ++f)A[p + f] = e[f];
                                        }
                                        null !== d && d.push(Bc, k);
                                        return k;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Oc,
                                    L (d) {
                                        Bc(d);
                                    }
                                });
                            },
                            _embind_register_std_wstring: (a, b, c)=>{
                                c = Q(c);
                                if (2 === b) {
                                    var d = Ad;
                                    var e = Bd;
                                    var f = Cd;
                                    var g = (k)=>Fa[k >> 1];
                                } else 4 === b && (d = Dd, e = Ed, f = Fd, g = (k)=>M[k >> 2]);
                                Rc(a, {
                                    name: c,
                                    fromWireType: (k)=>{
                                        for(var p = M[k >> 2], n, t = k + 4, x = 0; x <= p; ++x){
                                            var y = k + 4 + x * b;
                                            if (x == p || 0 == g(y)) t = d(t, y - t), void 0 === n ? n = t : (n += String.fromCharCode(0), n += t), t = y + b;
                                        }
                                        Bc(k);
                                        return n;
                                    },
                                    toWireType: (k, p)=>{
                                        if ("string" != typeof p) throw new P(`Cannot pass non-string to C++ string type ${c}`);
                                        var n = f(p), t = Xd(4 + n + b);
                                        M[t >> 2] = n / b;
                                        e(p, t + 4, n + b);
                                        null !== k && k.push(Bc, t);
                                        return t;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Oc,
                                    L (k) {
                                        Bc(k);
                                    }
                                });
                            },
                            _embind_register_value_object: (a, b, c, d, e, f)=>{
                                Mc[a] = {
                                    name: Q(b),
                                    Na: V(c, d),
                                    O: V(e, f),
                                    eb: []
                                };
                            },
                            _embind_register_value_object_field: (a, b, c, d, e, f, g, k, p, n)=>{
                                Mc[a].eb.push({
                                    Ob: Q(b),
                                    Ub: c,
                                    Sb: V(d, e),
                                    Tb: f,
                                    kc: g,
                                    jc: V(k, p),
                                    lc: n
                                });
                            },
                            _embind_register_void: (a, b)=>{
                                b = Q(b);
                                Rc(a, {
                                    Ic: !0,
                                    name: b,
                                    argPackAdvance: 0,
                                    fromWireType: ()=>{},
                                    toWireType: ()=>{}
                                });
                            },
                            _emscripten_get_now_is_monotonic: ()=>1,
                            _emscripten_memcpy_js: (a, b, c)=>A.copyWithin(a, b, b + c),
                            _emval_as: (a, b, c)=>{
                                a = pc(a);
                                b = Dc(b, "emval::as");
                                return Gd(b, c, a);
                            },
                            _emval_call_method: (a, b, c, d, e)=>{
                                a = Jd[a];
                                b = pc(b);
                                c = Id(c);
                                return a(b, b[c], d, e);
                            },
                            _emval_decref: ud,
                            _emval_get_method_caller: (a, b, c)=>{
                                var d = Ld(a, b), e = d.shift();
                                a--;
                                var f = Array(a);
                                b = `methodCaller<(${d.map((g)=>g.name).join(", ")}) => ${e.name}>`;
                                return Kd(mc(b, (g, k, p, n)=>{
                                    for(var t = 0, x = 0; x < a; ++x)f[x] = d[x].readValueFromPointer(n + t), t += d[x].argPackAdvance;
                                    g = 1 === c ? Md(k, f) : k.apply(g, f);
                                    return Gd(e, p, g);
                                }));
                            },
                            _emval_get_module_property: (a)=>{
                                a = Id(a);
                                return qc(m[a]);
                            },
                            _emval_get_property: (a, b)=>{
                                a = pc(a);
                                b = pc(b);
                                return qc(a[b]);
                            },
                            _emval_incref: (a)=>{
                                9 < a && (oc[a + 1] += 1);
                            },
                            _emval_new_array: ()=>qc([]),
                            _emval_new_cstring: (a)=>qc(Id(a)),
                            _emval_new_object: ()=>qc({}),
                            _emval_run_destructors: (a)=>{
                                var b = pc(a);
                                Nc(b);
                                ud(a);
                            },
                            _emval_set_property: (a, b, c)=>{
                                a = pc(a);
                                b = pc(b);
                                c = pc(c);
                                a[b] = c;
                            },
                            _emval_take_value: (a, b)=>{
                                a = Dc(a, "_emval_take_value");
                                a = a.readValueFromPointer(b);
                                return qc(a);
                            },
                            emscripten_asm_const_int: (a, b, c)=>{
                                Nd.length = 0;
                                for(var d; d = A[b++];){
                                    var e = 105 != d;
                                    e &= 112 != d;
                                    c += e && c % 8 ? 4 : 0;
                                    Nd.push(112 == d ? M[c >> 2] : 105 == d ? D[c >> 2] : Ha[c >> 3]);
                                    c += e ? 8 : 4;
                                }
                                return bb[a](...Nd);
                            },
                            emscripten_date_now: ()=>Date.now(),
                            emscripten_get_now: ()=>performance.now(),
                            emscripten_resize_heap: (a)=>{
                                var b = A.length;
                                a >>>= 0;
                                if (2147483648 < a) return !1;
                                for(var c = 1; 4 >= c; c *= 2){
                                    var d = b * (1 + 0.2 / c);
                                    d = Math.min(d, a + 100663296);
                                    var e = Math;
                                    d = Math.max(a, d);
                                    a: {
                                        e = (e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - Aa.buffer.byteLength + 65535) / 65536;
                                        try {
                                            Aa.grow(e);
                                            Ia();
                                            var f = 1;
                                            break a;
                                        } catch (g) {}
                                        f = void 0;
                                    }
                                    if (f) return !0;
                                }
                                return !1;
                            },
                            environ_get: (a, b)=>{
                                var c = 0;
                                Qd().forEach((d, e)=>{
                                    var f = b + c;
                                    e = M[a + 4 * e >> 2] = f;
                                    for(f = 0; f < d.length; ++f)z[e++] = d.charCodeAt(f);
                                    z[e] = 0;
                                    c += d.length + 1;
                                });
                                return 0;
                            },
                            environ_sizes_get: (a, b)=>{
                                var c = Qd();
                                M[a >> 2] = c.length;
                                var d = 0;
                                c.forEach((e)=>d += e.length + 1);
                                M[b >> 2] = d;
                                return 0;
                            },
                            fd_close: function(a) {
                                try {
                                    var b = Tb(a);
                                    if (null === b.W) throw new N(8);
                                    b.Ka && (b.Ka = null);
                                    try {
                                        b.m.close && b.m.close(b);
                                    } catch (c) {
                                        throw c;
                                    } finally{
                                        Gb[b.W] = null;
                                    }
                                    b.W = null;
                                    return 0;
                                } catch (c) {
                                    if ("undefined" == typeof lc || "ErrnoError" !== c.name) throw c;
                                    return c.$;
                                }
                            },
                            fd_read: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var k = M[a >> 2], p = M[a + 4 >> 2];
                                            a += 8;
                                            var n = e, t = f, x = z;
                                            if (0 > p || 0 > t) throw new N(28);
                                            if (null === n.W) throw new N(8);
                                            if (1 === (n.flags & 2097155)) throw new N(8);
                                            if (16384 === (n.node.mode & 61440)) throw new N(31);
                                            if (!n.m.read) throw new N(28);
                                            var y = "undefined" != typeof t;
                                            if (!y) t = n.position;
                                            else if (!n.seekable) throw new N(70);
                                            var l = n.m.read(n, x, k, p, t);
                                            y || (n.position += l);
                                            var u = l;
                                            if (0 > u) {
                                                var q = -1;
                                                break a;
                                            }
                                            b += u;
                                            if (u < p) break;
                                            "undefined" != typeof f && (f += u);
                                        }
                                        q = b;
                                    }
                                    M[d >> 2] = q;
                                    return 0;
                                } catch (C) {
                                    if ("undefined" == typeof lc || "ErrnoError" !== C.name) throw C;
                                    return C.$;
                                }
                            },
                            fd_seek: function(a, b, c, d, e) {
                                b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
                                try {
                                    if (isNaN(b)) return 61;
                                    var f = Tb(a);
                                    hc(f, b, d);
                                    Ya = [
                                        f.position >>> 0,
                                        (Xa = f.position, 1.0 <= +Math.abs(Xa) ? 0.0 < Xa ? +Math.floor(Xa / 4294967296.0) >>> 0 : ~~+Math.ceil((Xa - +(~~Xa >>> 0)) / 4294967296.0) >>> 0 : 0)
                                    ];
                                    D[e >> 2] = Ya[0];
                                    D[e + 4 >> 2] = Ya[1];
                                    f.Ka && 0 === b && 0 === d && (f.Ka = null);
                                    return 0;
                                } catch (g) {
                                    if ("undefined" == typeof lc || "ErrnoError" !== g.name) throw g;
                                    return g.$;
                                }
                            },
                            fd_write: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var k = M[a >> 2], p = M[a + 4 >> 2];
                                            a += 8;
                                            var n = e, t = k, x = p, y = f, l = z;
                                            if (0 > x || 0 > y) throw new N(28);
                                            if (null === n.W) throw new N(8);
                                            if (0 === (n.flags & 2097155)) throw new N(8);
                                            if (16384 === (n.node.mode & 61440)) throw new N(31);
                                            if (!n.m.write) throw new N(28);
                                            n.seekable && n.flags & 1024 && hc(n, 0, 2);
                                            var u = "undefined" != typeof y;
                                            if (!u) y = n.position;
                                            else if (!n.seekable) throw new N(70);
                                            var q = n.m.write(n, l, t, x, y, void 0);
                                            u || (n.position += q);
                                            var C = q;
                                            if (0 > C) {
                                                var E = -1;
                                                break a;
                                            }
                                            b += C;
                                            "undefined" != typeof f && (f += C);
                                        }
                                        E = b;
                                    }
                                    M[d >> 2] = E;
                                    return 0;
                                } catch (w) {
                                    if ("undefined" == typeof lc || "ErrnoError" !== w.name) throw w;
                                    return w.$;
                                }
                            },
                            strftime_l: (a, b, c, d)=>Ud(a, b, c, d)
                        }, X = function() {
                            function a(c) {
                                X = c.exports;
                                Aa = X.memory;
                                Ia();
                                gd = X.__indirect_function_table;
                                Ka.unshift(X.__wasm_call_ctors);
                                Na--;
                                m.monitorRunDependencies?.(Na);
                                0 == Na && (null !== Oa && (clearInterval(Oa), Oa = null), Pa && (c = Pa, Pa = null, c()));
                                return X;
                            }
                            var b = {
                                env: Yd,
                                wasi_snapshot_preview1: Yd
                            };
                            Na++;
                            m.monitorRunDependencies?.(Na);
                            if (m.instantiateWasm) try {
                                return m.instantiateWasm(b, a);
                            } catch (c) {
                                ya(`Module.instantiateWasm callback failed with error: ${c}`), ca(c);
                            }
                            Sa ||= Ra("canvas_advanced.wasm") ? "canvas_advanced.wasm" : m.locateFile ? m.locateFile("canvas_advanced.wasm", sa) : sa + "canvas_advanced.wasm";
                            Wa(b, function(c) {
                                a(c.instance);
                            }).catch(ca);
                            return {};
                        }(), Bc = (a)=>(Bc = X.free)(a), Xd = (a)=>(Xd = X.malloc)(a), Ac = (a)=>(Ac = X.__getTypeName)(a), Za = m._ma_device__on_notification_unlocked = (a)=>(Za = m._ma_device__on_notification_unlocked = X.ma_device__on_notification_unlocked)(a);
                        m._ma_malloc_emscripten = (a, b)=>(m._ma_malloc_emscripten = X.ma_malloc_emscripten)(a, b);
                        m._ma_free_emscripten = (a, b)=>(m._ma_free_emscripten = X.ma_free_emscripten)(a, b);
                        var $a = m._ma_device_process_pcm_frames_capture__webaudio = (a, b, c)=>($a = m._ma_device_process_pcm_frames_capture__webaudio = X.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), ab = m._ma_device_process_pcm_frames_playback__webaudio = (a, b, c)=>(ab = m._ma_device_process_pcm_frames_playback__webaudio = X.ma_device_process_pcm_frames_playback__webaudio)(a, b, c);
                        m.dynCall_iiji = (a, b, c, d, e)=>(m.dynCall_iiji = X.dynCall_iiji)(a, b, c, d, e);
                        m.dynCall_jiji = (a, b, c, d, e)=>(m.dynCall_jiji = X.dynCall_jiji)(a, b, c, d, e);
                        m.dynCall_iiiji = (a, b, c, d, e, f)=>(m.dynCall_iiiji = X.dynCall_iiiji)(a, b, c, d, e, f);
                        m.dynCall_iij = (a, b, c, d)=>(m.dynCall_iij = X.dynCall_iij)(a, b, c, d);
                        m.dynCall_jii = (a, b, c)=>(m.dynCall_jii = X.dynCall_jii)(a, b, c);
                        m.dynCall_viijii = (a, b, c, d, e, f, g)=>(m.dynCall_viijii = X.dynCall_viijii)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiij = (a, b, c, d, e, f, g)=>(m.dynCall_iiiiij = X.dynCall_iiiiij)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiijj = (a, b, c, d, e, f, g, k, p)=>(m.dynCall_iiiiijj = X.dynCall_iiiiijj)(a, b, c, d, e, f, g, k, p);
                        m.dynCall_iiiiiijj = (a, b, c, d, e, f, g, k, p, n)=>(m.dynCall_iiiiiijj = X.dynCall_iiiiiijj)(a, b, c, d, e, f, g, k, p, n);
                        var Zd;
                        Pa = function $d() {
                            Zd || ae();
                            Zd || (Pa = $d);
                        };
                        function ae() {
                            function a() {
                                if (!Zd && (Zd = !0, m.calledRun = !0, !Ba)) {
                                    m.noFSInit || ic || (ic = !0, m.stdin = m.stdin, m.stdout = m.stdout, m.stderr = m.stderr, m.stdin ? jc("stdin", m.stdin) : ec("/dev/tty", "/dev/stdin"), m.stdout ? jc("stdout", null, m.stdout) : ec("/dev/tty", "/dev/stdout"), m.stderr ? jc("stderr", null, m.stderr) : ec("/dev/tty1", "/dev/stderr"), fc("/dev/stdin", 0), fc("/dev/stdout", 1), fc("/dev/stderr", 1));
                                    Jb = !1;
                                    cb(Ka);
                                    ba(m);
                                    if (m.onRuntimeInitialized) m.onRuntimeInitialized();
                                    if (m.postRun) for("function" == typeof m.postRun && (m.postRun = [
                                        m.postRun
                                    ]); m.postRun.length;){
                                        var b = m.postRun.shift();
                                        La.unshift(b);
                                    }
                                    cb(La);
                                }
                            }
                            if (!(0 < Na)) {
                                if (m.preRun) for("function" == typeof m.preRun && (m.preRun = [
                                    m.preRun
                                ]); m.preRun.length;)Ma();
                                cb(Ja);
                                0 < Na || (m.setStatus ? (m.setStatus("Running..."), setTimeout(function() {
                                    setTimeout(function() {
                                        m.setStatus("");
                                    }, 1);
                                    a();
                                }, 1)) : a());
                            }
                        }
                        if (m.preInit) for("function" == typeof m.preInit && (m.preInit = [
                            m.preInit
                        ]); 0 < m.preInit.length;)m.preInit.pop()();
                        ae();
                        moduleRtn = da;
                        return moduleRtn;
                    };
                })();
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Rive;
            /***/ },
            /* 2 */ /***/ (module1)=>{
                module1.exports = /*#__PURE__*/ JSON.parse('{"name":"@rive-app/canvas","version":"2.32.0","description":"Rive\'s canvas based web api.","main":"rive.js","homepage":"https://rive.app","repository":{"type":"git","url":"https://github.com/rive-app/rive-wasm/tree/master/js"},"keywords":["rive","animation"],"author":"Rive","contributors":["Luigi Rosso <luigi@rive.app> (https://rive.app)","Maxwell Talbot <max@rive.app> (https://rive.app)","Arthur Vivian <arthur@rive.app> (https://rive.app)","Umberto Sonnino <umberto@rive.app> (https://rive.app)","Matthew Sullivan <matt.j.sullivan@gmail.com> (mailto:matt.j.sullivan@gmail.com)"],"license":"MIT","files":["rive.js","rive.js.map","rive.wasm","rive_fallback.wasm","rive.d.ts","rive_advanced.mjs.d.ts"],"typings":"rive.d.ts","dependencies":{},"browser":{"fs":false,"path":false}}');
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* reexport safe */ _Animation__WEBPACK_IMPORTED_MODULE_0__.Animation
                });
                /* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* binding */ Animation
                });
                /**
 * Represents an animation that can be played on an Artboard.
 * Wraps animations and instances from the runtime and keeps track of playback state.
 *
 * The `Animation` class manages the state and behavior of a single animation instance,
 * including its current time, loop count, and ability to scrub to a specific time.
 *
 * The class provides methods to advance the animation, apply its interpolated keyframe
 * values to the Artboard, and clean up the underlying animation instance when the
 * animation is no longer needed.
 */ var Animation = /** @class */ function() {
                    /**
     * Constructs a new animation
     * @constructor
     * @param {any} animation: runtime animation object
     * @param {any} instance: runtime animation instance object
     */ function Animation(animation, artboard, runtime, playing) {
                        this.animation = animation;
                        this.artboard = artboard;
                        this.playing = playing;
                        this.loopCount = 0;
                        /**
         * The time to which the animation should move to on the next render.
         * If not null, the animation will scrub to this time instead of advancing by the given time.
         */ this.scrubTo = null;
                        this.instance = new runtime.LinearAnimationInstance(animation, artboard);
                    }
                    Object.defineProperty(Animation.prototype, "name", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.animation.name;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "time", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.instance.time;
                        },
                        /**
         * Sets the animation's current time
         */ set: function(value) {
                            this.instance.time = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "loopValue", {
                        /**
         * Returns the animation's loop type
         */ get: function() {
                            return this.animation.loopValue;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "needsScrub", {
                        /**
         * Indicates whether the animation needs to be scrubbed.
         * @returns `true` if the animation needs to be scrubbed, `false` otherwise.
         */ get: function() {
                            return this.scrubTo !== null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Advances the animation by the give time. If the animation needs scrubbing,
     * time is ignored and the stored scrub value is used.
     * @param time the time to advance the animation by if no scrubbing required
     */ Animation.prototype.advance = function(time) {
                        if (this.scrubTo === null) this.instance.advance(time);
                        else {
                            this.instance.time = 0;
                            this.instance.advance(this.scrubTo);
                            this.scrubTo = null;
                        }
                    };
                    /**
     * Apply interpolated keyframe values to the artboard. This should be called after calling
     * .advance() on an animation instance so that new values are applied to properties.
     *
     * Note: This does not advance the artboard, which updates all objects on the artboard
     * @param mix - Mix value for the animation from 0 to 1
     */ Animation.prototype.apply = function(mix) {
                        this.instance.apply(mix);
                    };
                    /**
     * Deletes the backing Wasm animation instance; once this is called, this
     * animation is no more.
     */ Animation.prototype.cleanup = function() {
                        this.instance.delete();
                    };
                    return Animation;
                }();
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AudioAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.AudioAssetWrapper,
                    /* harmony export */ AudioWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.AudioWrapper,
                    /* harmony export */ BLANK_URL: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.BLANK_URL,
                    /* harmony export */ CustomFileAssetLoaderWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.CustomFileAssetLoaderWrapper,
                    /* harmony export */ FileAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FileAssetWrapper,
                    /* harmony export */ FileFinalizer: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FileFinalizer,
                    /* harmony export */ FontAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FontAssetWrapper,
                    /* harmony export */ FontWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FontWrapper,
                    /* harmony export */ ImageAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.ImageAssetWrapper,
                    /* harmony export */ ImageWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.ImageWrapper,
                    /* harmony export */ createFinalization: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.createFinalization,
                    /* harmony export */ finalizationRegistry: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.finalizationRegistry,
                    /* harmony export */ registerTouchInteractions: ()=>/* reexport safe */ _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__.registerTouchInteractions,
                    /* harmony export */ sanitizeUrl: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.sanitizeUrl
                });
                /* harmony import */ var _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
                /* harmony import */ var _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
                /* harmony import */ var _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ registerTouchInteractions: ()=>/* binding */ registerTouchInteractions
                });
                var _this = undefined;
                /**
 * Returns the clientX and clientY properties from touch or mouse events. Also
 * calls preventDefault() on the event if it is a touchstart or touchmove to prevent
 * scrolling the page on mobile devices
 * @param event - Either a TouchEvent or a MouseEvent
 * @returns - Coordinates of the clientX and clientY properties from the touch/mouse event
 */ var getClientCoordinates = function(event, isTouchScrollEnabled, enableMultiTouch) {
                    var _a, _b;
                    var coordinates = [];
                    if ([
                        "touchstart",
                        "touchmove"
                    ].indexOf(event.type) > -1 && ((_a = event.changedTouches) === null || _a === void 0 ? void 0 : _a.length)) {
                        // This flag, if false, prevents touch events on the canvas default behavior
                        // which may prevent scrolling if a drag motion on the canvas is performed
                        if (!isTouchScrollEnabled) event.preventDefault();
                        var cnt = 0;
                        var totalTouches = enableMultiTouch ? event.changedTouches.length : 1;
                        while(cnt < totalTouches){
                            var touch = event.changedTouches[cnt];
                            coordinates.push({
                                clientX: touch.clientX,
                                clientY: touch.clientY,
                                identifier: touch.identifier
                            });
                            cnt++;
                        }
                    } else if (event.type === "touchend" && ((_b = event.changedTouches) === null || _b === void 0 ? void 0 : _b.length)) {
                        var cnt = 0;
                        var totalTouches = enableMultiTouch ? event.changedTouches.length : 1;
                        while(cnt < totalTouches){
                            var touch = event.changedTouches[cnt];
                            coordinates.push({
                                clientX: touch.clientX,
                                clientY: touch.clientY,
                                identifier: touch.identifier
                            });
                            cnt++;
                        }
                    } else coordinates.push({
                        clientX: event.clientX,
                        clientY: event.clientY,
                        identifier: 0
                    });
                    return coordinates;
                };
                /**
 * Registers mouse move/up/down callback handlers on the canvas to send meaningful coordinates to
 * the state machine pointer move/up/down functions based on cursor interaction
 */ var registerTouchInteractions = function(_a) {
                    var canvas = _a.canvas, artboard = _a.artboard, _b = _a.stateMachines, stateMachines = _b === void 0 ? [] : _b, renderer = _a.renderer, rive = _a.rive, fit = _a.fit, alignment = _a.alignment, _c = _a.isTouchScrollEnabled, isTouchScrollEnabled = _c === void 0 ? false : _c, _d = _a.dispatchPointerExit, dispatchPointerExit = _d === void 0 ? true : _d, _e = _a.enableMultiTouch, enableMultiTouch = _e === void 0 ? false : _e, _f = _a.layoutScaleFactor, layoutScaleFactor = _f === void 0 ? 1.0 : _f;
                    if (!canvas || !stateMachines.length || !renderer || !rive || !artboard || typeof window === "undefined") return null;
                    /**
     * After a touchend event, some browsers may fire synthetic mouse events
     * (mouseover, mousedown, mousemove, mouseup) if the touch interaction did not cause
     * any default action (such as scrolling).
     *
     * This is done to simulate the behavior of a mouse for applications that do not support
     * touch events.
     *
     * We're keeping track of the previous event to not send the synthetic mouse events if the
     * touch event was a click (touchstart -> touchend).
     *
     * This is only needed when `isTouchScrollEnabled` is false
     * When true, `preventDefault()` is called which prevents this behaviour.
     **/ var _prevEventType = null;
                    var _syntheticEventsActive = false;
                    var processEventCallback = function(event) {
                        // Exit early out of all synthetic mouse events
                        // https://stackoverflow.com/questions/9656990/how-to-prevent-simulated-mouse-events-in-mobile-browsers
                        // https://stackoverflow.com/questions/25572070/javascript-touchend-versus-click-dilemma
                        if (_syntheticEventsActive && event instanceof MouseEvent) {
                            // Synthetic event finished
                            if (event.type == "mouseup") _syntheticEventsActive = false;
                            return;
                        }
                        // Test if it's a "touch click". This could cause the browser to send
                        // synthetic mouse events.
                        _syntheticEventsActive = isTouchScrollEnabled && event.type === "touchend" && _prevEventType === "touchstart";
                        _prevEventType = event.type;
                        var boundingRect = event.currentTarget.getBoundingClientRect();
                        var coordinateSets = getClientCoordinates(event, isTouchScrollEnabled, enableMultiTouch);
                        var forwardMatrix = rive.computeAlignment(fit, alignment, {
                            minX: 0,
                            minY: 0,
                            maxX: boundingRect.width,
                            maxY: boundingRect.height
                        }, artboard.bounds, layoutScaleFactor);
                        var invertedMatrix = new rive.Mat2D();
                        forwardMatrix.invert(invertedMatrix);
                        coordinateSets.forEach(function(coordinateSet) {
                            var clientX = coordinateSet.clientX;
                            var clientY = coordinateSet.clientY;
                            if (!clientX && !clientY) return;
                            var canvasX = clientX - boundingRect.left;
                            var canvasY = clientY - boundingRect.top;
                            var canvasCoordinatesVector = new rive.Vec2D(canvasX, canvasY);
                            var transformedVector = rive.mapXY(invertedMatrix, canvasCoordinatesVector);
                            var transformedX = transformedVector.x();
                            var transformedY = transformedVector.y();
                            coordinateSet.transformedX = transformedX;
                            coordinateSet.transformedY = transformedY;
                            transformedVector.delete();
                            canvasCoordinatesVector.delete();
                        });
                        invertedMatrix.delete();
                        forwardMatrix.delete();
                        switch(event.type){
                            /**
             * There's a 2px buffer for a hitRadius when translating the pointer coordinates
             * down to the state machine. In cases where the hitbox is about that much away
             * from the Artboard border, we don't have exact precision on determining pointer
             * exit. We're therefore adding to the translated coordinates on mouseout of a canvas
             * to ensure that we report the mouse has truly exited the hitarea.
             * https://github.com/rive-app/rive-cpp/blob/master/src/animation/state_machine_instance.cpp#L336
             *
             */ case "mouseout":
                                var _loop_1 = function(stateMachine) {
                                    if (dispatchPointerExit) coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerExit(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                    else coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerMove(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _i = 0, stateMachines_1 = stateMachines; _i < stateMachines_1.length; _i++){
                                    var stateMachine = stateMachines_1[_i];
                                    _loop_1(stateMachine);
                                }
                                break;
                            // Pointer moving/hovering on the canvas
                            case "touchmove":
                            case "mouseover":
                            case "mousemove":
                                var _loop_2 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerMove(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _a = 0, stateMachines_2 = stateMachines; _a < stateMachines_2.length; _a++){
                                    var stateMachine = stateMachines_2[_a];
                                    _loop_2(stateMachine);
                                }
                                break;
                            // Pointer click initiated but not released yet on the canvas
                            case "touchstart":
                            case "mousedown":
                                var _loop_3 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerDown(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _b = 0, stateMachines_3 = stateMachines; _b < stateMachines_3.length; _b++){
                                    var stateMachine = stateMachines_3[_b];
                                    _loop_3(stateMachine);
                                }
                                break;
                            // Pointer click released on the canvas
                            case "touchend":
                                var _loop_4 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerUp(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                        stateMachine.pointerExit(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _c = 0, stateMachines_4 = stateMachines; _c < stateMachines_4.length; _c++){
                                    var stateMachine = stateMachines_4[_c];
                                    _loop_4(stateMachine);
                                }
                                break;
                            case "mouseup":
                                var _loop_5 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerUp(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _d = 0, stateMachines_5 = stateMachines; _d < stateMachines_5.length; _d++){
                                    var stateMachine = stateMachines_5[_d];
                                    _loop_5(stateMachine);
                                }
                                break;
                            default:
                        }
                    };
                    var callback = processEventCallback.bind(_this);
                    canvas.addEventListener("mouseover", callback);
                    canvas.addEventListener("mouseout", callback);
                    canvas.addEventListener("mousemove", callback);
                    canvas.addEventListener("mousedown", callback);
                    canvas.addEventListener("mouseup", callback);
                    canvas.addEventListener("touchmove", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchstart", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchend", callback);
                    return function() {
                        canvas.removeEventListener("mouseover", callback);
                        canvas.removeEventListener("mouseout", callback);
                        canvas.removeEventListener("mousemove", callback);
                        canvas.removeEventListener("mousedown", callback);
                        canvas.removeEventListener("mouseup", callback);
                        canvas.removeEventListener("touchmove", callback);
                        canvas.removeEventListener("touchstart", callback);
                        canvas.removeEventListener("touchend", callback);
                    };
                };
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* binding */ BLANK_URL,
                    /* harmony export */ sanitizeUrl: ()=>/* binding */ sanitizeUrl
                });
                // Reference: https://github.com/braintree/sanitize-url/tree/main
                var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
                var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
                var htmlCtrlEntityRegex = /&(newline|tab);/gi;
                var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
                var urlSchemeRegex = /^.+(:|&colon;)/gim;
                var relativeFirstCharacters = [
                    ".",
                    "/"
                ];
                var BLANK_URL = "about:blank";
                function isRelativeUrlWithoutProtocol(url) {
                    return relativeFirstCharacters.indexOf(url[0]) > -1;
                }
                // adapted from https://stackoverflow.com/a/29824550/2601552
                function decodeHtmlCharacters(str) {
                    var removedNullByte = str.replace(ctrlCharactersRegex, "");
                    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
                        return String.fromCharCode(dec);
                    });
                }
                function sanitizeUrl(url) {
                    if (!url) return BLANK_URL;
                    var sanitizedUrl = decodeHtmlCharacters(url).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
                    if (!sanitizedUrl) return BLANK_URL;
                    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
                    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
                    if (!urlSchemeParseResults) return sanitizedUrl;
                    var urlScheme = urlSchemeParseResults[0];
                    if (invalidProtocolRegex.test(urlScheme)) return BLANK_URL;
                    return sanitizedUrl;
                }
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AudioAssetWrapper: ()=>/* binding */ AudioAssetWrapper,
                    /* harmony export */ AudioWrapper: ()=>/* binding */ AudioWrapper,
                    /* harmony export */ CustomFileAssetLoaderWrapper: ()=>/* binding */ CustomFileAssetLoaderWrapper,
                    /* harmony export */ FileAssetWrapper: ()=>/* binding */ FileAssetWrapper,
                    /* harmony export */ FileFinalizer: ()=>/* binding */ FileFinalizer,
                    /* harmony export */ FontAssetWrapper: ()=>/* binding */ FontAssetWrapper,
                    /* harmony export */ FontWrapper: ()=>/* binding */ FontWrapper,
                    /* harmony export */ ImageAssetWrapper: ()=>/* binding */ ImageAssetWrapper,
                    /* harmony export */ ImageWrapper: ()=>/* binding */ ImageWrapper,
                    /* harmony export */ createFinalization: ()=>/* binding */ createFinalization,
                    /* harmony export */ finalizationRegistry: ()=>/* binding */ finalizationRegistry
                });
                var __extends = function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var FileFinalizer = /** @class */ function() {
                    function FileFinalizer(file) {
                        this.selfUnref = false;
                        this._file = file;
                    }
                    FileFinalizer.prototype.unref = function() {
                        if (this._file) this._file.unref();
                    };
                    return FileFinalizer;
                }();
                var ObjectFinalizer = /** @class */ function() {
                    function ObjectFinalizer(finalizableObject) {
                        this._finalizableObject = finalizableObject;
                    }
                    ObjectFinalizer.prototype.unref = function() {
                        this._finalizableObject.unref();
                    };
                    return ObjectFinalizer;
                }();
                var AssetWrapper = /** @class */ function() {
                    function AssetWrapper() {
                        this.selfUnref = false;
                    }
                    AssetWrapper.prototype.unref = function() {};
                    return AssetWrapper;
                }();
                var ImageWrapper = /** @class */ function(_super) {
                    __extends(ImageWrapper, _super);
                    function ImageWrapper(image) {
                        var _this = _super.call(this) || this;
                        _this._nativeImage = image;
                        return _this;
                    }
                    Object.defineProperty(ImageWrapper.prototype, "nativeImage", {
                        get: function() {
                            return this._nativeImage;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ImageWrapper.prototype.unref = function() {
                        if (this.selfUnref) this._nativeImage.unref();
                    };
                    return ImageWrapper;
                }(AssetWrapper);
                var AudioWrapper = /** @class */ function(_super) {
                    __extends(AudioWrapper, _super);
                    function AudioWrapper(audio) {
                        var _this = _super.call(this) || this;
                        _this._nativeAudio = audio;
                        return _this;
                    }
                    Object.defineProperty(AudioWrapper.prototype, "nativeAudio", {
                        get: function() {
                            return this._nativeAudio;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AudioWrapper.prototype.unref = function() {
                        if (this.selfUnref) this._nativeAudio.unref();
                    };
                    return AudioWrapper;
                }(AssetWrapper);
                var FontWrapper = /** @class */ function(_super) {
                    __extends(FontWrapper, _super);
                    function FontWrapper(font) {
                        var _this = _super.call(this) || this;
                        _this._nativeFont = font;
                        return _this;
                    }
                    Object.defineProperty(FontWrapper.prototype, "nativeFont", {
                        get: function() {
                            return this._nativeFont;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    FontWrapper.prototype.unref = function() {
                        if (this.selfUnref) this._nativeFont.unref();
                    };
                    return FontWrapper;
                }(AssetWrapper);
                var CustomFileAssetLoaderWrapper = /** @class */ function() {
                    function CustomFileAssetLoaderWrapper(runtime, loaderCallback) {
                        this._assetLoaderCallback = loaderCallback;
                        this.assetLoader = new runtime.CustomFileAssetLoader({
                            loadContents: this.loadContents.bind(this)
                        });
                    }
                    CustomFileAssetLoaderWrapper.prototype.loadContents = function(asset, bytes) {
                        var assetWrapper;
                        if (asset.isImage) assetWrapper = new ImageAssetWrapper(asset);
                        else if (asset.isAudio) assetWrapper = new AudioAssetWrapper(asset);
                        else if (asset.isFont) assetWrapper = new FontAssetWrapper(asset);
                        return this._assetLoaderCallback(assetWrapper, bytes);
                    };
                    return CustomFileAssetLoaderWrapper;
                }();
                /**
 * Rive class representing a FileAsset with relevant metadata fields to describe
 * an asset associated wtih the Rive File
 */ var FileAssetWrapper = /** @class */ function() {
                    function FileAssetWrapper(nativeAsset) {
                        this._nativeFileAsset = nativeAsset;
                    }
                    FileAssetWrapper.prototype.decode = function(bytes) {
                        this._nativeFileAsset.decode(bytes);
                    };
                    Object.defineProperty(FileAssetWrapper.prototype, "name", {
                        get: function() {
                            return this._nativeFileAsset.name;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "fileExtension", {
                        get: function() {
                            return this._nativeFileAsset.fileExtension;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "uniqueFilename", {
                        get: function() {
                            return this._nativeFileAsset.uniqueFilename;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "isAudio", {
                        get: function() {
                            return this._nativeFileAsset.isAudio;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "isImage", {
                        get: function() {
                            return this._nativeFileAsset.isImage;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "isFont", {
                        get: function() {
                            return this._nativeFileAsset.isFont;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "cdnUuid", {
                        get: function() {
                            return this._nativeFileAsset.cdnUuid;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "nativeFileAsset", {
                        get: function() {
                            return this._nativeFileAsset;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return FileAssetWrapper;
                }();
                /**
 * Rive class extending the FileAsset that exposes a `setRenderImage()` API with a
 * decoded Image (via the `decodeImage()` API) to set a new Image on the Rive FileAsset
 */ var ImageAssetWrapper = /** @class */ function(_super) {
                    __extends(ImageAssetWrapper, _super);
                    function ImageAssetWrapper() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ImageAssetWrapper.prototype.setRenderImage = function(image) {
                        this._nativeFileAsset.setRenderImage(image.nativeImage);
                    };
                    return ImageAssetWrapper;
                }(FileAssetWrapper);
                /**
 * Rive class extending the FileAsset that exposes a `setAudioSource()` API with a
 * decoded Audio (via the `decodeAudio()` API) to set a new Audio on the Rive FileAsset
 */ var AudioAssetWrapper = /** @class */ function(_super) {
                    __extends(AudioAssetWrapper, _super);
                    function AudioAssetWrapper() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    AudioAssetWrapper.prototype.setAudioSource = function(audio) {
                        this._nativeFileAsset.setAudioSource(audio.nativeAudio);
                    };
                    return AudioAssetWrapper;
                }(FileAssetWrapper);
                /**
 * Rive class extending the FileAsset that exposes a `setFont()` API with a
 * decoded Font (via the `decodeFont()` API) to set a new Font on the Rive FileAsset
 */ var FontAssetWrapper = /** @class */ function(_super) {
                    __extends(FontAssetWrapper, _super);
                    function FontAssetWrapper() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FontAssetWrapper.prototype.setFont = function(font) {
                        this._nativeFileAsset.setFont(font.nativeFont);
                    };
                    return FontAssetWrapper;
                }(FileAssetWrapper);
                var FakeFinalizationRegistry = /** @class */ function() {
                    function FakeFinalizationRegistry(_) {}
                    FakeFinalizationRegistry.prototype.register = function(object) {
                        object.selfUnref = true;
                    };
                    FakeFinalizationRegistry.prototype.unregister = function(_) {};
                    return FakeFinalizationRegistry;
                }();
                var MyFinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : FakeFinalizationRegistry;
                var finalizationRegistry = new MyFinalizationRegistry(function(ob) {
                    ob === null || ob === void 0 || ob.unref();
                });
                var createFinalization = function(target, finalizable) {
                    var finalizer = new ObjectFinalizer(finalizable);
                    finalizationRegistry.register(target, finalizer);
                };
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
        (()=>{
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ Alignment: ()=>/* binding */ Alignment,
                /* harmony export */ DataEnum: ()=>/* binding */ DataEnum,
                /* harmony export */ EventType: ()=>/* binding */ EventType,
                /* harmony export */ Fit: ()=>/* binding */ Fit,
                /* harmony export */ Layout: ()=>/* binding */ Layout,
                /* harmony export */ LoopType: ()=>/* binding */ LoopType,
                /* harmony export */ Rive: ()=>/* binding */ Rive,
                /* harmony export */ RiveEventType: ()=>/* binding */ RiveEventType,
                /* harmony export */ RiveFile: ()=>/* binding */ RiveFile,
                /* harmony export */ RuntimeLoader: ()=>/* binding */ RuntimeLoader,
                /* harmony export */ StateMachineInput: ()=>/* binding */ StateMachineInput,
                /* harmony export */ StateMachineInputType: ()=>/* binding */ StateMachineInputType,
                /* harmony export */ Testing: ()=>/* binding */ Testing,
                /* harmony export */ ViewModel: ()=>/* binding */ ViewModel,
                /* harmony export */ ViewModelInstance: ()=>/* binding */ ViewModelInstance,
                /* harmony export */ ViewModelInstanceArtboard: ()=>/* binding */ ViewModelInstanceArtboard,
                /* harmony export */ ViewModelInstanceAssetImage: ()=>/* binding */ ViewModelInstanceAssetImage,
                /* harmony export */ ViewModelInstanceBoolean: ()=>/* binding */ ViewModelInstanceBoolean,
                /* harmony export */ ViewModelInstanceColor: ()=>/* binding */ ViewModelInstanceColor,
                /* harmony export */ ViewModelInstanceEnum: ()=>/* binding */ ViewModelInstanceEnum,
                /* harmony export */ ViewModelInstanceList: ()=>/* binding */ ViewModelInstanceList,
                /* harmony export */ ViewModelInstanceNumber: ()=>/* binding */ ViewModelInstanceNumber,
                /* harmony export */ ViewModelInstanceString: ()=>/* binding */ ViewModelInstanceString,
                /* harmony export */ ViewModelInstanceTrigger: ()=>/* binding */ ViewModelInstanceTrigger,
                /* harmony export */ ViewModelInstanceValue: ()=>/* binding */ ViewModelInstanceValue,
                /* harmony export */ decodeAudio: ()=>/* binding */ decodeAudio,
                /* harmony export */ decodeFont: ()=>/* binding */ decodeFont,
                /* harmony export */ decodeImage: ()=>/* binding */ decodeImage
            });
            /* harmony import */ var _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var package_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
                return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var __spreadArray = function(to, from, pack) {
                if (pack || arguments.length === 2) {
                    for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            };
            var RiveError = /** @class */ function(_super) {
                __extends(RiveError, _super);
                function RiveError() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isHandledError = true;
                    return _this;
                }
                return RiveError;
            }(Error);
            // #regions helpers
            var resolveErrorMessage = function(error) {
                return error && error.isHandledError ? error.message : "Problem loading file; may be corrupt!";
            };
            // #region layout
            // Fit options for the canvas
            var Fit;
            (function(Fit) {
                Fit["Cover"] = "cover";
                Fit["Contain"] = "contain";
                Fit["Fill"] = "fill";
                Fit["FitWidth"] = "fitWidth";
                Fit["FitHeight"] = "fitHeight";
                Fit["None"] = "none";
                Fit["ScaleDown"] = "scaleDown";
                Fit["Layout"] = "layout";
            })(Fit || (Fit = {}));
            // Alignment options for the canvas
            var Alignment;
            (function(Alignment) {
                Alignment["Center"] = "center";
                Alignment["TopLeft"] = "topLeft";
                Alignment["TopCenter"] = "topCenter";
                Alignment["TopRight"] = "topRight";
                Alignment["CenterLeft"] = "centerLeft";
                Alignment["CenterRight"] = "centerRight";
                Alignment["BottomLeft"] = "bottomLeft";
                Alignment["BottomCenter"] = "bottomCenter";
                Alignment["BottomRight"] = "bottomRight";
            })(Alignment || (Alignment = {}));
            // Alignment options for Rive animations in a HTML canvas
            var Layout = /** @class */ function() {
                function Layout(params) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    this.fit = (_a = params === null || params === void 0 ? void 0 : params.fit) !== null && _a !== void 0 ? _a : Fit.Contain;
                    this.alignment = (_b = params === null || params === void 0 ? void 0 : params.alignment) !== null && _b !== void 0 ? _b : Alignment.Center;
                    this.layoutScaleFactor = (_c = params === null || params === void 0 ? void 0 : params.layoutScaleFactor) !== null && _c !== void 0 ? _c : 1;
                    this.minX = (_d = params === null || params === void 0 ? void 0 : params.minX) !== null && _d !== void 0 ? _d : 0;
                    this.minY = (_e = params === null || params === void 0 ? void 0 : params.minY) !== null && _e !== void 0 ? _e : 0;
                    this.maxX = (_f = params === null || params === void 0 ? void 0 : params.maxX) !== null && _f !== void 0 ? _f : 0;
                    this.maxY = (_g = params === null || params === void 0 ? void 0 : params.maxY) !== null && _g !== void 0 ? _g : 0;
                }
                // Alternative constructor to build a Layout from an interface/object
                Layout.new = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    console.warn("This function is deprecated: please use `new Layout({})` instead");
                    return new Layout({
                        fit: fit,
                        alignment: alignment,
                        minX: minX,
                        minY: minY,
                        maxX: maxX,
                        maxY: maxY
                    });
                };
                /**
     * Makes a copy of the layout, replacing any specified parameters
     */ Layout.prototype.copyWith = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, layoutScaleFactor = _a.layoutScaleFactor, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    return new Layout({
                        fit: fit !== null && fit !== void 0 ? fit : this.fit,
                        alignment: alignment !== null && alignment !== void 0 ? alignment : this.alignment,
                        layoutScaleFactor: layoutScaleFactor !== null && layoutScaleFactor !== void 0 ? layoutScaleFactor : this.layoutScaleFactor,
                        minX: minX !== null && minX !== void 0 ? minX : this.minX,
                        minY: minY !== null && minY !== void 0 ? minY : this.minY,
                        maxX: maxX !== null && maxX !== void 0 ? maxX : this.maxX,
                        maxY: maxY !== null && maxY !== void 0 ? maxY : this.maxY
                    });
                };
                // Returns fit for the Wasm runtime format
                Layout.prototype.runtimeFit = function(rive) {
                    if (this.cachedRuntimeFit) return this.cachedRuntimeFit;
                    var fit;
                    if (this.fit === Fit.Cover) fit = rive.Fit.cover;
                    else if (this.fit === Fit.Contain) fit = rive.Fit.contain;
                    else if (this.fit === Fit.Fill) fit = rive.Fit.fill;
                    else if (this.fit === Fit.FitWidth) fit = rive.Fit.fitWidth;
                    else if (this.fit === Fit.FitHeight) fit = rive.Fit.fitHeight;
                    else if (this.fit === Fit.ScaleDown) fit = rive.Fit.scaleDown;
                    else if (this.fit === Fit.Layout) fit = rive.Fit.layout;
                    else fit = rive.Fit.none;
                    this.cachedRuntimeFit = fit;
                    return fit;
                };
                // Returns alignment for the Wasm runtime format
                Layout.prototype.runtimeAlignment = function(rive) {
                    if (this.cachedRuntimeAlignment) return this.cachedRuntimeAlignment;
                    var alignment;
                    if (this.alignment === Alignment.TopLeft) alignment = rive.Alignment.topLeft;
                    else if (this.alignment === Alignment.TopCenter) alignment = rive.Alignment.topCenter;
                    else if (this.alignment === Alignment.TopRight) alignment = rive.Alignment.topRight;
                    else if (this.alignment === Alignment.CenterLeft) alignment = rive.Alignment.centerLeft;
                    else if (this.alignment === Alignment.CenterRight) alignment = rive.Alignment.centerRight;
                    else if (this.alignment === Alignment.BottomLeft) alignment = rive.Alignment.bottomLeft;
                    else if (this.alignment === Alignment.BottomCenter) alignment = rive.Alignment.bottomCenter;
                    else if (this.alignment === Alignment.BottomRight) alignment = rive.Alignment.bottomRight;
                    else alignment = rive.Alignment.center;
                    this.cachedRuntimeAlignment = alignment;
                    return alignment;
                };
                return Layout;
            }();
            // Runtime singleton; use getInstance to provide a callback that returns the
            // Rive runtime
            var RuntimeLoader = /** @class */ function() {
                // Class is never instantiated
                function RuntimeLoader() {}
                // Loads the runtime
                RuntimeLoader.loadRuntime = function() {
                    _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]({
                        // Loads Wasm bundle
                        locateFile: function() {
                            return RuntimeLoader.wasmURL;
                        }
                    }).then(function(rive) {
                        var _a;
                        RuntimeLoader.runtime = rive;
                        // Fire all the callbacks
                        while(RuntimeLoader.callBackQueue.length > 0)(_a = RuntimeLoader.callBackQueue.shift()) === null || _a === void 0 || _a(RuntimeLoader.runtime);
                    }).catch(function(error) {
                        // Capture specific error details
                        var errorDetails = {
                            message: (error === null || error === void 0 ? void 0 : error.message) || "Unknown error",
                            type: (error === null || error === void 0 ? void 0 : error.name) || "Error",
                            // Some browsers may provide additional WebAssembly-specific details
                            wasmError: error instanceof WebAssembly.CompileError || error instanceof WebAssembly.RuntimeError,
                            originalError: error
                        };
                        // Log detailed error for debugging
                        console.debug("Rive WASM load error details:", errorDetails);
                        // In case unpkg fails, or the wasm was not supported, we try to load the fallback module from jsdelivr.
                        // This `rive_fallback.wasm` is compiled to support older architecture.
                        // TODO: (Gordon): preemptively test browser support and load the correct wasm file. Then use jsdelvr only if unpkg fails.
                        var backupJsdelivrUrl = "https://cdn.jsdelivr.net/npm/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive_fallback.wasm");
                        if (RuntimeLoader.wasmURL.toLowerCase() !== backupJsdelivrUrl) {
                            console.warn("Failed to load WASM from ".concat(RuntimeLoader.wasmURL, " (").concat(errorDetails.message, "), trying jsdelivr as a backup"));
                            RuntimeLoader.setWasmUrl(backupJsdelivrUrl);
                            RuntimeLoader.loadRuntime();
                        } else {
                            var errorMessage = [
                                "Could not load Rive WASM file from ".concat(RuntimeLoader.wasmURL, " or ").concat(backupJsdelivrUrl, "."),
                                "Possible reasons:",
                                "- Network connection is down",
                                "- WebAssembly is not supported in this environment",
                                "- The WASM file is corrupted or incompatible",
                                "\nError details:",
                                "- Type: ".concat(errorDetails.type),
                                "- Message: ".concat(errorDetails.message),
                                "- WebAssembly-specific error: ".concat(errorDetails.wasmError),
                                "\nTo resolve, you may need to:",
                                "1. Check your network connection",
                                "2. Set a new WASM source via RuntimeLoader.setWasmUrl()",
                                "3. Call RuntimeLoader.loadRuntime() again"
                            ].join("\n");
                            console.error(errorMessage);
                        }
                    });
                };
                // Provides a runtime instance via a callback
                RuntimeLoader.getInstance = function(callback) {
                    // If it's not loading, start loading runtime
                    if (!RuntimeLoader.isLoading) {
                        RuntimeLoader.isLoading = true;
                        RuntimeLoader.loadRuntime();
                    }
                    if (!RuntimeLoader.runtime) RuntimeLoader.callBackQueue.push(callback);
                    else callback(RuntimeLoader.runtime);
                };
                // Provides a runtime instance via a promise
                RuntimeLoader.awaitInstance = function() {
                    return new Promise(function(resolve) {
                        return RuntimeLoader.getInstance(function(rive) {
                            return resolve(rive);
                        });
                    });
                };
                // Manually sets the wasm url
                RuntimeLoader.setWasmUrl = function(url) {
                    RuntimeLoader.wasmURL = url;
                };
                // Gets the current wasm url
                RuntimeLoader.getWasmUrl = function() {
                    return RuntimeLoader.wasmURL;
                };
                // Flag to indicate that loading has started/completed
                RuntimeLoader.isLoading = false;
                // List of callbacks for the runtime that come in while loading
                RuntimeLoader.callBackQueue = [];
                // Path to the Wasm file; default path works for testing only;
                // if embedded wasm is used then this is never used.
                RuntimeLoader.wasmURL = "https://unpkg.com/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive.wasm");
                return RuntimeLoader;
            }();
            // #endregion
            // #region state machines
            var StateMachineInputType;
            (function(StateMachineInputType) {
                StateMachineInputType[StateMachineInputType["Number"] = 56] = "Number";
                StateMachineInputType[StateMachineInputType["Trigger"] = 58] = "Trigger";
                StateMachineInputType[StateMachineInputType["Boolean"] = 59] = "Boolean";
            })(StateMachineInputType || (StateMachineInputType = {}));
            /**
 * An input for a state machine
 */ var StateMachineInput = /** @class */ function() {
                function StateMachineInput(type, runtimeInput) {
                    this.type = type;
                    this.runtimeInput = runtimeInput;
                }
                Object.defineProperty(StateMachineInput.prototype, "name", {
                    /**
         * Returns the name of the input
         */ get: function() {
                        return this.runtimeInput.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachineInput.prototype, "value", {
                    /**
         * Returns the current value of the input
         */ get: function() {
                        return this.runtimeInput.value;
                    },
                    /**
         * Sets the value of the input
         */ set: function(value) {
                        this.runtimeInput.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Fires a trigger; does nothing on Number or Boolean input types
     */ StateMachineInput.prototype.fire = function() {
                    if (this.type === StateMachineInputType.Trigger) this.runtimeInput.fire();
                };
                /**
     * Deletes the input
     */ StateMachineInput.prototype.delete = function() {
                    this.runtimeInput = null;
                };
                return StateMachineInput;
            }();
            var RiveEventType;
            (function(RiveEventType) {
                RiveEventType[RiveEventType["General"] = 128] = "General";
                RiveEventType[RiveEventType["OpenUrl"] = 131] = "OpenUrl";
            })(RiveEventType || (RiveEventType = {}));
            var BaseArtboard = /** @class */ function() {
                function BaseArtboard(_isBindableArtboard) {
                    this.isBindableArtboard = false;
                    this.isBindableArtboard = _isBindableArtboard;
                }
                return BaseArtboard;
            }();
            var Artboard = /** @class */ function(_super) {
                __extends(Artboard, _super);
                function Artboard(artboard, _file) {
                    var _this = _super.call(this, false) || this;
                    _this.nativeArtboard = artboard;
                    _this.file = _file;
                    return _this;
                }
                return Artboard;
            }(BaseArtboard);
            var BindableArtboard = /** @class */ function(_super) {
                __extends(BindableArtboard, _super);
                function BindableArtboard(artboard) {
                    var _this = _super.call(this, true) || this;
                    _this.selfUnref = false;
                    _this.nativeArtboard = artboard;
                    return _this;
                }
                BindableArtboard.prototype.destroy = function() {
                    if (this.selfUnref) this.nativeArtboard.unref();
                };
                return BindableArtboard;
            }(BaseArtboard);
            var StateMachine = /** @class */ function() {
                /**
     * @constructor
     * @param stateMachine runtime state machine object
     * @param instance runtime state machine instance object
     */ function StateMachine(stateMachine, runtime, playing, artboard) {
                    this.stateMachine = stateMachine;
                    this.playing = playing;
                    this.artboard = artboard;
                    /**
         * Caches the inputs from the runtime
         */ this.inputs = [];
                    this.instance = new runtime.StateMachineInstance(stateMachine, artboard);
                    this.initInputs(runtime);
                }
                Object.defineProperty(StateMachine.prototype, "name", {
                    get: function() {
                        return this.stateMachine.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachine.prototype, "statesChanged", {
                    /**
         * Returns a list of state names that have changed on this frame
         */ get: function() {
                        var names = [];
                        for(var i = 0; i < this.instance.stateChangedCount(); i++)names.push(this.instance.stateChangedNameByIndex(i));
                        return names;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Advances the state machine instance by a given time.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advance = function(time) {
                    this.instance.advance(time);
                };
                /**
     * Advances the state machine instance by a given time and apply changes to artboard.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advanceAndApply = function(time) {
                    this.instance.advanceAndApply(time);
                };
                /**
     * Returns the number of events reported from the last advance call
     * @returns Number of events reported
     */ StateMachine.prototype.reportedEventCount = function() {
                    return this.instance.reportedEventCount();
                };
                /**
     * Returns a RiveEvent object emitted from the last advance call at the given index
     * of a list of potentially multiple events. If an event at the index is not found,
     * undefined is returned.
     * @param i index of the event reported in a list of potentially multiple events
     * @returns RiveEvent or extended RiveEvent object returned, or undefined
     */ StateMachine.prototype.reportedEventAt = function(i) {
                    return this.instance.reportedEventAt(i);
                };
                /**
     * Fetches references to the state machine's inputs and caches them
     * @param runtime an instance of the runtime; needed for the SMIInput types
     */ StateMachine.prototype.initInputs = function(runtime) {
                    // Fetch the inputs from the runtime if we don't have them
                    for(var i = 0; i < this.instance.inputCount(); i++){
                        var input = this.instance.input(i);
                        this.inputs.push(this.mapRuntimeInput(input, runtime));
                    }
                };
                /**
     * Maps a runtime input to it's appropriate type
     * @param input
     */ StateMachine.prototype.mapRuntimeInput = function(input, runtime) {
                    if (input.type === runtime.SMIInput.bool) return new StateMachineInput(StateMachineInputType.Boolean, input.asBool());
                    else if (input.type === runtime.SMIInput.number) return new StateMachineInput(StateMachineInputType.Number, input.asNumber());
                    else if (input.type === runtime.SMIInput.trigger) return new StateMachineInput(StateMachineInputType.Trigger, input.asTrigger());
                };
                /**
     * Deletes the backing Wasm state machine instance; once this is called, this
     * state machine is no more.
     */ StateMachine.prototype.cleanup = function() {
                    this.inputs.forEach(function(input) {
                        input.delete();
                    });
                    this.inputs.length = 0;
                    this.instance.delete();
                };
                StateMachine.prototype.bindViewModelInstance = function(viewModelInstance) {
                    if (viewModelInstance.runtimeInstance != null) this.instance.bindViewModelInstance(viewModelInstance.runtimeInstance);
                };
                return StateMachine;
            }();
            // #endregion
            // #region animator
            /**
 * Manages animation
 */ var Animator = /** @class */ function() {
                /**
     * Constructs a new animator
     * @constructor
     * @param runtime Rive runtime; needed to instance animations & state machines
     * @param artboard the artboard that holds all animations and state machines
     * @param animations optional list of animations
     * @param stateMachines optional list of state machines
     */ function Animator(runtime, artboard, eventManager, animations, stateMachines) {
                    if (animations === void 0) animations = [];
                    if (stateMachines === void 0) stateMachines = [];
                    this.runtime = runtime;
                    this.artboard = artboard;
                    this.eventManager = eventManager;
                    this.animations = animations;
                    this.stateMachines = stateMachines;
                }
                /**
     * Adds animations and state machines by their names. If names are shared
     * between animations & state machines, then the first one found will be
     * created. Best not to use the same names for these in your Rive file.
     * @param animatable the name(s) of animations and state machines to add
     * @returns a list of names of the playing animations and state machines
     */ Animator.prototype.add = function(animatables, playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    animatables = mapToStringArray(animatables);
                    // If animatables is empty, play or pause everything
                    if (animatables.length === 0) {
                        this.animations.forEach(function(a) {
                            return a.playing = playing;
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.playing = playing;
                        });
                    } else {
                        // Play/pause already instanced items, or create new instances
                        var instancedAnimationNames = this.animations.map(function(a) {
                            return a.name;
                        });
                        var instancedMachineNames = this.stateMachines.map(function(m) {
                            return m.name;
                        });
                        for(var i = 0; i < animatables.length; i++){
                            var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                            var mIndex = instancedMachineNames.indexOf(animatables[i]);
                            if (aIndex >= 0 || mIndex >= 0) {
                                if (aIndex >= 0) // Animation is instanced, play/pause it
                                this.animations[aIndex].playing = playing;
                                else // State machine is instanced, play/pause it
                                this.stateMachines[mIndex].playing = playing;
                            } else {
                                // Try to create a new animation instance
                                var anim = this.artboard.animationByName(animatables[i]);
                                if (anim) {
                                    var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                    // Display the first frame of the specified animation
                                    newAnimation.advance(0);
                                    newAnimation.apply(1.0);
                                    this.animations.push(newAnimation);
                                } else {
                                    // Try to create a new state machine instance
                                    var sm = this.artboard.stateMachineByName(animatables[i]);
                                    if (sm) {
                                        var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                        this.stateMachines.push(newStateMachine);
                                    }
                                }
                            }
                        }
                    }
                    // Fire play/paused events for animations
                    if (fireEvent) {
                        if (playing) this.eventManager.fire({
                            type: EventType.Play,
                            data: this.playing
                        });
                        else this.eventManager.fire({
                            type: EventType.Pause,
                            data: this.paused
                        });
                    }
                    return playing ? this.playing : this.paused;
                };
                /**
     * Adds linear animations by their names.
     * @param animatables the name(s) of animations to add
     * @param playing whether animations should play on instantiation
     */ Animator.prototype.initLinearAnimations = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedAnimationNames = this.animations.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.animations[aIndex].playing = playing;
                        else {
                            // Try to create a new animation instance
                            var anim = this.artboard.animationByName(animatables[i]);
                            if (anim) {
                                var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                // Display the first frame of the specified animation
                                newAnimation.advance(0);
                                newAnimation.apply(1.0);
                                this.animations.push(newAnimation);
                            } else console.error("Animation with name ".concat(animatables[i], " not found."));
                        }
                    }
                };
                /**
     * Adds state machines by their names.
     * @param animatables the name(s) of state machines to add
     * @param playing whether state machines should play on instantiation
     */ Animator.prototype.initStateMachines = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedStateMachineNames = this.stateMachines.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedStateMachineNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.stateMachines[aIndex].playing = playing;
                        else {
                            // Try to create a new state machine instance
                            var sm = this.artboard.stateMachineByName(animatables[i]);
                            if (sm) {
                                var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                this.stateMachines.push(newStateMachine);
                            } else {
                                console.warn("State Machine with name ".concat(animatables[i], " not found."));
                                // In order to maintain compatibility with current behavior, if a state machine is not found
                                // we look for an animation with the same name
                                this.initLinearAnimations([
                                    animatables[i]
                                ], playing);
                            }
                        }
                    }
                };
                /**
     * Play the named animations/state machines
     * @param animatables the names of the animations/machines to play; plays all if empty
     * @returns a list of the playing items
     */ Animator.prototype.play = function(animatables) {
                    return this.add(animatables, true);
                };
                /**
     * Advance state machines if they are paused after initialization
     */ Animator.prototype.advanceIfPaused = function() {
                    this.stateMachines.forEach(function(sm) {
                        if (!sm.playing) sm.advanceAndApply(0);
                    });
                };
                /**
     * Pauses named animations and state machines, or everything if nothing is
     * specified
     * @param animatables names of the animations and state machines to pause
     * @returns a list of names of the animations and state machines paused
     */ Animator.prototype.pause = function(animatables) {
                    return this.add(animatables, false);
                };
                /**
     * Set time of named animations
     * @param animations names of the animations to scrub
     * @param value time scrub value, a floating point number to which the playhead is jumped
     * @returns a list of names of the animations that were scrubbed
     */ Animator.prototype.scrub = function(animatables, value) {
                    var forScrubbing = this.animations.filter(function(a) {
                        return animatables.includes(a.name);
                    });
                    forScrubbing.forEach(function(a) {
                        return a.scrubTo = value;
                    });
                    return forScrubbing.map(function(a) {
                        return a.name;
                    });
                };
                Object.defineProperty(Animator.prototype, "playing", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * playing
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "paused", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * paused
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Stops and removes all named animations and state machines
     * @param animatables animations and state machines to remove
     * @returns a list of names of removed items
     */ Animator.prototype.stop = function(animatables) {
                    var _this = this;
                    animatables = mapToStringArray(animatables);
                    // If nothing's specified, wipe them out, all of them
                    var removedNames = [];
                    // Stop everything
                    if (animatables.length === 0) {
                        removedNames = this.animations.map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.map(function(m) {
                            return m.name;
                        }));
                        // Clean up before emptying the arrays
                        this.animations.forEach(function(a) {
                            return a.cleanup();
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.cleanup();
                        });
                        // Empty out the arrays
                        this.animations.splice(0, this.animations.length);
                        this.stateMachines.splice(0, this.stateMachines.length);
                    } else {
                        // Remove only the named animations/state machines
                        var animationsToRemove = this.animations.filter(function(a) {
                            return animatables.includes(a.name);
                        });
                        animationsToRemove.forEach(function(a) {
                            a.cleanup();
                            _this.animations.splice(_this.animations.indexOf(a), 1);
                        });
                        var machinesToRemove = this.stateMachines.filter(function(m) {
                            return animatables.includes(m.name);
                        });
                        machinesToRemove.forEach(function(m) {
                            m.cleanup();
                            _this.stateMachines.splice(_this.stateMachines.indexOf(m), 1);
                        });
                        removedNames = animationsToRemove.map(function(a) {
                            return a.name;
                        }).concat(machinesToRemove.map(function(m) {
                            return m.name;
                        }));
                    }
                    this.eventManager.fire({
                        type: EventType.Stop,
                        data: removedNames
                    });
                    // Return the list of animations removed
                    return removedNames;
                };
                Object.defineProperty(Animator.prototype, "isPlaying", {
                    /**
         * Returns true if at least one animation is active
         */ get: function() {
                        return this.animations.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false) || this.stateMachines.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isPaused", {
                    /**
         * Returns true if all animations are paused and there's at least one animation
         */ get: function() {
                        return !this.isPlaying && (this.animations.length > 0 || this.stateMachines.length > 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isStopped", {
                    /**
         * Returns true if there are no playing or paused animations/state machines
         */ get: function() {
                        return this.animations.length === 0 && this.stateMachines.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * If there are no animations or state machines, add the first one found
     * @returns the name of the animation or state machine instanced
     */ Animator.prototype.atLeastOne = function(playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    var instancedName;
                    if (this.animations.length === 0 && this.stateMachines.length === 0) {
                        if (this.artboard.animationCount() > 0) // Add the first animation
                        this.add([
                            instancedName = this.artboard.animationByIndex(0).name
                        ], playing, fireEvent);
                        else if (this.artboard.stateMachineCount() > 0) // Add the first state machine
                        this.add([
                            instancedName = this.artboard.stateMachineByIndex(0).name
                        ], playing, fireEvent);
                    }
                    return instancedName;
                };
                /**
     * Checks if any animations have looped and if so, fire the appropriate event
     */ Animator.prototype.handleLooping = function() {
                    for(var _i = 0, _a = this.animations.filter(function(a) {
                        return a.playing;
                    }); _i < _a.length; _i++){
                        var animation = _a[_i];
                        // Emit if the animation looped
                        if (animation.loopValue === 0 && animation.loopCount) {
                            animation.loopCount = 0;
                            // This is a one-shot; if it has ended, delete the instance
                            this.stop(animation.name);
                        } else if (animation.loopValue === 1 && animation.loopCount) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.Loop
                                }
                            });
                            animation.loopCount = 0;
                        } else if (animation.loopValue === 2 && animation.loopCount > 1) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.PingPong
                                }
                            });
                            animation.loopCount = 0;
                        }
                    }
                };
                /**
     * Checks if states have changed in state machines and fires a statechange
     * event
     */ Animator.prototype.handleStateChanges = function() {
                    var statesChanged = [];
                    for(var _i = 0, _a = this.stateMachines.filter(function(sm) {
                        return sm.playing;
                    }); _i < _a.length; _i++){
                        var stateMachine = _a[_i];
                        statesChanged.push.apply(statesChanged, stateMachine.statesChanged);
                    }
                    if (statesChanged.length > 0) this.eventManager.fire({
                        type: EventType.StateChange,
                        data: statesChanged
                    });
                };
                Animator.prototype.handleAdvancing = function(time) {
                    this.eventManager.fire({
                        type: EventType.Advance,
                        data: time
                    });
                };
                return Animator;
            }();
            // #endregion
            // #region events
            /**
 * Supported event types triggered in Rive
 */ var EventType;
            (function(EventType) {
                EventType["Load"] = "load";
                EventType["LoadError"] = "loaderror";
                EventType["Play"] = "play";
                EventType["Pause"] = "pause";
                EventType["Stop"] = "stop";
                EventType["Loop"] = "loop";
                EventType["Draw"] = "draw";
                EventType["Advance"] = "advance";
                EventType["StateChange"] = "statechange";
                EventType["RiveEvent"] = "riveevent";
                EventType["AudioStatusChange"] = "audiostatuschange";
            })(EventType || (EventType = {}));
            /**
 * Looping types: one-shot, loop, and ping-pong
 */ var LoopType;
            (function(LoopType) {
                LoopType["OneShot"] = "oneshot";
                LoopType["Loop"] = "loop";
                LoopType["PingPong"] = "pingpong";
            })(LoopType || (LoopType = {}));
            // Manages Rive events and listeners
            var EventManager = /** @class */ function() {
                function EventManager(listeners) {
                    if (listeners === void 0) listeners = [];
                    this.listeners = listeners;
                }
                // Gets listeners of specified type
                EventManager.prototype.getListeners = function(type) {
                    return this.listeners.filter(function(e) {
                        return e.type === type;
                    });
                };
                // Adds a listener
                EventManager.prototype.add = function(listener) {
                    if (!this.listeners.includes(listener)) this.listeners.push(listener);
                };
                /**
     * Removes a listener
     * @param listener the listener with the callback to be removed
     */ EventManager.prototype.remove = function(listener) {
                    // We can't simply look for the listener as it'll be a different instance to
                    // one originally subscribed. Find all the listeners of the right type and
                    // then check their callbacks which should match.
                    for(var i = 0; i < this.listeners.length; i++){
                        var currentListener = this.listeners[i];
                        if (currentListener.type === listener.type) {
                            if (currentListener.callback === listener.callback) {
                                this.listeners.splice(i, 1);
                                break;
                            }
                        }
                    }
                };
                /**
     * Clears all listeners of specified type, or every listener if no type is
     * specified
     * @param type the type of listeners to clear, or all listeners if not
     * specified
     */ EventManager.prototype.removeAll = function(type) {
                    var _this = this;
                    if (!type) this.listeners.splice(0, this.listeners.length);
                    else this.listeners.filter(function(l) {
                        return l.type === type;
                    }).forEach(function(l) {
                        return _this.remove(l);
                    });
                };
                // Fires an event
                EventManager.prototype.fire = function(event) {
                    var eventListeners = this.getListeners(event.type);
                    eventListeners.forEach(function(listener) {
                        return listener.callback(event);
                    });
                };
                return EventManager;
            }();
            // Manages a queue of tasks
            var TaskQueueManager = /** @class */ function() {
                function TaskQueueManager(eventManager) {
                    this.eventManager = eventManager;
                    this.queue = [];
                }
                // Adds a task top the queue
                TaskQueueManager.prototype.add = function(task) {
                    this.queue.push(task);
                };
                // Processes all tasks in the queue
                TaskQueueManager.prototype.process = function() {
                    while(this.queue.length > 0){
                        var task = this.queue.shift();
                        if (task === null || task === void 0 ? void 0 : task.action) task.action();
                        if (task === null || task === void 0 ? void 0 : task.event) this.eventManager.fire(task.event);
                    }
                };
                return TaskQueueManager;
            }();
            // #endregion
            // #region Audio
            var SystemAudioStatus;
            (function(SystemAudioStatus) {
                SystemAudioStatus[SystemAudioStatus["AVAILABLE"] = 0] = "AVAILABLE";
                SystemAudioStatus[SystemAudioStatus["UNAVAILABLE"] = 1] = "UNAVAILABLE";
            })(SystemAudioStatus || (SystemAudioStatus = {}));
            // Class to handle audio context availability and status changes
            var AudioManager = /** @class */ function(_super) {
                __extends(AudioManager, _super);
                function AudioManager() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this._started = false;
                    _this._enabled = false;
                    _this._status = SystemAudioStatus.UNAVAILABLE;
                    return _this;
                }
                AudioManager.prototype.delay = function(time) {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, time);
                                })
                            ];
                        });
                    });
                };
                AudioManager.prototype.timeout = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(_, reject) {
                                    return setTimeout(reject, 50);
                                })
                            ];
                        });
                    });
                };
                // Alerts animations on status changes and removes the listeners to avoid alerting twice.
                AudioManager.prototype.reportToListeners = function() {
                    this.fire({
                        type: EventType.AudioStatusChange
                    });
                    this.removeAll();
                };
                /**
     * The audio context has been resolved.
     * Alert any listeners that we can now play audio.
     * Rive will now play audio at the configured volume.
     */ AudioManager.prototype.enableAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            if (!this._enabled) {
                                this._enabled = true;
                                this._status = SystemAudioStatus.AVAILABLE;
                                this.reportToListeners();
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                /**
     * Check if we are able to play audio.
     *
     * We currently check the audio context, when resume() returns before a timeout we know that the
     * audio context is running and we can enable audio.
     */ AudioManager.prototype.testAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE && this._audioContext !== null)) return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            this._audioContext.resume(),
                                            this.timeout()
                                        ])
                                    ];
                                case 2:
                                    _b.sent();
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    _a = _b.sent();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Establish audio for use with rive.
     * We both test if we can use audio intermittently and listen for user interaction.
     * The aim is to enable audio playback as soon as the browser allows this.
     */ AudioManager.prototype._establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!!this._started) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    this._started = true;
                                    if (!(typeof window == "undefined")) return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 1:
                                    this._audioContext = new AudioContext();
                                    this.listenForUserAction();
                                    _a.label = 2;
                                case 2:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE)) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.testAudio()
                                    ];
                                case 3:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.delay(1000)
                                    ];
                                case 4:
                                    _a.sent();
                                    return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                AudioManager.prototype.listenForUserAction = function() {
                    var _this = this;
                    // NOTE: AudioContexts are ready immediately if requested in a ui callback
                    // we *could* re request one in this listener.
                    var _clickListener = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                // note this has "better" results than calling `await this.testAudio()`
                                // as we force audio to be enabled in the current thread, rather than chancing
                                // the thread to be passed over for some other async context
                                this.enableAudio();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    // NOTE: we should test this on mobile/pads
                    document.addEventListener("pointerdown", _clickListener, {
                        once: true
                    });
                };
                /**
     * Establish the audio context for rive, this lets rive know that we can play audio.
     */ AudioManager.prototype.establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            this._establishAudio();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                Object.defineProperty(AudioManager.prototype, "systemVolume", {
                    get: function() {
                        if (this._status === SystemAudioStatus.UNAVAILABLE) {
                            // We do an immediate test to avoid depending on the delay of the running test
                            this.testAudio();
                            return 0;
                        }
                        return 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AudioManager.prototype, "status", {
                    get: function() {
                        return this._status;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AudioManager;
            }(EventManager);
            var audioManager = new AudioManager();
            var FakeResizeObserver = /** @class */ function() {
                function FakeResizeObserver() {}
                FakeResizeObserver.prototype.observe = function() {};
                FakeResizeObserver.prototype.unobserve = function() {};
                FakeResizeObserver.prototype.disconnect = function() {};
                return FakeResizeObserver;
            }();
            var MyResizeObserver = globalThis.ResizeObserver || FakeResizeObserver;
            /**
 * This class takes care of any observers that will be attached to an animation.
 * It should be treated as a singleton because observers are much more performant
 * when used for observing multiple elements by a single instance.
 */ var ObjectObservers = /** @class */ function() {
                function ObjectObservers() {
                    var _this = this;
                    this._elementsMap = new Map();
                    /**
         * Resize observers trigger both when the element changes its size and also when the
         * element is added or removed from the document.
         */ this._onObservedEntry = function(entry) {
                        var observed = _this._elementsMap.get(entry.target);
                        if (observed !== null) observed.onResize(entry.target.clientWidth == 0 || entry.target.clientHeight == 0);
                        else _this._resizeObserver.unobserve(entry.target);
                    };
                    this._onObserved = function(entries) {
                        entries.forEach(_this._onObservedEntry);
                    };
                    this._resizeObserver = new MyResizeObserver(this._onObserved);
                }
                // Adds an observable element
                ObjectObservers.prototype.add = function(element, onResize) {
                    var observed = {
                        onResize: onResize,
                        element: element
                    };
                    this._elementsMap.set(element, observed);
                    this._resizeObserver.observe(element);
                    return observed;
                };
                // Removes an observable element
                ObjectObservers.prototype.remove = function(observed) {
                    this._resizeObserver.unobserve(observed.element);
                    this._elementsMap.delete(observed.element);
                };
                return ObjectObservers;
            }();
            var observers = new ObjectObservers();
            var RiveFile = /** @class */ function() {
                function RiveFile(params) {
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    this.referenceCount = 0;
                    this.destroyed = false;
                    this.selfUnref = false;
                    this.bindableArtboards = [];
                    this.src = params.src;
                    this.buffer = params.buffer;
                    if (params.assetLoader) this.assetLoader = params.assetLoader;
                    this.enableRiveAssetCDN = typeof params.enableRiveAssetCDN == "boolean" ? params.enableRiveAssetCDN : true;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                }
                RiveFile.prototype.releaseFile = function() {
                    var _a;
                    if (this.selfUnref) (_a = this.file) === null || _a === void 0 || _a.unref();
                    this.file = null;
                };
                RiveFile.prototype.releaseBindableArtboards = function() {
                    this.bindableArtboards.forEach(function(bindableArtboard) {
                        return bindableArtboard.destroy();
                    });
                };
                RiveFile.prototype.initData = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a, loader, loaderWrapper, _b, fileFinalizer;
                        return __generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    if (!this.src) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        loadRiveFile(this.src)
                                    ];
                                case 1:
                                    _a.buffer = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    if (this.assetLoader) {
                                        loaderWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.CustomFileAssetLoaderWrapper(this.runtime, this.assetLoader);
                                        loader = loaderWrapper.assetLoader;
                                    }
                                    // Load the Rive file
                                    _b = this;
                                    return [
                                        4 /*yield*/ ,
                                        this.runtime.load(new Uint8Array(this.buffer), loader, this.enableRiveAssetCDN)
                                    ];
                                case 3:
                                    // Load the Rive file
                                    _b.file = _c.sent();
                                    fileFinalizer = new _utils__WEBPACK_IMPORTED_MODULE_3__.FileFinalizer(this.file);
                                    _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(this, fileFinalizer);
                                    if (this.destroyed) {
                                        this.releaseFile();
                                        return [
                                            2 /*return*/ 
                                        ];
                                    }
                                    if (this.file !== null) this.eventManager.fire({
                                        type: EventType.Load,
                                        data: this
                                    });
                                    else this.fireLoadError(RiveFile.fileLoadErrorMessage);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                RiveFile.prototype.init = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a, error_1;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    // If no source file url specified, it's a bust
                                    if (!this.src && !this.buffer) {
                                        this.fireLoadError(RiveFile.missingErrorMessage);
                                        return [
                                            2 /*return*/ 
                                        ];
                                    }
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([
                                        1,
                                        4,
                                        ,
                                        5
                                    ]);
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        RuntimeLoader.awaitInstance()
                                    ];
                                case 2:
                                    _a.runtime = _b.sent();
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.initData()
                                    ];
                                case 3:
                                    _b.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    error_1 = _b.sent();
                                    this.fireLoadError(error_1 instanceof Error ? error_1.message : RiveFile.fileLoadErrorMessage);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                RiveFile.prototype.fireLoadError = function(message) {
                    this.eventManager.fire({
                        type: EventType.LoadError,
                        data: message
                    });
                    throw new Error(message);
                };
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ RiveFile.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ RiveFile.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                RiveFile.prototype.cleanup = function() {
                    this.referenceCount -= 1;
                    if (this.referenceCount <= 0) {
                        this.removeAllRiveEventListeners();
                        this.releaseFile();
                        this.releaseBindableArtboards();
                        this.destroyed = true;
                    }
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ RiveFile.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                RiveFile.prototype.getInstance = function() {
                    if (this.file !== null) {
                        this.referenceCount += 1;
                        return this.file;
                    }
                };
                RiveFile.prototype.destroyIfUnused = function() {
                    if (this.referenceCount <= 0) this.cleanup();
                };
                RiveFile.prototype.createBindableArtboard = function(nativeBindableArtboard) {
                    if (nativeBindableArtboard != null) {
                        var bindableArtboard = new BindableArtboard(nativeBindableArtboard);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(bindableArtboard, bindableArtboard.nativeArtboard);
                        this.bindableArtboards.push(bindableArtboard);
                        return bindableArtboard;
                    }
                    return null;
                };
                /**
     * @deprecated This function is deprecated. For better stability and memory management
     * use `getBindableArtboard()` instead.
     * @param {string} name - The name of the artboard.
     * @returns {Artboard} The artboard to bind to.
     */ RiveFile.prototype.getArtboard = function(name) {
                    var nativeArtboard = this.file.artboardByName(name);
                    if (nativeArtboard != null) return new Artboard(nativeArtboard, this);
                };
                RiveFile.prototype.getBindableArtboard = function(name) {
                    var nativeArtboard = this.file.bindableArtboardByName(name);
                    return this.createBindableArtboard(nativeArtboard);
                };
                RiveFile.prototype.getDefaultBindableArtboard = function() {
                    var nativeArtboard = this.file.bindableArtboardDefault();
                    return this.createBindableArtboard(nativeArtboard);
                };
                RiveFile.prototype.internalBindableArtboardFromArtboard = function(artboard) {
                    var nativeBindableArtboard = this.file.internalBindableArtboardFromArtboard(artboard);
                    return this.createBindableArtboard(nativeBindableArtboard);
                };
                // Error message for missing source or buffer
                RiveFile.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for file load error
                RiveFile.fileLoadErrorMessage = "The file failed to load";
                return RiveFile;
            }();
            var Rive = /** @class */ function() {
                function Rive(params) {
                    var _this = this;
                    var _a;
                    // Tracks if a Rive file is loaded
                    this.loaded = false;
                    // Tracks if a Rive file is destroyed
                    this.destroyed = false;
                    // Reference of an object that handles any observers for the animation
                    this._observed = null;
                    /**
         * Tracks if a Rive file is loaded; we need this in addition to loaded as some
         * commands (e.g. contents) can be called as soon as the file is loaded.
         * However, playback commands need to be queued and run in order once initial
         * animations and autoplay has been sorted out. This applies to play, pause,
         * and start.
         */ this.readyForPlaying = false;
                    // Runtime artboard
                    this.artboard = null;
                    // place to clear up event listeners
                    this.eventCleanup = null;
                    this.shouldDisableRiveListeners = false;
                    this.automaticallyHandleEvents = false;
                    this.dispatchPointerExit = true;
                    // Allow all pointers to be passed to the runtime
                    this.enableMultiTouch = false;
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    // Keep a local value of the set volume to update it asynchronously
                    this._volume = 1;
                    // Keep a local value of the set width to update it asynchronously
                    this._artboardWidth = undefined;
                    // Keep a local value of the set height to update it asynchronously
                    this._artboardHeight = undefined;
                    // Keep a local value of the device pixel ratio used in rendering and canvas/artboard resizing
                    this._devicePixelRatioUsed = 1;
                    // Whether the canvas element's size is 0
                    this._hasZeroSize = false;
                    // Audio event listener
                    this._audioEventListener = null;
                    // draw method bound to the class
                    this._boundDraw = null;
                    this._viewModelInstance = null;
                    this._dataEnums = null;
                    // Durations to generate a frame for the last second. Used for performance profiling.
                    this.durations = [];
                    this.frameTimes = [];
                    this.frameCount = 0;
                    this.isTouchScrollEnabled = false;
                    this.onCanvasResize = function(hasZeroSize) {
                        var toggledDisplay = _this._hasZeroSize !== hasZeroSize;
                        _this._hasZeroSize = hasZeroSize;
                        if (!hasZeroSize) {
                            if (toggledDisplay) _this.resizeDrawingSurfaceToCanvas();
                        } else if (!_this._layout.maxX || !_this._layout.maxY) _this.resizeToCanvas();
                    };
                    /**
         * Used be draw to track when a second of active rendering time has passed.
         * Used for debugging purposes
         */ this.renderSecondTimer = 0;
                    this._boundDraw = this.draw.bind(this);
                    this.canvas = params.canvas;
                    if (params.canvas.constructor === HTMLCanvasElement) this._observed = observers.add(this.canvas, this.onCanvasResize);
                    this.src = params.src;
                    this.buffer = params.buffer;
                    this.riveFile = params.riveFile;
                    this.layout = (_a = params.layout) !== null && _a !== void 0 ? _a : new Layout();
                    this.shouldDisableRiveListeners = !!params.shouldDisableRiveListeners;
                    this.isTouchScrollEnabled = !!params.isTouchScrollEnabled;
                    this.automaticallyHandleEvents = !!params.automaticallyHandleEvents;
                    this.dispatchPointerExit = params.dispatchPointerExit === false ? params.dispatchPointerExit : this.dispatchPointerExit;
                    this.enableMultiTouch = !!params.enableMultiTouch;
                    this.enableRiveAssetCDN = params.enableRiveAssetCDN === undefined ? true : params.enableRiveAssetCDN;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                    if (params.onPlay) this.on(EventType.Play, params.onPlay);
                    if (params.onPause) this.on(EventType.Pause, params.onPause);
                    if (params.onStop) this.on(EventType.Stop, params.onStop);
                    if (params.onLoop) this.on(EventType.Loop, params.onLoop);
                    if (params.onStateChange) this.on(EventType.StateChange, params.onStateChange);
                    if (params.onAdvance) this.on(EventType.Advance, params.onAdvance);
                    /**
         * @deprecated Use camelCase'd versions instead.
         */ if (params.onload && !params.onLoad) this.on(EventType.Load, params.onload);
                    if (params.onloaderror && !params.onLoadError) this.on(EventType.LoadError, params.onloaderror);
                    if (params.onplay && !params.onPlay) this.on(EventType.Play, params.onplay);
                    if (params.onpause && !params.onPause) this.on(EventType.Pause, params.onpause);
                    if (params.onstop && !params.onStop) this.on(EventType.Stop, params.onstop);
                    if (params.onloop && !params.onLoop) this.on(EventType.Loop, params.onloop);
                    if (params.onstatechange && !params.onStateChange) this.on(EventType.StateChange, params.onstatechange);
                    /**
         * Asset loading
         */ if (params.assetLoader) this.assetLoader = params.assetLoader;
                    // Hook up the task queue
                    this.taskQueue = new TaskQueueManager(this.eventManager);
                    this.init({
                        src: this.src,
                        buffer: this.buffer,
                        riveFile: this.riveFile,
                        autoplay: params.autoplay,
                        autoBind: params.autoBind,
                        animations: params.animations,
                        stateMachines: params.stateMachines,
                        artboard: params.artboard,
                        useOffscreenRenderer: params.useOffscreenRenderer
                    });
                }
                Object.defineProperty(Rive.prototype, "viewModelCount", {
                    get: function() {
                        return this.file.viewModelCount();
                    },
                    enumerable: false,
                    configurable: true
                });
                // Alternative constructor to build a Rive instance from an interface/object
                Rive.new = function(params) {
                    console.warn("This function is deprecated: please use `new Rive({})` instead");
                    return new Rive(params);
                };
                // Event handler for when audio context becomes available
                Rive.prototype.onSystemAudioChanged = function() {
                    this.volume = this._volume;
                };
                // Initializes the Rive object either from constructor or load()
                Rive.prototype.init = function(_a) {
                    var _this = this;
                    var src = _a.src, buffer = _a.buffer, riveFile = _a.riveFile, animations = _a.animations, stateMachines = _a.stateMachines, artboard = _a.artboard, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, _c = _a.useOffscreenRenderer, useOffscreenRenderer = _c === void 0 ? false : _c, _d = _a.autoBind, autoBind = _d === void 0 ? false : _d;
                    if (this.destroyed) return;
                    this.src = src;
                    this.buffer = buffer;
                    this.riveFile = riveFile;
                    // If no source file url specified, it's a bust
                    if (!this.src && !this.buffer && !this.riveFile) throw new RiveError(Rive.missingErrorMessage);
                    // List of animations that should be initialized.
                    var startingAnimationNames = mapToStringArray(animations);
                    // List of state machines that should be initialized
                    var startingStateMachineNames = mapToStringArray(stateMachines);
                    // Ensure loaded is marked as false if loading new file
                    this.loaded = false;
                    this.readyForPlaying = false;
                    // Ensure the runtime is loaded
                    RuntimeLoader.awaitInstance().then(function(runtime) {
                        if (_this.destroyed) return;
                        _this.runtime = runtime;
                        _this.removeRiveListeners();
                        _this.deleteRiveRenderer();
                        // Get the canvas where you want to render the animation and create a renderer
                        _this.renderer = _this.runtime.makeRenderer(_this.canvas, useOffscreenRenderer);
                        // Initial size adjustment based on devicePixelRatio if no width/height are
                        // specified explicitly
                        if (!(_this.canvas.width || _this.canvas.height)) _this.resizeDrawingSurfaceToCanvas();
                        // Load Rive data from a source uri or a data buffer
                        _this.initData(artboard, startingAnimationNames, startingStateMachineNames, autoplay, autoBind).then(function(hasInitialized) {
                            if (hasInitialized) return _this.setupRiveListeners();
                        }).catch(function(e) {
                            console.error(e);
                        });
                    }).catch(function(e) {
                        console.error(e);
                    });
                };
                /**
     * Setup Rive Listeners on the canvas
     * @param riveListenerOptions - Enables TouchEvent events on the canvas. Set to true to allow
     * touch scrolling on the canvas element on touch-enabled devices
     * i.e. { isTouchScrollEnabled: true }
     */ Rive.prototype.setupRiveListeners = function(riveListenerOptions) {
                    var _this = this;
                    if (this.eventCleanup) this.eventCleanup();
                    if (!this.shouldDisableRiveListeners) {
                        var activeStateMachines = (this.animator.stateMachines || []).filter(function(sm) {
                            return sm.playing && _this.runtime.hasListeners(sm.instance);
                        }).map(function(sm) {
                            return sm.instance;
                        });
                        var touchScrollEnabledOption = this.isTouchScrollEnabled;
                        var dispatchPointerExit = this.dispatchPointerExit;
                        var enableMultiTouch = this.enableMultiTouch;
                        if (riveListenerOptions && "isTouchScrollEnabled" in riveListenerOptions) touchScrollEnabledOption = riveListenerOptions.isTouchScrollEnabled;
                        this.eventCleanup = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.registerTouchInteractions)({
                            canvas: this.canvas,
                            artboard: this.artboard,
                            stateMachines: activeStateMachines,
                            renderer: this.renderer,
                            rive: this.runtime,
                            fit: this._layout.runtimeFit(this.runtime),
                            alignment: this._layout.runtimeAlignment(this.runtime),
                            isTouchScrollEnabled: touchScrollEnabledOption,
                            dispatchPointerExit: dispatchPointerExit,
                            enableMultiTouch: enableMultiTouch,
                            layoutScaleFactor: this._layout.layoutScaleFactor
                        });
                    }
                };
                /**
     * Remove Rive Listeners setup on the canvas
     */ Rive.prototype.removeRiveListeners = function() {
                    if (this.eventCleanup) {
                        this.eventCleanup();
                        this.eventCleanup = null;
                    }
                };
                /**
     * If the instance has audio and the system audio is not ready
     * we hook the instance to the audio manager
     */ Rive.prototype.initializeAudio = function() {
                    var _this = this;
                    var _a;
                    // Initialize audio if needed
                    if (audioManager.status == SystemAudioStatus.UNAVAILABLE) {
                        if (((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.hasAudio) && this._audioEventListener === null) {
                            this._audioEventListener = {
                                type: EventType.AudioStatusChange,
                                callback: function() {
                                    return _this.onSystemAudioChanged();
                                }
                            };
                            audioManager.add(this._audioEventListener);
                            audioManager.establishAudio();
                        }
                    }
                };
                Rive.prototype.initArtboardSize = function() {
                    if (!this.artboard) return;
                    // Use preset values if they are not undefined
                    this._artboardWidth = this.artboard.width = this._artboardWidth || this.artboard.width;
                    this._artboardHeight = this.artboard.height = this._artboardHeight || this.artboard.height;
                };
                // Initializes runtime with Rive data and preps for playing.
                // Returns true for successful initialization.
                Rive.prototype.initData = function(artboardName, animationNames, stateMachineNames, autoplay, autoBind) {
                    return __awaiter(this, void 0, void 0, function() {
                        var riveFile, error_2, msg;
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    _b.trys.push([
                                        0,
                                        3,
                                        ,
                                        4
                                    ]);
                                    if (!(this.riveFile == null)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    riveFile = new RiveFile({
                                        src: this.src,
                                        buffer: this.buffer,
                                        enableRiveAssetCDN: this.enableRiveAssetCDN,
                                        assetLoader: this.assetLoader
                                    });
                                    this.riveFile = riveFile;
                                    return [
                                        4 /*yield*/ ,
                                        riveFile.init()
                                    ];
                                case 1:
                                    _b.sent();
                                    if (this.destroyed) {
                                        // In the very unlikely scenario where the rive file created by this Rive is shared by
                                        // another rive file, we only want to destroy it if this file is the only owner.
                                        riveFile.destroyIfUnused();
                                        return [
                                            2 /*return*/ ,
                                            false
                                        ];
                                    }
                                    _b.label = 2;
                                case 2:
                                    this.file = this.riveFile.getInstance();
                                    // Initialize and draw frame
                                    this.initArtboard(artboardName, animationNames, stateMachineNames, autoplay, autoBind);
                                    // Initialize the artboard size
                                    this.initArtboardSize();
                                    // Check for audio
                                    this.initializeAudio();
                                    // Everything's set up, emit a load event
                                    this.loaded = true;
                                    this.eventManager.fire({
                                        type: EventType.Load,
                                        data: (_a = this.src) !== null && _a !== void 0 ? _a : "buffer"
                                    });
                                    // Only initialize paused state machines after the load event has been fired
                                    // to allow users to initialize inputs and view models before the first advance
                                    this.animator.advanceIfPaused();
                                    // Flag ready for playback commands and clear the task queue; this order
                                    // is important or it may infinitely recurse
                                    this.readyForPlaying = true;
                                    this.taskQueue.process();
                                    this.drawFrame();
                                    return [
                                        2 /*return*/ ,
                                        true
                                    ];
                                case 3:
                                    error_2 = _b.sent();
                                    msg = resolveErrorMessage(error_2);
                                    console.warn(msg);
                                    this.eventManager.fire({
                                        type: EventType.LoadError,
                                        data: msg
                                    });
                                    return [
                                        2 /*return*/ ,
                                        Promise.reject(msg)
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                // Initialize for playback
                Rive.prototype.initArtboard = function(artboardName, animationNames, stateMachineNames, autoplay, autoBind) {
                    if (!this.file) return;
                    // Fetch the artboard
                    var rootArtboard = artboardName ? this.file.artboardByName(artboardName) : this.file.defaultArtboard();
                    // Check we have a working artboard
                    if (!rootArtboard) {
                        var msg = "Invalid artboard name or no default artboard";
                        console.warn(msg);
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        return;
                    }
                    this.artboard = rootArtboard;
                    rootArtboard.volume = this._volume * audioManager.systemVolume;
                    // Initialize the animator
                    this.animator = new Animator(this.runtime, this.artboard, this.eventManager);
                    // Initialize the animations; as loaded hasn't happened yet, we need to
                    // suppress firing the play/pause events until the load event has fired. To
                    // do this we tell the animator to suppress firing events, and add event
                    // firing to the task queue.
                    var instanceNames;
                    if (animationNames.length > 0 || stateMachineNames.length > 0) {
                        instanceNames = animationNames.concat(stateMachineNames);
                        this.animator.initLinearAnimations(animationNames, autoplay);
                        this.animator.initStateMachines(stateMachineNames, autoplay);
                    } else instanceNames = [
                        this.animator.atLeastOne(autoplay, false)
                    ];
                    // Queue up firing the playback events
                    this.taskQueue.add({
                        event: {
                            type: autoplay ? EventType.Play : EventType.Pause,
                            data: instanceNames
                        }
                    });
                    if (autoBind) {
                        var viewModel = this.file.defaultArtboardViewModel(rootArtboard);
                        if (viewModel !== null) {
                            var runtimeInstance = viewModel.defaultInstance();
                            if (runtimeInstance !== null) {
                                var viewModelInstance = new ViewModelInstance(runtimeInstance, null);
                                (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, viewModelInstance.runtimeInstance);
                                this.bindViewModelInstance(viewModelInstance);
                            }
                        }
                    }
                };
                // Draws the current artboard frame
                Rive.prototype.drawFrame = function() {
                    var _a, _b;
                    if ((_a = document === null || document === void 0 ? void 0 : document.timeline) === null || _a === void 0 ? void 0 : _a.currentTime) {
                        if (this.loaded && this.artboard && !this.frameRequestId) {
                            this._boundDraw(document.timeline.currentTime);
                            (_b = this.runtime) === null || _b === void 0 || _b.resolveAnimationFrame();
                        }
                    } else this.startRendering();
                };
                /**
     * Draw rendering loop; renders animation frames at the correct time interval.
     * @param time the time at which to render a frame
     */ Rive.prototype.draw = function(time, onSecond) {
                    var _a;
                    // Clear the frameRequestId, as we're now rendering a fresh frame
                    this.frameRequestId = null;
                    var before = performance.now();
                    // On the first pass, make sure lastTime has a valid value
                    if (!this.lastRenderTime) this.lastRenderTime = time;
                    // Handle the onSecond callback
                    this.renderSecondTimer += time - this.lastRenderTime;
                    if (this.renderSecondTimer > 5000) {
                        this.renderSecondTimer = 0;
                        onSecond === null || onSecond === void 0 || onSecond();
                    }
                    // Calculate the elapsed time between frames in seconds
                    var elapsedTime = (time - this.lastRenderTime) / 1000;
                    this.lastRenderTime = time;
                    // - Advance non-paused animations by the elapsed number of seconds
                    // - Advance any animations that require scrubbing
                    // - Advance to the first frame even when autoplay is false
                    var activeAnimations = this.animator.animations.filter(function(a) {
                        return a.playing || a.needsScrub;
                    })// The scrubbed animations must be applied first to prevent weird artifacts
                    // if the playing animations conflict with the scrubbed animating attribuates.
                    .sort(function(first) {
                        return first.needsScrub ? -1 : 1;
                    });
                    for(var _i = 0, activeAnimations_1 = activeAnimations; _i < activeAnimations_1.length; _i++){
                        var animation = activeAnimations_1[_i];
                        animation.advance(elapsedTime);
                        if (animation.instance.didLoop) animation.loopCount += 1;
                        animation.apply(1.0);
                    }
                    // - Advance non-paused state machines by the elapsed number of seconds
                    // - Advance to the first frame even when autoplay is false
                    var activeStateMachines = this.animator.stateMachines.filter(function(a) {
                        return a.playing;
                    });
                    for(var _b = 0, activeStateMachines_1 = activeStateMachines; _b < activeStateMachines_1.length; _b++){
                        var stateMachine = activeStateMachines_1[_b];
                        // Check for events before the current frame's state machine advance
                        var numEventsReported = stateMachine.reportedEventCount();
                        if (numEventsReported) for(var i = 0; i < numEventsReported; i++){
                            var event_1 = stateMachine.reportedEventAt(i);
                            if (event_1) {
                                if (event_1.type === RiveEventType.OpenUrl) {
                                    this.eventManager.fire({
                                        type: EventType.RiveEvent,
                                        data: event_1
                                    });
                                    // Handle the event side effect if explicitly enabled
                                    if (this.automaticallyHandleEvents) {
                                        var newAnchorTag = document.createElement("a");
                                        var _c = event_1, url = _c.url, target = _c.target;
                                        var sanitizedUrl = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.sanitizeUrl)(url);
                                        url && newAnchorTag.setAttribute("href", sanitizedUrl);
                                        target && newAnchorTag.setAttribute("target", target);
                                        if (sanitizedUrl && sanitizedUrl !== _utils__WEBPACK_IMPORTED_MODULE_3__.BLANK_URL) newAnchorTag.click();
                                    }
                                } else this.eventManager.fire({
                                    type: EventType.RiveEvent,
                                    data: event_1
                                });
                            }
                        }
                        stateMachine.advanceAndApply(elapsedTime);
                    // stateMachine.instance.apply(this.artboard);
                    }
                    // Once the animations have been applied to the artboard, advance it
                    // by the elapsed time.
                    if (this.animator.stateMachines.length == 0) this.artboard.advance(elapsedTime);
                    var renderer = this.renderer;
                    // Canvas must be wiped to prevent artifacts
                    renderer.clear();
                    renderer.save();
                    // Update the renderer alignment if necessary
                    this.alignRenderer();
                    // Do not draw on 0 canvas size
                    if (!this._hasZeroSize) this.artboard.draw(renderer);
                    renderer.restore();
                    renderer.flush();
                    // Check for any animations that looped
                    this.animator.handleLooping();
                    // Check for any state machines that had a state change
                    this.animator.handleStateChanges();
                    // Report advanced time
                    this.animator.handleAdvancing(elapsedTime);
                    // Add duration to create frame to durations array
                    this.frameCount++;
                    var after = performance.now();
                    this.frameTimes.push(after);
                    this.durations.push(after - before);
                    while(this.frameTimes[0] <= after - 1000){
                        this.frameTimes.shift();
                        this.durations.shift();
                    }
                    (_a = this._viewModelInstance) === null || _a === void 0 || _a.handleCallbacks();
                    // Calling requestAnimationFrame will rerun draw() at the correct rate:
                    // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Basic_animations
                    if (this.animator.isPlaying) // Request a new rendering frame
                    this.startRendering();
                    else if (this.animator.isPaused) // Reset the end time so on playback it starts at the correct frame
                    this.lastRenderTime = 0;
                    else if (this.animator.isStopped) // Reset animation instances, artboard and time
                    // TODO: implement this properly when we have instancing
                    // this.initArtboard();
                    // this.drawFrame();
                    this.lastRenderTime = 0;
                };
                /**
     * Align the renderer
     */ Rive.prototype.alignRenderer = function() {
                    var _a = this, renderer = _a.renderer, runtime = _a.runtime, _layout = _a._layout, artboard = _a.artboard;
                    // Align things up safe in the knowledge we can restore if changed
                    renderer.align(_layout.runtimeFit(runtime), _layout.runtimeAlignment(runtime), {
                        minX: _layout.minX,
                        minY: _layout.minY,
                        maxX: _layout.maxX,
                        maxY: _layout.maxY
                    }, artboard.bounds, this._devicePixelRatioUsed * _layout.layoutScaleFactor);
                };
                Object.defineProperty(Rive.prototype, "fps", {
                    get: function() {
                        return this.durations.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "frameTime", {
                    get: function() {
                        if (this.durations.length === 0) return 0;
                        return (this.durations.reduce(function(a, b) {
                            return a + b;
                        }, 0) / this.durations.length).toFixed(4);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Cleans up all Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances,
     * renderer instance, file and runtime.
     *
     * Once this is called, you will need to initialise a new instance of the
     * Rive class
     */ Rive.prototype.cleanup = function() {
                    var _a, _b;
                    this.destroyed = true;
                    // Stop the renderer if it hasn't already been stopped.
                    this.stopRendering();
                    // Clean up any artboard, animation or state machine instances.
                    this.cleanupInstances();
                    // Remove from observer
                    if (this._observed !== null) observers.remove(this._observed);
                    this.removeRiveListeners();
                    if (this.file) {
                        (_a = this.riveFile) === null || _a === void 0 || _a.cleanup();
                        this.file = null;
                    }
                    this.riveFile = null;
                    this.deleteRiveRenderer();
                    if (this._audioEventListener !== null) {
                        audioManager.remove(this._audioEventListener);
                        this._audioEventListener = null;
                    }
                    (_b = this._viewModelInstance) === null || _b === void 0 || _b.cleanup();
                    this._viewModelInstance = null;
                    this._dataEnums = null;
                };
                /**
     * Cleans up the Renderer object. Only call this API if you no longer
     * need to render Rive content in your session.
     */ Rive.prototype.deleteRiveRenderer = function() {
                    var _a;
                    (_a = this.renderer) === null || _a === void 0 || _a.delete();
                    this.renderer = null;
                };
                /**
     * Cleans up any Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances.
     *
     * Once this is called, things will need to be reinitialized or bad things
     * might happen.
     */ Rive.prototype.cleanupInstances = function() {
                    if (this.eventCleanup !== null) this.eventCleanup();
                    // Delete all animation and state machine instances
                    this.stop();
                    if (this.artboard) {
                        this.artboard.delete();
                        this.artboard = null;
                    }
                };
                /**
     * Tries to query the setup Artboard for a text run node with the given name.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - TextValueRun node or undefined if the text run cannot be queried
     */ Rive.prototype.retrieveTextRun = function(textRunName) {
                    var _a;
                    if (!textRunName) {
                        console.warn("No text run name provided");
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text run, but the Artboard is null");
                        return;
                    }
                    var textRun = this.artboard.textRun(textRunName);
                    if (!textRun) {
                        console.warn("Could not access a text run with name '".concat(textRunName, "' in the '").concat((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.name, "' Artboard. Note that you must rename a text run node in the Rive editor to make it queryable at runtime."));
                        return;
                    }
                    return textRun;
                };
                /**
     * Returns a string from a given text run node name, or undefined if the text run
     * cannot be queried.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - String value of the text run node or undefined
     */ Rive.prototype.getTextRunValue = function(textRunName) {
                    var textRun = this.retrieveTextRun(textRunName);
                    return textRun ? textRun.text : undefined;
                };
                /**
     * Sets a text value for a given text run node name if possible
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @param textRunValue - String value to set on the text run node
     */ Rive.prototype.setTextRunValue = function(textRunName, textRunValue) {
                    var textRun = this.retrieveTextRun(textRunName);
                    if (textRun) textRun.text = textRunValue;
                };
                // Plays specified animations; if none specified, it unpauses everything.
                Rive.prototype.play = function(animationNames, autoplay) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, queue up the play
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.play(animationNames, autoplay);
                            }
                        });
                        return;
                    }
                    this.animator.play(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                    this.setupRiveListeners();
                    this.startRendering();
                };
                // Pauses specified animations; if none specified, pauses all.
                Rive.prototype.pause = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.pause(animationNames);
                            }
                        });
                        return;
                    }
                    if (this.eventCleanup) this.eventCleanup();
                    this.animator.pause(animationNames);
                };
                Rive.prototype.scrub = function(animationNames, value) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.scrub(animationNames, value);
                            }
                        });
                        return;
                    }
                    // Scrub the animation time; we draw a single frame here so that if
                    // nothing's currently playing, the scrubbed animation is still rendered/
                    this.animator.scrub(animationNames, value || 0);
                    this.drawFrame();
                };
                // Stops specified animations; if none specifies, stops them all.
                Rive.prototype.stop = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.stop(animationNames);
                            }
                        });
                        return;
                    }
                    // If there is no artboard, this.animator will be undefined
                    if (this.animator) this.animator.stop(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                };
                /**
     * Resets the animation
     * @param artboard the name of the artboard, or default if none given
     * @param animations the names of animations for playback
     * @param stateMachines the names of state machines for playback
     * @param autoplay whether to autoplay when reset, defaults to false
     *
     */ Rive.prototype.reset = function(params) {
                    var _a, _b;
                    // Get the current artboard, animations, state machines, and playback states
                    var artBoardName = params === null || params === void 0 ? void 0 : params.artboard;
                    var animationNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.animations);
                    var stateMachineNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.stateMachines);
                    var autoplay = (_a = params === null || params === void 0 ? void 0 : params.autoplay) !== null && _a !== void 0 ? _a : false;
                    var autoBind = (_b = params === null || params === void 0 ? void 0 : params.autoBind) !== null && _b !== void 0 ? _b : false;
                    // Stop everything and clean up
                    this.cleanupInstances();
                    // Reinitialize an artboard instance with the state
                    this.initArtboard(artBoardName, animationNames, stateMachineNames, autoplay, autoBind);
                    this.taskQueue.process();
                };
                // Loads a new Rive file, keeping listeners in place
                Rive.prototype.load = function(params) {
                    this.file = null;
                    // Stop all animations
                    this.stop();
                    // Reinitialize
                    this.init(params);
                };
                Object.defineProperty(Rive.prototype, "layout", {
                    /**
         * Returns the current layout. Note that layout should be treated as
         * immutable. If you want to change the layout, create a new one use the
         * layout setter
         */ get: function() {
                        return this._layout;
                    },
                    // Sets a new layout
                    set: function(layout) {
                        this._layout = layout;
                        // If the maxX or maxY are 0, then set them to the canvas width and height
                        if (!layout.maxX || !layout.maxY) this.resizeToCanvas();
                        if (this.loaded && !this.animator.isPlaying) this.drawFrame();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets the layout bounds to the current canvas size; this is typically called
     * when the canvas is resized
     */ Rive.prototype.resizeToCanvas = function() {
                    this._layout = this.layout.copyWith({
                        minX: 0,
                        minY: 0,
                        maxX: this.canvas.width,
                        maxY: this.canvas.height
                    });
                };
                /**
     * Accounts for devicePixelRatio as a multiplier to render the size of the canvas drawing surface.
     * Uses the size of the backing canvas to set new width/height attributes. Need to re-render
     * and resize the layout to match the new drawing surface afterwards.
     * Useful function for consumers to include in a window resize listener.
     *
     * This method will set the {@link devicePixelRatioUsed} property.
     *
     * Optionally, you can provide a {@link customDevicePixelRatio} to provide a
     * custom value.
     */ Rive.prototype.resizeDrawingSurfaceToCanvas = function(customDevicePixelRatio) {
                    if (this.canvas instanceof HTMLCanvasElement && !!window) {
                        var _a = this.canvas.getBoundingClientRect(), width = _a.width, height = _a.height;
                        var dpr = customDevicePixelRatio || window.devicePixelRatio || 1;
                        this.devicePixelRatioUsed = dpr;
                        this.canvas.width = dpr * width;
                        this.canvas.height = dpr * height;
                        this.resizeToCanvas();
                        this.drawFrame();
                        if (this.layout.fit === Fit.Layout) {
                            var scaleFactor = this._layout.layoutScaleFactor;
                            this.artboard.width = width / scaleFactor;
                            this.artboard.height = height / scaleFactor;
                        }
                    }
                };
                Object.defineProperty(Rive.prototype, "source", {
                    // Returns the animation source, which may be undefined
                    get: function() {
                        return this.src;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "activeArtboard", {
                    /**
         * Returns the name of the active artboard
         */ get: function() {
                        return this.artboard ? this.artboard.name : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "animationNames", {
                    // Returns a list of animation names on the chosen artboard
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var animationNames = [];
                        for(var i = 0; i < this.artboard.animationCount(); i++)animationNames.push(this.artboard.animationByIndex(i).name);
                        return animationNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "stateMachineNames", {
                    /**
         * Returns a list of state machine names from the current artboard
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var stateMachineNames = [];
                        for(var i = 0; i < this.artboard.stateMachineCount(); i++)stateMachineNames.push(this.artboard.stateMachineByIndex(i).name);
                        return stateMachineNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the inputs for the specified instanced state machine, or an empty
     * list if the name is invalid or the state machine is not instanced
     * @param name the state machine name
     * @returns the inputs for the named state machine
     */ Rive.prototype.stateMachineInputs = function(name) {
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.loaded) return;
                    var stateMachine = this.animator.stateMachines.find(function(m) {
                        return m.name === name;
                    });
                    return stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.inputs;
                };
                // Returns the input with the provided name at the given path
                Rive.prototype.retrieveInputAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No input name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access input: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var input = this.artboard.inputByPath(name, path);
                    if (!input) {
                        console.warn("Could not access an input with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return input;
                };
                /**
     * Set the boolean input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setBooleanStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Boolean) input.asBool().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a boolean"));
                };
                /**
     * Set the number input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setNumberStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Number) input.asNumber().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a number"));
                };
                /**
     * Fire the trigger with the provided name at the given path
     * @param input the state machine input name
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.fireStateAtPath = function(inputName, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Trigger) input.asTrigger().fire();
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a trigger"));
                };
                // Returns the TextValueRun object for the provided name at the given path
                Rive.prototype.retrieveTextAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No text name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!path) {
                        console.warn("No path provided for text '".concat(name, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var text = this.artboard.textByPath(name, path);
                    if (!text) {
                        console.warn("Could not access text with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return text;
                };
                /**
     * Retrieves the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param path The path to the text run within the artboard
     * @returns The text value of the text run, or undefined if not found
     *
     * @example
     * // Get the text value for a text run named "title" at one nested artboard deep
     * const titleText = riveInstance.getTextRunValueAtPath("title", "artboard1");
     *
     * @example
     * // Get the text value for a text run named "subtitle" within a nested group two artboards deep
     * const subtitleText = riveInstance.getTextRunValueAtPath("subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.getTextRunValueAtPath = function(textName, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not get text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return run.text;
                };
                /**
     * Sets the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param value The new text value to set
     * @param path The path to the text run within the artboard
     * @returns void
     *
     * @example
     * // Set the text value for a text run named "title" at one nested artboard deep
     * riveInstance.setTextRunValueAtPath("title", "New Title", "artboard1");
     *
     * @example
     * // Set the text value for a text run named "subtitle" within a nested group two artboards deep
     * riveInstance.setTextRunValueAtPath("subtitle", "New Subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.setTextRunValueAtPath = function(textName, value, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not set text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    run.text = value;
                };
                Object.defineProperty(Rive.prototype, "playingStateMachineNames", {
                    // Returns a list of playing machine names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "playingAnimationNames", {
                    // Returns a list of playing animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedAnimationNames", {
                    // Returns a list of paused animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedStateMachineNames", {
                    /**
         *  Returns a list of paused machine names
         * @returns a list of state machine names that are paused
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPlaying", {
                    /**
         * @returns true if any animation is playing
         */ get: function() {
                        return this.animator.isPlaying;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPaused", {
                    /**
         * @returns true if all instanced animations are paused
         */ get: function() {
                        return this.animator.isPaused;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isStopped", {
                    /**
         * @returns true if no animations are playing or paused
         */ get: function() {
                        return this.animator.isStopped;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "bounds", {
                    /**
         * @returns the bounds of the current artboard, or undefined if the artboard
         * isn't loaded yet.
         */ get: function() {
                        return this.artboard ? this.artboard.bounds : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ Rive.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ Rive.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @deprecated
     * @param callback the callback to unsubscribe from
     */ Rive.prototype.unsubscribe = function(type, callback) {
                    console.warn("This function is deprecated: please use `off()` instead.");
                    this.off(type, callback);
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                /**
     * Unsubscribes all listeners from an event type, or everything if no type is
     * given
     * @deprecated
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.unsubscribeAll = function(type) {
                    console.warn("This function is deprecated: please use `removeAllRiveEventListeners()` instead.");
                    this.removeAllRiveEventListeners(type);
                };
                /**
     * Stops the rendering loop; this is different from pausing in that it doesn't
     * change the state of any animation. It stops rendering from occurring. This
     * is designed for situations such as when Rive isn't visible.
     *
     * The only way to start rendering again is to call `startRendering`.
     * Animations that are marked as playing will start from the position that
     * they would have been at if rendering had not been stopped.
     */ Rive.prototype.stopRendering = function() {
                    if (this.loaded && this.frameRequestId) {
                        if (this.runtime.cancelAnimationFrame) this.runtime.cancelAnimationFrame(this.frameRequestId);
                        else cancelAnimationFrame(this.frameRequestId);
                        this.frameRequestId = null;
                    }
                };
                /**
     * Starts the rendering loop if it has been previously stopped. If the
     * renderer is already active, then this will have zero effect.
     */ Rive.prototype.startRendering = function() {
                    if (this.loaded && this.artboard && !this.frameRequestId) {
                        if (this.runtime.requestAnimationFrame) this.frameRequestId = this.runtime.requestAnimationFrame(this._boundDraw);
                        else this.frameRequestId = requestAnimationFrame(this._boundDraw);
                    }
                };
                /**
     * Enables frames-per-second (FPS) reporting for the runtime
     * If no callback is provided, Rive will append a fixed-position div at the top-right corner of
     * the page with the FPS reading
     * @param fpsCallback - Callback from the runtime during the RAF loop that supplies the FPS value
     */ Rive.prototype.enableFPSCounter = function(fpsCallback) {
                    this.runtime.enableFPSCounter(fpsCallback);
                };
                /**
     * Disables frames-per-second (FPS) reporting for the runtime
     */ Rive.prototype.disableFPSCounter = function() {
                    this.runtime.disableFPSCounter();
                };
                Object.defineProperty(Rive.prototype, "contents", {
                    /**
         * Returns the contents of a Rive file: the artboards, animations, and state machines
         */ get: function() {
                        if (!this.loaded) return undefined;
                        var riveContents = {
                            artboards: []
                        };
                        for(var i = 0; i < this.file.artboardCount(); i++){
                            var artboard = this.file.artboardByIndex(i);
                            var artboardContents = {
                                name: artboard.name,
                                animations: [],
                                stateMachines: []
                            };
                            for(var j = 0; j < artboard.animationCount(); j++){
                                var animation = artboard.animationByIndex(j);
                                artboardContents.animations.push(animation.name);
                            }
                            for(var k = 0; k < artboard.stateMachineCount(); k++){
                                var stateMachine = artboard.stateMachineByIndex(k);
                                var name_1 = stateMachine.name;
                                var instance = new this.runtime.StateMachineInstance(stateMachine, artboard);
                                var inputContents = [];
                                for(var l = 0; l < instance.inputCount(); l++){
                                    var input = instance.input(l);
                                    inputContents.push({
                                        name: input.name,
                                        type: input.type
                                    });
                                }
                                artboardContents.stateMachines.push({
                                    name: name_1,
                                    inputs: inputContents
                                });
                            }
                            riveContents.artboards.push(artboardContents);
                        }
                        return riveContents;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "volume", {
                    /**
         * Getter / Setter for the volume of the artboard
         */ get: function() {
                        if (this.artboard && this.artboard.volume !== this._volume) this._volume = this.artboard.volume;
                        return this._volume;
                    },
                    set: function(value) {
                        this._volume = value;
                        if (this.artboard) this.artboard.volume = value * audioManager.systemVolume;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardWidth", {
                    /**
         * The width of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * width has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard width is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.width;
                        return (_a = this._artboardWidth) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardWidth = value;
                        if (this.artboard) this.artboard.width = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardHeight", {
                    /**
         * The height of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * height has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard height is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.height;
                        return (_a = this._artboardHeight) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardHeight = value;
                        if (this.artboard) this.artboard.height = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Reset the artboard size to its original values.
     */ Rive.prototype.resetArtboardSize = function() {
                    if (this.artboard) {
                        this.artboard.resetArtboardSize();
                        this._artboardWidth = this.artboard.width;
                        this._artboardHeight = this.artboard.height;
                    } else {
                        // If the artboard isn't loaded, we need to reset the custom width and height
                        this._artboardWidth = undefined;
                        this._artboardHeight = undefined;
                    }
                };
                Object.defineProperty(Rive.prototype, "devicePixelRatioUsed", {
                    /**
         * The device pixel ratio used in rendering and canvas/artboard resizing.
         *
         * This value will be overidden by the device pixel ratio used in
         * {@link resizeDrawingSurfaceToCanvas}. If you use that method, do not set this value.
         */ get: function() {
                        return this._devicePixelRatioUsed;
                    },
                    set: function(value) {
                        this._devicePixelRatioUsed = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Initialize the data context with the view model instance.
     */ Rive.prototype.bindViewModelInstance = function(viewModelInstance) {
                    var _a;
                    if (this.artboard && !this.destroyed) {
                        if (viewModelInstance && viewModelInstance.runtimeInstance) {
                            viewModelInstance.internalIncrementReferenceCount();
                            (_a = this._viewModelInstance) === null || _a === void 0 || _a.cleanup();
                            this._viewModelInstance = viewModelInstance;
                            if (this.animator.stateMachines.length > 0) this.animator.stateMachines.forEach(function(stateMachine) {
                                return stateMachine.bindViewModelInstance(viewModelInstance);
                            });
                            else this.artboard.bindViewModelInstance(viewModelInstance.runtimeInstance);
                        }
                    }
                };
                Object.defineProperty(Rive.prototype, "viewModelInstance", {
                    get: function() {
                        return this._viewModelInstance;
                    },
                    enumerable: false,
                    configurable: true
                });
                Rive.prototype.viewModelByIndex = function(index) {
                    var viewModel = this.file.viewModelByIndex(index);
                    if (viewModel !== null) return new ViewModel(viewModel);
                    return null;
                };
                Rive.prototype.viewModelByName = function(name) {
                    var viewModel = this.file.viewModelByName(name);
                    if (viewModel !== null) return new ViewModel(viewModel);
                    return null;
                };
                Rive.prototype.enums = function() {
                    if (this._dataEnums === null) {
                        var dataEnums = this.file.enums();
                        this._dataEnums = dataEnums.map(function(dataEnum) {
                            return new DataEnum(dataEnum);
                        });
                    }
                    return this._dataEnums;
                };
                Rive.prototype.defaultViewModel = function() {
                    if (this.artboard) {
                        var viewModel = this.file.defaultArtboardViewModel(this.artboard);
                        if (viewModel) return new ViewModel(viewModel);
                    }
                    return null;
                };
                /**
     * @deprecated This function is deprecated. For better stability and memory management
     * use `getBindableArtboard()` instead.
     * @param {string} name - The name of the artboard.
     * @returns {Artboard} The artboard to bind to.
     */ Rive.prototype.getArtboard = function(name) {
                    var _a, _b;
                    return (_b = (_a = this.riveFile) === null || _a === void 0 ? void 0 : _a.getArtboard(name)) !== null && _b !== void 0 ? _b : null;
                };
                Rive.prototype.getBindableArtboard = function(name) {
                    var _a, _b;
                    return (_b = (_a = this.riveFile) === null || _a === void 0 ? void 0 : _a.getBindableArtboard(name)) !== null && _b !== void 0 ? _b : null;
                };
                Rive.prototype.getDefaultBindableArtboard = function() {
                    var _a, _b;
                    return (_b = (_a = this.riveFile) === null || _a === void 0 ? void 0 : _a.getDefaultBindableArtboard()) !== null && _b !== void 0 ? _b : null;
                };
                // Error message for missing source or buffer
                Rive.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for removed rive file
                Rive.cleanupErrorMessage = "Attempt to use file after calling cleanup.";
                return Rive;
            }();
            var ViewModel = /** @class */ function() {
                function ViewModel(viewModel) {
                    this._viewModel = viewModel;
                }
                Object.defineProperty(ViewModel.prototype, "instanceCount", {
                    get: function() {
                        return this._viewModel.instanceCount;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModel.prototype, "name", {
                    get: function() {
                        return this._viewModel.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModel.prototype.instanceByIndex = function(index) {
                    var instance = this._viewModel.instanceByIndex(index);
                    if (instance !== null) {
                        var viewModelInstance = new ViewModelInstance(instance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, instance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModel.prototype.instanceByName = function(name) {
                    var instance = this._viewModel.instanceByName(name);
                    if (instance !== null) {
                        var viewModelInstance = new ViewModelInstance(instance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, instance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModel.prototype.defaultInstance = function() {
                    var runtimeInstance = this._viewModel.defaultInstance();
                    if (runtimeInstance !== null) {
                        var viewModelInstance = new ViewModelInstance(runtimeInstance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, runtimeInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModel.prototype.instance = function() {
                    var runtimeInstance = this._viewModel.instance();
                    if (runtimeInstance !== null) {
                        var viewModelInstance = new ViewModelInstance(runtimeInstance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, runtimeInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                Object.defineProperty(ViewModel.prototype, "properties", {
                    get: function() {
                        return this._viewModel.getProperties();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModel.prototype, "instanceNames", {
                    get: function() {
                        return this._viewModel.getInstanceNames();
                    },
                    enumerable: false,
                    configurable: true
                });
                return ViewModel;
            }();
            var DataEnum = /** @class */ function() {
                function DataEnum(dataEnum) {
                    this._dataEnum = dataEnum;
                }
                Object.defineProperty(DataEnum.prototype, "name", {
                    get: function() {
                        return this._dataEnum.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DataEnum.prototype, "values", {
                    get: function() {
                        return this._dataEnum.values;
                    },
                    enumerable: false,
                    configurable: true
                });
                return DataEnum;
            }();
            var PropertyType;
            (function(PropertyType) {
                PropertyType["Number"] = "number";
                PropertyType["String"] = "string";
                PropertyType["Boolean"] = "boolean";
                PropertyType["Color"] = "color";
                PropertyType["Trigger"] = "trigger";
                PropertyType["Enum"] = "enum";
                PropertyType["List"] = "list";
                PropertyType["Image"] = "image";
                PropertyType["Artboard"] = "artboard";
            })(PropertyType || (PropertyType = {}));
            var ViewModelInstance = /** @class */ function() {
                function ViewModelInstance(runtimeInstance, parent) {
                    this._parents = [];
                    this._children = [];
                    this._viewModelInstances = new Map();
                    this._propertiesWithCallbacks = [];
                    this._referenceCount = 0;
                    this.selfUnref = false;
                    this._runtimeInstance = runtimeInstance;
                    if (parent !== null) this._parents.push(parent);
                }
                Object.defineProperty(ViewModelInstance.prototype, "runtimeInstance", {
                    get: function() {
                        return this._runtimeInstance;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModelInstance.prototype, "nativeInstance", {
                    get: function() {
                        return this._runtimeInstance;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstance.prototype.handleCallbacks = function() {
                    if (this._propertiesWithCallbacks.length !== 0) {
                        this._propertiesWithCallbacks.forEach(function(property) {
                            property.handleCallbacks();
                        });
                        this._propertiesWithCallbacks.forEach(function(property) {
                            property.clearChanges();
                        });
                    }
                    this._children.forEach(function(child) {
                        return child.handleCallbacks();
                    });
                };
                ViewModelInstance.prototype.addParent = function(parent) {
                    if (!this._parents.includes(parent)) {
                        this._parents.push(parent);
                        if (this._propertiesWithCallbacks.length > 0 || this._children.length > 0) parent.addToViewModelCallbacks(this);
                    }
                };
                ViewModelInstance.prototype.removeParent = function(parent) {
                    var index = this._parents.indexOf(parent);
                    if (index !== -1) {
                        var parent_1 = this._parents[index];
                        parent_1.removeFromViewModelCallbacks(this);
                        this._parents.splice(index, 1);
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.addToPropertyCallbacks = function(property) {
                    var _this = this;
                    if (!this._propertiesWithCallbacks.includes(property)) {
                        this._propertiesWithCallbacks.push(property);
                        if (this._propertiesWithCallbacks.length > 0) this._parents.forEach(function(parent) {
                            parent.addToViewModelCallbacks(_this);
                        });
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.removeFromPropertyCallbacks = function(property) {
                    var _this = this;
                    if (this._propertiesWithCallbacks.includes(property)) {
                        this._propertiesWithCallbacks = this._propertiesWithCallbacks.filter(function(prop) {
                            return prop !== property;
                        });
                        if (this._children.length === 0 && this._propertiesWithCallbacks.length === 0) this._parents.forEach(function(parent) {
                            parent.removeFromViewModelCallbacks(_this);
                        });
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.addToViewModelCallbacks = function(instance) {
                    var _this = this;
                    if (!this._children.includes(instance)) {
                        this._children.push(instance);
                        this._parents.forEach(function(parent) {
                            parent.addToViewModelCallbacks(_this);
                        });
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.removeFromViewModelCallbacks = function(instance) {
                    var _this = this;
                    if (this._children.includes(instance)) {
                        this._children = this._children.filter(function(child) {
                            return child !== instance;
                        });
                        if (this._children.length === 0 && this._propertiesWithCallbacks.length === 0) this._parents.forEach(function(parent) {
                            parent.removeFromViewModelCallbacks(_this);
                        });
                    }
                };
                ViewModelInstance.prototype.clearCallbacks = function() {
                    this._propertiesWithCallbacks.forEach(function(property) {
                        property.clearCallbacks();
                    });
                };
                ViewModelInstance.prototype.propertyFromPath = function(path, type) {
                    var pathSegments = path.split("/");
                    return this.propertyFromPathSegments(pathSegments, 0, type);
                };
                ViewModelInstance.prototype.viewModelFromPathSegments = function(pathSegments, index) {
                    var viewModelInstance = this.internalViewModelInstance(pathSegments[index]);
                    if (viewModelInstance !== null) {
                        if (index == pathSegments.length - 1) return viewModelInstance;
                        else return viewModelInstance.viewModelFromPathSegments(pathSegments, index++);
                    }
                    return null;
                };
                ViewModelInstance.prototype.propertyFromPathSegments = function(pathSegments, index, type) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                    if (index < pathSegments.length - 1) {
                        var viewModelInstance = this.internalViewModelInstance(pathSegments[index]);
                        if (viewModelInstance !== null) return viewModelInstance.propertyFromPathSegments(pathSegments, index + 1, type);
                        else return null;
                    }
                    var instance = null;
                    switch(type){
                        case PropertyType.Number:
                            instance = (_b = (_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.number(pathSegments[index])) !== null && _b !== void 0 ? _b : null;
                            if (instance !== null) return new ViewModelInstanceNumber(instance, this);
                            break;
                        case PropertyType.String:
                            instance = (_d = (_c = this._runtimeInstance) === null || _c === void 0 ? void 0 : _c.string(pathSegments[index])) !== null && _d !== void 0 ? _d : null;
                            if (instance !== null) return new ViewModelInstanceString(instance, this);
                            break;
                        case PropertyType.Boolean:
                            instance = (_f = (_e = this._runtimeInstance) === null || _e === void 0 ? void 0 : _e.boolean(pathSegments[index])) !== null && _f !== void 0 ? _f : null;
                            if (instance !== null) return new ViewModelInstanceBoolean(instance, this);
                            break;
                        case PropertyType.Color:
                            instance = (_h = (_g = this._runtimeInstance) === null || _g === void 0 ? void 0 : _g.color(pathSegments[index])) !== null && _h !== void 0 ? _h : null;
                            if (instance !== null) return new ViewModelInstanceColor(instance, this);
                            break;
                        case PropertyType.Trigger:
                            instance = (_k = (_j = this._runtimeInstance) === null || _j === void 0 ? void 0 : _j.trigger(pathSegments[index])) !== null && _k !== void 0 ? _k : null;
                            if (instance !== null) return new ViewModelInstanceTrigger(instance, this);
                            break;
                        case PropertyType.Enum:
                            instance = (_m = (_l = this._runtimeInstance) === null || _l === void 0 ? void 0 : _l.enum(pathSegments[index])) !== null && _m !== void 0 ? _m : null;
                            if (instance !== null) return new ViewModelInstanceEnum(instance, this);
                            break;
                        case PropertyType.List:
                            instance = (_p = (_o = this._runtimeInstance) === null || _o === void 0 ? void 0 : _o.list(pathSegments[index])) !== null && _p !== void 0 ? _p : null;
                            if (instance !== null) return new ViewModelInstanceList(instance, this);
                            break;
                        case PropertyType.Image:
                            instance = (_r = (_q = this._runtimeInstance) === null || _q === void 0 ? void 0 : _q.image(pathSegments[index])) !== null && _r !== void 0 ? _r : null;
                            if (instance !== null) return new ViewModelInstanceAssetImage(instance, this);
                            break;
                        case PropertyType.Artboard:
                            instance = (_t = (_s = this._runtimeInstance) === null || _s === void 0 ? void 0 : _s.artboard(pathSegments[index])) !== null && _t !== void 0 ? _t : null;
                            if (instance !== null) return new ViewModelInstanceArtboard(instance, this);
                            break;
                    }
                    return null;
                };
                ViewModelInstance.prototype.internalViewModelInstance = function(name) {
                    var _a;
                    if (this._viewModelInstances.has(name)) return this._viewModelInstances.get(name);
                    var viewModelRuntimeInstance = (_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.viewModel(name);
                    if (viewModelRuntimeInstance !== null) {
                        var viewModelInstance = new ViewModelInstance(viewModelRuntimeInstance, this);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, viewModelRuntimeInstance);
                        viewModelInstance.internalIncrementReferenceCount();
                        this._viewModelInstances.set(name, viewModelInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                /**
     * method to access a property instance of type number belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the number property
     */ ViewModelInstance.prototype.number = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Number);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type string belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the string property
     */ ViewModelInstance.prototype.string = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.String);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type boolean belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the boolean property
     */ ViewModelInstance.prototype.boolean = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Boolean);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type color belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the ttrigger property
     */ ViewModelInstance.prototype.color = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Color);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type trigger belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the trigger property
     */ ViewModelInstance.prototype.trigger = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Trigger);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type enum belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the enum property
     */ ViewModelInstance.prototype.enum = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Enum);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type list belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the list property
     */ ViewModelInstance.prototype.list = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.List);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a view model property instance belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the image property
     */ ViewModelInstance.prototype.image = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Image);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access an artboard property instance belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the image property
     */ ViewModelInstance.prototype.artboard = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Artboard);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a view model property instance belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the view model property
     */ ViewModelInstance.prototype.viewModel = function(path) {
                    var pathSegments = path.split("/");
                    var parentViewModelInstance = pathSegments.length > 1 ? this.viewModelFromPathSegments(pathSegments.slice(0, pathSegments.length - 1), 0) : this;
                    if (parentViewModelInstance != null) return parentViewModelInstance.internalViewModelInstance(pathSegments[pathSegments.length - 1]);
                    return null;
                };
                ViewModelInstance.prototype.internalReplaceViewModel = function(name, value) {
                    var _a;
                    if (value.runtimeInstance !== null) {
                        var result = ((_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.replaceViewModel(name, value.runtimeInstance)) || false;
                        if (result) {
                            value.internalIncrementReferenceCount();
                            var oldInstance_1 = this.internalViewModelInstance(name);
                            if (oldInstance_1 !== null) {
                                oldInstance_1.removeParent(this);
                                if (this._children.includes(oldInstance_1)) this._children = this._children.filter(function(child) {
                                    return child !== oldInstance_1;
                                });
                                oldInstance_1.cleanup();
                            }
                            this._viewModelInstances.set(name, value);
                            value.addParent(this);
                        }
                        return result;
                    }
                    return false;
                };
                /**
     * method to replace a view model property with another view model value
     * @param path - path to the view model property
     * @param value - view model that will replace the original
     */ ViewModelInstance.prototype.replaceViewModel = function(path, value) {
                    var _a;
                    var pathSegments = path.split("/");
                    var viewModelInstance = pathSegments.length > 1 ? this.viewModelFromPathSegments(pathSegments.slice(0, pathSegments.length - 1), 0) : this;
                    return (_a = viewModelInstance === null || viewModelInstance === void 0 ? void 0 : viewModelInstance.internalReplaceViewModel(pathSegments[pathSegments.length - 1], value)) !== null && _a !== void 0 ? _a : false;
                };
                /*
     * method to add one to the reference counter of the instance.
     * Use if the file owning the reference is destroyed but the instance needs to stay around
     */ ViewModelInstance.prototype.incrementReferenceCount = function() {
                    var _a;
                    this._referenceCount++;
                    (_a = this._runtimeInstance) === null || _a === void 0 || _a.incrementReferenceCount();
                };
                /*
     * method to subtract one to the reference counter of the instance.
     * Use if incrementReferenceCount has been called
     */ ViewModelInstance.prototype.decrementReferenceCount = function() {
                    var _a;
                    this._referenceCount--;
                    (_a = this._runtimeInstance) === null || _a === void 0 || _a.decrementReferenceCount();
                };
                Object.defineProperty(ViewModelInstance.prototype, "properties", {
                    get: function() {
                        var _a;
                        return ((_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.getProperties().map(function(prop) {
                            return __assign({}, prop);
                        })) || [];
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstance.prototype.internalIncrementReferenceCount = function() {
                    this._referenceCount++;
                };
                ViewModelInstance.prototype.cleanup = function() {
                    var _this = this;
                    var _a;
                    this._referenceCount--;
                    if (this._referenceCount <= 0) {
                        if (this.selfUnref) (_a = this._runtimeInstance) === null || _a === void 0 || _a.unref();
                        this._runtimeInstance = null;
                        this.clearCallbacks();
                        this._propertiesWithCallbacks = [];
                        this._viewModelInstances.forEach(function(value) {
                            value.cleanup();
                        });
                        this._viewModelInstances.clear();
                        var children = __spreadArray([], this._children, true);
                        this._children.length = 0;
                        var parents = __spreadArray([], this._parents, true);
                        this._parents.length = 0;
                        children.forEach(function(child) {
                            child.removeParent(_this);
                        });
                        parents.forEach(function(parent) {
                            parent.removeFromViewModelCallbacks(_this);
                        });
                    }
                };
                return ViewModelInstance;
            }();
            var ViewModelInstanceValue = /** @class */ function() {
                function ViewModelInstanceValue(instance, parent) {
                    this.callbacks = [];
                    this._viewModelInstanceValue = instance;
                    this._parentViewModel = parent;
                }
                ViewModelInstanceValue.prototype.on = function(callback) {
                    // Since we don't clean the changed flag for properties that don't have listeners,
                    // we clean it the first time we add a listener to it
                    if (this.callbacks.length === 0) this._viewModelInstanceValue.clearChanges();
                    if (!this.callbacks.includes(callback)) {
                        this.callbacks.push(callback);
                        this._parentViewModel.addToPropertyCallbacks(this);
                    }
                };
                ViewModelInstanceValue.prototype.off = function(callback) {
                    if (!callback) this.callbacks.length = 0;
                    else this.callbacks = this.callbacks.filter(function(cb) {
                        return cb !== callback;
                    });
                    if (this.callbacks.length === 0) this._parentViewModel.removeFromPropertyCallbacks(this);
                };
                ViewModelInstanceValue.prototype.internalHandleCallback = function(callback) {};
                ViewModelInstanceValue.prototype.handleCallbacks = function() {
                    var _this = this;
                    if (this._viewModelInstanceValue.hasChanged) this.callbacks.forEach(function(callback) {
                        _this.internalHandleCallback(callback);
                    });
                };
                ViewModelInstanceValue.prototype.clearChanges = function() {
                    this._viewModelInstanceValue.clearChanges();
                };
                ViewModelInstanceValue.prototype.clearCallbacks = function() {
                    this.callbacks.length = 0;
                };
                Object.defineProperty(ViewModelInstanceValue.prototype, "name", {
                    get: function() {
                        return this._viewModelInstanceValue.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                return ViewModelInstanceValue;
            }();
            var ViewModelInstanceString = /** @class */ function(_super) {
                __extends(ViewModelInstanceString, _super);
                function ViewModelInstanceString(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceString.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceString.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceString;
            }(ViewModelInstanceValue);
            var ViewModelInstanceNumber = /** @class */ function(_super) {
                __extends(ViewModelInstanceNumber, _super);
                function ViewModelInstanceNumber(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceNumber.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceNumber.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceNumber;
            }(ViewModelInstanceValue);
            var ViewModelInstanceBoolean = /** @class */ function(_super) {
                __extends(ViewModelInstanceBoolean, _super);
                function ViewModelInstanceBoolean(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceBoolean.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceBoolean.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceBoolean;
            }(ViewModelInstanceValue);
            var ViewModelInstanceTrigger = /** @class */ function(_super) {
                __extends(ViewModelInstanceTrigger, _super);
                function ViewModelInstanceTrigger(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                ViewModelInstanceTrigger.prototype.trigger = function() {
                    return this._viewModelInstanceValue.trigger();
                };
                ViewModelInstanceTrigger.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceTrigger;
            }(ViewModelInstanceValue);
            var ViewModelInstanceEnum = /** @class */ function(_super) {
                __extends(ViewModelInstanceEnum, _super);
                function ViewModelInstanceEnum(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceEnum.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModelInstanceEnum.prototype, "valueIndex", {
                    get: function() {
                        return this._viewModelInstanceValue.valueIndex;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.valueIndex = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModelInstanceEnum.prototype, "values", {
                    get: function() {
                        return this._viewModelInstanceValue.values;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceEnum.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceEnum;
            }(ViewModelInstanceValue);
            var ViewModelInstanceList = /** @class */ function(_super) {
                __extends(ViewModelInstanceList, _super);
                function ViewModelInstanceList(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceList.prototype, "length", {
                    get: function() {
                        return this._viewModelInstanceValue.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceList.prototype.addInstance = function(instance) {
                    if (instance.runtimeInstance != null) {
                        this._viewModelInstanceValue.addInstance(instance.runtimeInstance);
                        instance.addParent(this._parentViewModel);
                    }
                };
                ViewModelInstanceList.prototype.addInstanceAt = function(instance, index) {
                    if (instance.runtimeInstance != null) {
                        if (this._viewModelInstanceValue.addInstanceAt(instance.runtimeInstance, index)) {
                            instance.addParent(this._parentViewModel);
                            return true;
                        }
                    }
                    return false;
                };
                ViewModelInstanceList.prototype.removeInstance = function(instance) {
                    if (instance.runtimeInstance != null) {
                        this._viewModelInstanceValue.removeInstance(instance.runtimeInstance);
                        instance.removeParent(this._parentViewModel);
                    }
                };
                ViewModelInstanceList.prototype.removeInstanceAt = function(index) {
                    this._viewModelInstanceValue.removeInstanceAt(index);
                };
                ViewModelInstanceList.prototype.instanceAt = function(index) {
                    var runtimeInstance = this._viewModelInstanceValue.instanceAt(index);
                    if (runtimeInstance != null) {
                        var viewModelInstance = new ViewModelInstance(runtimeInstance, this._parentViewModel);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, runtimeInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModelInstanceList.prototype.swap = function(a, b) {
                    this._viewModelInstanceValue.swap(a, b);
                };
                ViewModelInstanceList.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceList;
            }(ViewModelInstanceValue);
            var ViewModelInstanceColor = /** @class */ function(_super) {
                __extends(ViewModelInstanceColor, _super);
                function ViewModelInstanceColor(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceColor.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceColor.prototype.rgb = function(r, g, b) {
                    this._viewModelInstanceValue.rgb(r, g, b);
                };
                ViewModelInstanceColor.prototype.rgba = function(r, g, b, a) {
                    this._viewModelInstanceValue.argb(a, r, g, b);
                };
                ViewModelInstanceColor.prototype.argb = function(a, r, g, b) {
                    this._viewModelInstanceValue.argb(a, r, g, b);
                };
                // Value 0 to 255
                ViewModelInstanceColor.prototype.alpha = function(a) {
                    this._viewModelInstanceValue.alpha(a);
                };
                // Value 0 to 1
                ViewModelInstanceColor.prototype.opacity = function(o) {
                    this._viewModelInstanceValue.alpha(Math.round(Math.max(0, Math.min(1, o)) * 255));
                };
                ViewModelInstanceColor.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceColor;
            }(ViewModelInstanceValue);
            var ViewModelInstanceAssetImage = /** @class */ function(_super) {
                __extends(ViewModelInstanceAssetImage, _super);
                function ViewModelInstanceAssetImage(instance, root) {
                    return _super.call(this, instance, root) || this;
                }
                Object.defineProperty(ViewModelInstanceAssetImage.prototype, "value", {
                    set: function(image) {
                        var _a;
                        this._viewModelInstanceValue.value((_a = image === null || image === void 0 ? void 0 : image.nativeImage) !== null && _a !== void 0 ? _a : null);
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceAssetImage.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceAssetImage;
            }(ViewModelInstanceValue);
            var ViewModelInstanceArtboard = /** @class */ function(_super) {
                __extends(ViewModelInstanceArtboard, _super);
                function ViewModelInstanceArtboard(instance, root) {
                    return _super.call(this, instance, root) || this;
                }
                Object.defineProperty(ViewModelInstanceArtboard.prototype, "value", {
                    set: function(artboard) {
                        var _a;
                        var bindableArtboard;
                        if (artboard.isBindableArtboard) bindableArtboard = artboard;
                        else bindableArtboard = artboard.file.internalBindableArtboardFromArtboard(artboard.nativeArtboard);
                        this._viewModelInstanceValue.value((_a = bindableArtboard === null || bindableArtboard === void 0 ? void 0 : bindableArtboard.nativeArtboard) !== null && _a !== void 0 ? _a : null);
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceArtboard.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceArtboard;
            }(ViewModelInstanceValue);
            // Loads Rive data from a URI via fetch.
            var loadRiveFile = function(src) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var req, res, buffer;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                req = new Request(src);
                                return [
                                    4 /*yield*/ ,
                                    fetch(req)
                                ];
                            case 1:
                                res = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    res.arrayBuffer()
                                ];
                            case 2:
                                buffer = _a.sent();
                                return [
                                    2 /*return*/ ,
                                    buffer
                                ];
                        }
                    });
                });
            };
            // #endregion
            // #region utility functions
            /*
 * Utility function to ensure an object is a string array
 */ var mapToStringArray = function(obj) {
                if (typeof obj === "string") return [
                    obj
                ];
                else if (obj instanceof Array) return obj;
                // If obj is undefined, return empty array
                return [];
            };
            // #endregion
            // #region testing utilities
            // Exports to only be used for tests
            var Testing = {
                EventManager: EventManager,
                TaskQueueManager: TaskQueueManager
            };
            // #endregion
            // #region asset loaders
            /**
 * Decodes bytes into an audio asset.
 *
 * Be sure to call `.unref()` on the audio once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeAudio = function(bytes) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var decodedPromise, audio, audioWrapper;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                decodedPromise = new Promise(function(resolve) {
                                    return RuntimeLoader.getInstance(function(rive) {
                                        rive.decodeAudio(bytes, resolve);
                                    });
                                });
                                return [
                                    4 /*yield*/ ,
                                    decodedPromise
                                ];
                            case 1:
                                audio = _a.sent();
                                audioWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.AudioWrapper(audio);
                                _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(audioWrapper, audio);
                                return [
                                    2 /*return*/ ,
                                    audioWrapper
                                ];
                        }
                    });
                });
            };
            /**
 * Decodes bytes into an image.
 *
 * Be sure to call `.unref()` on the image once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeImage = function(bytes) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var decodedPromise, image, imageWrapper;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                decodedPromise = new Promise(function(resolve) {
                                    return RuntimeLoader.getInstance(function(rive) {
                                        rive.decodeImage(bytes, resolve);
                                    });
                                });
                                return [
                                    4 /*yield*/ ,
                                    decodedPromise
                                ];
                            case 1:
                                image = _a.sent();
                                imageWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.ImageWrapper(image);
                                _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(imageWrapper, image);
                                return [
                                    2 /*return*/ ,
                                    imageWrapper
                                ];
                        }
                    });
                });
            };
            /**
 * Decodes bytes into a font.
 *
 * Be sure to call `.unref()` on the font once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeFont = function(bytes) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var decodedPromise, font, fontWrapper;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                decodedPromise = new Promise(function(resolve) {
                                    return RuntimeLoader.getInstance(function(rive) {
                                        rive.decodeFont(bytes, resolve);
                                    });
                                });
                                return [
                                    4 /*yield*/ ,
                                    decodedPromise
                                ];
                            case 1:
                                font = _a.sent();
                                fontWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.FontWrapper(font);
                                _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(fontWrapper, font);
                                return [
                                    2 /*return*/ ,
                                    fontWrapper
                                ];
                        }
                    });
                });
            };
        // #endregion
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});


function $2305b7cdeafa4e99$var$t(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
var $2305b7cdeafa4e99$var$r = /*#__PURE__*/ $2305b7cdeafa4e99$var$t($7pfQ9), $2305b7cdeafa4e99$var$u = function() {
    return $2305b7cdeafa4e99$var$u = Object.assign || function(e) {
        for(var n, t = 1, r = arguments.length; t < r; t++)for(var u in n = arguments[t])Object.prototype.hasOwnProperty.call(n, u) && (e[u] = n[u]);
        return e;
    }, $2305b7cdeafa4e99$var$u.apply(this, arguments);
};
function $2305b7cdeafa4e99$var$a(e, n) {
    var t = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var u = 0;
        for(r = Object.getOwnPropertySymbols(e); u < r.length; u++)n.indexOf(r[u]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[u]) && (t[r[u]] = e[r[u]]);
    }
    return t;
}
function $2305b7cdeafa4e99$var$i(e, n, t, r) {
    return new (t || (t = Promise))(function(u, a) {
        function i(e) {
            try {
                l(r.next(e));
            } catch (e) {
                a(e);
            }
        }
        function o(e) {
            try {
                l(r.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function l(e) {
            var n;
            e.done ? u(e.value) : (n = e.value, n instanceof t ? n : new t(function(e) {
                e(n);
            })).then(i, o);
        }
        l((r = r.apply(e, n || [])).next());
    });
}
function $2305b7cdeafa4e99$var$o(e, n) {
    var t, r, u, a, i = {
        label: 0,
        sent: function() {
            if (1 & u[0]) throw u[1];
            return u[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function o(a) {
        return function(o) {
            return function(a) {
                if (t) throw new TypeError("Generator is already executing.");
                for(; i;)try {
                    if (t = 1, r && (u = 2 & a[0] ? r.return : a[0] ? r.throw || ((u = r.return) && u.call(r), 0) : r.next) && !(u = u.call(r, a[1])).done) return u;
                    switch(r = 0, u && (a = [
                        2 & a[0],
                        u.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            u = a;
                            break;
                        case 4:
                            return i.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            i.label++, r = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(u = i.trys, (u = u.length > 0 && u[u.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === a[0] && (!u || a[1] > u[0] && a[1] < u[3])) {
                                i.label = a[1];
                                break;
                            }
                            if (6 === a[0] && i.label < u[1]) {
                                i.label = u[1], u = a;
                                break;
                            }
                            if (u && i.label < u[2]) {
                                i.label = u[2], i.ops.push(a);
                                break;
                            }
                            u[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    a = n.call(e, i);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    t = u = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                o
            ]);
        };
    }
}
function $2305b7cdeafa4e99$var$l(n) {
    var t = n || $2305b7cdeafa4e99$var$c(), r = $7pfQ9.useState(t), u = r[0], a = r[1];
    return $7pfQ9.useEffect(function() {
        if ("undefined" != typeof window && "matchMedia" in window) {
            var e = function() {
                var e = n || $2305b7cdeafa4e99$var$c();
                a(e);
            }, t = window.matchMedia("screen and (resolution: ".concat(u, "dppx)"));
            return t.hasOwnProperty("addEventListener") ? t.addEventListener("change", e) : t.addListener(e), function() {
                t.hasOwnProperty("removeEventListener") ? t.removeEventListener("change", e) : t.removeListener(e);
            };
        }
    }, [
        u,
        n
    ]), u;
}
function $2305b7cdeafa4e99$var$c() {
    var e = "undefined" != typeof window && "number" == typeof window.devicePixelRatio ? window.devicePixelRatio : 1;
    return Math.min(Math.max(1, e), 3);
}
var $2305b7cdeafa4e99$var$s = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}();
var $2305b7cdeafa4e99$var$f = globalThis.ResizeObserver || $2305b7cdeafa4e99$var$s, $2305b7cdeafa4e99$var$d = void 0 !== globalThis.ResizeObserver, $2305b7cdeafa4e99$var$v = !$2305b7cdeafa4e99$var$d;
function $2305b7cdeafa4e99$var$p(n, t) {
    void 0 === t && (t = !0);
    var r = $7pfQ9.useState({
        width: 0,
        height: 0
    }), u = r[0], a = r[1];
    $7pfQ9.useEffect(function() {
        if ("undefined" != typeof window && t) {
            var e = function() {
                a({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            return $2305b7cdeafa4e99$var$v && (e(), window.addEventListener("resize", e)), function() {
                return window.removeEventListener("resize", e);
            };
        }
    }, []);
    var i, o, l, c = $7pfQ9.useRef(new $2305b7cdeafa4e99$var$f((i = function(e) {
        $2305b7cdeafa4e99$var$d && a({
            width: e[e.length - 1].contentRect.width,
            height: e[e.length - 1].contentRect.height
        });
    }, o = 0, l = 0, function() {
        for(var e = this, n = [], t = 0; t < arguments.length; t++)n[t] = arguments[t];
        clearTimeout(l), l = window.setTimeout(function() {
            return i.apply(e, n);
        }, o);
    })));
    return $7pfQ9.useEffect(function() {
        var e = c.current;
        if (t) {
            var r = n.current;
            return n.current && $2305b7cdeafa4e99$var$d && e.observe(n.current), function() {
                e.disconnect(), r && $2305b7cdeafa4e99$var$d && e.unobserve(r);
            };
        }
        e.disconnect();
    }, [
        n,
        c
    ]), u;
}
var $2305b7cdeafa4e99$var$h = {
    useDevicePixelRatio: !0,
    fitCanvasToArtboardHeight: !1,
    useOffscreenRenderer: !0,
    shouldResizeCanvasToContainer: !0
};
function $2305b7cdeafa4e99$var$b(e) {
    return Object.assign({}, $2305b7cdeafa4e99$var$h, e);
}
function $2305b7cdeafa4e99$var$g(n) {
    var t = n.riveLoaded, r = void 0 !== t && t, u = n.canvasElem, a = n.containerRef, i = n.options, o = void 0 === i ? {} : i, c = n.onCanvasHasResized, s = n.artboardBounds, f = $2305b7cdeafa4e99$var$b(o), d = $7pfQ9.useState({
        height: 0,
        width: 0
    }), v = d[0], h = v.height, g = v.width, y = d[1], w = $7pfQ9.useState({
        height: 0,
        width: 0
    }), m = w[0], C = m.height, R = m.width, E = w[1], V = $7pfQ9.useState(!0), x = V[0], k = V[1], O = f.fitCanvasToArtboardHeight, I = f.shouldResizeCanvasToContainer, P = f.useDevicePixelRatio, M = f.customDevicePixelRatio, T = $2305b7cdeafa4e99$var$p(a, I), S = $2305b7cdeafa4e99$var$l(M), D = null != s ? s : {}, L = D.maxX, A = D.maxY, z = $7pfQ9.useCallback(function() {
        var e, n, t, r, u = null !== (n = null === (e = a.current) || void 0 === e ? void 0 : e.clientWidth) && void 0 !== n ? n : 0, i = null !== (r = null === (t = a.current) || void 0 === t ? void 0 : t.clientHeight) && void 0 !== r ? r : 0;
        return O && s ? {
            width: u,
            height: u * (s.maxY / s.maxX)
        } : {
            width: u,
            height: i
        };
    }, [
        a,
        O,
        L,
        A
    ]);
    $7pfQ9.useEffect(function() {
        if (I && a.current && r) {
            var e = z(), n = e.width, t = e.height, i = !1;
            if (u) {
                var o = n !== g || t !== h;
                if (f.fitCanvasToArtboardHeight && o && (a.current.style.height = t + "px", i = !0), f.useDevicePixelRatio) {
                    if (o || n * S !== R || t * S !== C) {
                        var l = S * n, s = S * t;
                        u.width = l, u.height = s, u.style.width = n + "px", u.style.height = t + "px", E({
                            width: l,
                            height: s
                        }), i = !0;
                    }
                } else o && (u.width = n, u.height = t, E({
                    width: n,
                    height: t
                }), i = !0);
                y({
                    width: n,
                    height: t
                });
            }
            c && (x || i) && c && c(), x && k(!1);
        }
    }, [
        u,
        a,
        T,
        S,
        z,
        x,
        k,
        C,
        R,
        h,
        g,
        c,
        I,
        O,
        P,
        r
    ]), $7pfQ9.useEffect(function() {
        E({
            width: 0,
            height: 0
        });
    }, [
        u
    ]);
}
var $2305b7cdeafa4e99$var$y, $2305b7cdeafa4e99$var$w = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}(), $2305b7cdeafa4e99$var$m = globalThis.IntersectionObserver || $2305b7cdeafa4e99$var$w, $2305b7cdeafa4e99$var$C = function() {
    function e() {
        var e = this;
        this.elementsMap = new Map, this.onObserved = function(n) {
            n.forEach(function(n) {
                var t = e.elementsMap.get(n.target);
                t && t(n);
            });
        }, this.observer = new $2305b7cdeafa4e99$var$m(this.onObserved);
    }
    return e.prototype.registerCallback = function(e, n) {
        this.observer.observe(e), this.elementsMap.set(e, n);
    }, e.prototype.removeCallback = function(e) {
        this.observer.unobserve(e), this.elementsMap.delete(e);
    }, e;
}(), $2305b7cdeafa4e99$var$R = function() {
    return $2305b7cdeafa4e99$var$y || ($2305b7cdeafa4e99$var$y = new $2305b7cdeafa4e99$var$C), $2305b7cdeafa4e99$var$y;
};
function $2305b7cdeafa4e99$var$E(e) {
    var n = e.setContainerRef, t = e.setCanvasRef, i = e.className, o = void 0 === i ? "" : i, l = e.style, c = e.children, s = $2305b7cdeafa4e99$var$a(e, [
        "setContainerRef",
        "setCanvasRef",
        "className",
        "style",
        "children"
    ]), f = $2305b7cdeafa4e99$var$u({
        width: "100%",
        height: "100%"
    }, l);
    return $2305b7cdeafa4e99$var$r.default.createElement("div", $2305b7cdeafa4e99$var$u({
        ref: n,
        className: o
    }, !o && {
        style: f
    }), $2305b7cdeafa4e99$var$r.default.createElement("canvas", $2305b7cdeafa4e99$var$u({
        ref: t,
        style: {
            verticalAlign: "top",
            width: 0,
            height: 0
        }
    }, s), c));
}
function $2305b7cdeafa4e99$var$V(t, i) {
    void 0 === i && (i = {});
    var o = $7pfQ9.useState(null), c = o[0], s = o[1], f = $7pfQ9.useRef(null), d = $7pfQ9.useRef(null), v = $7pfQ9.useState(null), p = v[0], h = v[1], y = Boolean(t), w = $2305b7cdeafa4e99$var$b(i), m = $2305b7cdeafa4e99$var$l(), C = $7pfQ9.useCallback(function() {
        if (p) {
            if (p.layout && p.layout.fit === $fae66df3ca4d9b5e$exports.Fit.Layout && c) {
                var e = m * p.layout.layoutScaleFactor;
                p.devicePixelRatioUsed = m, p.artboardWidth = (null == c ? void 0 : c.width) / e, p.artboardHeight = (null == c ? void 0 : c.height) / e;
            }
            p.startRendering(), p.resizeToCanvas();
        }
    }, [
        p,
        m
    ]);
    $2305b7cdeafa4e99$var$g({
        riveLoaded: !!p,
        canvasElem: c,
        containerRef: f,
        options: w,
        onCanvasHasResized: C,
        artboardBounds: null == p ? void 0 : p.bounds
    });
    var V = $7pfQ9.useCallback(function(e) {
        null === e && c && (c.height = 0, c.width = 0), s(e);
    }, []);
    $7pfQ9.useEffect(function() {
        if (c && t) {
            var e, r = null != p;
            if (null == p) {
                var i = w.useOffscreenRenderer, o = t.onRiveReady, l = $2305b7cdeafa4e99$var$a(t, [
                    "onRiveReady"
                ]);
                e = new $fae66df3ca4d9b5e$exports.Rive($2305b7cdeafa4e99$var$u($2305b7cdeafa4e99$var$u({
                    useOffscreenRenderer: i
                }, l), {
                    canvas: c
                })), null != d.current && d.current.cleanup(), d.current = e, e.on($fae66df3ca4d9b5e$exports.EventType.Load, function() {
                    r = !0, o && o(e), c ? h(e) : e.cleanup();
                });
            }
            return function() {
                r || null == e || e.cleanup();
            };
        }
    }, [
        c,
        y,
        p
    ]);
    var x = $7pfQ9.useCallback(function(e) {
        f.current = e;
    }, []), k = {
        observe: $7pfQ9.useCallback(function(e, n) {
            $2305b7cdeafa4e99$var$R().registerCallback(e, n);
        }, []),
        unobserve: $7pfQ9.useCallback(function(e) {
            $2305b7cdeafa4e99$var$R().removeCallback(e);
        }, [])
    }, O = k.observe, I = k.unobserve;
    $7pfQ9.useEffect(function() {
        var e, n = !1, t = function() {
            if (c && n) {
                var e = c.getBoundingClientRect();
                e.width > 0 && e.height > 0 && e.top < (window.innerHeight || document.documentElement.clientHeight) && e.bottom > 0 && e.left < (window.innerWidth || document.documentElement.clientWidth) && e.right > 0 && (null == p || p.startRendering(), n = !1);
            }
        };
        return c && !1 !== w.shouldUseIntersectionObserver && O(c, function(r) {
            r.isIntersecting ? p && p.startRendering() : p && p.stopRendering(), n = !r.isIntersecting, clearTimeout(e), r.isIntersecting || 0 !== r.boundingClientRect.width || (e = setTimeout(t, 10));
        }), function() {
            c && I(c);
        };
    }, [
        O,
        I,
        p,
        c,
        w.shouldUseIntersectionObserver
    ]), $7pfQ9.useEffect(function() {
        return function() {
            p && (p.cleanup(), h(null));
        };
    }, [
        p,
        c
    ]), $7pfQ9.useEffect(function() {
        return function() {
            null != d.current && d.current.cleanup();
        };
    }, []);
    var P = null == t ? void 0 : t.animations;
    $7pfQ9.useEffect(function() {
        p && P && (p.isPlaying ? (p.stop(p.animationNames), p.play(P)) : p.isPaused && (p.stop(p.animationNames), p.pause(P)));
    }, [
        P,
        p
    ]);
    var M = $7pfQ9.useCallback(function(e) {
        return $2305b7cdeafa4e99$var$r.default.createElement($2305b7cdeafa4e99$var$E, $2305b7cdeafa4e99$var$u({
            setContainerRef: x,
            setCanvasRef: V
        }, e));
    }, [
        V,
        x
    ]);
    return {
        canvas: c,
        container: f.current,
        setCanvasRef: V,
        setContainerRef: x,
        rive: p,
        RiveComponent: M
    };
}
function $2305b7cdeafa4e99$var$x(n, t, r) {
    var a = $7pfQ9.useState(null), i = a[0], o = a[1], l = $7pfQ9.useState(r.defaultValue), c = l[0], s = l[1], f = $7pfQ9.useState(null), d = f[0], v = f[1], p = $7pfQ9.useRef(null), h = $7pfQ9.useRef(n), b = $7pfQ9.useRef(r);
    $7pfQ9.useEffect(function() {
        b.current = r;
    }, [
        r
    ]);
    var g = $7pfQ9.useCallback(function() {
        var e = p.current, n = h.current, t = b.current;
        if (!e || !n) return o(null), s(t.defaultValue), v(null), function() {};
        var r = t.getProperty(e, n);
        if (r) {
            o(r), s(t.getValue(r)), t.getExtendedData && v(t.getExtendedData(r));
            var u = function() {
                s(t.getValue(r)), t.getExtendedData && v(t.getExtendedData(r)), t.onPropertyEvent && t.onPropertyEvent();
            };
            return r.on(u), function() {
                r.off(u);
            };
        }
        return function() {};
    }, []);
    $7pfQ9.useEffect(function() {
        return p.current = t, h.current = n, g();
    }, [
        t,
        n,
        g
    ]);
    var y = $7pfQ9.useCallback(function(e) {
        if (i && p.current === t) try {
            return e(i), void (b.current.getExtendedData && v(b.current.getExtendedData(i)));
        } catch (e) {}
        if (p.current) try {
            var n = b.current.getProperty(p.current, h.current);
            n && (o(n), e(n), b.current.getExtendedData && v(b.current.getExtendedData(n)));
        } catch (e) {}
    }, [
        i,
        t
    ]), w = $7pfQ9.useMemo(function() {
        return b.current.buildPropertyOperations(y);
    }, [
        y
    ]), m = $2305b7cdeafa4e99$var$u({
        value: c
    }, w);
    return r.getExtendedData && (m.extendedData = d), m;
}
$2305b7cdeafa4e99$exports.default = function(e) {
    var n = e.src, t = e.artboard, i = e.animations, o = e.stateMachines, l = e.layout, c = e.useOffscreenRenderer, s = void 0 === c || c, f = e.shouldDisableRiveListeners, d = void 0 !== f && f, v = e.shouldResizeCanvasToContainer, p = void 0 === v || v, h = e.automaticallyHandleEvents, b = void 0 !== h && h, g = e.children, y = $2305b7cdeafa4e99$var$a(e, [
        "src",
        "artboard",
        "animations",
        "stateMachines",
        "layout",
        "useOffscreenRenderer",
        "shouldDisableRiveListeners",
        "shouldResizeCanvasToContainer",
        "automaticallyHandleEvents",
        "children"
    ]), w = $2305b7cdeafa4e99$var$V({
        src: n,
        artboard: t,
        animations: i,
        layout: l,
        stateMachines: o,
        autoplay: !0,
        shouldDisableRiveListeners: d,
        automaticallyHandleEvents: b
    }, {
        useOffscreenRenderer: s,
        shouldResizeCanvasToContainer: p
    }).RiveComponent;
    return $2305b7cdeafa4e99$var$r.default.createElement(w, $2305b7cdeafa4e99$var$u({}, y), g);
}, $2305b7cdeafa4e99$exports.useResizeCanvas = $2305b7cdeafa4e99$var$g, $2305b7cdeafa4e99$exports.useRive = $2305b7cdeafa4e99$var$V, $2305b7cdeafa4e99$exports.useRiveFile = function(t) {
    var r = this, u = $7pfQ9.useState(null), a = u[0], l = u[1], c = $7pfQ9.useState("idle"), s = c[0], f = c[1];
    return $7pfQ9.useEffect(function() {
        var e = null;
        return $2305b7cdeafa4e99$var$i(r, void 0, void 0, function() {
            return $2305b7cdeafa4e99$var$o(this, function(r) {
                try {
                    f("loading"), (e = new $fae66df3ca4d9b5e$exports.RiveFile(t)).init(), e.on($fae66df3ca4d9b5e$exports.EventType.Load, function() {
                        null == e || e.getInstance(), l(e), f("success");
                    }), e.on($fae66df3ca4d9b5e$exports.EventType.LoadError, function() {
                        f("failed");
                    }), l(e);
                } catch (e) {
                    console.error(e), f("failed");
                }
                return [
                    2
                ];
            });
        }), function() {
            null == e || e.cleanup();
        };
    }, [
        t.src,
        t.buffer
    ]), {
        riveFile: a,
        status: s
    };
}, $2305b7cdeafa4e99$exports.useStateMachineInput = function(t, r, u, a) {
    var i = $7pfQ9.useState(null), o = i[0], l = i[1];
    return $7pfQ9.useEffect(function() {
        function e() {
            if (t && r && u || l(null), t && r && u) {
                var e = t.stateMachineInputs(r);
                if (e) {
                    var n = e.find(function(e) {
                        return e.name === u;
                    });
                    void 0 !== a && n && (n.value = a), l(n || null);
                }
            } else l(null);
        }
        e(), t && t.on($fae66df3ca4d9b5e$exports.EventType.Load, function() {
            e();
        });
    }, [
        t
    ]), o;
}, $2305b7cdeafa4e99$exports.useViewModel = function(t, r) {
    var u = null != r ? r : {}, a = u.name, i = u.useDefault, o = void 0 !== i && i, l = $7pfQ9.useState(null), c = l[0], s = l[1];
    return $7pfQ9.useEffect(function() {
        function e() {
            var e;
            if (t) {
                var n = null;
                n = null != a ? (null === (e = t.viewModelByName) || void 0 === e ? void 0 : e.call(t, a)) || null : t.defaultViewModel() || null, s(n);
            } else s(null);
        }
        return e(), t && t.on($fae66df3ca4d9b5e$exports.EventType.Load, e), function() {
            t && t.off($fae66df3ca4d9b5e$exports.EventType.Load, e);
        };
    }, [
        t,
        a,
        o
    ]), c;
}, $2305b7cdeafa4e99$exports.useViewModelInstance = function(n, t) {
    var r = null != t ? t : {}, u = r.name, a = r.useDefault, i = void 0 !== a && a, o = r.useNew, l = void 0 !== o && o, c = r.rive, s = $7pfQ9.useState(null), f = s[0], d = s[1];
    return $7pfQ9.useEffect(function() {
        var e, t, r;
        if (n) {
            var a = null;
            a = null != u ? n.instanceByName(u) || null : i ? (null === (e = n.defaultInstance) || void 0 === e ? void 0 : e.call(n)) || null : l ? (null === (t = n.instance) || void 0 === t ? void 0 : t.call(n)) || null : (null === (r = n.defaultInstance) || void 0 === r ? void 0 : r.call(n)) || null, d(a), c && a && c.viewModelInstance !== a && c.bindViewModelInstance(a);
        } else d(null);
    }, [
        n,
        u,
        i,
        l,
        c
    ]), f;
}, $2305b7cdeafa4e99$exports.useViewModelInstanceArtboard = function(n, t) {
    return {
        setValue: $2305b7cdeafa4e99$var$x(n, t, {
            getProperty: $7pfQ9.useCallback(function(e, n) {
                return e.artboard(n);
            }, []),
            getValue: $7pfQ9.useCallback(function() {}, []),
            defaultValue: null,
            buildPropertyOperations: $7pfQ9.useCallback(function(e) {
                return {
                    setValue: function(n) {
                        e(function(e) {
                            e.value = n;
                        });
                    }
                };
            }, [])
        }).setValue
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceBoolean = function(n, t) {
    var r = $2305b7cdeafa4e99$var$x(n, t, {
        getProperty: $7pfQ9.useCallback(function(e, n) {
            return e.boolean(n);
        }, []),
        getValue: $7pfQ9.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $7pfQ9.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceColor = function(n, t) {
    var r = $2305b7cdeafa4e99$var$x(n, t, {
        getProperty: $7pfQ9.useCallback(function(e, n) {
            return e.color(n);
        }, []),
        getValue: $7pfQ9.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $7pfQ9.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                },
                setRgb: function(n, t, r) {
                    e(function(e) {
                        e.rgb(n, t, r);
                    });
                },
                setRgba: function(n, t, r, u) {
                    e(function(e) {
                        e.rgba(n, t, r, u);
                    });
                },
                setAlpha: function(n) {
                    e(function(e) {
                        e.alpha(n);
                    });
                },
                setOpacity: function(n) {
                    e(function(e) {
                        e.opacity(n);
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue,
        setRgb: r.setRgb,
        setRgba: r.setRgba,
        setAlpha: r.setAlpha,
        setOpacity: r.setOpacity
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceEnum = function(n, t) {
    var r = $2305b7cdeafa4e99$var$x(n, t, {
        getProperty: $7pfQ9.useCallback(function(e, n) {
            return e.enum(n);
        }, []),
        getValue: $7pfQ9.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        getExtendedData: $7pfQ9.useCallback(function(e) {
            return e.values;
        }, []),
        buildPropertyOperations: $7pfQ9.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        values: r.extendedData || [],
        setValue: r.setValue
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceImage = function(n, t) {
    return {
        setValue: $2305b7cdeafa4e99$var$x(n, t, {
            getProperty: $7pfQ9.useCallback(function(e, n) {
                return e.image(n);
            }, []),
            getValue: $7pfQ9.useCallback(function() {}, []),
            defaultValue: null,
            buildPropertyOperations: $7pfQ9.useCallback(function(e) {
                return {
                    setValue: function(n) {
                        e(function(e) {
                            e.value = n;
                        });
                    }
                };
            }, [])
        }).setValue
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceList = function(n, t) {
    var r, u = $7pfQ9.useState(0)[1], a = $2305b7cdeafa4e99$var$x(n, t, {
        getProperty: $7pfQ9.useCallback(function(e, n) {
            return e.list(n);
        }, []),
        getValue: $7pfQ9.useCallback(function(e) {
            return e.length;
        }, []),
        defaultValue: null,
        onPropertyEvent: function() {
            u(function(e) {
                return e + 1;
            });
        },
        buildPropertyOperations: $7pfQ9.useCallback(function(e) {
            return {
                addInstance: function(n) {
                    e(function(e) {
                        return e.addInstance(n);
                    });
                },
                addInstanceAt: function(n, t) {
                    var r = !1;
                    return e(function(e) {
                        r = e.addInstanceAt(n, t);
                    }), r;
                },
                removeInstance: function(n) {
                    e(function(e) {
                        return e.removeInstance(n);
                    });
                },
                removeInstanceAt: function(n) {
                    e(function(e) {
                        return e.removeInstanceAt(n);
                    });
                },
                getInstanceAt: function(n) {
                    var t = null;
                    return e(function(e) {
                        t = e.instanceAt(n);
                    }), t;
                },
                swap: function(n, t) {
                    e(function(e) {
                        return e.swap(n, t);
                    });
                }
            };
        }, [])
    });
    return {
        length: null !== (r = a.value) && void 0 !== r ? r : 0,
        addInstance: a.addInstance,
        addInstanceAt: a.addInstanceAt,
        removeInstance: a.removeInstance,
        removeInstanceAt: a.removeInstanceAt,
        getInstanceAt: a.getInstanceAt,
        swap: a.swap
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceNumber = function(n, t) {
    var r = $2305b7cdeafa4e99$var$x(n, t, {
        getProperty: $7pfQ9.useCallback(function(e, n) {
            return e.number(n);
        }, []),
        getValue: $7pfQ9.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $7pfQ9.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceString = function(n, t) {
    var r = $2305b7cdeafa4e99$var$x(n, t, {
        getProperty: $7pfQ9.useCallback(function(e, n) {
            return e.string(n);
        }, []),
        getValue: $7pfQ9.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $7pfQ9.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue
    };
}, $2305b7cdeafa4e99$exports.useViewModelInstanceTrigger = function(n, t, r) {
    var u = (null != r ? r : {}).onTrigger;
    return {
        trigger: $2305b7cdeafa4e99$var$x(n, t, {
            getProperty: $7pfQ9.useCallback(function(e, n) {
                return e.trigger(n);
            }, []),
            getValue: $7pfQ9.useCallback(function() {}, []),
            defaultValue: null,
            onPropertyEvent: u,
            buildPropertyOperations: $7pfQ9.useCallback(function(e) {
                return {
                    trigger: function() {
                        e(function(e) {
                            e.trigger();
                        });
                    }
                };
            }, [])
        }).trigger
    };
}, Object.keys($fae66df3ca4d9b5e$exports).forEach(function(e) {
    "default" === e || $2305b7cdeafa4e99$exports.hasOwnProperty(e) || Object.defineProperty($2305b7cdeafa4e99$exports, e, {
        enumerable: !0,
        get: function() {
            return $fae66df3ca4d9b5e$exports[e];
        }
    });
});


var $8c33aa39fddc02f0$exports = {};
$8c33aa39fddc02f0$exports = import.meta.resolve("dJKDP");


function $94c580caacdc2367$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $94c580caacdc2367$var$_ref = {
    name: "zov8s0",
    styles: "width:100%;display:flex;justify-content:center"
};
var $94c580caacdc2367$var$_ref2 = {
    name: "1qxq657",
    styles: "width:196px;height:196px"
};
const $94c580caacdc2367$var$ProcessingAnimation = ()=>{
    const { RiveComponent: RiveComponent } = (0, $2305b7cdeafa4e99$exports.useRive)({
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8c33aa39fddc02f0$exports))),
        stateMachines: "processing",
        // layout: new Layout({
        //   fit: Fit.Contain,
        //   alignment: Alignment.Center
        // }),
        autoplay: true
    });
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        css: $94c580caacdc2367$var$_ref,
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
            css: $94c580caacdc2367$var$_ref2,
            children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)(RiveComponent, {})
        })
    });
};
var $94c580caacdc2367$export$2e2bcd8739ae039 = $94c580caacdc2367$var$ProcessingAnimation;


function $7d324f2ffc1020f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7d324f2ffc1020f7$var$_ref = {
    name: "dkza9d",
    styles: "width:100%;display:flex;justify-content:center;flex-grow:1"
};
const $7d324f2ffc1020f7$var$Preview = ({ cachedVideoBlob: cachedVideoBlob, isCaching: isCaching })=>{
    const isChristmas = true;
    const containerRef = (0, $7pfQ9.useRef)(null);
    const [parentHeight, setParentHeight] = (0, $7pfQ9.useState)(null);
    (0, $7pfQ9.useEffect)(()=>{
        const measure = ()=>{
            if (!containerRef.current) return;
            const el = containerRef.current;
            const h = el.clientHeight;
            setParentHeight(h);
            // print to console as requested
            console.log("Measured containerRef height (px):", h);
        };
        // initial measure
        measure();
    }, []);
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        css: $7d324f2ffc1020f7$var$_ref,
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
            ref: containerRef,
            css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
                position: "relative",
                borderRadius: 8,
                background: "rgba(0, 0, 0, 0.20)",
                boxShadow: "0px 0px 16px 0px #083EB5",
                ...isChristmas && {
                    border: "1px solid #B5DDE6",
                    backdropFilter: "blur(1px)",
                    background: "rgba(0, 0, 0, 0.20)",
                    boxShadow: "0 0 24px 0 rgba(0, 234, 129, 0.80)"
                },
                height: "100%",
                width: "100%",
                color: "gray",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }, "", ""),
            children: isCaching ? /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $94c580caacdc2367$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("video", {
                width: "100%",
                controls: true,
                autoPlay: false,
                css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
                    borderRadius: 8,
                    objectFit: "contain",
                    height: parentHeight - 1
                }, "", ""),
                children: [
                    /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("source", {
                        src: URL.createObjectURL(cachedVideoBlob),
                        type: "video/mp4"
                    }),
                    "Your browser does not support the video tag."
                ]
            })
        })
    });
};
var $7d324f2ffc1020f7$export$2e2bcd8739ae039 = $7d324f2ffc1020f7$var$Preview;






var $0805e949e4d25d99$exports = {};
$0805e949e4d25d99$exports = import.meta.resolve("fAqVF");


function $54ec0703303d6b6a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $54ec0703303d6b6a$var$_ref = {
    name: "1rnx7zs",
    styles: "width:256px;height:256px"
};
const $54ec0703303d6b6a$var$DesertAnimation = ()=>{
    const { RiveComponent: RiveComponent } = (0, $2305b7cdeafa4e99$exports.useRive)({
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0805e949e4d25d99$exports))),
        stateMachines: "desert",
        autoplay: true
    });
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        css: $54ec0703303d6b6a$var$_ref,
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)(RiveComponent, {})
    });
};
var $54ec0703303d6b6a$export$2e2bcd8739ae039 = $54ec0703303d6b6a$var$DesertAnimation;


function $12877f5c77f60f70$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $12877f5c77f60f70$var$_ref = {
    name: "1ebh8dt",
    styles: "display:flex;flex-direction:column;justify-content:start;gap:16px;flex:1"
};
var $12877f5c77f60f70$var$_ref2 = {
    name: "1lcajcz",
    styles: "margin:0;color:#F2F3F5;font-size:17px;text-align:center"
};
const $12877f5c77f60f70$var$Empty = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: $12877f5c77f60f70$var$_ref,
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $54ec0703303d6b6a$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ad547a3e175225db$export$2e2bcd8739ae039), {
                title: "Nothing to download"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("p", {
                css: $12877f5c77f60f70$var$_ref2,
                children: "Scan a QR code to get the link."
            })
        ]
    });
var $12877f5c77f60f70$export$2e2bcd8739ae039 = $12877f5c77f60f70$var$Empty;




function $34713ed227684cb4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $34713ed227684cb4$var$_ref = {
    name: "706mpj",
    styles: "display:flex;flex-direction:column;justify-content:start;flex:1"
};
var $34713ed227684cb4$var$_ref2 = {
    name: "1lcajcz",
    styles: "margin:0;color:#F2F3F5;font-size:17px;text-align:center"
};
const $34713ed227684cb4$var$Processing = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: $34713ed227684cb4$var$_ref,
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ad547a3e175225db$export$2e2bcd8739ae039), {
                title: "Processing video..."
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("p", {
                css: $34713ed227684cb4$var$_ref2,
                children: "We promise it\u2019s worth the wait!"
            })
        ]
    });
var $34713ed227684cb4$export$2e2bcd8739ae039 = $34713ed227684cb4$var$Processing;




const $9f68933ab596a152$var$Img_hypervsn = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("svg", {
        width: 178,
        height: 16,
        style: {
            opacity: 0.8
        },
        viewBox: "0 0 178 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                d: "M177 1.26313V1.26313C176.947 0.58711 176.389 0.0410933 175.671 0.0410933C174.954 0.0410933 174.395 0.58711 174.342 1.26313V1.26313V11.2734L161.345 0.2751V0.2751C160.787 -0.140912 159.99 -0.0889107 159.538 0.457106C159.299 0.717114 159.192 1.05512 159.219 1.36713V14.1595V14.1595C159.245 14.8355 159.83 15.3816 160.548 15.3816C161.265 15.3816 161.824 14.8355 161.877 14.1595V14.1595V4.14922L174.821 15.0955C175.379 15.5636 176.203 15.5116 176.681 14.9655C176.708 14.9395 176.708 14.9395 176.708 14.9135C176.734 14.8615 176.761 14.8355 176.787 14.7835C176.787 14.7575 176.814 14.7315 176.814 14.7315C176.841 14.6535 176.894 14.6015 176.92 14.5235V14.5235C176.974 14.3935 177 14.2635 177 14.1075V1.26313Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M59.6739 0.0261252C62.2567 0.0522504 64.3336 2.09002 64.3602 4.62416C64.3602 7.15831 62.2567 9.19607 59.6739 9.19607H46.8663V14.186C46.8131 14.8652 46.2539 15.4139 45.535 15.4139C44.816 15.4139 44.2302 14.8652 44.2036 14.186V1.30626C44.2036 0.574755 44.7894 0 45.535 0C45.6415 0 45.7213 0 45.8012 0.0261252H59.6739ZM59.6739 6.6097C60.7923 6.58358 61.671 5.72145 61.671 4.62419C61.671 3.52693 60.7923 2.6648 59.6739 2.63867H46.8664V6.6097H59.6739Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                d: "M17.5259 1.25189V1.25189C17.4732 0.573782 16.9194 0.026081 16.2075 0.026081C15.4955 0.026081 14.9418 0.573782 14.889 1.25189V1.25189V6.65065H2.97037V1.30405C2.97037 0.573782 2.39025 0 1.65193 0C0.913608 0 0.333496 0.573782 0.333496 1.30405V14.162V14.162C0.359865 14.8401 0.939976 15.3878 1.65193 15.3878C2.36389 15.3878 2.91763 14.8401 2.97037 14.162V14.162V9.25875H14.889V14.1098C14.889 14.8401 15.4691 15.4139 16.2075 15.4139C16.9458 15.4139 17.5259 14.8401 17.5259 14.1098V1.25189Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                d: "M40.9926 0.540926C40.5746 -0.0301123 39.7647 -0.159894 39.1638 0.255407L30.8561 6.25131L22.4962 0.203494V0.203494C21.9214 -0.159894 21.1377 -0.0301123 20.7458 0.540926C20.3278 1.11196 20.4323 1.8647 20.9809 2.30595V2.30595L29.4976 8.45759V14.1161C29.4976 14.8428 30.0724 15.4139 30.8039 15.4139C31.5354 15.4139 32.1101 14.8428 32.1101 14.1161V8.56141L40.7313 2.33191C41.2799 1.91661 41.4106 1.11196 40.9926 0.540926",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                d: "M84.465 1.32564C84.465 0.59784 83.8926 0.025993 83.1641 0.025993H69.4525C69.3745 0 69.2964 0 69.2184 0C68.4899 0 67.9175 0.571847 67.9175 1.29965V1.29965V1.32564V1.35164V7.90188V7.92788V7.95387V14.1402V14.1402C67.9435 14.5821 68.1777 14.972 68.5419 15.1799C68.7501 15.3099 69.0102 15.4139 69.2704 15.4139H83.2942V15.4139C83.9707 15.3879 84.517 14.816 84.517 14.1142C84.517 13.4124 83.9707 12.8666 83.2942 12.8146V12.8146H70.5193V9.22753H77.6483C78.3768 9.22753 78.9492 8.65568 78.9492 7.92788C78.9492 7.20007 78.3768 6.62822 77.6483 6.62822H70.5193V2.6253H83.1641C83.8926 2.6253 84.465 2.05345 84.465 1.32564",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M103.544 0.0260366C106.127 0.0520731 108.204 2.08293 108.23 4.60847C108.204 6.74347 106.686 8.53999 104.636 9.06072L107.831 13.4349C108.204 14.0077 108.071 14.7888 107.485 15.1793C106.899 15.5699 106.1 15.4657 105.674 14.919L101.494 9.16487H90.7364V14.0597C90.7364 14.7888 90.1506 15.3616 89.4051 15.3616C88.6595 15.3616 88.0737 14.7888 88.0737 14.0597V1.22372C88.127 0.546768 88.6862 0 89.4051 0C89.5116 0 89.5915 0 89.6713 0.0260366H103.544ZM103.517 6.58712C104.636 6.56108 105.514 5.70187 105.514 4.60834C105.514 3.5148 104.636 2.65559 103.517 2.62956H90.7098V6.58712H103.517Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                d: "M155.124 1.32506C155.124 0.609527 154.563 0.0530024 153.869 0H140.2C137.61 0.0265012 135.528 2.09359 135.501 4.66421C135.528 7.23482 137.61 9.30191 140.2 9.32842H142.736C142.763 9.32842 142.789 9.32842 142.816 9.32842H150.959C152.053 9.35492 152.961 10.2295 152.961 11.3425C152.961 12.4556 152.08 13.3301 150.959 13.3566H137.29C136.596 13.3831 136.035 13.9661 136.035 14.6817C136.035 15.3972 136.596 15.9537 137.29 16.0067H150.959C153.548 15.9802 155.631 13.9131 155.658 11.3425C155.631 8.77189 153.548 6.7048 150.959 6.6783H149.223C149.197 6.6783 149.17 6.6783 149.143 6.6783H140.173C139.078 6.6518 138.171 5.77726 138.171 4.66421C138.171 3.55116 139.052 2.67662 140.173 2.65012H153.842C154.563 2.62362 155.124 2.04059 155.124 1.32506",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M130.809 0.507581C131.251 -0.0642086 132.056 -0.16817 132.627 0.273667C133.199 0.715505 133.303 1.5472 132.835 2.093L125.537 11.4756C125.095 11.9954 124.316 12.0733 123.77 11.6575C123.225 11.2156 123.121 10.4619 123.511 9.89013L130.809 0.507581ZM112.861 0.507508L122.913 13.3208C123.355 13.8666 123.251 14.6983 122.679 15.1401C122.108 15.582 121.303 15.478 120.861 14.9062L110.836 2.09293C110.446 1.52114 110.55 0.741422 111.095 0.325575C111.641 -0.0902724 112.42 -0.012301 112.861 0.507508Z",
                fill: "white"
            })
        ]
    });
var // return <div
//   css={{
//     alignSelf: 'center',
//     display: 'flex',
//     width: '265px',
//     maxWidth: '100%',
//     flexDirection: 'column',
//     justifyContent: 'start',
//   }}
// >
//   <svg width={265} height={24} viewBox="0 0 265 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M265 1.8947V1.8947C264.92 0.880665 264.083 0.0616399 263.007 0.0616399C261.93 0.0616399 261.093 0.880665 261.013 1.8947V1.8947V16.9101L241.518 0.412651V0.412651C240.68 -0.211368 239.484 -0.133366 238.807 0.685659C238.448 1.07567 238.288 1.58269 238.328 2.0507V21.2393V21.2393C238.368 22.2533 239.245 23.0723 240.322 23.0723C241.398 23.0723 242.235 22.2533 242.315 21.2393V21.2393V6.22383L261.731 22.6433C262.568 23.3453 263.804 23.2673 264.522 22.4483C264.562 22.4093 264.562 22.4093 264.562 22.3703C264.601 22.2923 264.641 22.2533 264.681 22.1753C264.681 22.1363 264.721 22.0973 264.721 22.0973C264.761 21.9803 264.841 21.9023 264.881 21.7853V21.7853C264.96 21.5903 265 21.3953 265 21.1613V1.8947Z" fill="#230871" />
//     <path fillRule="evenodd" clipRule="evenodd" d="M89.0108 0.0391878C92.885 0.0783756 96.0004 3.13502 96.0403 6.93624C96.0403 10.7375 92.885 13.7941 89.0108 13.7941H69.7995V21.279C69.7196 22.2979 68.8808 23.1208 67.8024 23.1208C66.724 23.1208 65.8454 22.2979 65.8054 21.279V1.95939C65.8054 0.862132 66.6841 0 67.8024 0C67.9622 0 68.082 0 68.2018 0.0391878H89.0108ZM89.0108 9.91459C90.6883 9.8754 92.0063 8.5822 92.0063 6.93631C92.0063 5.29043 90.6883 3.99723 89.0108 3.95804H69.7994V9.91459H89.0108Z" fill="#230871" />
//     <path d="M25.7886 1.87783V1.87783C25.7095 0.860673 24.8789 0.0391215 23.8109 0.0391215C22.743 0.0391215 21.9124 0.860673 21.8333 1.87783V1.87783V9.97598H3.95531V1.95607C3.95531 0.860673 3.08514 0 1.97765 0C0.870167 0 0 0.860673 0 1.95607V21.243V21.243C0.0395531 22.2601 0.90972 23.0817 1.97765 23.0817C3.04558 23.0817 3.8762 22.2601 3.95531 21.243V21.243V13.8881H21.8333V21.1647C21.8333 22.2601 22.7035 23.1208 23.8109 23.1208C24.9184 23.1208 25.7886 22.2601 25.7886 21.1647V1.87783Z" fill="#230871" />
//     <path d="M60.9891 0.811388C60.3621 -0.0451685 59.1473 -0.23984 58.246 0.38311L45.7844 9.37696L33.2445 0.305241V0.305241C32.3824 -0.23984 31.2068 -0.0451685 30.6189 0.811388C29.9919 1.66795 30.1487 2.79704 30.9716 3.45893V3.45893L43.7467 12.6864V21.1741C43.7467 22.2642 44.6088 23.1208 45.7061 23.1208C46.8033 23.1208 47.6654 22.2642 47.6654 21.1741V12.8421L60.5972 3.49786C61.4202 2.87491 61.6161 1.66795 60.9891 0.811388" fill="#230871" />
//     <path d="M126.197 1.98847C126.197 0.89676 125.338 0.0389895 124.246 0.0389895H103.678C103.561 0 103.444 0 103.327 0C102.234 0 101.376 0.85777 101.376 1.94948V1.94948V1.98847V2.02746V11.8528V11.8918V11.9308V21.2103V21.2103C101.415 21.8731 101.766 22.458 102.312 22.7699C102.625 22.9648 103.015 23.1208 103.405 23.1208H124.441V23.1208C125.455 23.0818 126.275 22.224 126.275 21.1713C126.275 20.1186 125.455 19.2998 124.441 19.2218V19.2218H105.278V13.8413H115.972C117.065 13.8413 117.923 12.9835 117.923 11.8918C117.923 10.8001 117.065 9.94233 115.972 9.94233H105.278V3.93794H124.246C125.338 3.93794 126.197 3.08017 126.197 1.98847" fill="#230871" />
//     <path fillRule="evenodd" clipRule="evenodd" d="M154.816 0.0390548C158.69 0.0781097 161.806 3.12439 161.846 6.91271C161.806 10.1152 159.529 12.81 156.454 13.5911L161.247 20.1523C161.806 21.0115 161.606 22.1832 160.727 22.769C159.849 23.3548 158.651 23.1986 158.011 22.3784L151.741 13.7473H135.605V21.0896C135.605 22.1832 134.726 23.0424 133.608 23.0424C132.49 23.0424 131.611 22.1832 131.611 21.0896V1.83558C131.691 0.820152 132.529 0 133.608 0C133.768 0 133.887 0 134.007 0.0390548H154.816ZM154.776 9.88092C156.454 9.84186 157.772 8.55305 157.772 6.91275C157.772 5.27244 156.454 3.98363 154.776 3.94458H135.565V9.88092H154.776Z" fill="#230871" />
//     <path d="M232.186 1.98759C232.186 0.914291 231.345 0.0795035 230.304 0H209.8C205.915 0.0397518 202.792 3.14039 202.752 6.99631C202.792 10.8522 205.915 13.9529 209.8 13.9926H213.604C213.644 13.9926 213.684 13.9926 213.724 13.9926H225.938C227.58 14.0324 228.942 15.3442 228.942 17.0138C228.942 18.6833 227.62 19.9951 225.938 20.0349H205.435C204.394 20.0746 203.553 20.9492 203.553 22.0225C203.553 23.0958 204.394 23.9306 205.435 24.0101H225.938C229.823 23.9703 232.947 20.8697 232.987 17.0138C232.947 13.1578 229.823 10.0572 225.938 10.0174H223.335C223.295 10.0174 223.255 10.0174 223.215 10.0174H209.76C208.118 9.97769 206.756 8.66589 206.756 6.99631C206.756 5.32674 208.078 4.01493 209.76 3.97518H230.263C231.345 3.93542 232.186 3.06089 232.186 1.98759" fill="#230871" />
//     <path fillRule="evenodd" clipRule="evenodd" d="M195.714 0.761372C196.376 -0.0963129 197.584 -0.252256 198.441 0.410501C199.298 1.07326 199.454 2.3208 198.753 3.1395L187.805 17.2133C187.143 17.993 185.974 18.11 185.156 17.4862C184.338 16.8235 184.182 15.6929 184.766 14.8352L195.714 0.761372ZM168.792 0.761462L183.87 19.9814C184.532 20.8001 184.377 22.0476 183.519 22.7104C182.662 23.3731 181.455 23.2172 180.792 22.3595L165.754 3.13959C165.169 2.2819 165.325 1.11233 166.143 0.488562C166.961 -0.135209 168.13 -0.0182517 168.792 0.761462Z" fill="#230871" />
//   </svg>
// </div >
$9f68933ab596a152$export$2e2bcd8739ae039 = $9f68933ab596a152$var$Img_hypervsn;




const $8f4d515c511e3ad2$var$isChristmas = true;
const $8f4d515c511e3ad2$var$TopGlow = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
        className: "spin-slow",
        css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
            zIndex: -1,
            position: "fixed",
            left: "15%",
            /* keep translate here so rotation happens around the element center */ transform: "translate(-50%, 0px)",
            transformOrigin: "55% 50%",
            top: -135,
            background: "conic-gradient(from 242deg at 50% 50%, #60B9F8 24.239592254161835deg, #4907A5 270.7325005531311deg, #00E5D5 360deg)",
            ...$8f4d515c511e3ad2$var$isChristmas && {
                background: "conic-gradient(from 242deg at 50% 50%, #60E4F8 24.239592254161835deg, #8D07A5 270.7325005531311deg, #4CE500 360deg)"
            },
            //
            filter: "blur(74px)",
            width: 320,
            height: 270
        }, "", "")
    });
var $8f4d515c511e3ad2$export$2e2bcd8739ae039 = $8f4d515c511e3ad2$var$TopGlow;




var $7b9eec58b82569d1$exports = {};
$7b9eec58b82569d1$exports = import.meta.resolve("1hhCq");


var $22b97a20de2e4319$exports = {};
$22b97a20de2e4319$exports = import.meta.resolve("2YkM9");


var $563dfb78872d2a1c$exports = {};
$563dfb78872d2a1c$exports = import.meta.resolve("dTFQ8");


var $5bb61b1c884cd243$exports = {};
$5bb61b1c884cd243$exports = import.meta.resolve("NP6rg");


var $b2eb382393155863$exports = {};
$b2eb382393155863$exports = import.meta.resolve("y07kg");


var $49570c26ac12564a$exports = {};
$49570c26ac12564a$exports = import.meta.resolve("91pNd");


const $cb7606b13d545135$var$randomInRangeInt = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
const $cb7606b13d545135$var$FallingFlakes = ()=>{
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: (0, $98dbebeb6ce3dfb0$export$dbf350e5966cf602)({
            zIndex: -1,
            position: "fixed",
            width: "100%"
        }, "", ""),
        children: [
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($b2eb382393155863$exports))),
                alt: "Hat",
                style: {
                    // transform: "rotate(-30deg)",
                    position: "absolute",
                    top: -32,
                    left: `${$cb7606b13d545135$var$randomInRangeInt(2, 7)}%`,
                    width: 32,
                    animation: "fall-presents 16s linear infinite",
                    animationDelay: "2s"
                }
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7b9eec58b82569d1$exports))),
                alt: "Candy",
                style: {
                    zIndex: 999,
                    position: "absolute",
                    top: -32,
                    left: `${$cb7606b13d545135$var$randomInRangeInt(5, 15)}%`,
                    width: 30,
                    animation: "fall-presents 12s linear infinite",
                    animationDelay: "1s"
                }
            }),
            [
                ...Array(5)
            ].map((_, i)=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($22b97a20de2e4319$exports))),
                    alt: "Snowflake",
                    style: {
                        position: "absolute",
                        top: -26,
                        left: `${$cb7606b13d545135$var$randomInRangeInt(5, 30)}%`,
                        width: $cb7606b13d545135$var$randomInRangeInt(20, 26),
                        animation: `fall ${10 + Math.random() * 10}s linear infinite`,
                        animationDelay: `${Math.random() * $cb7606b13d545135$var$randomInRangeInt(5, 10)}s`
                    }
                }, i)),
            [
                ...Array(5)
            ].map((_, i)=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($22b97a20de2e4319$exports))),
                    alt: "Snowflake",
                    style: {
                        position: "absolute",
                        top: -26,
                        left: `${$cb7606b13d545135$var$randomInRangeInt(70, 98)}%`,
                        width: $cb7606b13d545135$var$randomInRangeInt(20, 26),
                        animation: `fall ${10 + Math.random() * 10}s linear infinite`,
                        animationDelay: `${Math.random() * $cb7606b13d545135$var$randomInRangeInt(5, 10)}s`
                    }
                }, i)),
            [
                ...Array(5)
            ].map((_, i)=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($22b97a20de2e4319$exports))),
                    alt: "Snowflake",
                    style: {
                        position: "absolute",
                        top: -26,
                        left: `${$cb7606b13d545135$var$randomInRangeInt(5, 30)}%`,
                        width: $cb7606b13d545135$var$randomInRangeInt(20, 26),
                        animation: `fall ${10 + Math.random() * 10}s linear infinite`,
                        animationDelay: `${Math.random() * 5}s`
                    }
                }, i)),
            [
                ...Array(5)
            ].map((_, i)=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($22b97a20de2e4319$exports))),
                    alt: "Snowflake",
                    style: {
                        position: "absolute",
                        top: -26,
                        left: `${$cb7606b13d545135$var$randomInRangeInt(70, 98)}%`,
                        width: $cb7606b13d545135$var$randomInRangeInt(20, 26),
                        animation: `fall ${10 + Math.random() * 10}s linear infinite`,
                        animationDelay: `${Math.random() * 5}s`
                    }
                }, i)),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($563dfb78872d2a1c$exports))),
                alt: "Present",
                style: {
                    zIndex: 999,
                    position: "absolute",
                    top: -35,
                    left: `${$cb7606b13d545135$var$randomInRangeInt(80, 95)}%`,
                    width: 35,
                    animation: "fall-presents 15s linear infinite"
                }
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($5bb61b1c884cd243$exports))),
                alt: "Snowman",
                style: {
                    position: "absolute",
                    top: -40,
                    left: `${$cb7606b13d545135$var$randomInRangeInt(8, 20)}%`,
                    width: 40,
                    animation: "fall-presents 17s linear infinite",
                    animationDelay: "1s"
                }
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($49570c26ac12564a$exports))),
                alt: "Santa",
                style: {
                    position: "absolute",
                    top: -40,
                    left: `${$cb7606b13d545135$var$randomInRangeInt(90, 93)}%`,
                    width: 40,
                    animation: "fall-presents 16s linear infinite"
                }
            })
        ]
    });
};
var $cb7606b13d545135$export$2e2bcd8739ae039 = $cb7606b13d545135$var$FallingFlakes;


function $d357f58ff1306473$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d357f58ff1306473$var$isChristmas = true;
var $d357f58ff1306473$var$_ref = {
    name: "163rmow",
    styles: "font-family:Montserrat, sans-serif;font-weight:400;color:white;display:flex;flex-direction:column;justify-content:space-between;max-width:480px;width:100%;height:calc(100svh - 3px);align-items:center;margin:0 auto;box-sizing:border-box"
};
var $d357f58ff1306473$var$_ref2 = {
    name: "acf2e7",
    styles: "padding:16px 0"
};
var $d357f58ff1306473$var$_ref3 = {
    name: "111wd8f",
    styles: "display:flex;flex-direction:column;justify-content:space-between;gap:24px;flex:1;padding:0 24px 24px 24px"
};
const $d357f58ff1306473$var$Layout = ({ children: children })=>/*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)("div", {
        css: $d357f58ff1306473$var$_ref,
        children: [
            $d357f58ff1306473$var$isChristmas && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $cb7606b13d545135$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $8f4d515c511e3ad2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
                css: $d357f58ff1306473$var$_ref2,
                children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $9f68933ab596a152$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
                css: $d357f58ff1306473$var$_ref3,
                children: children
            })
        ]
    });
var $d357f58ff1306473$export$2e2bcd8739ae039 = $d357f58ff1306473$var$Layout;




function $f0774b9dfd5fb980$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f0774b9dfd5fb980$var$_ref = {
    name: "1x1jjwl",
    styles: "border-radius:8px;background:rgba(0, 0, 0, 0.20);display:flex;justify-content:center;align-items:center;color:gray;font-size:16px;border-radius:8px;width:256px;height:196px"
};
const $f0774b9dfd5fb980$var$Loading = ()=>/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $d357f58ff1306473$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)("div", {
            css: $f0774b9dfd5fb980$var$_ref,
            children: "Loading..."
        })
    });
var $f0774b9dfd5fb980$export$2e2bcd8739ae039 = $f0774b9dfd5fb980$var$Loading;


const $f3ed699629d9b0ca$export$f9107b66120eb036 = ()=>{
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `HYPERVSN_HOLOBOOTH_${hours}-${minutes}.mp4`;
};


const $3acbb378139a800f$export$a26c6e4ae30395cf = async (cachedBlob)=>{
    try {
        // const videoUrl = `https://holobooth.hypervsn.com/video/${urlHash}.mp4`
        // const response = await fetch(videoUrl)
        // const blob = await response.blob()
        const blobUrl = window.URL.createObjectURL(cachedBlob);
        const anchor = document.createElement("a");
        anchor.href = blobUrl;
        anchor.download = (0, $f3ed699629d9b0ca$export$f9107b66120eb036)();
        anchor.style.display = "none";
        document.body.appendChild(anchor);
        anchor.click();
        // Cleanup
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error("Error downloading video:", error);
    }
};



async function $67e77fe9cca1ad68$export$6436779be3fc19da(urlHash, cachedBlob = null) {
    try {
        const videoUrl = `https://holobooth.hypervsn.com/video/${urlHash}.mp4`;
        const isAndroid = /Android/.test(navigator.userAgent);
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        // If navigator.share not available -> fallback to download
        if (!navigator.share) {
            console.log("\u26A0\uFE0F Share not supported - downloading instead");
            await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob);
            return;
        }
        // If Android: download first, then continue to share
        if (isAndroid) {
            console.log("Android device detected - downloading before share");
            await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob);
        // continue to attempt navigator.share after download
        } else if (!isIOS) {
            // Non-iOS and non-Android devices fallback to download
            console.log("Not an iOS/Android device - downloading instead");
            await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob);
            return;
        }
        let blob;
        if (cachedBlob) blob = cachedBlob;
        else {
            const response = await fetch(videoUrl);
            blob = await response.blob();
        }
        const file = new File([
            blob
        ], (0, $f3ed699629d9b0ca$export$f9107b66120eb036)(), {
            type: "video/mp4"
        });
        console.log("Open Share Window");
        await navigator.share({
            title: "My HYPERVSN Experience",
            text: "Check out my HYPERVSN holographic experience!",
            files: [
                file
            ]
        });
    } catch (error) {
        if (error?.name === "AbortError" || (error?.message || "").includes("canceled")) {
            console.log("\uD83D\uDFE1 Share canceled");
            return;
        }
        console.error("Error sharing:", error);
        await (0, $3acbb378139a800f$export$a26c6e4ae30395cf)(cachedBlob);
    }
}


function $f056666ea3ba6e49$export$86fbec116b87613f() {
    const [page, setPage] = (0, $7pfQ9.useState)("default"); // empty, processing
    const [isLoading, setLoading] = (0, $7pfQ9.useState)(true);
    const [urlHash, setUrlHash] = (0, $7pfQ9.useState)(null);
    const [cachedVideoBlob, setCachedVideoBlob] = (0, $7pfQ9.useState)(null);
    const videoPreviewUrl = `https://holobooth.hypervsn.com/video/${urlHash}.mp4`;
    const [searchParams] = (0, $86cabefda0aacd74$export$f1a78c17382fe22a)(); // Hook to access query parameters
    (0, $7pfQ9.useEffect)(()=>{
        // Get the value of the "hash" parameter
        const hashValue = searchParams.get("h");
        if (hashValue) {
            setUrlHash(hashValue);
            const videoUrl = `https://holobooth.hypervsn.com/video/${hashValue}.mp4`;
            // console.log(`hash: ${hashValue}`)
            console.log("\uD83D\uDD17 videoUrl", videoUrl);
        } else {
            console.log("\uD83D\uDEA8 hash parameter not found in URL");
            setLoading(false);
            setPage("empty");
        }
    }, [
        urlHash
    ]);
    const checkVideo = async ()=>{
        const videoUrl = `https://holobooth.hypervsn.com/video/${urlHash}.mp4`;
        // Use a <video> element to probe availability without triggering a CORS preflight.
        // A HEAD fetch to another origin can be blocked if the server doesn't send
        // Access-Control-Allow-Origin. Loading metadata on a video element relies on
        // media element fetches and will fire `loadedmetadata` or `error` which we
        // can use to detect readiness in most browsers without causing a CORS preflight.
        return new Promise((resolve)=>{
            let settled = false;
            const video = document.createElement("video");
            video.preload = "metadata";
            video.src = videoUrl;
            const cleanup = ()=>{
                video.pause();
                video.removeAttribute("src");
                video.load();
                video.remove();
                settled = true;
            };
            const onReady = ()=>{
                if (settled) return;
                console.log("\u2705 Video is ready (loadedmetadata)");
                setLoading(false);
                if (page === "processing") setPage("default");
                cleanup();
                resolve(true);
            };
            const onError = (e)=>{
                if (settled) return;
                // If the server returns 404 or otherwise, the media element will error.
                console.log("\uD83E\uDD14 Video not ready / error loading video", e);
                // Distinguish between not found (empty) and still processing is not
                // always possible from the media element alone. We'll treat errors as
                // "processing" first, and fall back to empty after repeated failures.
                setPage("processing");
                setLoading(false);
                cleanup();
                resolve(false);
            };
            // Timeout in case the request hangs (network issues). Treat as error.
            const timeoutId = setTimeout(()=>{
                if (settled) return;
                console.log("\u23F1\uFE0F Video probe timed out");
                onError(new Error("timeout"));
            }, 15000);
            video.addEventListener("loadedmetadata", ()=>{
                clearTimeout(timeoutId);
                onReady();
            });
            video.addEventListener("error", (e)=>{
                clearTimeout(timeoutId);
                onError(e);
            });
            // Start loading metadata
            // Some browsers start loading only after appending to DOM; append briefly.
            // We append invisibly to avoid layout shifts.
            video.style.width = "0";
            video.style.height = "0";
            video.style.position = "absolute";
            video.style.left = "-9999px";
            document.body.appendChild(video);
            // Calling load triggers the media network requests in many browsers.
            try {
                video.load();
            } catch (e) {
                // Some browsers may throw; fall back to onError
                clearTimeout(timeoutId);
                onError(e);
            }
        });
    };
    // Add new function to fetch and cache video
    const cacheVideo = async ()=>{
        if (!videoPreviewUrl) {
            console.warn("\u26A0\uFE0F No videoPreviewUrl provided \u2014 skipping cache.");
            return;
        }
        try {
            const response = await fetch(videoPreviewUrl);
            if (!response.ok) {
                console.warn(`\u{26A0}\u{FE0F} Video fetch failed with status: ${response.status}`);
                return;
            }
            const blob = await response.blob();
            setCachedVideoBlob(blob);
            console.log("\u2705 Video cached successfully");
        } catch (error) {
            console.error("\u274C Error caching video:", error);
        }
    };
    // Modify the existing checkVideo useEffect to also cache the video when ready
    (0, $7pfQ9.useEffect)(()=>{
        if (urlHash) checkVideo().then((isReady)=>{
            if (isReady) {
                console.log("\uD83D\uDCE6 Cache video");
                cacheVideo();
            }
        });
    }, [
        urlHash
    ]);
    (0, $7pfQ9.useEffect)(()=>{
        if (page === "processing") setTimeout(()=>{
            console.log("\u23F1\uFE0F Check video after 6 seconds");
            checkVideo();
            console.log("\u23F1\uFE0F Check video in 10 seconds...");
            const waitProcessing = setInterval(()=>checkVideo(), 10000);
            return ()=>clearInterval(waitProcessing);
        }, 6000);
    }, [
        page
    ]);
    const handleShareVideo = async ()=>{
        if (cachedVideoBlob) return (0, $67e77fe9cca1ad68$export$6436779be3fc19da)(urlHash, cachedVideoBlob);
        else return (0, $67e77fe9cca1ad68$export$6436779be3fc19da)(urlHash);
    };
    if (isLoading) return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $f0774b9dfd5fb980$export$2e2bcd8739ae039), {});
    const isCaching = !!!cachedVideoBlob;
    return /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $ee37356223c3448b$export$ffb0004e005737fa), {
        children: /*#__PURE__*/ (0, $ee37356223c3448b$export$25062201e9e25d76)((0, $d357f58ff1306473$export$2e2bcd8739ae039), {
            children: [
                !(page === "empty") && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $7d324f2ffc1020f7$export$2e2bcd8739ae039), {
                    page: page,
                    videoUrl: videoPreviewUrl,
                    cachedVideoBlob: cachedVideoBlob,
                    isCaching: isCaching
                }),
                page === "default" && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $7b52c13f12b5f4d4$export$2e2bcd8739ae039), {
                    shareVideo: handleShareVideo,
                    isCaching: isCaching
                }),
                page === "empty" && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $12877f5c77f60f70$export$2e2bcd8739ae039), {}),
                page === "processing" && /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $34713ed227684cb4$export$2e2bcd8739ae039), {})
            ]
        })
    });
}


var $d0f2c3d3121bd26b$exports = {};
$d0f2c3d3121bd26b$exports = JSON.parse("{\"name\":\"holo-booth-02\",\"version\":\"0.10.3\",\"scripts\":{\"test\":\"echo \\\"Error: no test specified\\\" && exit 1\",\"d\":\"parcel src/index.html --https --host localhost\",\"build\":\"parcel build src/index.js --dist-dir build\",\"b\":\"yarn remove-zip & yarn build && yarn zip\",\"remove-zip\":\"rm *.zip\",\"zip\":\"zip -r build.zip build && rm -r build\",\"build:prod\":\"parcel build src/index.html --dist-dir ./build\"},\"browserslist\":[\"last 2 ChromeAndroid versions\",\"last 2 iOS major versions\"],\"keywords\":[],\"author\":\"HYPERVSN\",\"license\":\"ISC\",\"description\":\"\",\"packageManager\":\"yarn@4.9.2\",\"dependencies\":{\"@emotion/react\":\"^11.14.0\",\"@rive-app/react-canvas\":\"^4.24.0\",\"motion\":\"^12.23.24\",\"react\":\"^19.2.0\",\"react-dom\":\"^19.2.0\",\"react-router\":\"^7.9.5\",\"react-router-dom\":\"^7.9.5\"},\"devDependencies\":{\"@babel/core\":\"^7.28.5\",\"@emotion/babel-plugin\":\"^11.13.5\",\"@parcel/transformer-svg-jsx\":\"^2.16.1\",\"parcel\":\"^2.16.1\"},\"alias\":{\"process\":false}}");


const $151a08da3f096b3b$var$getVersionWithEmoji = (version)=>{
    const fruits = [
        "\uD83C\uDF4E",
        "\uD83C\uDF4C",
        "\uD83C\uDF52",
        "\uD83C\uDF47",
        "\uD83C\uDF49",
        "\uD83C\uDF4A",
        "\uD83C\uDF4B",
        "\uD83C\uDF53",
        "\uD83E\uDD5D",
        "\uD83C\uDF4D"
    ];
    const lastDigit = parseInt(version.split(".").pop(), 10);
    const emoji = fruits[lastDigit % 10];
    return `${emoji}  ${version}`;
};
const $151a08da3f096b3b$var$version = (0, (/*@__PURE__*/$parcel$interopDefault($d0f2c3d3121bd26b$exports))).version;
console.log($151a08da3f096b3b$var$getVersionWithEmoji($151a08da3f096b3b$var$version));
const $151a08da3f096b3b$var$container = document.getElementById("app");
const $151a08da3f096b3b$var$root = (0, $f8a33d11906b9b49$exports.createRoot)($151a08da3f096b3b$var$container);
$151a08da3f096b3b$var$root.render(/*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $86cabefda0aacd74$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $ee37356223c3448b$export$34b9dba7ce09269b)((0, $f056666ea3ba6e49$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=build.ee144b27.js.map
